
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7mbQa", function(module, exports) {

var $fE4FO = parcelRequire("fE4FO");
var $55b3c5c261aa2a00$var$Global = $fE4FO.Global;
module.exports = {
    name: "localStorage",
    read: $55b3c5c261aa2a00$var$read,
    write: $55b3c5c261aa2a00$var$write,
    each: $55b3c5c261aa2a00$var$each,
    remove: $55b3c5c261aa2a00$var$remove,
    clearAll: $55b3c5c261aa2a00$var$clearAll
};
function $55b3c5c261aa2a00$var$localStorage() {
    return $55b3c5c261aa2a00$var$Global.localStorage;
}
function $55b3c5c261aa2a00$var$read(key) {
    return $55b3c5c261aa2a00$var$localStorage().getItem(key);
}
function $55b3c5c261aa2a00$var$write(key, data) {
    return $55b3c5c261aa2a00$var$localStorage().setItem(key, data);
}
function $55b3c5c261aa2a00$var$each(fn) {
    for(var i = $55b3c5c261aa2a00$var$localStorage().length - 1; i >= 0; i--){
        var key = $55b3c5c261aa2a00$var$localStorage().key(i);
        fn($55b3c5c261aa2a00$var$read(key), key);
    }
}
function $55b3c5c261aa2a00$var$remove(key) {
    return $55b3c5c261aa2a00$var$localStorage().removeItem(key);
}
function $55b3c5c261aa2a00$var$clearAll() {
    return $55b3c5c261aa2a00$var$localStorage().clear();
}

});
parcelRegister("fE4FO", function(module, exports) {
var $b63e377f8a561b77$var$assign = $b63e377f8a561b77$var$make_assign();
var $b63e377f8a561b77$var$create = $b63e377f8a561b77$var$make_create();
var $b63e377f8a561b77$var$trim = $b63e377f8a561b77$var$make_trim();
var $b63e377f8a561b77$var$Global = typeof window !== "undefined" ? window : $parcel$global;
module.exports = {
    assign: $b63e377f8a561b77$var$assign,
    create: $b63e377f8a561b77$var$create,
    trim: $b63e377f8a561b77$var$trim,
    bind: $b63e377f8a561b77$var$bind,
    slice: $b63e377f8a561b77$var$slice,
    each: $b63e377f8a561b77$var$each,
    map: $b63e377f8a561b77$var$map,
    pluck: $b63e377f8a561b77$var$pluck,
    isList: $b63e377f8a561b77$var$isList,
    isFunction: $b63e377f8a561b77$var$isFunction,
    isObject: $b63e377f8a561b77$var$isObject,
    Global: $b63e377f8a561b77$var$Global
};
function $b63e377f8a561b77$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$b63e377f8a561b77$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $b63e377f8a561b77$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $b63e377f8a561b77$var$slice(arguments, 1);
        return $b63e377f8a561b77$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $b63e377f8a561b77$var$slice(arguments, 1);
            F.prototype = obj;
            return $b63e377f8a561b77$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $b63e377f8a561b77$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
}
function $b63e377f8a561b77$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $b63e377f8a561b77$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $b63e377f8a561b77$var$each(obj, fn) {
    $b63e377f8a561b77$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $b63e377f8a561b77$var$map(obj, fn) {
    var res = $b63e377f8a561b77$var$isList(obj) ? [] : {};
    $b63e377f8a561b77$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $b63e377f8a561b77$var$pluck(obj, fn) {
    if ($b63e377f8a561b77$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $b63e377f8a561b77$var$isList(val) {
    return val != null && typeof val != "function" && typeof val.length == "number";
}
function $b63e377f8a561b77$var$isFunction(val) {
    return val && ({}).toString.call(val) === "[object Function]";
}
function $b63e377f8a561b77$var$isObject(val) {
    return val && ({}).toString.call(val) === "[object Object]";
}

});


parcelRegister("deyjU", function(module, exports) {
// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var $fE4FO = parcelRequire("fE4FO");
var $9a27346c17ebc997$var$Global = $fE4FO.Global;
module.exports = {
    name: "oldFF-globalStorage",
    read: $9a27346c17ebc997$var$read,
    write: $9a27346c17ebc997$var$write,
    each: $9a27346c17ebc997$var$each,
    remove: $9a27346c17ebc997$var$remove,
    clearAll: $9a27346c17ebc997$var$clearAll
};
var $9a27346c17ebc997$var$globalStorage = $9a27346c17ebc997$var$Global.globalStorage;
function $9a27346c17ebc997$var$read(key) {
    return $9a27346c17ebc997$var$globalStorage[key];
}
function $9a27346c17ebc997$var$write(key, data) {
    $9a27346c17ebc997$var$globalStorage[key] = data;
}
function $9a27346c17ebc997$var$each(fn) {
    for(var i = $9a27346c17ebc997$var$globalStorage.length - 1; i >= 0; i--){
        var key = $9a27346c17ebc997$var$globalStorage.key(i);
        fn($9a27346c17ebc997$var$globalStorage[key], key);
    }
}
function $9a27346c17ebc997$var$remove(key) {
    return $9a27346c17ebc997$var$globalStorage.removeItem(key);
}
function $9a27346c17ebc997$var$clearAll() {
    $9a27346c17ebc997$var$each(function(key, _) {
        delete $9a27346c17ebc997$var$globalStorage[key];
    });
}

});

parcelRegister("eCrE3", function(module, exports) {
// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var $fE4FO = parcelRequire("fE4FO");
var $aa4a0f0382525b09$var$Global = $fE4FO.Global;
module.exports = {
    name: "oldIE-userDataStorage",
    write: $aa4a0f0382525b09$var$write,
    read: $aa4a0f0382525b09$var$read,
    each: $aa4a0f0382525b09$var$each,
    remove: $aa4a0f0382525b09$var$remove,
    clearAll: $aa4a0f0382525b09$var$clearAll
};
var $aa4a0f0382525b09$var$storageName = "storejs";
var $aa4a0f0382525b09$var$doc = $aa4a0f0382525b09$var$Global.document;
var $aa4a0f0382525b09$var$_withStorageEl = $aa4a0f0382525b09$var$_makeIEStorageElFunction();
var $aa4a0f0382525b09$var$disable = ($aa4a0f0382525b09$var$Global.navigator ? $aa4a0f0382525b09$var$Global.navigator.userAgent : "").match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x
;
function $aa4a0f0382525b09$var$write(unfixedKey, data) {
    if ($aa4a0f0382525b09$var$disable) return;
    var fixedKey = $aa4a0f0382525b09$var$fixKey(unfixedKey);
    $aa4a0f0382525b09$var$_withStorageEl(function(storageEl) {
        storageEl.setAttribute(fixedKey, data);
        storageEl.save($aa4a0f0382525b09$var$storageName);
    });
}
function $aa4a0f0382525b09$var$read(unfixedKey) {
    if ($aa4a0f0382525b09$var$disable) return;
    var fixedKey = $aa4a0f0382525b09$var$fixKey(unfixedKey);
    var res = null;
    $aa4a0f0382525b09$var$_withStorageEl(function(storageEl) {
        res = storageEl.getAttribute(fixedKey);
    });
    return res;
}
function $aa4a0f0382525b09$var$each(callback) {
    $aa4a0f0382525b09$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        for(var i = attributes.length - 1; i >= 0; i--){
            var attr = attributes[i];
            callback(storageEl.getAttribute(attr.name), attr.name);
        }
    });
}
function $aa4a0f0382525b09$var$remove(unfixedKey) {
    var fixedKey = $aa4a0f0382525b09$var$fixKey(unfixedKey);
    $aa4a0f0382525b09$var$_withStorageEl(function(storageEl) {
        storageEl.removeAttribute(fixedKey);
        storageEl.save($aa4a0f0382525b09$var$storageName);
    });
}
function $aa4a0f0382525b09$var$clearAll() {
    $aa4a0f0382525b09$var$_withStorageEl(function(storageEl) {
        var attributes = storageEl.XMLDocument.documentElement.attributes;
        storageEl.load($aa4a0f0382525b09$var$storageName);
        for(var i = attributes.length - 1; i >= 0; i--)storageEl.removeAttribute(attributes[i].name);
        storageEl.save($aa4a0f0382525b09$var$storageName);
    });
}
// Helpers
//////////
// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var $aa4a0f0382525b09$var$forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
function $aa4a0f0382525b09$var$fixKey(key) {
    return key.replace(/^\d/, "___$&").replace($aa4a0f0382525b09$var$forbiddenCharsRegex, "___");
}
function $aa4a0f0382525b09$var$_makeIEStorageElFunction() {
    if (!$aa4a0f0382525b09$var$doc || !$aa4a0f0382525b09$var$doc.documentElement || !$aa4a0f0382525b09$var$doc.documentElement.addBehavior) return null;
    var scriptTag = "script", storageOwner, storageContainer, storageEl;
    // Since #userData storage applies only to specific paths, we need to
    // somehow link our data to a specific path.  We choose /favicon.ico
    // as a pretty safe option, since all browsers already make a request to
    // this URL anyway and being a 404 will not hurt us here.  We wrap an
    // iframe pointing to the favicon in an ActiveXObject(htmlfile) object
    // (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
    // since the iframe access rules appear to allow direct access and
    // manipulation of the document element, even for a 404 page.  This
    // document can be used instead of the current document (which would
    // have been limited to the current path) to perform #userData storage.
    try {
        /* global ActiveXObject */ storageContainer = new ActiveXObject("htmlfile");
        storageContainer.open();
        storageContainer.write("<" + scriptTag + ">document.w=window</" + scriptTag + '><iframe src="/favicon.ico"></iframe>');
        storageContainer.close();
        storageOwner = storageContainer.w.frames[0].document;
        storageEl = storageOwner.createElement("div");
    } catch (e) {
        // somehow ActiveXObject instantiation failed (perhaps some special
        // security settings or otherwse), fall back to per-path storage
        storageEl = $aa4a0f0382525b09$var$doc.createElement("div");
        storageOwner = $aa4a0f0382525b09$var$doc.body;
    }
    return function(storeFunction) {
        var args = [].slice.call(arguments, 0);
        args.unshift(storageEl);
        // See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
        // and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
        storageOwner.appendChild(storageEl);
        storageEl.addBehavior("#default#userData");
        storageEl.load($aa4a0f0382525b09$var$storageName);
        storeFunction.apply(this, args);
        storageOwner.removeChild(storageEl);
        return;
    };
}

});

parcelRegister("hmYM5", function(module, exports) {
// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var $fE4FO = parcelRequire("fE4FO");
var $ca53a254bb96ef40$var$Global = $fE4FO.Global;
var $ca53a254bb96ef40$var$trim = $fE4FO.trim;
module.exports = {
    name: "cookieStorage",
    read: $ca53a254bb96ef40$var$read,
    write: $ca53a254bb96ef40$var$write,
    each: $ca53a254bb96ef40$var$each,
    remove: $ca53a254bb96ef40$var$remove,
    clearAll: $ca53a254bb96ef40$var$clearAll
};
var $ca53a254bb96ef40$var$doc = $ca53a254bb96ef40$var$Global.document;
function $ca53a254bb96ef40$var$read(key) {
    if (!key || !$ca53a254bb96ef40$var$_has(key)) return null;
    var regexpStr = "(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*";
    return unescape($ca53a254bb96ef40$var$doc.cookie.replace(new RegExp(regexpStr), "$1"));
}
function $ca53a254bb96ef40$var$each(callback) {
    var cookies = $ca53a254bb96ef40$var$doc.cookie.split(/; ?/g);
    for(var i = cookies.length - 1; i >= 0; i--){
        if (!$ca53a254bb96ef40$var$trim(cookies[i])) continue;
        var kvp = cookies[i].split("=");
        var key = unescape(kvp[0]);
        var val = unescape(kvp[1]);
        callback(val, key);
    }
}
function $ca53a254bb96ef40$var$write(key, data) {
    if (!key) return;
    $ca53a254bb96ef40$var$doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
}
function $ca53a254bb96ef40$var$remove(key) {
    if (!key || !$ca53a254bb96ef40$var$_has(key)) return;
    $ca53a254bb96ef40$var$doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}
function $ca53a254bb96ef40$var$clearAll() {
    $ca53a254bb96ef40$var$each(function(_, key) {
        $ca53a254bb96ef40$var$remove(key);
    });
}
function $ca53a254bb96ef40$var$_has(key) {
    return new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test($ca53a254bb96ef40$var$doc.cookie);
}

});

parcelRegister("64b1H", function(module, exports) {

var $fE4FO = parcelRequire("fE4FO");
var $46abab686a422357$var$Global = $fE4FO.Global;
module.exports = {
    name: "sessionStorage",
    read: $46abab686a422357$var$read,
    write: $46abab686a422357$var$write,
    each: $46abab686a422357$var$each,
    remove: $46abab686a422357$var$remove,
    clearAll: $46abab686a422357$var$clearAll
};
function $46abab686a422357$var$sessionStorage() {
    return $46abab686a422357$var$Global.sessionStorage;
}
function $46abab686a422357$var$read(key) {
    return $46abab686a422357$var$sessionStorage().getItem(key);
}
function $46abab686a422357$var$write(key, data) {
    return $46abab686a422357$var$sessionStorage().setItem(key, data);
}
function $46abab686a422357$var$each(fn) {
    for(var i = $46abab686a422357$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $46abab686a422357$var$sessionStorage().key(i);
        fn($46abab686a422357$var$read(key), key);
    }
}
function $46abab686a422357$var$remove(key) {
    return $46abab686a422357$var$sessionStorage().removeItem(key);
}
function $46abab686a422357$var$clearAll() {
    return $46abab686a422357$var$sessionStorage().clear();
}

});

parcelRegister("ibNr9", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: "memoryStorage",
    read: $d3df9a3b32b1c1df$var$read,
    write: $d3df9a3b32b1c1df$var$write,
    each: $d3df9a3b32b1c1df$var$each,
    remove: $d3df9a3b32b1c1df$var$remove,
    clearAll: $d3df9a3b32b1c1df$var$clearAll
};
var $d3df9a3b32b1c1df$var$memoryStorage = {};
function $d3df9a3b32b1c1df$var$read(key) {
    return $d3df9a3b32b1c1df$var$memoryStorage[key];
}
function $d3df9a3b32b1c1df$var$write(key, data) {
    $d3df9a3b32b1c1df$var$memoryStorage[key] = data;
}
function $d3df9a3b32b1c1df$var$each(callback) {
    for(var key in $d3df9a3b32b1c1df$var$memoryStorage)if ($d3df9a3b32b1c1df$var$memoryStorage.hasOwnProperty(key)) callback($d3df9a3b32b1c1df$var$memoryStorage[key], key);
}
function $d3df9a3b32b1c1df$var$remove(key) {
    delete $d3df9a3b32b1c1df$var$memoryStorage[key];
}
function $d3df9a3b32b1c1df$var$clearAll(key) {
    $d3df9a3b32b1c1df$var$memoryStorage = {};
}

});

parcelRegister("8RueS", function(module, exports) {
module.exports = $673abacddebc7f1a$var$json2Plugin;

function $673abacddebc7f1a$var$json2Plugin() {
    (parcelRequire("fZtw7"));
    return {};
}

});
parcelRegister("fZtw7", function(module, exports) {
/* eslint-disable */ //  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html
//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.
//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.
//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.
//          For example, this would serialize Dates as ISO strings.
//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };
//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.
//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.
//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.
//          JSON.stringify(undefined) returns undefined.
//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.
//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.
//          Example:
//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'
//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'
//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.
//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.
//          Example:
//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.
//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });
//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });
//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.
/*jslint
    eval, for, this
*/ /*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/ // Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.
if (typeof JSON !== "object") JSON = {};
(function() {
    "use strict";
    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? "0" + n : n;
    }
    function this_value() {
        return this.valueOf();
    }
    if (typeof Date.prototype.toJSON !== "function") {
        Date.prototype.toJSON = function() {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
        };
        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }
    var gap;
    var indent;
    var meta;
    var rep;
    function quote(string) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string) ? '"' + string.replace(rx_escapable, function(a) {
            var c = meta[a];
            return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }
    function str(key, holder) {
        // Produce a string from holder[key].
        var i; // The loop counter.
        var k; // The member key.
        var v; // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];
        // If the value has a toJSON method, call it to obtain a replacement value.
        if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.
        if (typeof rep === "function") value = rep.call(holder, key, value);
        // What happens next depends on the value's type.
        switch(typeof value){
            case "string":
                return quote(value);
            case "number":
                // JSON numbers must be finite. Encode non-finite numbers as null.
                return isFinite(value) ? String(value) : "null";
            case "boolean":
            case "null":
                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce "null". The case is included here in
                // the remote chance that this gets fixed someday.
                return String(value);
            // If the type is "object", we might be dealing with an object or an array or
            // null.
            case "object":
                // Due to a specification blunder in ECMAScript, typeof null is "object",
                // so watch out for that case.
                if (!value) return "null";
                // Make an array to hold the partial results of stringifying this object value.
                gap += indent;
                partial = [];
                // Is the value an array?
                if (Object.prototype.toString.apply(value) === "[object Array]") {
                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.
                    length = value.length;
                    for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.
                    v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                    gap = mind;
                    return v;
                }
                // If the replacer is an array, use it to select the members to be stringified.
                if (rep && typeof rep === "object") {
                    length = rep.length;
                    for(i = 0; i < length; i += 1)if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                } else {
                    // Otherwise, iterate through all of the keys in the object.
                    for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                }
                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.
                v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
                gap = mind;
                return v;
        }
    }
    // If the JSON object does not yet have a stringify method, give it one.
    if (typeof JSON.stringify !== "function") {
        meta = {
            "\b": "\\b",
            "	": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
        };
        JSON.stringify = function(value, replacer, space) {
            // The stringify method takes a value and an optional replacer, and an optional
            // space parameter, and returns a JSON text. The replacer can be a function
            // that can replace values, or an array of strings that will select the keys.
            // A default replacer method can be provided. Use of the space parameter can
            // produce text that is more easily readable.
            var i;
            gap = "";
            indent = "";
            // If the space parameter is a number, make an indent string containing that
            // many spaces.
            if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
            else if (typeof space === "string") indent = space;
            // If there is a replacer, it must be a function or an array.
            // Otherwise, throw an error.
            rep = replacer;
            if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
            // Make a fake root object containing our value under the key of "".
            // Return the result of stringifying the value.
            return str("", {
                "": value
            });
        };
    }
    // If the JSON object does not yet have a parse method, give it one.
    if (typeof JSON.parse !== "function") JSON.parse = function(text, reviver) {
        // The parse method takes a text and an optional reviver function, and returns
        // a JavaScript value if the text is a valid JSON text.
        var j;
        function walk(holder, key) {
            // The walk method is used to recursively walk the resulting structure so
            // that modifications can be made.
            var k;
            var v;
            var value = holder[key];
            if (value && typeof value === "object") {
                for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                    v = walk(value, k);
                    if (v !== undefined) value[k] = v;
                    else delete value[k];
                }
            }
            return reviver.call(holder, key, value);
        }
        // Parsing happens in four stages. In the first stage, we replace certain
        // Unicode characters with escape sequences. JavaScript handles many characters
        // incorrectly, either silently deleting them, or treating them as line endings.
        text = String(text);
        rx_dangerous.lastIndex = 0;
        if (rx_dangerous.test(text)) text = text.replace(rx_dangerous, function(a) {
            return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
        });
        // In the second stage, we run the text against regular expressions that look
        // for non-JSON patterns. We are especially concerned with "()" and "new"
        // because they can cause invocation, and "=" because it can cause mutation.
        // But just to be safe, we want to reject all unexpected forms.
        // We split the second stage into 4 regexp operations in order to work around
        // crippling inefficiencies in IE's and Safari's regexp engines. First we
        // replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
        // replace all simple value tokens with "]" characters. Third, we delete all
        // open brackets that follow a colon or comma or that begin the text. Finally,
        // we look to see that the remaining characters are only whitespace or "]" or
        // "," or ":" or "{" or "}". If that is so, then the text is safe for eval.
        if (rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) {
            // In the third stage we use the eval function to compile the text into a
            // JavaScript structure. The "{" operator is subject to a syntactic ambiguity
            // in JavaScript: it can begin a block or an object literal. We wrap the text
            // in parens to eliminate the ambiguity.
            j = eval("(" + text + ")");
            // In the optional fourth stage, we recursively walk the new structure, passing
            // each name/value pair to a reviver function for possible transformation.
            return typeof reviver === "function" ? walk({
                "": j
            }, "") : j;
        }
        // If the text is not JSON parseable, then a SyntaxError is thrown.
        throw new SyntaxError("JSON.parse");
    };
})();

});


var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $4eae0a726ab50395$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


var $1b5031d44df7baeb$exports = {};
var $b56da5de5b72d494$exports = {};

var $fE4FO = parcelRequire("fE4FO");
var $b56da5de5b72d494$var$slice = $fE4FO.slice;
var $b56da5de5b72d494$var$pluck = $fE4FO.pluck;
var $b56da5de5b72d494$var$each = $fE4FO.each;
var $b56da5de5b72d494$var$bind = $fE4FO.bind;
var $b56da5de5b72d494$var$create = $fE4FO.create;
var $b56da5de5b72d494$var$isList = $fE4FO.isList;
var $b56da5de5b72d494$var$isFunction = $fE4FO.isFunction;
var $b56da5de5b72d494$var$isObject = $fE4FO.isObject;
$b56da5de5b72d494$exports = {
    createStore: $b56da5de5b72d494$var$createStore
};
var $b56da5de5b72d494$var$storeAPI = {
    version: "2.0.12",
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || "").replace(self._namespaceRegexp, ""));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == "__storejs_" + namespace + "_";
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $b56da5de5b72d494$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $b56da5de5b72d494$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $b56da5de5b72d494$var$_warn() {
    var _console = typeof console == "undefined" ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $b56da5de5b72d494$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = "";
    if (storages && !$b56da5de5b72d494$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$b56da5de5b72d494$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? "__storejs_" + namespace + "_" : "";
    var namespaceRegexp = namespace ? new RegExp("^" + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error("store.js namespaces can only have alphanumerics + underscores and dashes");
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = "__storejs__test__";
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $b56da5de5b72d494$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $b56da5de5b72d494$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = "";
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($b56da5de5b72d494$var$isList(plugin)) {
                $b56da5de5b72d494$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $b56da5de5b72d494$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$b56da5de5b72d494$var$isFunction(plugin)) throw new Error("Plugins must be function values that return objects");
            var pluginProperties = plugin.call(this);
            if (!$b56da5de5b72d494$var$isObject(pluginProperties)) throw new Error("Plugins must return an object of function properties");
            // Add the plugin function properties to this store instance.
            $b56da5de5b72d494$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$b56da5de5b72d494$var$isFunction(pluginFnProp)) throw new Error("Bad plugin property: " + propName + " from plugin " + plugin.name + ". Plugins should only return functions.");
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $b56da5de5b72d494$var$_warn("store.addStorage(storage) is deprecated. Use createStore([storages])");
            this._addStorage(storage);
        }
    };
    var store = $b56da5de5b72d494$var$create(_privateStoreProps, $b56da5de5b72d494$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $b56da5de5b72d494$var$each(store, function(prop, propName) {
        if ($b56da5de5b72d494$var$isFunction(prop)) store.raw[propName] = $b56da5de5b72d494$var$bind(store, prop);
    });
    $b56da5de5b72d494$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $b56da5de5b72d494$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}


var $f590d80a5de1f4a7$exports = {};






$f590d80a5de1f4a7$exports = [
    // Listed in order of usage preference
    (parcelRequire("7mbQa")),
    (parcelRequire("deyjU")),
    (parcelRequire("eCrE3")),
    (parcelRequire("hmYM5")),
    (parcelRequire("64b1H")),
    (parcelRequire("ibNr9"))
];



var $1b5031d44df7baeb$var$plugins = [
    (parcelRequire("8RueS"))
];
$1b5031d44df7baeb$exports = $b56da5de5b72d494$exports.createStore($f590d80a5de1f4a7$exports, $1b5031d44df7baeb$var$plugins);




function $57aa6ed7a3256ce7$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $57aa6ed7a3256ce7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $57aa6ed7a3256ce7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $57aa6ed7a3256ce7$var$_typeof(obj);
}
function $57aa6ed7a3256ce7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $57aa6ed7a3256ce7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $57aa6ed7a3256ce7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $57aa6ed7a3256ce7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $57aa6ed7a3256ce7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $57aa6ed7a3256ce7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $57aa6ed7a3256ce7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $57aa6ed7a3256ce7$var$_setPrototypeOf(subClass, superClass);
}
function $57aa6ed7a3256ce7$var$_getPrototypeOf(o) {
    $57aa6ed7a3256ce7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $57aa6ed7a3256ce7$var$_getPrototypeOf(o);
}
function $57aa6ed7a3256ce7$var$_setPrototypeOf(o, p) {
    $57aa6ed7a3256ce7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $57aa6ed7a3256ce7$var$_setPrototypeOf(o, p);
}
function $57aa6ed7a3256ce7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $57aa6ed7a3256ce7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $57aa6ed7a3256ce7$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $57aa6ed7a3256ce7$var$_assertThisInitialized(self);
}
function $57aa6ed7a3256ce7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $57aa6ed7a3256ce7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $57aa6ed7a3256ce7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $57aa6ed7a3256ce7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $57aa6ed7a3256ce7$var$_possibleConstructorReturn(this, result);
    };
}
function $57aa6ed7a3256ce7$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $57aa6ed7a3256ce7$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $57aa6ed7a3256ce7$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $57aa6ed7a3256ce7$var$_get = Reflect.get.bind();
    else $57aa6ed7a3256ce7$var$_get = function _get(target, property, receiver) {
        var base = $57aa6ed7a3256ce7$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $57aa6ed7a3256ce7$var$_get.apply(this, arguments);
}
function $57aa6ed7a3256ce7$var$_slicedToArray(arr, i) {
    return $57aa6ed7a3256ce7$var$_arrayWithHoles(arr) || $57aa6ed7a3256ce7$var$_iterableToArrayLimit(arr, i) || $57aa6ed7a3256ce7$var$_unsupportedIterableToArray(arr, i) || $57aa6ed7a3256ce7$var$_nonIterableRest();
}
function $57aa6ed7a3256ce7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $57aa6ed7a3256ce7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $57aa6ed7a3256ce7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $57aa6ed7a3256ce7$var$_arrayLikeToArray(o, minLen);
}
function $57aa6ed7a3256ce7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $57aa6ed7a3256ce7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $57aa6ed7a3256ce7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $57aa6ed7a3256ce7$var$_toPropertyKey(arg) {
    var key = $57aa6ed7a3256ce7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// Core Foundation Utilities, utilized in a number of places.
/**
 * Returns a boolean for RTL support
 */ function $57aa6ed7a3256ce7$var$rtl() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").attr("dir") === "rtl";
}
/**
 * returns a random base-36 uid with namespacing
 * @function
 * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
 * @param {String} namespace - name of plugin to be incorporated in uid, optional.
 * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
 * @returns {String} - unique id
 */ function $57aa6ed7a3256ce7$var$GetYoDigits() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
    var namespace = arguments.length > 1 ? arguments[1] : undefined;
    var str = "";
    var chars = "0123456789abcdefghijklmnopqrstuvwxyz";
    var charsLength = chars.length;
    for(var i = 0; i < length; i++)str += chars[Math.floor(Math.random() * charsLength)];
    return namespace ? "".concat(str, "-").concat(namespace) : str;
}
/**
 * Escape a string so it can be used as a regexp pattern
 * @function
 * @see https://stackoverflow.com/a/9310752/4317384
 *
 * @param {String} str - string to escape.
 * @returns {String} - escaped string
 */ function $57aa6ed7a3256ce7$var$RegExpEscape(str) {
    return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
function $57aa6ed7a3256ce7$var$transitionend($elem) {
    var transitions = {
        "transition": "transitionend",
        "WebkitTransition": "webkitTransitionEnd",
        "MozTransition": "transitionend",
        "OTransition": "otransitionend"
    };
    var elem = document.createElement("div"), end;
    for(var transition in transitions)if (typeof elem.style[transition] !== "undefined") end = transitions[transition];
    if (end) return end;
    else {
        setTimeout(function() {
            $elem.triggerHandler("transitionend", [
                $elem
            ]);
        }, 1);
        return "transitionend";
    }
}
/**
 * Return an event type to listen for window load.
 *
 * If `$elem` is passed, an event will be triggered on `$elem`. If window is already loaded, the event will still be triggered.
 * If `handler` is passed, attach it to the event on `$elem`.
 * Calling `onLoad` without handler allows you to get the event type that will be triggered before attaching the handler by yourself.
 * @function
 *
 * @param {Object} [] $elem - jQuery element on which the event will be triggered if passed.
 * @param {Function} [] handler - function to attach to the event.
 * @returns {String} - event type that should or will be triggered.
 */ function $57aa6ed7a3256ce7$var$onLoad($elem, handler) {
    var didLoad = document.readyState === "complete";
    var eventType = (didLoad ? "_didLoad" : "load") + ".zf.util.onLoad";
    var cb = function cb() {
        return $elem.triggerHandler(eventType);
    };
    if ($elem) {
        if (handler) $elem.one(eventType, handler);
        if (didLoad) setTimeout(cb);
        else (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).one("load", cb);
    }
    return eventType;
}
/**
 * Retuns an handler for the `mouseleave` that ignore disappeared mouses.
 *
 * If the mouse "disappeared" from the document (like when going on a browser UI element, See https://git.io/zf-11410),
 * the event is ignored.
 * - If the `ignoreLeaveWindow` is `true`, the event is ignored when the user actually left the window
 *   (like by switching to an other window with [Alt]+[Tab]).
 * - If the `ignoreReappear` is `true`, the event will be ignored when the mouse will reappear later on the document
 *   outside of the element it left.
 *
 * @function
 *
 * @param {Function} [] handler - handler for the filtered `mouseleave` event to watch.
 * @param {Object} [] options - object of options:
 * - {Boolean} [false] ignoreLeaveWindow - also ignore when the user switched windows.
 * - {Boolean} [false] ignoreReappear - also ignore when the mouse reappeared outside of the element it left.
 * @returns {Function} - filtered handler to use to listen on the `mouseleave` event.
 */ function $57aa6ed7a3256ce7$var$ignoreMousedisappear(handler) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$ignoreLeaveWindo = _ref.ignoreLeaveWindow, ignoreLeaveWindow = _ref$ignoreLeaveWindo === void 0 ? false : _ref$ignoreLeaveWindo, _ref$ignoreReappear = _ref.ignoreReappear, ignoreReappear = _ref$ignoreReappear === void 0 ? false : _ref$ignoreReappear;
    return function leaveEventHandler(eLeave) {
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var callback = handler.bind.apply(handler, [
            this,
            eLeave
        ].concat(rest));
        // The mouse left: call the given callback if the mouse entered elsewhere
        if (eLeave.relatedTarget !== null) return callback();
        // Otherwise, check if the mouse actually left the window.
        // In firefox if the user switched between windows, the window sill have the focus by the time
        // the event is triggered. We have to debounce the event to test this case.
        setTimeout(function leaveEventDebouncer() {
            if (!ignoreLeaveWindow && document.hasFocus && !document.hasFocus()) return callback();
            // Otherwise, wait for the mouse to reeapear outside of the element,
            if (!ignoreReappear) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document).one("mouseenter", function reenterEventHandler(eReenter) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(eLeave.currentTarget).has(eReenter.target).length) {
                    // Fill where the mouse finally entered.
                    eLeave.relatedTarget = eReenter.target;
                    callback();
                }
            });
        }, 0);
    };
}
var $57aa6ed7a3256ce7$export$8e4719d8761024a1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    rtl: $57aa6ed7a3256ce7$var$rtl,
    GetYoDigits: $57aa6ed7a3256ce7$var$GetYoDigits,
    RegExpEscape: $57aa6ed7a3256ce7$var$RegExpEscape,
    transitionend: $57aa6ed7a3256ce7$var$transitionend,
    onLoad: $57aa6ed7a3256ce7$var$onLoad,
    ignoreMousedisappear: $57aa6ed7a3256ce7$var$ignoreMousedisappear
});
// Default set of media queries
// const defaultQueries = {
//   'default' : 'only screen',
//   landscape : 'only screen and (orientation: landscape)',
//   portrait : 'only screen and (orientation: portrait)',
//   retina : 'only screen and (-webkit-min-device-pixel-ratio: 2),' +
//     'only screen and (min--moz-device-pixel-ratio: 2),' +
//     'only screen and (-o-min-device-pixel-ratio: 2/1),' +
//     'only screen and (min-device-pixel-ratio: 2),' +
//     'only screen and (min-resolution: 192dpi),' +
//     'only screen and (min-resolution: 2dppx)'
//   };
// matchMedia() polyfill - Test a CSS media type/query in JS.
// Authors & copyright © 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license
/* eslint-disable */ window.matchMedia || (window.matchMedia = function() {
    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = window.styleMedia || window.media;
    // For those that don't support matchMedium
    if (!styleMedia) {
        var style = document.createElement("style"), script = document.getElementsByTagName("script")[0], info = null;
        style.type = "text/css";
        style.id = "matchmediajs-test";
        if (!script) document.head.appendChild(style);
        else script.parentNode.insertBefore(style, script);
        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = "getComputedStyle" in window && window.getComputedStyle(style, null) || style.currentStyle;
        styleMedia = {
            matchMedium: function matchMedium(media) {
                var text = "@media " + media + "{ #matchmediajs-test { width: 1px; } }";
                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) style.styleSheet.cssText = text;
                else style.textContent = text;
                // Test if media query is true or false
                return info.width === "1px";
            }
        };
    }
    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || "all"),
            media: media || "all"
        };
    };
}());
/* eslint-enable */ var $57aa6ed7a3256ce7$export$b745838c41029eb3 = {
    queries: [],
    current: "",
    /**
   * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
   * @function
   * @private
   */ _init: function _init() {
        // make sure the initialization is only done once when calling _init() several times
        if (this.isInitialized === true) return this;
        else this.isInitialized = true;
        var self = this;
        var $meta = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("meta.foundation-mq");
        if (!$meta.length) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('<meta class="foundation-mq" name="foundation-mq" content>').appendTo(document.head);
        var extractedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".foundation-mq").css("font-family");
        var namedQueries;
        namedQueries = $57aa6ed7a3256ce7$var$parseStyleToObject(extractedStyles);
        self.queries = []; // reset
        for(var key in namedQueries)if (namedQueries.hasOwnProperty(key)) self.queries.push({
            name: key,
            value: "only screen and (min-width: ".concat(namedQueries[key], ")")
        });
        this.current = this._getCurrentSize();
        this._watcher();
    },
    /**
   * Reinitializes the media query helper.
   * Useful if your CSS breakpoint configuration has just been loaded or has changed since the initialization.
   * @function
   * @private
   */ _reInit: function _reInit() {
        this.isInitialized = false;
        this._init();
    },
    /**
   * Checks if the screen is at least as wide as a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
   */ atLeast: function atLeast(size) {
        var query = this.get(size);
        if (query) return window.matchMedia(query).matches;
        return false;
    },
    /**
   * Checks if the screen is within the given breakpoint.
   * If smaller than the breakpoint of larger than its upper limit it returns false.
   * @function
   * @param {String} size - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` otherwise.
   */ only: function only(size) {
        return size === this._getCurrentSize();
    },
    /**
   * Checks if the screen is within a breakpoint or smaller.
   * @function
   * @param {String} size - Name of the breakpoint to check.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it's larger.
   */ upTo: function upTo(size) {
        var nextSize = this.next(size);
        // If the next breakpoint does not match, the screen is smaller than
        // the upper limit of this breakpoint.
        if (nextSize) return !this.atLeast(nextSize);
        // If there is no next breakpoint, the "size" breakpoint does not have
        // an upper limit and the screen will always be within it or smaller.
        return true;
    },
    /**
   * Checks if the screen matches to a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to check, either 'small only' or 'small'. Omitting 'only' falls back to using atLeast() method.
   * @returns {Boolean} `true` if the breakpoint matches, `false` if it does not.
   */ is: function is(size) {
        var parts = size.trim().split(" ").filter(function(p) {
            return !!p.length;
        });
        var _parts = $57aa6ed7a3256ce7$var$_slicedToArray(parts, 2), bpSize = _parts[0], _parts$ = _parts[1], bpModifier = _parts$ === void 0 ? "" : _parts$;
        // Only the breakpont
        if (bpModifier === "only") return this.only(bpSize);
        // At least the breakpoint (included)
        if (!bpModifier || bpModifier === "up") return this.atLeast(bpSize);
        // Up to the breakpoint (included)
        if (bpModifier === "down") return this.upTo(bpSize);
        throw new Error('\n      Invalid breakpoint passed to MediaQuery.is().\n      Expected a breakpoint name formatted like "<size> <modifier>", got "'.concat(size, '".\n    '));
    },
    /**
   * Gets the media query of a breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint to get.
   * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
   */ get: function get(size) {
        for(var i in this.queries)if (this.queries.hasOwnProperty(i)) {
            var query = this.queries[i];
            if (size === query.name) return query.value;
        }
        return null;
    },
    /**
   * Get the breakpoint following the given breakpoint.
   * @function
   * @param {String} size - Name of the breakpoint.
   * @returns {String|null} - The name of the following breakpoint, or `null` if the passed breakpoint was the last one.
   */ next: function next(size) {
        var _this = this;
        var queryIndex = this.queries.findIndex(function(q) {
            return _this._getQueryName(q) === size;
        });
        if (queryIndex === -1) throw new Error('\n        Unknown breakpoint "'.concat(size, '" passed to MediaQuery.next().\n        Ensure it is present in your Sass "$breakpoints" setting.\n      '));
        var nextQuery = this.queries[queryIndex + 1];
        return nextQuery ? nextQuery.name : null;
    },
    /**
   * Returns the name of the breakpoint related to the given value.
   * @function
   * @private
   * @param {String|Object} value - Breakpoint name or query object.
   * @returns {String} Name of the breakpoint.
   */ _getQueryName: function _getQueryName(value) {
        if (typeof value === "string") return value;
        if ($57aa6ed7a3256ce7$var$_typeof(value) === "object") return value.name;
        throw new TypeError('\n      Invalid value passed to MediaQuery._getQueryName().\n      Expected a breakpoint name (String) or a breakpoint query (Object), got "'.concat(value, '" (').concat($57aa6ed7a3256ce7$var$_typeof(value), ")\n    "));
    },
    /**
   * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
   * @function
   * @private
   * @returns {String} Name of the current breakpoint.
   */ _getCurrentSize: function _getCurrentSize() {
        var matched;
        for(var i = 0; i < this.queries.length; i++){
            var query = this.queries[i];
            if (window.matchMedia(query.value).matches) matched = query;
        }
        return matched && this._getQueryName(matched);
    },
    /**
   * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
   * @function
   * @private
   */ _watcher: function _watcher() {
        var _this2 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("resize.zf.trigger", function() {
            var newSize = _this2._getCurrentSize(), currentSize = _this2.current;
            if (newSize !== currentSize) {
                // Change the current media query
                _this2.current = newSize;
                // Broadcast the media query change on the window
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).trigger("changed.zf.mediaquery", [
                    newSize,
                    currentSize
                ]);
            }
        });
    }
};
// Thank you: https://github.com/sindresorhus/query-string
function $57aa6ed7a3256ce7$var$parseStyleToObject(str) {
    var styleObject = {};
    if (typeof str !== "string") return styleObject;
    str = str.trim().slice(1, -1); // browsers re-quote string style values
    if (!str) return styleObject;
    styleObject = str.split("&").reduce(function(ret, param) {
        var parts = param.replace(/\+/g, " ").split("=");
        var key = parts[0];
        var val = parts[1];
        key = decodeURIComponent(key);
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = typeof val === "undefined" ? null : decodeURIComponent(val);
        if (!ret.hasOwnProperty(key)) ret[key] = val;
        else if (Array.isArray(ret[key])) ret[key].push(val);
        else ret[key] = [
            ret[key],
            val
        ];
        return ret;
    }, {});
    return styleObject;
}
var $57aa6ed7a3256ce7$var$FOUNDATION_VERSION = "6.8.1";
// Global Foundation object
// This is attached to the window, or used as a module for AMD/Browserify
var $57aa6ed7a3256ce7$export$4143ab5b91744744 = {
    version: $57aa6ed7a3256ce7$var$FOUNDATION_VERSION,
    /**
   * Stores initialized plugins.
   */ _plugins: {},
    /**
   * Stores generated unique ids for plugin instances
   */ _uuids: [],
    /**
   * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
   * @param {Object} plugin - The constructor of the plugin.
   */ plugin: function plugin(_plugin, name) {
        // Object key to use when adding to global Foundation object
        // Examples: Foundation.Reveal, Foundation.OffCanvas
        var className = name || $57aa6ed7a3256ce7$var$functionName(_plugin);
        // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
        // Examples: data-reveal, data-off-canvas
        var attrName = $57aa6ed7a3256ce7$var$hyphenate(className);
        // Add to the Foundation object and the plugins list (for reflowing)
        this._plugins[attrName] = this[className] = _plugin;
    },
    /**
   * @function
   * Populates the _uuids array with pointers to each individual plugin instance.
   * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
   * Also fires the initialization event for each plugin, consolidating repetitive code.
   * @param {Object} plugin - an instance of a plugin, usually `this` in context.
   * @param {String} name - the name of the plugin, passed as a camelCased string.
   * @fires Plugin#init
   */ registerPlugin: function registerPlugin(plugin, name) {
        var pluginName = name ? $57aa6ed7a3256ce7$var$hyphenate(name) : $57aa6ed7a3256ce7$var$functionName(plugin.constructor).toLowerCase();
        plugin.uuid = $57aa6ed7a3256ce7$var$GetYoDigits(6, pluginName);
        if (!plugin.$element.attr("data-".concat(pluginName))) plugin.$element.attr("data-".concat(pluginName), plugin.uuid);
        if (!plugin.$element.data("zfPlugin")) plugin.$element.data("zfPlugin", plugin);
        /**
     * Fires when the plugin has initialized.
     * @event Plugin#init
     */ plugin.$element.trigger("init.zf.".concat(pluginName));
        this._uuids.push(plugin.uuid);
        return;
    },
    /**
   * @function
   * Removes the plugins uuid from the _uuids array.
   * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
   * Also fires the destroyed event for the plugin, consolidating repetitive code.
   * @param {Object} plugin - an instance of a plugin, usually `this` in context.
   * @fires Plugin#destroyed
   */ unregisterPlugin: function unregisterPlugin(plugin) {
        var pluginName = $57aa6ed7a3256ce7$var$hyphenate($57aa6ed7a3256ce7$var$functionName(plugin.$element.data("zfPlugin").constructor));
        this._uuids.splice(this._uuids.indexOf(plugin.uuid), 1);
        plugin.$element.removeAttr("data-".concat(pluginName)).removeData("zfPlugin")/**
     * Fires when the plugin has been destroyed.
     * @event Plugin#destroyed
     */ .trigger("destroyed.zf.".concat(pluginName));
        for(var prop in plugin)if (typeof plugin[prop] === "function") plugin[prop] = null; //clean up script to prep for garbage collection.
        return;
    },
    /**
   * @function
   * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
   * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
   * @default If no argument is passed, reflow all currently active plugins.
   */ reInit: function reInit(plugins) {
        var isJQ = plugins instanceof (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)));
        try {
            if (isJQ) plugins.each(function() {
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("zfPlugin")._init();
            });
            else {
                var type = $57aa6ed7a3256ce7$var$_typeof(plugins), _this = this, fns = {
                    "object": function object(plgs) {
                        plgs.forEach(function(p) {
                            p = $57aa6ed7a3256ce7$var$hyphenate(p);
                            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-" + p + "]").foundation("_init");
                        });
                    },
                    "string": function string() {
                        plugins = $57aa6ed7a3256ce7$var$hyphenate(plugins);
                        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-" + plugins + "]").foundation("_init");
                    },
                    "undefined": function undefined$1() {
                        this.object(Object.keys(_this._plugins));
                    }
                };
                fns[type](plugins);
            }
        } catch (err) {
            console.error(err);
        } finally{
            return plugins;
        }
    },
    /**
   * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
   * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
   * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
   */ reflow: function reflow(elem, plugins) {
        // If plugins is undefined, just grab everything
        if (typeof plugins === "undefined") plugins = Object.keys(this._plugins);
        else if (typeof plugins === "string") plugins = [
            plugins
        ];
        var _this = this;
        // Iterate through each plugin
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).each(plugins, function(i, name) {
            // Get the current plugin
            var plugin = _this._plugins[name];
            // Localize the search to all elements inside elem, as well as elem itself, unless elem === document
            var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(elem).find("[data-" + name + "]").addBack("[data-" + name + "]").filter(function() {
                return typeof (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("zfPlugin") === "undefined";
            });
            // For each plugin found, initialize it
            $elem.each(function() {
                var $el = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), opts = {
                    reflow: true
                };
                if ($el.attr("data-options")) $el.attr("data-options").split(";").forEach(function(option) {
                    var opt = option.split(":").map(function(el) {
                        return el.trim();
                    });
                    if (opt[0]) opts[opt[0]] = $57aa6ed7a3256ce7$var$parseValue(opt[1]);
                });
                try {
                    $el.data("zfPlugin", new plugin((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), opts));
                } catch (er) {
                    console.error(er);
                } finally{
                    return;
                }
            });
        });
    },
    getFnName: $57aa6ed7a3256ce7$var$functionName,
    addToJquery: function addToJquery() {
        // TODO: consider not making this a jQuery function
        // TODO: need way to reflow vs. re-initialize
        /**
     * The Foundation jQuery method.
     * @param {String|Array} method - An action to perform on the current jQuery object.
     */ var foundation = function foundation(method) {
            var type = $57aa6ed7a3256ce7$var$_typeof(method), $noJS = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".no-js");
            if ($noJS.length) $noJS.removeClass("no-js");
            if (type === "undefined") {
                //needs to initialize the Foundation object, or an individual plugin.
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                $57aa6ed7a3256ce7$export$4143ab5b91744744.reflow(this);
            } else if (type === "string") {
                //an individual method to invoke on a plugin or group of plugins
                var args = Array.prototype.slice.call(arguments, 1); //collect all the arguments, if necessary
                var plugClass = this.data("zfPlugin"); //determine the class of plugin
                if (typeof plugClass !== "undefined" && typeof plugClass[method] !== "undefined") {
                    //make sure both the class and method exist
                    if (this.length === 1) //if there's only one, call it directly.
                    plugClass[method].apply(plugClass, args);
                    else this.each(function(i, el) {
                        //otherwise loop through the jQuery collection and invoke the method on each
                        plugClass[method].apply((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el).data("zfPlugin"), args);
                    });
                } else //error for no class or no method
                throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass ? $57aa6ed7a3256ce7$var$functionName(plugClass) : "this element") + ".");
            } else //error for invalid argument type
            throw new TypeError("We're sorry, ".concat(type, " is not a valid parameter. You must use a string representing the method you wish to invoke."));
            return this;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).fn.foundation = foundation;
        return 0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports));
    }
};
$57aa6ed7a3256ce7$export$4143ab5b91744744.util = {
    /**
   * Function for applying a debounce effect to a function call.
   * @function
   * @param {Function} func - Function to be called at end of timeout.
   * @param {Number} delay - Time in ms to delay the call of `func`.
   * @returns function
   */ throttle: function throttle(func, delay) {
        var timer = null;
        return function() {
            var context = this, args = arguments;
            if (timer === null) timer = setTimeout(function() {
                func.apply(context, args);
                timer = null;
            }, delay);
        };
    }
};
window.Foundation = $57aa6ed7a3256ce7$export$4143ab5b91744744;
// Polyfill for requestAnimationFrame
(function() {
    if (!Date.now || !window.Date.now) window.Date.now = Date.now = function() {
        return new Date().getTime();
    };
    var vendors = [
        "webkit",
        "moz"
    ];
    for(var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i){
        var vp = vendors[i];
        window.requestAnimationFrame = window[vp + "RequestAnimationFrame"];
        window.cancelAnimationFrame = window[vp + "CancelAnimationFrame"] || window[vp + "CancelRequestAnimationFrame"];
    }
    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
        var lastTime = 0;
        window.requestAnimationFrame = function(callback) {
            var now = Date.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function() {
                callback(lastTime = nextTime);
            }, nextTime - now);
        };
        window.cancelAnimationFrame = clearTimeout;
    }
    /**
   * Polyfill for performance.now, required by rAF
   */ if (!window.performance || !window.performance.now) window.performance = {
        start: Date.now(),
        now: function now() {
            return Date.now() - this.start;
        }
    };
})();
if (!Function.prototype.bind) /* eslint-disable no-extend-native */ Function.prototype.bind = function(oThis) {
    if (typeof this !== "function") // closest thing possible to the ECMAScript 5
    // internal IsCallable function
    throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    var aArgs = Array.prototype.slice.call(arguments, 1), fToBind = this, fNOP = function fNOP() {}, fBound = function fBound() {
        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
    };
    if (this.prototype) // native functions don't have a prototype
    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();
    return fBound;
};
// Polyfill to get the name of a function in IE9
function $57aa6ed7a3256ce7$var$functionName(fn) {
    if (typeof Function.prototype.name === "undefined") {
        var funcNameRegex = /function\s([^(]{1,})\(/;
        var results = funcNameRegex.exec(fn.toString());
        return results && results.length > 1 ? results[1].trim() : "";
    } else if (typeof fn.prototype === "undefined") return fn.constructor.name;
    else return fn.prototype.constructor.name;
}
function $57aa6ed7a3256ce7$var$parseValue(str) {
    if ("true" === str) return true;
    else if ("false" === str) return false;
    else if (!isNaN(str * 1)) return parseFloat(str);
    return str;
}
// Convert PascalCase to kebab-case
// Thank you: http://stackoverflow.com/a/8955580
function $57aa6ed7a3256ce7$var$hyphenate(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
var $57aa6ed7a3256ce7$export$e71c4d32a2263218 = {
    ImNotTouchingYou: $57aa6ed7a3256ce7$var$ImNotTouchingYou,
    OverlapArea: $57aa6ed7a3256ce7$var$OverlapArea,
    GetDimensions: $57aa6ed7a3256ce7$var$GetDimensions,
    GetExplicitOffsets: $57aa6ed7a3256ce7$var$GetExplicitOffsets
};
/**
 * Compares the dimensions of an element to a container and determines collision events with container.
 * @function
 * @param {jQuery} element - jQuery object to test for collisions.
 * @param {jQuery} parent - jQuery object to use as bounding container.
 * @param {Boolean} lrOnly - set to true to check left and right values only.
 * @param {Boolean} tbOnly - set to true to check top and bottom values only.
 * @default if no parent object passed, detects collisions with `window`.
 * @returns {Boolean} - true if collision free, false if a collision in any direction.
 */ function $57aa6ed7a3256ce7$var$ImNotTouchingYou(element, parent, lrOnly, tbOnly, ignoreBottom) {
    return $57aa6ed7a3256ce7$var$OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) === 0;
}
function $57aa6ed7a3256ce7$var$OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) {
    var eleDims = $57aa6ed7a3256ce7$var$GetDimensions(element), topOver, bottomOver, leftOver, rightOver;
    if (parent) {
        var parDims = $57aa6ed7a3256ce7$var$GetDimensions(parent);
        bottomOver = parDims.height + parDims.offset.top - (eleDims.offset.top + eleDims.height);
        topOver = eleDims.offset.top - parDims.offset.top;
        leftOver = eleDims.offset.left - parDims.offset.left;
        rightOver = parDims.width + parDims.offset.left - (eleDims.offset.left + eleDims.width);
    } else {
        bottomOver = eleDims.windowDims.height + eleDims.windowDims.offset.top - (eleDims.offset.top + eleDims.height);
        topOver = eleDims.offset.top - eleDims.windowDims.offset.top;
        leftOver = eleDims.offset.left - eleDims.windowDims.offset.left;
        rightOver = eleDims.windowDims.width - (eleDims.offset.left + eleDims.width);
    }
    bottomOver = ignoreBottom ? 0 : Math.min(bottomOver, 0);
    topOver = Math.min(topOver, 0);
    leftOver = Math.min(leftOver, 0);
    rightOver = Math.min(rightOver, 0);
    if (lrOnly) return leftOver + rightOver;
    if (tbOnly) return topOver + bottomOver;
    // use sum of squares b/c we care about overlap area.
    return Math.sqrt(topOver * topOver + bottomOver * bottomOver + leftOver * leftOver + rightOver * rightOver);
}
/**
 * Uses native methods to return an object of dimension values.
 * @function
 * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
 * @returns {Object} - nested object of integer pixel values
 * TODO - if element is window, return only those values.
 */ function $57aa6ed7a3256ce7$var$GetDimensions(elem) {
    elem = elem.length ? elem[0] : elem;
    if (elem === window || elem === document) throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");
    var rect = elem.getBoundingClientRect(), parRect = elem.parentNode.getBoundingClientRect(), winRect = document.body.getBoundingClientRect(), winY = window.pageYOffset, winX = window.pageXOffset;
    return {
        width: rect.width,
        height: rect.height,
        offset: {
            top: rect.top + winY,
            left: rect.left + winX
        },
        parentDims: {
            width: parRect.width,
            height: parRect.height,
            offset: {
                top: parRect.top + winY,
                left: parRect.left + winX
            }
        },
        windowDims: {
            width: winRect.width,
            height: winRect.height,
            offset: {
                top: winY,
                left: winX
            }
        }
    };
}
/**
 * Returns an object of top and left integer pixel values for dynamically rendered elements,
 * such as: Tooltip, Reveal, and Dropdown. Maintained for backwards compatibility, and where
 * you don't know alignment, but generally from
 * 6.4 forward you should use GetExplicitOffsets, as GetOffsets conflates position and alignment.
 * @function
 * @param {jQuery} element - jQuery object for the element being positioned.
 * @param {jQuery} anchor - jQuery object for the element's anchor point.
 * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
 * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
 * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
 * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
 * TODO alter/rewrite to work with `em` values as well/instead of pixels
 */ function $57aa6ed7a3256ce7$var$GetExplicitOffsets(element, anchor, position, alignment, vOffset, hOffset, isOverflow) {
    var $eleDims = $57aa6ed7a3256ce7$var$GetDimensions(element), $anchorDims = anchor ? $57aa6ed7a3256ce7$var$GetDimensions(anchor) : null;
    var topVal, leftVal;
    if ($anchorDims !== null) {
        // set position related attribute
        switch(position){
            case "top":
                topVal = $anchorDims.offset.top - ($eleDims.height + vOffset);
                break;
            case "bottom":
                topVal = $anchorDims.offset.top + $anchorDims.height + vOffset;
                break;
            case "left":
                leftVal = $anchorDims.offset.left - ($eleDims.width + hOffset);
                break;
            case "right":
                leftVal = $anchorDims.offset.left + $anchorDims.width + hOffset;
                break;
        }
        // set alignment related attribute
        switch(position){
            case "top":
            case "bottom":
                switch(alignment){
                    case "left":
                        leftVal = $anchorDims.offset.left + hOffset;
                        break;
                    case "right":
                        leftVal = $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset;
                        break;
                    case "center":
                        leftVal = isOverflow ? hOffset : $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2 + hOffset;
                        break;
                }
                break;
            case "right":
            case "left":
                switch(alignment){
                    case "bottom":
                        topVal = $anchorDims.offset.top - vOffset + $anchorDims.height - $eleDims.height;
                        break;
                    case "top":
                        topVal = $anchorDims.offset.top + vOffset;
                        break;
                    case "center":
                        topVal = $anchorDims.offset.top + vOffset + $anchorDims.height / 2 - $eleDims.height / 2;
                        break;
                }
                break;
        }
    }
    return {
        top: topVal,
        left: leftVal
    };
}
/**
 * Runs a callback function when images are fully loaded.
 * @param {Object} images - Image(s) to check if loaded.
 * @param {Func} callback - Function to execute when image is fully loaded.
 */ function $57aa6ed7a3256ce7$export$9a7c395a24d73631(images, callback) {
    var unloaded = images.length;
    if (unloaded === 0) callback();
    images.each(function() {
        // Check if image is loaded
        if (this.complete && typeof this.naturalWidth !== "undefined") singleImageLoaded();
        else {
            // If the above check failed, simulate loading on detached element.
            var image = new Image();
            // Still count image as loaded if it finalizes with an error.
            var events = "load.zf.images error.zf.images";
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(image).one(events, function me() {
                // Unbind the event listeners. We're using 'one' but only one of the two events will have fired.
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).off(events, me);
                singleImageLoaded();
            });
            image.src = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("src");
        }
    });
    function singleImageLoaded() {
        unloaded--;
        if (unloaded === 0) callback();
    }
}
/*******************************************
 *                                         *
 * This util was created by Marius Olbertz *
 * Please thank Marius on GitHub /owlbertz *
 * or the web http://www.mariusolbertz.de/ *
 *                                         *
 ******************************************/ var $57aa6ed7a3256ce7$var$keyCodes = {
    9: "TAB",
    13: "ENTER",
    27: "ESCAPE",
    32: "SPACE",
    35: "END",
    36: "HOME",
    37: "ARROW_LEFT",
    38: "ARROW_UP",
    39: "ARROW_RIGHT",
    40: "ARROW_DOWN"
};
var $57aa6ed7a3256ce7$var$commands = {};
// Functions pulled out to be referenceable from internals
function $57aa6ed7a3256ce7$var$findFocusable($element) {
    if (!$element) return false;
    return $element.find("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]").filter(function() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).is(":visible") || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("tabindex") < 0) return false;
         //only have visible elements and those that have a tabindex greater or equal 0
        return true;
    }).sort(function(a, b) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(a).attr("tabindex") === (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(b).attr("tabindex")) return 0;
        var aTabIndex = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(a).attr("tabindex"), 10), bTabIndex = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(b).attr("tabindex"), 10);
        // Undefined is treated the same as 0
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(a).attr("tabindex") === "undefined" && bTabIndex > 0) return 1;
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(b).attr("tabindex") === "undefined" && aTabIndex > 0) return -1;
        if (aTabIndex === 0 && bTabIndex > 0) return 1;
        if (bTabIndex === 0 && aTabIndex > 0) return -1;
        if (aTabIndex < bTabIndex) return -1;
        if (aTabIndex > bTabIndex) return 1;
    });
}
function $57aa6ed7a3256ce7$var$parseKey(event) {
    var key = $57aa6ed7a3256ce7$var$keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
    // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
    key = key.replace(/\W+/, "");
    if (event.shiftKey) key = "SHIFT_".concat(key);
    if (event.ctrlKey) key = "CTRL_".concat(key);
    if (event.altKey) key = "ALT_".concat(key);
    // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
    key = key.replace(/_$/, "");
    return key;
}
var $57aa6ed7a3256ce7$export$16e4d70cc375e707 = {
    keys: $57aa6ed7a3256ce7$var$getKeyCodes($57aa6ed7a3256ce7$var$keyCodes),
    /**
   * Parses the (keyboard) event and returns a String that represents its key
   * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
   * @param {Event} event - the event generated by the event handler
   * @return String key - String that represents the key pressed
   */ parseKey: $57aa6ed7a3256ce7$var$parseKey,
    /**
   * Handles the given (keyboard) event
   * @param {Event} event - the event generated by the event handler
   * @param {String} component - Foundation component's name, e.g. Slider or Reveal
   * @param {Objects} functions - collection of functions that are to be executed
   */ handleKey: function handleKey(event, component, functions) {
        var commandList = $57aa6ed7a3256ce7$var$commands[component], keyCode = this.parseKey(event), cmds, command, fn;
        if (!commandList) return console.warn("Component not defined!");
        // Ignore the event if it was already handled
        if (event.zfIsKeyHandled === true) return;
        // This component does not differentiate between ltr and rtl
        if (typeof commandList.ltr === "undefined") cmds = commandList; // use plain list
        else // merge ltr and rtl: if document is rtl, rtl overwrites ltr and vice versa
        if ($57aa6ed7a3256ce7$var$rtl()) cmds = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, commandList.ltr, commandList.rtl);
        else cmds = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, commandList.rtl, commandList.ltr);
        command = cmds[keyCode];
        fn = functions[command];
        // Execute the handler if found
        if (fn && typeof fn === "function") {
            var returnValue = fn.apply();
            // Mark the event as "handled" to prevent future handlings
            event.zfIsKeyHandled = true;
            // Execute function when event was handled
            if (functions.handled || typeof functions.handled === "function") functions.handled(returnValue);
        } else // Execute function when event was not handled
        if (functions.unhandled || typeof functions.unhandled === "function") functions.unhandled();
    },
    /**
   * Finds all focusable elements within the given `$element`
   * @param {jQuery} $element - jQuery object to search within
   * @return {jQuery} $focusable - all focusable elements within `$element`
   */ findFocusable: $57aa6ed7a3256ce7$var$findFocusable,
    /**
   * Returns the component name name
   * @param {Object} component - Foundation component, e.g. Slider or Reveal
   * @return String componentName
   */ register: function register(componentName, cmds) {
        $57aa6ed7a3256ce7$var$commands[componentName] = cmds;
    },
    // TODO9438: These references to Keyboard need to not require global. Will 'this' work in this context?
    //
    /**
   * Traps the focus in the given element.
   * @param  {jQuery} $element  jQuery object to trap the foucs into.
   */ trapFocus: function trapFocus($element) {
        var $focusable = $57aa6ed7a3256ce7$var$findFocusable($element), $firstFocusable = $focusable.eq(0), $lastFocusable = $focusable.eq(-1);
        $element.on("keydown.zf.trapfocus", function(event) {
            if (event.target === $lastFocusable[0] && $57aa6ed7a3256ce7$var$parseKey(event) === "TAB") {
                event.preventDefault();
                $firstFocusable.focus();
            } else if (event.target === $firstFocusable[0] && $57aa6ed7a3256ce7$var$parseKey(event) === "SHIFT_TAB") {
                event.preventDefault();
                $lastFocusable.focus();
            }
        });
    },
    /**
   * Releases the trapped focus from the given element.
   * @param  {jQuery} $element  jQuery object to release the focus for.
   */ releaseFocus: function releaseFocus($element) {
        $element.off("keydown.zf.trapfocus");
    }
};
/*
 * Constants for easier comparing.
 * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
 */ function $57aa6ed7a3256ce7$var$getKeyCodes(kcs) {
    var k = {};
    for(var kc in kcs)if (kcs.hasOwnProperty(kc)) k[kcs[kc]] = kcs[kc];
    return k;
}
/**
 * Motion module.
 * @module foundation.motion
 */ var $57aa6ed7a3256ce7$var$initClasses = [
    "mui-enter",
    "mui-leave"
];
var $57aa6ed7a3256ce7$var$activeClasses = [
    "mui-enter-active",
    "mui-leave-active"
];
var $57aa6ed7a3256ce7$export$ab7b018719e111db = {
    animateIn: function animateIn(element, animation, cb) {
        $57aa6ed7a3256ce7$var$animate(true, element, animation, cb);
    },
    animateOut: function animateOut(element, animation, cb) {
        $57aa6ed7a3256ce7$var$animate(false, element, animation, cb);
    }
};
function $57aa6ed7a3256ce7$export$e49a5ad3dd6df925(duration, elem, fn) {
    var anim, prog, start = null;
    if (duration === 0) {
        fn.apply(elem);
        elem.trigger("finished.zf.animate", [
            elem
        ]).triggerHandler("finished.zf.animate", [
            elem
        ]);
        return;
    }
    function move(ts) {
        if (!start) start = ts;
        prog = ts - start;
        fn.apply(elem);
        if (prog < duration) anim = window.requestAnimationFrame(move, elem);
        else {
            window.cancelAnimationFrame(anim);
            elem.trigger("finished.zf.animate", [
                elem
            ]).triggerHandler("finished.zf.animate", [
                elem
            ]);
        }
    }
    anim = window.requestAnimationFrame(move);
}
/**
 * Animates an element in or out using a CSS transition class.
 * @function
 * @private
 * @param {Boolean} isIn - Defines if the animation is in or out.
 * @param {Object} element - jQuery or HTML object to animate.
 * @param {String} animation - CSS class to use.
 * @param {Function} cb - Callback to run when animation is finished.
 */ function $57aa6ed7a3256ce7$var$animate(isIn, element, animation, cb) {
    element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).eq(0);
    if (!element.length) return;
    var initClass = isIn ? $57aa6ed7a3256ce7$var$initClasses[0] : $57aa6ed7a3256ce7$var$initClasses[1];
    var activeClass = isIn ? $57aa6ed7a3256ce7$var$activeClasses[0] : $57aa6ed7a3256ce7$var$activeClasses[1];
    // Set up the animation
    reset();
    element.addClass(animation).css("transition", "none");
    requestAnimationFrame(function() {
        element.addClass(initClass);
        if (isIn) element.show();
    });
    // Start the animation
    requestAnimationFrame(function() {
        // will trigger the browser to synchronously calculate the style and layout
        // also called reflow or layout thrashing
        // see https://gist.github.com/paulirish/5d52fb081b3570c81e3a
        element[0].offsetWidth;
        element.css("transition", "").addClass(activeClass);
    });
    // Clean up the animation when it finishes
    element.one($57aa6ed7a3256ce7$var$transitionend(element), finish);
    // Hides the element (for out animations), resets the element, and runs a callback
    function finish() {
        if (!isIn) element.hide();
        reset();
        if (cb) cb.apply(element);
    }
    // Resets transitions and removes motion-specific classes
    function reset() {
        element[0].style.transitionDuration = 0;
        element.removeClass("".concat(initClass, " ").concat(activeClass, " ").concat(animation));
    }
}
var $57aa6ed7a3256ce7$export$b33048315ba1159e = {
    Feather: function Feather(menu) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "zf";
        menu.attr("role", "menubar");
        menu.find("a").attr({
            "role": "menuitem"
        });
        var items = menu.find("li").attr({
            "role": "none"
        }), subMenuClass = "is-".concat(type, "-submenu"), subItemClass = "".concat(subMenuClass, "-item"), hasSubClass = "is-".concat(type, "-submenu-parent"), applyAria = type !== "accordion"; // Accordions handle their own ARIA attriutes.
        items.each(function() {
            var $item = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), $sub = $item.children("ul");
            if ($sub.length) {
                $item.addClass(hasSubClass);
                if (applyAria) {
                    var firstItem = $item.children("a:first");
                    firstItem.attr({
                        "aria-haspopup": true,
                        "aria-label": firstItem.attr("aria-label") || firstItem.text()
                    });
                    // Note:  Drilldowns behave differently in how they hide, and so need
                    // additional attributes.  We should look if this possibly over-generalized
                    // utility (Nest) is appropriate when we rework menus in 6.4
                    if (type === "drilldown") $item.attr({
                        "aria-expanded": false
                    });
                }
                $sub.addClass("submenu ".concat(subMenuClass)).attr({
                    "data-submenu": "",
                    "role": "menubar"
                });
                if (type === "drilldown") $sub.attr({
                    "aria-hidden": true
                });
            }
            if ($item.parent("[data-submenu]").length) $item.addClass("is-submenu-item ".concat(subItemClass));
        });
        return;
    },
    Burn: function Burn(menu, type) {
        var //items = menu.find('li'),
        subMenuClass = "is-".concat(type, "-submenu"), subItemClass = "".concat(subMenuClass, "-item"), hasSubClass = "is-".concat(type, "-submenu-parent");
        menu.find(">li, > li > ul, .menu, .menu > li, [data-submenu] > li").removeClass("".concat(subMenuClass, " ").concat(subItemClass, " ").concat(hasSubClass, " is-submenu-item submenu is-active")).removeAttr("data-submenu").css("display", "");
    }
};
function $57aa6ed7a3256ce7$export$c57e9b2d8b9e4de(elem, options, cb) {
    var _this = this, duration = options.duration, //options is an object for easily adding features later.
    nameSpace = Object.keys(elem.data())[0] || "timer", remain = -1, start, timer;
    this.isPaused = false;
    this.restart = function() {
        remain = -1;
        clearTimeout(timer);
        this.start();
    };
    this.start = function() {
        this.isPaused = false;
        // if(!elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.
        clearTimeout(timer);
        remain = remain <= 0 ? duration : remain;
        elem.data("paused", false);
        start = Date.now();
        timer = setTimeout(function() {
            if (options.infinite) _this.restart(); //rerun the timer.
            if (cb && typeof cb === "function") cb();
        }, remain);
        elem.trigger("timerstart.zf.".concat(nameSpace));
    };
    this.pause = function() {
        this.isPaused = true;
        //if(elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.
        clearTimeout(timer);
        elem.data("paused", true);
        var end = Date.now();
        remain = remain - (end - start);
        elem.trigger("timerpaused.zf.".concat(nameSpace));
    };
}
var $57aa6ed7a3256ce7$export$746b04bbf92762fd = {};
var $57aa6ed7a3256ce7$var$startPosX, $57aa6ed7a3256ce7$var$startTime, $57aa6ed7a3256ce7$var$elapsedTime, $57aa6ed7a3256ce7$var$startEvent, $57aa6ed7a3256ce7$var$isMoving = false, $57aa6ed7a3256ce7$var$didMoved = false;
function $57aa6ed7a3256ce7$var$onTouchEnd(e) {
    this.removeEventListener("touchmove", $57aa6ed7a3256ce7$var$onTouchMove);
    this.removeEventListener("touchend", $57aa6ed7a3256ce7$var$onTouchEnd);
    // If the touch did not move, consider it as a "tap"
    if (!$57aa6ed7a3256ce7$var$didMoved) {
        var tapEvent = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).Event("tap", $57aa6ed7a3256ce7$var$startEvent || e);
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).trigger(tapEvent);
    }
    $57aa6ed7a3256ce7$var$startEvent = null;
    $57aa6ed7a3256ce7$var$isMoving = false;
    $57aa6ed7a3256ce7$var$didMoved = false;
}
function $57aa6ed7a3256ce7$var$onTouchMove(e) {
    if (true === (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).spotSwipe.preventDefault) e.preventDefault();
    if ($57aa6ed7a3256ce7$var$isMoving) {
        var x = e.touches[0].pageX;
        // var y = e.touches[0].pageY;
        var dx = $57aa6ed7a3256ce7$var$startPosX - x;
        // var dy = startPosY - y;
        var dir;
        $57aa6ed7a3256ce7$var$didMoved = true;
        $57aa6ed7a3256ce7$var$elapsedTime = new Date().getTime() - $57aa6ed7a3256ce7$var$startTime;
        if (Math.abs(dx) >= (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).spotSwipe.moveThreshold && $57aa6ed7a3256ce7$var$elapsedTime <= (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).spotSwipe.timeThreshold) dir = dx > 0 ? "left" : "right";
        // else if(Math.abs(dy) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
        //   dir = dy > 0 ? 'down' : 'up';
        // }
        if (dir) {
            e.preventDefault();
            $57aa6ed7a3256ce7$var$onTouchEnd.apply(this, arguments);
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).trigger((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).Event("swipe", Object.assign({}, e)), dir).trigger((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).Event("swipe".concat(dir), Object.assign({}, e)));
        }
    }
}
function $57aa6ed7a3256ce7$var$onTouchStart(e) {
    if (e.touches.length === 1) {
        $57aa6ed7a3256ce7$var$startPosX = e.touches[0].pageX;
        $57aa6ed7a3256ce7$var$startEvent = e;
        $57aa6ed7a3256ce7$var$isMoving = true;
        $57aa6ed7a3256ce7$var$didMoved = false;
        $57aa6ed7a3256ce7$var$startTime = new Date().getTime();
        this.addEventListener("touchmove", $57aa6ed7a3256ce7$var$onTouchMove, {
            passive: true === (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).spotSwipe.preventDefault
        });
        this.addEventListener("touchend", $57aa6ed7a3256ce7$var$onTouchEnd, false);
    }
}
function $57aa6ed7a3256ce7$var$init() {
    this.addEventListener && this.addEventListener("touchstart", $57aa6ed7a3256ce7$var$onTouchStart, {
        passive: true
    });
}
// function teardown() {
//   this.removeEventListener('touchstart', onTouchStart);
// }
var $57aa6ed7a3256ce7$var$SpotSwipe = /*#__PURE__*/ function() {
    function SpotSwipe() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, SpotSwipe);
        this.version = "1.0.0";
        this.enabled = "ontouchstart" in document.documentElement;
        this.preventDefault = false;
        this.moveThreshold = 75;
        this.timeThreshold = 200;
        this._init();
    }
    $57aa6ed7a3256ce7$var$_createClass(SpotSwipe, [
        {
            key: "_init",
            value: function _init() {
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).event.special.swipe = {
                    setup: $57aa6ed7a3256ce7$var$init
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).event.special.tap = {
                    setup: $57aa6ed7a3256ce7$var$init
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).each([
                    "left",
                    "up",
                    "down",
                    "right"
                ], function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).event.special["swipe".concat(this)] = {
                        setup: function setup() {
                            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).on("swipe", (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).noop);
                        }
                    };
                });
            }
        }
    ]);
    return SpotSwipe;
}();
/****************************************************
 * As far as I can tell, both setupSpotSwipe and    *
 * setupTouchHandler should be idempotent,          *
 * because they directly replace functions &        *
 * values, and do not add event handlers directly.  *
 ****************************************************/ $57aa6ed7a3256ce7$export$746b04bbf92762fd.setupSpotSwipe = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).spotSwipe = new $57aa6ed7a3256ce7$var$SpotSwipe((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
};
/****************************************************
 * Method for adding pseudo drag events to elements *
 ***************************************************/ $57aa6ed7a3256ce7$export$746b04bbf92762fd.setupTouchHandler = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).fn.addTouch = function() {
        this.each(function(i, el) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el).bind("touchstart touchmove touchend touchcancel", function(event) {
                //we pass the original event object because the jQuery event
                //object is normalized to w3c specs and does not provide the TouchList
                handleTouch(event);
            });
        });
        var handleTouch = function handleTouch(event) {
            var touches = event.changedTouches, first = touches[0], eventTypes = {
                touchstart: "mousedown",
                touchmove: "mousemove",
                touchend: "mouseup"
            }, type = eventTypes[event.type], simulatedEvent;
            if ("MouseEvent" in window && typeof window.MouseEvent === "function") simulatedEvent = new window.MouseEvent(type, {
                "bubbles": true,
                "cancelable": true,
                "screenX": first.screenX,
                "screenY": first.screenY,
                "clientX": first.clientX,
                "clientY": first.clientY
            });
            else {
                simulatedEvent = document.createEvent("MouseEvent");
                simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0 /*left*/ , null);
            }
            first.target.dispatchEvent(simulatedEvent);
        };
    };
};
$57aa6ed7a3256ce7$export$746b04bbf92762fd.init = function() {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).spotSwipe === "undefined") {
        $57aa6ed7a3256ce7$export$746b04bbf92762fd.setupSpotSwipe((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
        $57aa6ed7a3256ce7$export$746b04bbf92762fd.setupTouchHandler((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
    }
};
var $57aa6ed7a3256ce7$var$MutationObserver = function() {
    var prefixes = [
        "WebKit",
        "Moz",
        "O",
        "Ms",
        ""
    ];
    for(var i = 0; i < prefixes.length; i++){
        if ("".concat(prefixes[i], "MutationObserver") in window) return window["".concat(prefixes[i], "MutationObserver")];
    }
    return false;
}();
var $57aa6ed7a3256ce7$var$triggers = function triggers(el, type) {
    el.data(type).split(" ").forEach(function(id) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(id))[type === "close" ? "trigger" : "triggerHandler"]("".concat(type, ".zf.trigger"), [
            el
        ]);
    });
};
var $57aa6ed7a3256ce7$export$2f0ccbe60836e02e = {
    Listeners: {
        Basic: {},
        Global: {}
    },
    Initializers: {}
};
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic = {
    openListener: function openListener() {
        $57aa6ed7a3256ce7$var$triggers((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), "open");
    },
    closeListener: function closeListener() {
        var id = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("close");
        if (id) $57aa6ed7a3256ce7$var$triggers((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), "close");
        else (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).trigger("close.zf.trigger");
    },
    toggleListener: function toggleListener() {
        var id = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("toggle");
        if (id) $57aa6ed7a3256ce7$var$triggers((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), "toggle");
        else (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).trigger("toggle.zf.trigger");
    },
    closeableListener: function closeableListener(e) {
        var animation = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("closable");
        // Only close the first closable element. See https://git.io/zf-7833
        e.stopPropagation();
        if (animation !== "") $57aa6ed7a3256ce7$export$ab7b018719e111db.animateOut((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), animation, function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).trigger("closed.zf");
        });
        else (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).fadeOut().trigger("closed.zf");
    },
    toggleFocusListener: function toggleFocusListener() {
        var id = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("toggle-focus");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(id)).triggerHandler("toggle.zf.trigger", [
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this)
        ]);
    }
};
// Elements with [data-open] will reveal a plugin that supports it when clicked.
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addOpenListener = function($elem) {
    $elem.off("click.zf.trigger", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.openListener);
    $elem.on("click.zf.trigger", "[data-open]", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.openListener);
};
// Elements with [data-close] will close a plugin that supports it when clicked.
// If used without a value on [data-close], the event will bubble, allowing it to close a parent component.
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addCloseListener = function($elem) {
    $elem.off("click.zf.trigger", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.closeListener);
    $elem.on("click.zf.trigger", "[data-close]", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.closeListener);
};
// Elements with [data-toggle] will toggle a plugin that supports it when clicked.
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addToggleListener = function($elem) {
    $elem.off("click.zf.trigger", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.toggleListener);
    $elem.on("click.zf.trigger", "[data-toggle]", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.toggleListener);
};
// Elements with [data-closable] will respond to close.zf.trigger events.
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addCloseableListener = function($elem) {
    $elem.off("close.zf.trigger", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.closeableListener);
    $elem.on("close.zf.trigger", "[data-closeable], [data-closable]", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.closeableListener);
};
// Elements with [data-toggle-focus] will respond to coming in and out of focus
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addToggleFocusListener = function($elem) {
    $elem.off("focus.zf.trigger blur.zf.trigger", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.toggleFocusListener);
    $elem.on("focus.zf.trigger blur.zf.trigger", "[data-toggle-focus]", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Basic.toggleFocusListener);
};
// More Global/complex listeners and triggers
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Global = {
    resizeListener: function resizeListener($nodes) {
        if (!$57aa6ed7a3256ce7$var$MutationObserver) //fallback for IE 9
        $nodes.each(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).triggerHandler("resizeme.zf.trigger");
        });
        //trigger all listening elements and signal a resize event
        $nodes.attr("data-events", "resize");
    },
    scrollListener: function scrollListener($nodes) {
        if (!$57aa6ed7a3256ce7$var$MutationObserver) //fallback for IE 9
        $nodes.each(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).triggerHandler("scrollme.zf.trigger");
        });
        //trigger all listening elements and signal a scroll event
        $nodes.attr("data-events", "scroll");
    },
    closeMeListener: function closeMeListener(e, pluginId) {
        var plugin = e.namespace.split(".")[0];
        var plugins = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-".concat(plugin, "]")).not('[data-yeti-box="'.concat(pluginId, '"]'));
        plugins.each(function() {
            var _this = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this);
            _this.triggerHandler("close.zf.trigger", [
                _this
            ]);
        });
    }
};
// Global, parses whole document.
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addClosemeListener = function(pluginName) {
    var yetiBoxes = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-yeti-box]"), plugNames = [
        "dropdown",
        "tooltip",
        "reveal"
    ];
    if (pluginName) {
        if (typeof pluginName === "string") plugNames.push(pluginName);
        else if ($57aa6ed7a3256ce7$var$_typeof(pluginName) === "object" && typeof pluginName[0] === "string") plugNames = plugNames.concat(pluginName);
        else console.error("Plugin names must be strings");
    }
    if (yetiBoxes.length) {
        var listeners = plugNames.map(function(name) {
            return "closeme.zf.".concat(name);
        }).join(" ");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(listeners).on(listeners, $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Global.closeMeListener);
    }
};
function $57aa6ed7a3256ce7$var$debounceGlobalListener(debounce, trigger, listener) {
    var timer, args = Array.prototype.slice.call(arguments, 3);
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on(trigger, function() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            listener.apply(null, args);
        }, debounce || 10); //default time to emit scroll event
    });
}
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addResizeListener = function(debounce) {
    var $nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-resize]");
    if ($nodes.length) $57aa6ed7a3256ce7$var$debounceGlobalListener(debounce, "resize.zf.trigger", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Global.resizeListener, $nodes);
};
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addScrollListener = function(debounce) {
    var $nodes = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-scroll]");
    if ($nodes.length) $57aa6ed7a3256ce7$var$debounceGlobalListener(debounce, "scroll.zf.trigger", $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Listeners.Global.scrollListener, $nodes);
};
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addMutationEventsListener = function($elem) {
    if (!$57aa6ed7a3256ce7$var$MutationObserver) return false;
    var $nodes = $elem.find("[data-resize], [data-scroll], [data-mutate]");
    //element callback
    var listeningElementsMutation = function listeningElementsMutation(mutationRecordsList) {
        var $target = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(mutationRecordsList[0].target);
        //trigger the event handler for the element depending on type
        switch(mutationRecordsList[0].type){
            case "attributes":
                if ($target.attr("data-events") === "scroll" && mutationRecordsList[0].attributeName === "data-events") $target.triggerHandler("scrollme.zf.trigger", [
                    $target,
                    window.pageYOffset
                ]);
                if ($target.attr("data-events") === "resize" && mutationRecordsList[0].attributeName === "data-events") $target.triggerHandler("resizeme.zf.trigger", [
                    $target
                ]);
                if (mutationRecordsList[0].attributeName === "style") {
                    $target.closest("[data-mutate]").attr("data-events", "mutate");
                    $target.closest("[data-mutate]").triggerHandler("mutateme.zf.trigger", [
                        $target.closest("[data-mutate]")
                    ]);
                }
                break;
            case "childList":
                $target.closest("[data-mutate]").attr("data-events", "mutate");
                $target.closest("[data-mutate]").triggerHandler("mutateme.zf.trigger", [
                    $target.closest("[data-mutate]")
                ]);
                break;
            default:
                return false;
        }
    };
    if ($nodes.length) //for each element that needs to listen for resizing, scrolling, or mutation add a single observer
    for(var i = 0; i <= $nodes.length - 1; i++){
        var elementObserver = new $57aa6ed7a3256ce7$var$MutationObserver(listeningElementsMutation);
        elementObserver.observe($nodes[i], {
            attributes: true,
            childList: true,
            characterData: false,
            subtree: true,
            attributeFilter: [
                "data-events",
                "style"
            ]
        });
    }
};
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addSimpleListeners = function() {
    var $document = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addOpenListener($document);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addCloseListener($document);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addToggleListener($document);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addCloseableListener($document);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addToggleFocusListener($document);
};
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addGlobalListeners = function() {
    var $document = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addMutationEventsListener($document);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addResizeListener(250);
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addScrollListener();
    $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addClosemeListener();
};
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init = function(__, Foundation) {
    $57aa6ed7a3256ce7$var$onLoad((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window), function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).triggersInitialized !== true) {
            $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addSimpleListeners();
            $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addGlobalListeners();
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).triggersInitialized = true;
        }
    });
    if (Foundation) {
        Foundation.Triggers = $57aa6ed7a3256ce7$export$2f0ccbe60836e02e;
        // Legacy included to be backwards compatible for now.
        Foundation.IHearYou = $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.Initializers.addGlobalListeners;
    }
};
// Abstract class for providing lifecycle hooks. Expect plugins to define AT LEAST
// {function} _setup (replaces previous constructor),
// {function} _destroy (replaces previous destroy)
var $57aa6ed7a3256ce7$var$Plugin = /*#__PURE__*/ function() {
    function Plugin(element, options) {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Plugin);
        this._setup(element, options);
        var pluginName = $57aa6ed7a3256ce7$var$getPluginName(this);
        this.uuid = $57aa6ed7a3256ce7$var$GetYoDigits(6, pluginName);
        if (!this.$element.attr("data-".concat(pluginName))) this.$element.attr("data-".concat(pluginName), this.uuid);
        if (!this.$element.data("zfPlugin")) this.$element.data("zfPlugin", this);
        /**
     * Fires when the plugin has initialized.
     * @event Plugin#init
     */ this.$element.trigger("init.zf.".concat(pluginName));
    }
    $57aa6ed7a3256ce7$var$_createClass(Plugin, [
        {
            key: "destroy",
            value: function destroy() {
                this._destroy();
                var pluginName = $57aa6ed7a3256ce7$var$getPluginName(this);
                this.$element.removeAttr("data-".concat(pluginName)).removeData("zfPlugin")/**
       * Fires when the plugin has been destroyed.
       * @event Plugin#destroyed
       */ .trigger("destroyed.zf.".concat(pluginName));
                for(var prop in this)if (this.hasOwnProperty(prop)) this[prop] = null; //clean up script to prep for garbage collection.
            }
        }
    ]);
    return Plugin;
}(); // Convert PascalCase to kebab-case
// Thank you: http://stackoverflow.com/a/8955580
function $57aa6ed7a3256ce7$var$hyphenate$1(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $57aa6ed7a3256ce7$var$getPluginName(obj) {
    return $57aa6ed7a3256ce7$var$hyphenate$1(obj.className);
}
/**
 * Abide module.
 * @module foundation.abide
 */ var $57aa6ed7a3256ce7$export$3d3f1ff3b6a4f356 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Abide, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Abide);
    function Abide() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Abide);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Abide, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of Abide.
     * @class
     * @name Abide
     * @fires Abide#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend(true, {}, Abide.defaults, this.$element.data(), options);
                this.isEnabled = true;
                this.formnovalidate = null;
                this.className = "Abide"; // ie9 back compat
                this._init();
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this2 = this;
                this.$inputs = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).merge(// Consider as input to validate:
                this.$element.find("input").not('[type="submit"]'), // * all input fields expect submit
                this.$element.find("textarea, select") // * all textareas and select fields
                );
                this.$submits = this.$element.find('[type="submit"]');
                var $globalErrors = this.$element.find("[data-abide-error]");
                // Add a11y attributes to all fields
                if (this.options.a11yAttributes) {
                    this.$inputs.each(function(i, input) {
                        return _this2.addA11yAttributes((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(input));
                    });
                    $globalErrors.each(function(i, error) {
                        return _this2.addGlobalErrorA11yAttributes((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(error));
                    });
                }
                this._events();
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this3 = this;
                this.$element.off(".abide").on("reset.zf.abide", function() {
                    _this3.resetForm();
                }).on("submit.zf.abide", function() {
                    return _this3.validateForm();
                });
                this.$submits.off("click.zf.abide keydown.zf.abide").on("click.zf.abide keydown.zf.abide", function(e) {
                    if (!e.key || e.key === " " || e.key === "Enter") {
                        e.preventDefault();
                        _this3.formnovalidate = e.target.getAttribute("formnovalidate") !== null;
                        _this3.$element.submit();
                    }
                });
                if (this.options.validateOn === "fieldChange") this.$inputs.off("change.zf.abide").on("change.zf.abide", function(e) {
                    _this3.validateInput((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target));
                });
                if (this.options.liveValidate) this.$inputs.off("input.zf.abide").on("input.zf.abide", function(e) {
                    _this3.validateInput((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target));
                });
                if (this.options.validateOnBlur) this.$inputs.off("blur.zf.abide").on("blur.zf.abide", function(e) {
                    _this3.validateInput((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target));
                });
            }
        },
        {
            key: "_reflow",
            value: function _reflow() {
                this._init();
            }
        },
        {
            key: "_validationIsDisabled",
            value: function _validationIsDisabled() {
                if (this.isEnabled === false) // whole validation disabled
                return true;
                else if (typeof this.formnovalidate === "boolean") // triggered by $submit
                return this.formnovalidate;
                // triggered by Enter in non-submit input
                return this.$submits.length ? this.$submits[0].getAttribute("formnovalidate") !== null : false;
            }
        },
        {
            key: "enableValidation",
            value: function enableValidation() {
                this.isEnabled = true;
            }
        },
        {
            key: "disableValidation",
            value: function disableValidation() {
                this.isEnabled = false;
            }
        },
        {
            key: "requiredCheck",
            value: function requiredCheck($el) {
                if (!$el.attr("required")) return true;
                var isGood = true;
                switch($el[0].type){
                    case "checkbox":
                        isGood = $el[0].checked;
                        break;
                    case "select":
                    case "select-one":
                    case "select-multiple":
                        var opt = $el.find("option:selected");
                        if (!opt.length || !opt.val()) isGood = false;
                        break;
                    default:
                        if (!$el.val() || !$el.val().length) isGood = false;
                }
                return isGood;
            }
        },
        {
            key: "findFormError",
            value: function findFormError($el, failedValidators) {
                var _this4 = this;
                var id = $el.length ? $el[0].id : "";
                var $error = $el.siblings(this.options.formErrorSelector);
                if (!$error.length) $error = $el.parent().find(this.options.formErrorSelector);
                if (id) $error = $error.add(this.$element.find('[data-form-error-for="'.concat(id, '"]')));
                if (!!failedValidators) {
                    $error = $error.not("[data-form-error-on]");
                    failedValidators.forEach(function(v) {
                        $error = $error.add($el.siblings('[data-form-error-on="'.concat(v, '"]')));
                        $error = $error.add(_this4.$element.find('[data-form-error-for="'.concat(id, '"][data-form-error-on="').concat(v, '"]')));
                    });
                }
                return $error;
            }
        },
        {
            key: "findLabel",
            value: function findLabel($el) {
                var id = $el[0].id;
                var $label = this.$element.find('label[for="'.concat(id, '"]'));
                if (!$label.length) return $el.closest("label");
                return $label;
            }
        },
        {
            key: "findRadioLabels",
            value: function findRadioLabels($els) {
                var _this5 = this;
                var labels = $els.map(function(i, el) {
                    var id = el.id;
                    var $label = _this5.$element.find('label[for="'.concat(id, '"]'));
                    if (!$label.length) $label = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el).closest("label");
                    return $label[0];
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(labels);
            }
        },
        {
            key: "findCheckboxLabels",
            value: function findCheckboxLabels($els) {
                var _this6 = this;
                var labels = $els.map(function(i, el) {
                    var id = el.id;
                    var $label = _this6.$element.find('label[for="'.concat(id, '"]'));
                    if (!$label.length) $label = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el).closest("label");
                    return $label[0];
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(labels);
            }
        },
        {
            key: "addErrorClasses",
            value: function addErrorClasses($el, failedValidators) {
                var $label = this.findLabel($el);
                var $formError = this.findFormError($el, failedValidators);
                if ($label.length) $label.addClass(this.options.labelErrorClass);
                if ($formError.length) $formError.addClass(this.options.formErrorClass);
                $el.addClass(this.options.inputErrorClass).attr({
                    "data-invalid": "",
                    "aria-invalid": true
                });
                if ($formError.filter(":visible").length) this.addA11yErrorDescribe($el, $formError);
            }
        },
        {
            key: "addA11yAttributes",
            value: function addA11yAttributes($el) {
                var $errors = this.findFormError($el);
                var $labels = $errors.filter("label");
                if (!$errors.length) return;
                var $error = $errors.filter(":visible").first();
                if ($error.length) this.addA11yErrorDescribe($el, $error);
                if ($labels.filter("[for]").length < $labels.length) {
                    // Get the input ID or create one
                    var elemId = $el.attr("id");
                    if (typeof elemId === "undefined") {
                        elemId = $57aa6ed7a3256ce7$var$GetYoDigits(6, "abide-input");
                        $el.attr("id", elemId);
                    }
                    // For each label targeting $el, set [for] if it is not set.
                    $labels.each(function(i, label) {
                        var $label = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(label);
                        if (typeof $label.attr("for") === "undefined") $label.attr("for", elemId);
                    });
                }
                // For each error targeting $el, set [role=alert] if it is not set.
                $errors.each(function(i, label) {
                    var $label = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(label);
                    if (typeof $label.attr("role") === "undefined") $label.attr("role", "alert");
                }).end();
            }
        },
        {
            key: "addA11yErrorDescribe",
            value: function addA11yErrorDescribe($el, $error) {
                if (typeof $el.attr("aria-describedby") !== "undefined") return;
                // Set [aria-describedby] on the input toward the first form error if it is not set
                // Get the first error ID or create one
                var errorId = $error.attr("id");
                if (typeof errorId === "undefined") {
                    errorId = $57aa6ed7a3256ce7$var$GetYoDigits(6, "abide-error");
                    $error.attr("id", errorId);
                }
                $el.attr("aria-describedby", errorId).data("abide-describedby", true);
            }
        },
        {
            key: "addGlobalErrorA11yAttributes",
            value: function addGlobalErrorA11yAttributes($el) {
                if (typeof $el.attr("aria-live") === "undefined") $el.attr("aria-live", this.options.a11yErrorLevel);
            }
        },
        {
            key: "removeRadioErrorClasses",
            value: function removeRadioErrorClasses(groupName) {
                var $els = this.$element.find(':radio[name="'.concat(groupName, '"]'));
                var $labels = this.findRadioLabels($els);
                var $formErrors = this.findFormError($els);
                if ($labels.length) $labels.removeClass(this.options.labelErrorClass);
                if ($formErrors.length) $formErrors.removeClass(this.options.formErrorClass);
                $els.removeClass(this.options.inputErrorClass).attr({
                    "data-invalid": null,
                    "aria-invalid": null
                });
            }
        },
        {
            key: "removeCheckboxErrorClasses",
            value: function removeCheckboxErrorClasses(groupName) {
                var $els = this.$element.find(':checkbox[name="'.concat(groupName, '"]'));
                var $labels = this.findCheckboxLabels($els);
                var $formErrors = this.findFormError($els);
                if ($labels.length) $labels.removeClass(this.options.labelErrorClass);
                if ($formErrors.length) $formErrors.removeClass(this.options.formErrorClass);
                $els.removeClass(this.options.inputErrorClass).attr({
                    "data-invalid": null,
                    "aria-invalid": null
                });
            }
        },
        {
            key: "removeErrorClasses",
            value: function removeErrorClasses($el) {
                // radios need to clear all of the els
                if ($el[0].type === "radio") return this.removeRadioErrorClasses($el.attr("name"));
                else if ($el[0].type === "checkbox") return this.removeCheckboxErrorClasses($el.attr("name"));
                var $label = this.findLabel($el);
                var $formError = this.findFormError($el);
                if ($label.length) $label.removeClass(this.options.labelErrorClass);
                if ($formError.length) $formError.removeClass(this.options.formErrorClass);
                $el.removeClass(this.options.inputErrorClass).attr({
                    "data-invalid": null,
                    "aria-invalid": null
                });
                if ($el.data("abide-describedby")) $el.removeAttr("aria-describedby").removeData("abide-describedby");
            }
        },
        {
            key: "validateInput",
            value: function validateInput($el) {
                var _this7 = this;
                var clearRequire = this.requiredCheck($el), validator = $el.attr("data-validator"), failedValidators = [], manageErrorClasses = true;
                // skip validation if disabled
                if (this._validationIsDisabled()) return true;
                // don't validate ignored inputs or hidden inputs or disabled inputs
                if ($el.is("[data-abide-ignore]") || $el.is('[type="hidden"]') || $el.is("[disabled]")) return true;
                switch($el[0].type){
                    case "radio":
                        this.validateRadio($el.attr("name")) || failedValidators.push("required");
                        break;
                    case "checkbox":
                        this.validateCheckbox($el.attr("name")) || failedValidators.push("required");
                        // validateCheckbox() adds/removes error classes
                        manageErrorClasses = false;
                        break;
                    case "select":
                    case "select-one":
                    case "select-multiple":
                        clearRequire || failedValidators.push("required");
                        break;
                    default:
                        clearRequire || failedValidators.push("required");
                        this.validateText($el) || failedValidators.push("pattern");
                }
                if (validator) {
                    var required = $el.attr("required") ? true : false;
                    validator.split(" ").forEach(function(v) {
                        _this7.options.validators[v]($el, required, $el.parent()) || failedValidators.push(v);
                    });
                }
                if ($el.attr("data-equalto")) this.options.validators.equalTo($el) || failedValidators.push("equalTo");
                var goodToGo = failedValidators.length === 0;
                var message = (goodToGo ? "valid" : "invalid") + ".zf.abide";
                if (goodToGo) {
                    // Re-validate inputs that depend on this one with equalto
                    var dependentElements = this.$element.find('[data-equalto="'.concat($el.attr("id"), '"]'));
                    if (dependentElements.length) {
                        var _this = this;
                        dependentElements.each(function() {
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).val()) _this.validateInput((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this));
                        });
                    }
                }
                if (manageErrorClasses) {
                    if (!goodToGo) this.addErrorClasses($el, failedValidators);
                    else this.removeErrorClasses($el);
                }
                /**
       * Fires when the input is done checking for validation. Event trigger is either `valid.zf.abide` or `invalid.zf.abide`
       * Trigger includes the DOM element of the input.
       * @event Abide#valid
       * @event Abide#invalid
       */ $el.trigger(message, [
                    $el
                ]);
                return goodToGo;
            }
        },
        {
            key: "validateForm",
            value: function validateForm() {
                var _this8 = this;
                var acc = [];
                var _this = this;
                var checkboxGroupName;
                // Remember first form submission to prevent specific checkbox validation (more than one required) until form got initially submitted
                if (!this.initialized) this.initialized = true;
                // skip validation if disabled
                if (this._validationIsDisabled()) {
                    this.formnovalidate = null;
                    return true;
                }
                this.$inputs.each(function() {
                    // Only use one checkbox per group since validateCheckbox() iterates over all associated checkboxes
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this)[0].type === "checkbox") {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("name") === checkboxGroupName) return true;
                        checkboxGroupName = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("name");
                    }
                    acc.push(_this.validateInput((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this)));
                });
                var noError = acc.indexOf(false) === -1;
                this.$element.find("[data-abide-error]").each(function(i, elem) {
                    var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(elem);
                    // Ensure a11y attributes are set
                    if (_this8.options.a11yAttributes) _this8.addGlobalErrorA11yAttributes($elem);
                    // Show or hide the error
                    $elem.css("display", noError ? "none" : "block");
                });
                /**
       * Fires when the form is finished validating. Event trigger is either `formvalid.zf.abide` or `forminvalid.zf.abide`.
       * Trigger includes the element of the form.
       * @event Abide#formvalid
       * @event Abide#forminvalid
       */ this.$element.trigger((noError ? "formvalid" : "forminvalid") + ".zf.abide", [
                    this.$element
                ]);
                return noError;
            }
        },
        {
            key: "validateText",
            value: function validateText($el, pattern) {
                // A pattern can be passed to this function, or it will be infered from the input's "pattern" attribute, or it's "type" attribute
                pattern = pattern || $el.attr("data-pattern") || $el.attr("pattern") || $el.attr("type");
                var inputText = $el.val();
                var valid = true;
                if (inputText.length) {
                    // If the pattern attribute on the element is in Abide's list of patterns, then test that regexp
                    if (this.options.patterns.hasOwnProperty(pattern)) valid = this.options.patterns[pattern].test(inputText);
                    else if (pattern !== $el.attr("type")) valid = new RegExp(pattern).test(inputText);
                }
                return valid;
            }
        },
        {
            key: "validateRadio",
            value: function validateRadio(groupName) {
                // If at least one radio in the group has the `required` attribute, the group is considered required
                // Per W3C spec, all radio buttons in a group should have `required`, but we're being nice
                var $group = this.$element.find(':radio[name="'.concat(groupName, '"]'));
                var valid = false, required = false;
                // For the group to be required, at least one radio needs to be required
                $group.each(function(i, e) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e).attr("required")) required = true;
                });
                if (!required) valid = true;
                if (!valid) // For the group to be valid, at least one radio needs to be checked
                $group.each(function(i, e) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e).prop("checked")) valid = true;
                });
                return valid;
            }
        },
        {
            key: "validateCheckbox",
            value: function validateCheckbox(groupName) {
                var _this9 = this;
                // If at least one checkbox in the group has the `required` attribute, the group is considered required
                // Per W3C spec, all checkboxes in a group should have `required`, but we're being nice
                var $group = this.$element.find(':checkbox[name="'.concat(groupName, '"]'));
                var valid = false, required = false, minRequired = 1, checked = 0;
                // For the group to be required, at least one checkbox needs to be required
                $group.each(function(i, e) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e).attr("required")) required = true;
                });
                if (!required) valid = true;
                if (!valid) {
                    // Count checked checkboxes within the group
                    // Use data-min-required if available (default: 1)
                    $group.each(function(i, e) {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e).prop("checked")) checked++;
                        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e).attr("data-min-required") !== "undefined") minRequired = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e).attr("data-min-required"), 10);
                    });
                    // For the group to be valid, the minRequired amount of checkboxes have to be checked
                    if (checked >= minRequired) valid = true;
                }
                // Skip validation if more than 1 checkbox have to be checked AND if the form hasn't got submitted yet (otherwise it will already show an error during the first fill in)
                if (this.initialized !== true && minRequired > 1) return true;
                // Refresh error class for all input
                $group.each(function(i, e) {
                    if (!valid) _this9.addErrorClasses((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e), [
                        "required"
                    ]);
                    else _this9.removeErrorClasses((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e));
                });
                return valid;
            }
        },
        {
            key: "matchValidation",
            value: function matchValidation($el, validators, required) {
                var _this10 = this;
                required = required ? true : false;
                var clear = validators.split(" ").map(function(v) {
                    return _this10.options.validators[v]($el, required, $el.parent());
                });
                return clear.indexOf(false) === -1;
            }
        },
        {
            key: "resetForm",
            value: function resetForm() {
                var $form = this.$element, opts = this.options;
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".".concat(opts.labelErrorClass), $form).not("small").removeClass(opts.labelErrorClass);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".".concat(opts.inputErrorClass), $form).not("small").removeClass(opts.inputErrorClass);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("".concat(opts.formErrorSelector, ".").concat(opts.formErrorClass)).removeClass(opts.formErrorClass);
                $form.find("[data-abide-error]").css("display", "none");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(":input", $form).not(":button, :submit, :reset, :hidden, :radio, :checkbox, [data-abide-ignore]").val("").attr({
                    "data-invalid": null,
                    "aria-invalid": null
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(":input:radio", $form).not("[data-abide-ignore]").prop("checked", false).attr({
                    "data-invalid": null,
                    "aria-invalid": null
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(":input:checkbox", $form).not("[data-abide-ignore]").prop("checked", false).attr({
                    "data-invalid": null,
                    "aria-invalid": null
                });
                /**
       * Fires when the form has been reset.
       * @event Abide#formreset
       */ $form.trigger("formreset.zf.abide", [
                    $form
                ]);
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                var _this = this;
                this.$element.off(".abide").find("[data-abide-error]").css("display", "none");
                this.$inputs.off(".abide").each(function() {
                    _this.removeErrorClasses((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this));
                });
                this.$submits.off(".abide");
            }
        }
    ]);
    return Abide;
}($57aa6ed7a3256ce7$var$Plugin);
/**
 * Default settings for plugin
 */ $57aa6ed7a3256ce7$export$3d3f1ff3b6a4f356.defaults = {
    /**
   * The default event to validate inputs. Checkboxes and radios validate immediately.
   * Remove or change this value for manual validation.
   * @option
   * @type {?string}
   * @default 'fieldChange'
   */ validateOn: "fieldChange",
    /**
   * Class to be applied to input labels on failed validation.
   * @option
   * @type {string}
   * @default 'is-invalid-label'
   */ labelErrorClass: "is-invalid-label",
    /**
   * Class to be applied to inputs on failed validation.
   * @option
   * @type {string}
   * @default 'is-invalid-input'
   */ inputErrorClass: "is-invalid-input",
    /**
   * Class selector to use to target Form Errors for show/hide.
   * @option
   * @type {string}
   * @default '.form-error'
   */ formErrorSelector: ".form-error",
    /**
   * Class added to Form Errors on failed validation.
   * @option
   * @type {string}
   * @default 'is-visible'
   */ formErrorClass: "is-visible",
    /**
   * If true, automatically insert when possible:
   * - `[aria-describedby]` on fields
   * - `[role=alert]` on form errors and `[for]` on form error labels
   * - `[aria-live]` on global errors `[data-abide-error]` (see option `a11yErrorLevel`).
   * @option
   * @type {boolean}
   * @default true
   */ a11yAttributes: true,
    /**
   * [aria-live] attribute value to be applied on global errors `[data-abide-error]`.
   * Options are: 'assertive', 'polite' and 'off'/null
   * @option
   * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions
   * @type {string}
   * @default 'assertive'
   */ a11yErrorLevel: "assertive",
    /**
   * Set to true to validate text inputs on any value change.
   * @option
   * @type {boolean}
   * @default false
   */ liveValidate: false,
    /**
   * Set to true to validate inputs on blur.
   * @option
   * @type {boolean}
   * @default false
   */ validateOnBlur: false,
    patterns: {
        alpha: /^[a-zA-Z]+$/,
        // eslint-disable-next-line camelcase
        alpha_numeric: /^[a-zA-Z0-9]+$/,
        integer: /^[-+]?\d+$/,
        number: /^[-+]?\d*(?:[\.\,]\d+)?$/,
        // amex, visa, diners
        card: /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(?:222[1-9]|2[3-6][0-9]{2}|27[0-1][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
        cvv: /^([0-9]){3,4}$/,
        // http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#valid-e-mail-address
        email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
        // From CommonRegexJS (@talyssonoc)
        // https://github.com/talyssonoc/CommonRegexJS/blob/e2901b9f57222bc14069dc8f0598d5f412555411/lib/commonregex.js#L76
        // For more restrictive URL Regexs, see https://mathiasbynens.be/demo/url-regex.
        url: /^((?:(https?|ftps?|file|ssh|sftp):\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\))+(?:\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:\'".,<>?\xab\xbb\u201c\u201d\u2018\u2019]))$/,
        // abc.de
        domain: /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,8}$/,
        datetime: /^([0-2][0-9]{3})\-([0-1][0-9])\-([0-3][0-9])T([0-5][0-9])\:([0-5][0-9])\:([0-5][0-9])(Z|([\-\+]([0-1][0-9])\:00))$/,
        // YYYY-MM-DD
        date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/,
        // HH:MM:SS
        time: /^(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){2}$/,
        dateISO: /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/,
        // MM/DD/YYYY
        // eslint-disable-next-line camelcase
        month_day_year: /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.]\d{4}$/,
        // DD/MM/YYYY
        // eslint-disable-next-line camelcase
        day_month_year: /^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.]\d{4}$/,
        // #FFF or #FFFFFF
        color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
        // Domain || URL
        website: {
            test: function test(text) {
                return $57aa6ed7a3256ce7$export$3d3f1ff3b6a4f356.defaults.patterns.domain.test(text) || $57aa6ed7a3256ce7$export$3d3f1ff3b6a4f356.defaults.patterns.url.test(text);
            }
        }
    },
    /**
   * Optional validation functions to be used. `equalTo` being the only default included function.
   * Functions should return only a boolean if the input is valid or not. Functions are given the following arguments:
   * el : The jQuery element to validate.
   * @option
   */ validators: {
        equalTo: function equalTo(el) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(el.attr("data-equalto"))).val() === el.val();
        }
    }
};
/**
 * Accordion module.
 * @module foundation.accordion
 * @requires foundation.util.keyboard
 */ var $57aa6ed7a3256ce7$export$a766cd26d0d69044 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Accordion, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Accordion);
    function Accordion() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Accordion);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Accordion, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of an accordion.
     * @class
     * @name Accordion
     * @fires Accordion#init
     * @param {jQuery} element - jQuery object to make into an accordion.
     * @param {Object} options - a plain object with settings to override the default options.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Accordion.defaults, this.$element.data(), options);
                this.className = "Accordion"; // ie9 back compat
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("Accordion", {
                    "ENTER": "toggle",
                    "SPACE": "toggle",
                    "ARROW_DOWN": "next",
                    "ARROW_UP": "previous",
                    "HOME": "first",
                    "END": "last"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this2 = this;
                this._isInitializing = true;
                this.$tabs = this.$element.children("[data-accordion-item]");
                this.$tabs.each(function(idx, el) {
                    var $el = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el), $content = $el.children("[data-tab-content]"), id = $content[0].id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "accordion"), linkId = el.id ? "".concat(el.id, "-label") : "".concat(id, "-label");
                    $el.find("a:first").attr({
                        "aria-controls": id,
                        "id": linkId,
                        "aria-expanded": false
                    });
                    $content.attr({
                        "role": "region",
                        "aria-labelledby": linkId,
                        "aria-hidden": true,
                        "id": id
                    });
                });
                var $initActive = this.$element.find(".is-active").children("[data-tab-content]");
                if ($initActive.length) {
                    // Save up the initial hash to return to it later when going back in history
                    this._initialAnchor = $initActive.prev("a").attr("href");
                    this._openSingleTab($initActive);
                }
                this._checkDeepLink = function() {
                    var anchor = window.location.hash;
                    if (!anchor.length) {
                        // If we are still initializing and there is no anchor, then there is nothing to do
                        if (_this2._isInitializing) return;
                        // Otherwise, move to the initial anchor
                        if (_this2._initialAnchor) anchor = _this2._initialAnchor;
                    }
                    var $anchor = anchor && (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(anchor);
                    var $link = anchor && _this2.$element.find('[href$="'.concat(anchor, '"]'));
                    // Whether the anchor element that has been found is part of this element
                    var isOwnAnchor = !!($anchor.length && $link.length);
                    if (isOwnAnchor) {
                        // If there is an anchor for the hash, open it (if not already active)
                        if ($anchor && $link && $link.length) {
                            if (!$link.parent("[data-accordion-item]").hasClass("is-active")) _this2._openSingleTab($anchor);
                        } else _this2._closeAllTabs();
                        // Roll up a little to show the titles
                        if (_this2.options.deepLinkSmudge) $57aa6ed7a3256ce7$var$onLoad((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window), function() {
                            var offset = _this2.$element.offset();
                            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html, body").animate({
                                scrollTop: offset.top - _this2.options.deepLinkSmudgeOffset
                            }, _this2.options.deepLinkSmudgeDelay);
                        });
                        /**
           * Fires when the plugin has deeplinked at pageload
           * @event Accordion#deeplink
           */ _this2.$element.trigger("deeplink.zf.accordion", [
                            $link,
                            $anchor
                        ]);
                    }
                };
                //use browser to open a tab, if it exists in this tabset
                if (this.options.deepLink) this._checkDeepLink();
                this._events();
                this._isInitializing = false;
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this;
                this.$tabs.each(function() {
                    var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this);
                    var $tabContent = $elem.children("[data-tab-content]");
                    if ($tabContent.length) $elem.children("a").off("click.zf.accordion keydown.zf.accordion").on("click.zf.accordion", function(e) {
                        e.preventDefault();
                        _this.toggle($tabContent);
                    }).on("keydown.zf.accordion", function(e) {
                        $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "Accordion", {
                            toggle: function toggle() {
                                _this.toggle($tabContent);
                            },
                            next: function next() {
                                var $a = $elem.next().find("a").focus();
                                if (!_this.options.multiExpand) $a.trigger("click.zf.accordion");
                            },
                            previous: function previous() {
                                var $a = $elem.prev().find("a").focus();
                                if (!_this.options.multiExpand) $a.trigger("click.zf.accordion");
                            },
                            first: function first() {
                                var $a = _this.$tabs.first().find(".accordion-title").focus();
                                if (!_this.options.multiExpand) $a.trigger("click.zf.accordion");
                            },
                            last: function last() {
                                var $a = _this.$tabs.last().find(".accordion-title").focus();
                                if (!_this.options.multiExpand) $a.trigger("click.zf.accordion");
                            },
                            handled: function handled() {
                                e.preventDefault();
                            }
                        });
                    });
                });
                if (this.options.deepLink) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("hashchange", this._checkDeepLink);
            }
        },
        {
            key: "toggle",
            value: function toggle($target) {
                if ($target.closest("[data-accordion]").is("[disabled]")) {
                    console.info("Cannot toggle an accordion that is disabled.");
                    return;
                }
                if ($target.parent().hasClass("is-active")) this.up($target);
                else this.down($target);
                //either replace or update browser history
                if (this.options.deepLink) {
                    var anchor = $target.prev("a").attr("href");
                    if (this.options.updateHistory) history.pushState({}, "", anchor);
                    else history.replaceState({}, "", anchor);
                }
            }
        },
        {
            key: "down",
            value: function down($target) {
                if ($target.closest("[data-accordion]").is("[disabled]")) {
                    console.info("Cannot call down on an accordion that is disabled.");
                    return;
                }
                if (this.options.multiExpand) this._openTab($target);
                else this._openSingleTab($target);
            }
        },
        {
            key: "up",
            value: function up($target) {
                if (this.$element.is("[disabled]")) {
                    console.info("Cannot call up on an accordion that is disabled.");
                    return;
                }
                // Don't close the item if it is already closed
                var $targetItem = $target.parent();
                if (!$targetItem.hasClass("is-active")) return;
                // Don't close the item if there is no other active item (unless with `allowAllClosed`)
                var $othersItems = $targetItem.siblings();
                if (!this.options.allowAllClosed && !$othersItems.hasClass("is-active")) return;
                this._closeTab($target);
            }
        },
        {
            key: "_openSingleTab",
            value: function _openSingleTab($target) {
                // Close all the others active tabs.
                var $activeContents = this.$element.children(".is-active").children("[data-tab-content]");
                if ($activeContents.length) this._closeTab($activeContents.not($target));
                // Then open the target.
                this._openTab($target);
            }
        },
        {
            key: "_openTab",
            value: function _openTab($target) {
                var _this3 = this;
                var $targetItem = $target.parent();
                var targetContentId = $target.attr("aria-labelledby");
                $target.attr("aria-hidden", false);
                $targetItem.addClass("is-active");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(targetContentId)).attr({
                    "aria-expanded": true
                });
                $target.finish().slideDown(this.options.slideSpeed, function() {
                    /**
         * Fires when the tab is done opening.
         * @event Accordion#down
         */ _this3.$element.trigger("down.zf.accordion", [
                        $target
                    ]);
                });
            }
        },
        {
            key: "_closeTab",
            value: function _closeTab($target) {
                var _this4 = this;
                var $targetItem = $target.parent();
                var targetContentId = $target.attr("aria-labelledby");
                $target.attr("aria-hidden", true);
                $targetItem.removeClass("is-active");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(targetContentId)).attr({
                    "aria-expanded": false
                });
                $target.finish().slideUp(this.options.slideSpeed, function() {
                    /**
         * Fires when the tab is done collapsing up.
         * @event Accordion#up
         */ _this4.$element.trigger("up.zf.accordion", [
                        $target
                    ]);
                });
            }
        },
        {
            key: "_closeAllTabs",
            value: function _closeAllTabs() {
                var $activeTabs = this.$element.children(".is-active").children("[data-tab-content]");
                if ($activeTabs.length) this._closeTab($activeTabs);
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.find("[data-tab-content]").stop(true).slideUp(0).css("display", "");
                this.$element.find("a").off(".zf.accordion");
                if (this.options.deepLink) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off("hashchange", this._checkDeepLink);
            }
        }
    ]);
    return Accordion;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$a766cd26d0d69044.defaults = {
    /**
   * Amount of time to animate the opening of an accordion pane.
   * @option
   * @type {number}
   * @default 250
   */ slideSpeed: 250,
    /**
   * Allow the accordion to have multiple open panes.
   * @option
   * @type {boolean}
   * @default false
   */ multiExpand: false,
    /**
   * Allow the accordion to close all panes.
   * @option
   * @type {boolean}
   * @default false
   */ allowAllClosed: false,
    /**
   * Link the location hash to the open pane.
   * Set the location hash when the opened pane changes, and open and scroll to the corresponding pane when the location changes.
   * @option
   * @type {boolean}
   * @default false
   */ deepLink: false,
    /**
   * If `deepLink` is enabled, adjust the deep link scroll to make sure the top of the accordion panel is visible
   * @option
   * @type {boolean}
   * @default false
   */ deepLinkSmudge: false,
    /**
   * If `deepLinkSmudge` is enabled, animation time (ms) for the deep link adjustment
   * @option
   * @type {number}
   * @default 300
   */ deepLinkSmudgeDelay: 300,
    /**
   * If `deepLinkSmudge` is enabled, the offset for scrollToTtop to prevent overlap by a sticky element at the top of the page
   * @option
   * @type {number}
   * @default 0
   */ deepLinkSmudgeOffset: 0,
    /**
   * If `deepLink` is enabled, update the browser history with the open accordion
   * @option
   * @type {boolean}
   * @default false
   */ updateHistory: false
};
/**
 * AccordionMenu module.
 * @module foundation.accordionMenu
 * @requires foundation.util.keyboard
 * @requires foundation.util.nest
 */ var $57aa6ed7a3256ce7$export$6abe07ec29339e67 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(AccordionMenu, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(AccordionMenu);
    function AccordionMenu() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, AccordionMenu);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(AccordionMenu, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of an accordion menu.
     * @class
     * @name AccordionMenu
     * @fires AccordionMenu#init
     * @param {jQuery} element - jQuery object to make into an accordion menu.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, AccordionMenu.defaults, this.$element.data(), options);
                this.className = "AccordionMenu"; // ie9 back compat
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("AccordionMenu", {
                    "ENTER": "toggle",
                    "SPACE": "toggle",
                    "ARROW_RIGHT": "open",
                    "ARROW_UP": "up",
                    "ARROW_DOWN": "down",
                    "ARROW_LEFT": "close",
                    "ESCAPE": "closeAll"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b33048315ba1159e.Feather(this.$element, "accordion");
                var _this = this;
                this.$element.find("[data-submenu]").not(".is-active").slideUp(0); //.find('a').css('padding-left', '1rem');
                this.$element.attr({
                    "aria-multiselectable": this.options.multiOpen
                });
                this.$menuLinks = this.$element.find(".is-accordion-submenu-parent");
                this.$menuLinks.each(function() {
                    var linkId = this.id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "acc-menu-link"), $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), $sub = $elem.children("[data-submenu]"), subId = $sub[0].id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "acc-menu"), isActive = $sub.hasClass("is-active");
                    if (_this.options.parentLink) {
                        var $anchor = $elem.children("a");
                        $anchor.clone().prependTo($sub).wrap('<li data-is-parent-link class="is-submenu-parent-item is-submenu-item is-accordion-submenu-item"></li>');
                    }
                    if (_this.options.submenuToggle) {
                        $elem.addClass("has-submenu-toggle");
                        $elem.children("a").after('<button id="' + linkId + '" class="submenu-toggle" aria-controls="' + subId + '" aria-expanded="' + isActive + '" title="' + _this.options.submenuToggleText + '"><span class="submenu-toggle-text">' + _this.options.submenuToggleText + "</span></button>");
                    } else $elem.attr({
                        "aria-controls": subId,
                        "aria-expanded": isActive,
                        "id": linkId
                    });
                    $sub.attr({
                        "aria-labelledby": linkId,
                        "aria-hidden": !isActive,
                        "role": "group",
                        "id": subId
                    });
                });
                var initPanes = this.$element.find(".is-active");
                if (initPanes.length) initPanes.each(function() {
                    _this.down((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this));
                });
                this._events();
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this;
                this.$element.find("li").each(function() {
                    var $submenu = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).children("[data-submenu]");
                    if ($submenu.length) {
                        if (_this.options.submenuToggle) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).children(".submenu-toggle").off("click.zf.accordionMenu").on("click.zf.accordionMenu", function() {
                            _this.toggle($submenu);
                        });
                        else (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).children("a").off("click.zf.accordionMenu").on("click.zf.accordionMenu", function(e) {
                            e.preventDefault();
                            _this.toggle($submenu);
                        });
                    }
                }).on("keydown.zf.accordionMenu", function(e) {
                    var $element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), $elements = $element.parent("ul").children("li"), $prevElement, $nextElement, $target = $element.children("[data-submenu]");
                    $elements.each(function(i) {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).is($element)) {
                            $prevElement = $elements.eq(Math.max(0, i - 1)).find("a").first();
                            $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1)).find("a").first();
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).children("[data-submenu]:visible").length) // has open sub menu
                            $nextElement = $element.find("li:first-child").find("a").first();
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).is(":first-child")) // is first element of sub menu
                            $prevElement = $element.parents("li").first().find("a").first();
                            else if ($prevElement.parents("li").first().children("[data-submenu]:visible").length) // if previous element has open sub menu
                            $prevElement = $prevElement.parents("li").find("li:last-child").find("a").first();
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).is(":last-child")) // is last element of sub menu
                            $nextElement = $element.parents("li").first().next("li").find("a").first();
                            return;
                        }
                    });
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "AccordionMenu", {
                        open: function open() {
                            if ($target.is(":hidden")) {
                                _this.down($target);
                                $target.find("li").first().find("a").first().focus();
                            }
                        },
                        close: function close() {
                            if ($target.length && !$target.is(":hidden")) // close active sub of this item
                            _this.up($target);
                            else if ($element.parent("[data-submenu]").length) {
                                // close currently open sub
                                _this.up($element.parent("[data-submenu]"));
                                $element.parents("li").first().find("a").first().focus();
                            }
                        },
                        up: function up() {
                            $prevElement.focus();
                            return true;
                        },
                        down: function down() {
                            $nextElement.focus();
                            return true;
                        },
                        toggle: function toggle() {
                            if (_this.options.submenuToggle) return false;
                            if ($element.children("[data-submenu]").length) {
                                _this.toggle($element.children("[data-submenu]"));
                                return true;
                            }
                        },
                        closeAll: function closeAll() {
                            _this.hideAll();
                        },
                        handled: function handled(preventDefault) {
                            if (preventDefault) e.preventDefault();
                        }
                    });
                }); //.attr('tabindex', 0);
            }
        },
        {
            key: "hideAll",
            value: function hideAll() {
                this.up(this.$element.find("[data-submenu]"));
            }
        },
        {
            key: "showAll",
            value: function showAll() {
                this.down(this.$element.find("[data-submenu]"));
            }
        },
        {
            key: "toggle",
            value: function toggle($target) {
                if (!$target.is(":animated")) {
                    if (!$target.is(":hidden")) this.up($target);
                    else this.down($target);
                }
            }
        },
        {
            key: "down",
            value: function down($target) {
                var _this2 = this;
                // If having multiple submenus active is disabled, close all the submenus
                // that are not parents or children of the targeted submenu.
                if (!this.options.multiOpen) {
                    // The "branch" of the targetted submenu, from the component root to
                    // the active submenus nested in it.
                    var $targetBranch = $target.parentsUntil(this.$element).add($target).add($target.find(".is-active"));
                    // All the active submenus that are not in the branch.
                    var $othersActiveSubmenus = this.$element.find(".is-active").not($targetBranch);
                    this.up($othersActiveSubmenus);
                }
                $target.addClass("is-active").attr({
                    "aria-hidden": false
                });
                if (this.options.submenuToggle) $target.prev(".submenu-toggle").attr({
                    "aria-expanded": true
                });
                else $target.parent(".is-accordion-submenu-parent").attr({
                    "aria-expanded": true
                });
                $target.slideDown(this.options.slideSpeed, function() {
                    /**
         * Fires when the menu is done opening.
         * @event AccordionMenu#down
         */ _this2.$element.trigger("down.zf.accordionMenu", [
                        $target
                    ]);
                });
            }
        },
        {
            key: "up",
            value: function up($target) {
                var _this3 = this;
                var $submenus = $target.find("[data-submenu]");
                var $allmenus = $target.add($submenus);
                $submenus.slideUp(0);
                $allmenus.removeClass("is-active").attr("aria-hidden", true);
                if (this.options.submenuToggle) $allmenus.prev(".submenu-toggle").attr("aria-expanded", false);
                else $allmenus.parent(".is-accordion-submenu-parent").attr("aria-expanded", false);
                $target.slideUp(this.options.slideSpeed, function() {
                    /**
         * Fires when the menu is done collapsing up.
         * @event AccordionMenu#up
         */ _this3.$element.trigger("up.zf.accordionMenu", [
                        $target
                    ]);
                });
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.find("[data-submenu]").slideDown(0).css("display", "");
                this.$element.find("a").off("click.zf.accordionMenu");
                this.$element.find("[data-is-parent-link]").detach();
                if (this.options.submenuToggle) {
                    this.$element.find(".has-submenu-toggle").removeClass("has-submenu-toggle");
                    this.$element.find(".submenu-toggle").remove();
                }
                $57aa6ed7a3256ce7$export$b33048315ba1159e.Burn(this.$element, "accordion");
            }
        }
    ]);
    return AccordionMenu;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$6abe07ec29339e67.defaults = {
    /**
   * Adds the parent link to the submenu.
   * @option
   * @type {boolean}
   * @default false
   */ parentLink: false,
    /**
   * Amount of time to animate the opening of a submenu in ms.
   * @option
   * @type {number}
   * @default 250
   */ slideSpeed: 250,
    /**
   * Adds a separate submenu toggle button. This allows the parent item to have a link.
   * @option
   * @example true
   */ submenuToggle: false,
    /**
   * The text used for the submenu toggle if enabled. This is used for screen readers only.
   * @option
   * @example true
   */ submenuToggleText: "Toggle menu",
    /**
   * Allow the menu to have multiple open panes.
   * @option
   * @type {boolean}
   * @default true
   */ multiOpen: true
};
/**
 * Drilldown module.
 * @module foundation.drilldown
 * @requires foundation.util.keyboard
 * @requires foundation.util.nest
 * @requires foundation.util.box
 */ var $57aa6ed7a3256ce7$export$c039e4c66cecbe03 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Drilldown, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Drilldown);
    function Drilldown() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Drilldown);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Drilldown, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of a drilldown menu.
     * @class
     * @name Drilldown
     * @param {jQuery} element - jQuery object to make into an accordion menu.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Drilldown.defaults, this.$element.data(), options);
                this.className = "Drilldown"; // ie9 back compat
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("Drilldown", {
                    "ENTER": "open",
                    "SPACE": "open",
                    "ARROW_RIGHT": "next",
                    "ARROW_UP": "up",
                    "ARROW_DOWN": "down",
                    "ARROW_LEFT": "previous",
                    "ESCAPE": "close"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b33048315ba1159e.Feather(this.$element, "drilldown");
                if (this.options.autoApplyClass) this.$element.addClass("drilldown");
                this.$element.attr({
                    "aria-multiselectable": false
                });
                this.$submenuAnchors = this.$element.find("li.is-drilldown-submenu-parent").children("a");
                this.$submenus = this.$submenuAnchors.parent("li").children("[data-submenu]").attr("role", "group");
                this.$menuItems = this.$element.find("li").not(".js-drilldown-back").find("a");
                // Set the main menu as current by default (unless a submenu is selected)
                // Used to set the wrapper height when the drilldown is closed/reopened from any (sub)menu
                this.$currentMenu = this.$element;
                this.$element.attr("data-mutate", this.$element.attr("data-drilldown") || $57aa6ed7a3256ce7$var$GetYoDigits(6, "drilldown"));
                this._prepareMenu();
                this._registerEvents();
                this._keyboardEvents();
            }
        },
        {
            key: "_prepareMenu",
            value: function _prepareMenu() {
                var _this = this;
                // if(!this.options.holdOpen){
                //   this._menuLinkEvents();
                // }
                this.$submenuAnchors.each(function() {
                    var $link = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this);
                    var $sub = $link.parent();
                    if (_this.options.parentLink) $link.clone().prependTo($sub.children("[data-submenu]")).wrap('<li data-is-parent-link class="is-submenu-parent-item is-submenu-item is-drilldown-submenu-item" role="none"></li>');
                    $link.data("savedHref", $link.attr("href")).removeAttr("href").attr("tabindex", 0);
                    $link.children("[data-submenu]").attr({
                        "aria-hidden": true,
                        "tabindex": 0,
                        "role": "group"
                    });
                    _this._events($link);
                });
                this.$submenus.each(function() {
                    var $menu = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), $back = $menu.find(".js-drilldown-back");
                    if (!$back.length) switch(_this.options.backButtonPosition){
                        case "bottom":
                            $menu.append(_this.options.backButton);
                            break;
                        case "top":
                            $menu.prepend(_this.options.backButton);
                            break;
                        default:
                            console.error("Unsupported backButtonPosition value '" + _this.options.backButtonPosition + "'");
                    }
                    _this._back($menu);
                });
                this.$submenus.addClass("invisible");
                if (!this.options.autoHeight) this.$submenus.addClass("drilldown-submenu-cover-previous");
                // create a wrapper on element if it doesn't exist.
                if (!this.$element.parent().hasClass("is-drilldown")) {
                    this.$wrapper = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.options.wrapper).addClass("is-drilldown");
                    if (this.options.animateHeight) this.$wrapper.addClass("animate-height");
                    this.$element.wrap(this.$wrapper);
                }
                // set wrapper
                this.$wrapper = this.$element.parent();
                this.$wrapper.css(this._getMaxDims());
            }
        },
        {
            key: "_resize",
            value: function _resize() {
                this.$wrapper.css({
                    "max-width": "none",
                    "min-height": "none"
                });
                // _getMaxDims has side effects (boo) but calling it should update all other necessary heights & widths
                this.$wrapper.css(this._getMaxDims());
            }
        },
        {
            key: "_events",
            value: function _events($elem) {
                var _this = this;
                $elem.off("click.zf.drilldown").on("click.zf.drilldown", function(e) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target).parentsUntil("ul", "li").hasClass("is-drilldown-submenu-parent")) e.preventDefault();
                    // if(e.target !== e.currentTarget.firstElementChild){
                    //   return false;
                    // }
                    _this._show($elem.parent("li"));
                    if (_this.options.closeOnClick) {
                        var $body = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body");
                        $body.off(".zf.drilldown").on("click.zf.drilldown", function(ev) {
                            if (ev.target === _this.$element[0] || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).contains(_this.$element[0], ev.target)) return;
                            ev.preventDefault();
                            _this._hideAll();
                            $body.off(".zf.drilldown");
                        });
                    }
                });
            }
        },
        {
            key: "_registerEvents",
            value: function _registerEvents() {
                if (this.options.scrollTop) {
                    this._bindHandler = this._scrollTop.bind(this);
                    this.$element.on("open.zf.drilldown hide.zf.drilldown close.zf.drilldown closed.zf.drilldown", this._bindHandler);
                }
                this.$element.on("mutateme.zf.trigger", this._resize.bind(this));
            }
        },
        {
            key: "_scrollTop",
            value: function _scrollTop() {
                var _this = this;
                var $scrollTopElement = _this.options.scrollTopElement !== "" ? (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(_this.options.scrollTopElement) : _this.$element, scrollPos = parseInt($scrollTopElement.offset().top + _this.options.scrollTopOffset, 10);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html, body").stop(true).animate({
                    scrollTop: scrollPos
                }, _this.options.animationDuration, _this.options.animationEasing, function() {
                    /**
          * Fires after the menu has scrolled
          * @event Drilldown#scrollme
          */ if (this === (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html")[0]) _this.$element.trigger("scrollme.zf.drilldown");
                });
            }
        },
        {
            key: "_keyboardEvents",
            value: function _keyboardEvents() {
                var _this = this;
                this.$menuItems.add(this.$element.find(".js-drilldown-back > a, .is-submenu-parent-item > a")).on("keydown.zf.drilldown", function(e) {
                    var $element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), $elements = $element.parent("li").parent("ul").children("li").children("a"), $prevElement, $nextElement;
                    $elements.each(function(i) {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).is($element)) {
                            $prevElement = $elements.eq(Math.max(0, i - 1));
                            $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1));
                            return;
                        }
                    });
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "Drilldown", {
                        next: function next() {
                            if ($element.is(_this.$submenuAnchors)) {
                                _this._show($element.parent("li"));
                                $element.parent("li").one($57aa6ed7a3256ce7$var$transitionend($element), function() {
                                    $element.parent("li").find("ul li a").not(".js-drilldown-back a").first().focus();
                                });
                                return true;
                            }
                        },
                        previous: function previous() {
                            _this._hide($element.parent("li").parent("ul"));
                            $element.parent("li").parent("ul").one($57aa6ed7a3256ce7$var$transitionend($element), function() {
                                setTimeout(function() {
                                    $element.parent("li").parent("ul").parent("li").children("a").first().focus();
                                }, 1);
                            });
                            return true;
                        },
                        up: function up() {
                            $prevElement.focus();
                            // Don't tap focus on first element in root ul
                            return !$element.is(_this.$element.find("> li:first-child > a"));
                        },
                        down: function down() {
                            $nextElement.focus();
                            // Don't tap focus on last element in root ul
                            return !$element.is(_this.$element.find("> li:last-child > a"));
                        },
                        close: function close() {
                            // Don't close on element in root ul
                            if (!$element.is(_this.$element.find("> li > a"))) {
                                _this._hide($element.parent().parent());
                                $element.parent().parent().siblings("a").focus();
                            }
                        },
                        open: function open() {
                            if (_this.options.parentLink && $element.attr("href")) // Link with href
                            return false;
                            else if (!$element.is(_this.$menuItems)) {
                                // not menu item means back button
                                _this._hide($element.parent("li").parent("ul"));
                                $element.parent("li").parent("ul").one($57aa6ed7a3256ce7$var$transitionend($element), function() {
                                    setTimeout(function() {
                                        $element.parent("li").parent("ul").parent("li").children("a").first().focus();
                                    }, 1);
                                });
                                return true;
                            } else if ($element.is(_this.$submenuAnchors)) {
                                // Sub menu item
                                _this._show($element.parent("li"));
                                $element.parent("li").one($57aa6ed7a3256ce7$var$transitionend($element), function() {
                                    $element.parent("li").find("ul li a").not(".js-drilldown-back a").first().focus();
                                });
                                return true;
                            }
                        },
                        handled: function handled(preventDefault) {
                            if (preventDefault) e.preventDefault();
                        }
                    });
                }); // end keyboardAccess
            }
        },
        {
            key: "_hideAll",
            value: function _hideAll() {
                var _this2 = this;
                var $elem = this.$element.find(".is-drilldown-submenu.is-active");
                $elem.addClass("is-closing");
                $elem.parent().closest("ul").removeClass("invisible");
                if (this.options.autoHeight) {
                    var calcHeight = $elem.parent().closest("ul").data("calcHeight");
                    this.$wrapper.css({
                        height: calcHeight
                    });
                }
                /**
       * Fires when the menu is closing.
       * @event Drilldown#close
       */ this.$element.trigger("close.zf.drilldown");
                $elem.one($57aa6ed7a3256ce7$var$transitionend($elem), function() {
                    $elem.removeClass("is-active is-closing");
                    /**
         * Fires when the menu is fully closed.
         * @event Drilldown#closed
         */ _this2.$element.trigger("closed.zf.drilldown");
                });
            }
        },
        {
            key: "_back",
            value: function _back($elem) {
                var _this = this;
                $elem.off("click.zf.drilldown");
                $elem.children(".js-drilldown-back").on("click.zf.drilldown", function() {
                    _this._hide($elem);
                    // If there is a parent submenu, call show
                    var parentSubMenu = $elem.parent("li").parent("ul").parent("li");
                    if (parentSubMenu.length) _this._show(parentSubMenu);
                    else _this.$currentMenu = _this.$element;
                });
            }
        },
        {
            key: "_menuLinkEvents",
            value: function _menuLinkEvents() {
                var _this = this;
                this.$menuItems.not(".is-drilldown-submenu-parent").off("click.zf.drilldown").on("click.zf.drilldown", function() {
                    setTimeout(function() {
                        _this._hideAll();
                    }, 0);
                });
            }
        },
        {
            key: "_setShowSubMenuClasses",
            value: function _setShowSubMenuClasses($elem, trigger) {
                $elem.addClass("is-active").removeClass("invisible").attr("aria-hidden", false);
                $elem.parent("li").attr("aria-expanded", true);
                if (trigger === true) this.$element.trigger("open.zf.drilldown", [
                    $elem
                ]);
            }
        },
        {
            key: "_setHideSubMenuClasses",
            value: function _setHideSubMenuClasses($elem, trigger) {
                $elem.removeClass("is-active").addClass("invisible").attr("aria-hidden", true);
                $elem.parent("li").attr("aria-expanded", false);
                if (trigger === true) $elem.trigger("hide.zf.drilldown", [
                    $elem
                ]);
            }
        },
        {
            key: "_showMenu",
            value: function _showMenu($elem, autoFocus) {
                var _this = this;
                // Reset drilldown
                var $expandedSubmenus = this.$element.find('li[aria-expanded="true"] > ul[data-submenu]');
                $expandedSubmenus.each(function() {
                    _this._setHideSubMenuClasses((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this));
                });
                // Save the menu as the currently displayed one.
                this.$currentMenu = $elem;
                // If target menu is root, focus first link & exit
                if ($elem.is("[data-drilldown]")) {
                    if (autoFocus === true) $elem.find("li > a").first().focus();
                    if (this.options.autoHeight) this.$wrapper.css("height", $elem.data("calcHeight"));
                    return;
                }
                // Find all submenus on way to root incl. the element itself
                var $submenus = $elem.children().first().parentsUntil("[data-drilldown]", "[data-submenu]");
                // Open target menu and all submenus on its way to root
                $submenus.each(function(index) {
                    // Update height of first child (target menu) if autoHeight option true
                    if (index === 0 && _this.options.autoHeight) _this.$wrapper.css("height", (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("calcHeight"));
                    var isLastChild = index === $submenus.length - 1;
                    // Add transitionsend listener to last child (root due to reverse order) to open target menu's first link
                    // Last child makes sure the event gets always triggered even if going through several menus
                    if (isLastChild === true) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).one($57aa6ed7a3256ce7$var$transitionend((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this)), function() {
                        if (autoFocus === true) $elem.find("li > a").first().focus();
                    });
                    _this._setShowSubMenuClasses((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), isLastChild);
                });
            }
        },
        {
            key: "_show",
            value: function _show($elem) {
                var $submenu = $elem.children("[data-submenu]");
                $elem.attr("aria-expanded", true);
                this.$currentMenu = $submenu;
                //hide drilldown parent menu when submenu is open
                // this removes it from the dom so that the tab key will take the user to the next visible element
                $elem.parent().closest("ul").addClass("invisible");
                // add visible class to submenu to override invisible class above
                $submenu.addClass("is-active visible").removeClass("invisible").attr("aria-hidden", false);
                if (this.options.autoHeight) this.$wrapper.css({
                    height: $submenu.data("calcHeight")
                });
                /**
       * Fires when the submenu has opened.
       * @event Drilldown#open
       */ this.$element.trigger("open.zf.drilldown", [
                    $elem
                ]);
            }
        },
        {
            key: "_hide",
            value: function _hide($elem) {
                if (this.options.autoHeight) this.$wrapper.css({
                    height: $elem.parent().closest("ul").data("calcHeight")
                });
                $elem.parent().closest("ul").removeClass("invisible");
                $elem.parent("li").attr("aria-expanded", false);
                $elem.attr("aria-hidden", true);
                $elem.addClass("is-closing").one($57aa6ed7a3256ce7$var$transitionend($elem), function() {
                    $elem.removeClass("is-active is-closing visible");
                    $elem.blur().addClass("invisible");
                });
                /**
       * Fires when the submenu has closed.
       * @event Drilldown#hide
       */ $elem.trigger("hide.zf.drilldown", [
                    $elem
                ]);
            }
        },
        {
            key: "_getMaxDims",
            value: function _getMaxDims() {
                var maxHeight = 0, result = {}, _this = this;
                // Recalculate menu heights and total max height
                this.$submenus.add(this.$element).each(function() {
                    var height = $57aa6ed7a3256ce7$export$e71c4d32a2263218.GetDimensions(this).height;
                    maxHeight = height > maxHeight ? height : maxHeight;
                    if (_this.options.autoHeight) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("calcHeight", height);
                });
                if (this.options.autoHeight) result.height = this.$currentMenu.data("calcHeight");
                else result["min-height"] = "".concat(maxHeight, "px");
                result["max-width"] = "".concat(this.$element[0].getBoundingClientRect().width, "px");
                return result;
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").off(".zf.drilldown");
                if (this.options.scrollTop) this.$element.off(".zf.drilldown", this._bindHandler);
                this._hideAll();
                this.$element.off("mutateme.zf.trigger");
                $57aa6ed7a3256ce7$export$b33048315ba1159e.Burn(this.$element, "drilldown");
                this.$element.unwrap().find(".js-drilldown-back, .is-submenu-parent-item").remove().end().find(".is-active, .is-closing, .is-drilldown-submenu").removeClass("is-active is-closing is-drilldown-submenu").off("transitionend otransitionend webkitTransitionEnd").end().find("[data-submenu]").removeAttr("aria-hidden tabindex role");
                this.$submenuAnchors.each(function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).off(".zf.drilldown");
                });
                this.$element.find("[data-is-parent-link]").detach();
                this.$submenus.removeClass("drilldown-submenu-cover-previous invisible");
                this.$element.find("a").each(function() {
                    var $link = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this);
                    $link.removeAttr("tabindex");
                    if ($link.data("savedHref")) $link.attr("href", $link.data("savedHref")).removeData("savedHref");
                    else return;
                });
            }
        }
    ]);
    return Drilldown;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$c039e4c66cecbe03.defaults = {
    /**
   * Drilldowns depend on styles in order to function properly; in the default build of Foundation these are
   * on the `drilldown` class. This option auto-applies this class to the drilldown upon initialization.
   * @option
   * @type {boolean}
   * @default true
   */ autoApplyClass: true,
    /**
   * Markup used for JS generated back button. Prepended  or appended (see backButtonPosition) to submenu lists and deleted on `destroy` method, 'js-drilldown-back' class required. Remove the backslash (`\`) if copy and pasting.
   * @option
   * @type {string}
   * @default '<li class="js-drilldown-back"><a tabindex="0">Back</a></li>'
   */ backButton: '<li class="js-drilldown-back"><a tabindex="0">Back</a></li>',
    /**
   * Position the back button either at the top or bottom of drilldown submenus. Can be `'left'` or `'bottom'`.
   * @option
   * @type {string}
   * @default top
   */ backButtonPosition: "top",
    /**
   * Markup used to wrap drilldown menu. Use a class name for independent styling; the JS applied class: `is-drilldown` is required. Remove the backslash (`\`) if copy and pasting.
   * @option
   * @type {string}
   * @default '<div></div>'
   */ wrapper: "<div></div>",
    /**
   * Adds the parent link to the submenu.
   * @option
   * @type {boolean}
   * @default false
   */ parentLink: false,
    /**
   * Allow the menu to return to root list on body click.
   * @option
   * @type {boolean}
   * @default false
   */ closeOnClick: false,
    /**
   * Allow the menu to auto adjust height.
   * @option
   * @type {boolean}
   * @default false
   */ autoHeight: false,
    /**
   * Animate the auto adjust height.
   * @option
   * @type {boolean}
   * @default false
   */ animateHeight: false,
    /**
   * Scroll to the top of the menu after opening a submenu or navigating back using the menu back button
   * @option
   * @type {boolean}
   * @default false
   */ scrollTop: false,
    /**
   * String jquery selector (for example 'body') of element to take offset().top from, if empty string the drilldown menu offset().top is taken
   * @option
   * @type {string}
   * @default ''
   */ scrollTopElement: "",
    /**
   * ScrollTop offset
   * @option
   * @type {number}
   * @default 0
   */ scrollTopOffset: 0,
    /**
   * Scroll animation duration
   * @option
   * @type {number}
   * @default 500
   */ animationDuration: 500,
    /**
   * Scroll animation easing. Can be `'swing'` or `'linear'`.
   * @option
   * @type {string}
   * @see {@link https://api.jquery.com/animate|JQuery animate}
   * @default 'swing'
   */ animationEasing: "swing"
};
var $57aa6ed7a3256ce7$var$POSITIONS = [
    "left",
    "right",
    "top",
    "bottom"
];
var $57aa6ed7a3256ce7$var$VERTICAL_ALIGNMENTS = [
    "top",
    "bottom",
    "center"
];
var $57aa6ed7a3256ce7$var$HORIZONTAL_ALIGNMENTS = [
    "left",
    "right",
    "center"
];
var $57aa6ed7a3256ce7$var$ALIGNMENTS = {
    "left": $57aa6ed7a3256ce7$var$VERTICAL_ALIGNMENTS,
    "right": $57aa6ed7a3256ce7$var$VERTICAL_ALIGNMENTS,
    "top": $57aa6ed7a3256ce7$var$HORIZONTAL_ALIGNMENTS,
    "bottom": $57aa6ed7a3256ce7$var$HORIZONTAL_ALIGNMENTS
};
function $57aa6ed7a3256ce7$var$nextItem(item, array) {
    var currentIdx = array.indexOf(item);
    if (currentIdx === array.length - 1) return array[0];
    else return array[currentIdx + 1];
}
var $57aa6ed7a3256ce7$var$Positionable = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Positionable, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Positionable);
    function Positionable() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Positionable);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Positionable, [
        {
            key: "_init",
            value: /**
     * Abstract class encapsulating the tether-like explicit positioning logic
     * including repositioning based on overlap.
     * Expects classes to define defaults for vOffset, hOffset, position,
     * alignment, allowOverlap, and allowBottomOverlap. They can do this by
     * extending the defaults, or (for now recommended due to the way docs are
     * generated) by explicitly declaring them.
     *
     **/ function _init() {
                this.triedPositions = {};
                this.position = this.options.position === "auto" ? this._getDefaultPosition() : this.options.position;
                this.alignment = this.options.alignment === "auto" ? this._getDefaultAlignment() : this.options.alignment;
                this.originalPosition = this.position;
                this.originalAlignment = this.alignment;
            }
        },
        {
            key: "_getDefaultPosition",
            value: function _getDefaultPosition() {
                return "bottom";
            }
        },
        {
            key: "_getDefaultAlignment",
            value: function _getDefaultAlignment() {
                switch(this.position){
                    case "bottom":
                    case "top":
                        return $57aa6ed7a3256ce7$var$rtl() ? "right" : "left";
                    case "left":
                    case "right":
                        return "bottom";
                }
            }
        },
        {
            key: "_reposition",
            value: function _reposition() {
                if (this._alignmentsExhausted(this.position)) {
                    this.position = $57aa6ed7a3256ce7$var$nextItem(this.position, $57aa6ed7a3256ce7$var$POSITIONS);
                    this.alignment = $57aa6ed7a3256ce7$var$ALIGNMENTS[this.position][0];
                } else this._realign();
            }
        },
        {
            key: "_realign",
            value: function _realign() {
                this._addTriedPosition(this.position, this.alignment);
                this.alignment = $57aa6ed7a3256ce7$var$nextItem(this.alignment, $57aa6ed7a3256ce7$var$ALIGNMENTS[this.position]);
            }
        },
        {
            key: "_addTriedPosition",
            value: function _addTriedPosition(position, alignment) {
                this.triedPositions[position] = this.triedPositions[position] || [];
                this.triedPositions[position].push(alignment);
            }
        },
        {
            key: "_positionsExhausted",
            value: function _positionsExhausted() {
                var isExhausted = true;
                for(var i = 0; i < $57aa6ed7a3256ce7$var$POSITIONS.length; i++)isExhausted = isExhausted && this._alignmentsExhausted($57aa6ed7a3256ce7$var$POSITIONS[i]);
                return isExhausted;
            }
        },
        {
            key: "_alignmentsExhausted",
            value: function _alignmentsExhausted(position) {
                return this.triedPositions[position] && this.triedPositions[position].length === $57aa6ed7a3256ce7$var$ALIGNMENTS[position].length;
            }
        },
        {
            key: "_getVOffset",
            value: function _getVOffset() {
                return this.options.vOffset;
            }
        },
        {
            key: "_getHOffset",
            value: function _getHOffset() {
                return this.options.hOffset;
            }
        },
        {
            key: "_setPosition",
            value: function _setPosition($anchor, $element, $parent) {
                if ($anchor.attr("aria-expanded") === "false") return false;
                if (!this.options.allowOverlap) {
                    // restore original position & alignment before checking overlap
                    this.position = this.originalPosition;
                    this.alignment = this.originalAlignment;
                }
                $element.offset($57aa6ed7a3256ce7$export$e71c4d32a2263218.GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
                if (!this.options.allowOverlap) {
                    var minOverlap = 100000000;
                    // default coordinates to how we start, in case we can't figure out better
                    var minCoordinates = {
                        position: this.position,
                        alignment: this.alignment
                    };
                    while(!this._positionsExhausted()){
                        var overlap = $57aa6ed7a3256ce7$export$e71c4d32a2263218.OverlapArea($element, $parent, false, false, this.options.allowBottomOverlap);
                        if (overlap === 0) return;
                        if (overlap < minOverlap) {
                            minOverlap = overlap;
                            minCoordinates = {
                                position: this.position,
                                alignment: this.alignment
                            };
                        }
                        this._reposition();
                        $element.offset($57aa6ed7a3256ce7$export$e71c4d32a2263218.GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
                    }
                    // If we get through the entire loop, there was no non-overlapping
                    // position available. Pick the version with least overlap.
                    this.position = minCoordinates.position;
                    this.alignment = minCoordinates.alignment;
                    $element.offset($57aa6ed7a3256ce7$export$e71c4d32a2263218.GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
                }
            }
        }
    ]);
    return Positionable;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$var$Positionable.defaults = {
    /**
   * Position of positionable relative to anchor. Can be left, right, bottom, top, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */ position: "auto",
    /**
   * Alignment of positionable relative to anchor. Can be left, right, bottom, top, center, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */ alignment: "auto",
    /**
   * Allow overlap of container/window. If false, dropdown positionable first
   * try to position as defined by data-position and data-alignment, but
   * reposition if it would cause an overflow.
   * @option
   * @type {boolean}
   * @default false
   */ allowOverlap: false,
    /**
   * Allow overlap of only the bottom of the container. This is the most common
   * behavior for dropdowns, allowing the dropdown to extend the bottom of the
   * screen but not otherwise influence or break out of the container.
   * @option
   * @type {boolean}
   * @default true
   */ allowBottomOverlap: true,
    /**
   * Number of pixels the positionable should be separated vertically from anchor
   * @option
   * @type {number}
   * @default 0
   */ vOffset: 0,
    /**
   * Number of pixels the positionable should be separated horizontally from anchor
   * @option
   * @type {number}
   * @default 0
   */ hOffset: 0
};
/**
 * Dropdown module.
 * @module foundation.dropdown
 * @requires foundation.util.keyboard
 * @requires foundation.util.box
 * @requires foundation.util.touch
 * @requires foundation.util.triggers
 */ var $57aa6ed7a3256ce7$export$931cbfb6bfb85fc = /*#__PURE__*/ function(_Positionable) {
    $57aa6ed7a3256ce7$var$_inherits(Dropdown, _Positionable);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Dropdown);
    function Dropdown() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Dropdown);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Dropdown, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of a dropdown.
     * @class
     * @name Dropdown
     * @param {jQuery} element - jQuery object to make into a dropdown.
     *        Object should be of the dropdown panel, rather than its anchor.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Dropdown.defaults, this.$element.data(), options);
                this.className = "Dropdown"; // ie9 back compat
                // Touch and Triggers init are idempotent, just need to make sure they are initialized
                $57aa6ed7a3256ce7$export$746b04bbf92762fd.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("Dropdown", {
                    "ENTER": "toggle",
                    "SPACE": "toggle",
                    "ESCAPE": "close"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                var $id = this.$element.attr("id");
                this.$anchors = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-toggle="'.concat($id, '"]')).length ? (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-toggle="'.concat($id, '"]')) : (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-open="'.concat($id, '"]'));
                this.$anchors.attr({
                    "aria-controls": $id,
                    "data-is-focus": false,
                    "data-yeti-box": $id,
                    "aria-haspopup": true,
                    "aria-expanded": false
                });
                this._setCurrentAnchor(this.$anchors.first());
                if (this.options.parentClass) this.$parent = this.$element.parents("." + this.options.parentClass);
                else this.$parent = null;
                // Set [aria-labelledby] on the Dropdown if it is not set
                if (typeof this.$element.attr("aria-labelledby") === "undefined") {
                    // Get the anchor ID or create one
                    if (typeof this.$currentAnchor.attr("id") === "undefined") this.$currentAnchor.attr("id", $57aa6ed7a3256ce7$var$GetYoDigits(6, "dd-anchor"));
                    this.$element.attr("aria-labelledby", this.$currentAnchor.attr("id"));
                }
                this.$element.attr({
                    "aria-hidden": "true",
                    "data-yeti-box": $id,
                    "data-resize": $id
                });
                $57aa6ed7a3256ce7$var$_get($57aa6ed7a3256ce7$var$_getPrototypeOf(Dropdown.prototype), "_init", this).call(this);
                this._events();
            }
        },
        {
            key: "_getDefaultPosition",
            value: function _getDefaultPosition() {
                // handle legacy classnames
                var position = this.$element[0].className.match(/(top|left|right|bottom)/g);
                if (position) return position[0];
                else return "bottom";
            }
        },
        {
            key: "_getDefaultAlignment",
            value: function _getDefaultAlignment() {
                // handle legacy float approach
                var horizontalPosition = /float-(\S+)/.exec(this.$currentAnchor.attr("class"));
                if (horizontalPosition) return horizontalPosition[1];
                return $57aa6ed7a3256ce7$var$_get($57aa6ed7a3256ce7$var$_getPrototypeOf(Dropdown.prototype), "_getDefaultAlignment", this).call(this);
            }
        },
        {
            key: "_setPosition",
            value: function _setPosition() {
                this.$element.removeClass("has-position-".concat(this.position, " has-alignment-").concat(this.alignment));
                $57aa6ed7a3256ce7$var$_get($57aa6ed7a3256ce7$var$_getPrototypeOf(Dropdown.prototype), "_setPosition", this).call(this, this.$currentAnchor, this.$element, this.$parent);
                this.$element.addClass("has-position-".concat(this.position, " has-alignment-").concat(this.alignment));
            }
        },
        {
            key: "_setCurrentAnchor",
            value: function _setCurrentAnchor(el) {
                this.$currentAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el);
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this, hasTouch = "ontouchstart" in window || typeof window.ontouchstart !== "undefined";
                this.$element.on({
                    "open.zf.trigger": this.open.bind(this),
                    "close.zf.trigger": this.close.bind(this),
                    "toggle.zf.trigger": this.toggle.bind(this),
                    "resizeme.zf.trigger": this._setPosition.bind(this)
                });
                this.$anchors.off("click.zf.trigger").on("click.zf.trigger", function(e) {
                    _this._setCurrentAnchor(this);
                    if (// if forceFollow false, always prevent default action
                    _this.options.forceFollow === false || // if forceFollow true and hover option true, only prevent default action on 1st click
                    // on 2nd click (dropown opened) the default action (e.g. follow a href) gets executed
                    hasTouch && _this.options.hover && _this.$element.hasClass("is-open") === false) e.preventDefault();
                });
                if (this.options.hover) {
                    this.$anchors.off("mouseenter.zf.dropdown mouseleave.zf.dropdown").on("mouseenter.zf.dropdown", function() {
                        _this._setCurrentAnchor(this);
                        var bodyData = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").data();
                        if (typeof bodyData.whatinput === "undefined" || bodyData.whatinput === "mouse") {
                            clearTimeout(_this.timeout);
                            _this.timeout = setTimeout(function() {
                                _this.open();
                                _this.$anchors.data("hover", true);
                            }, _this.options.hoverDelay);
                        }
                    }).on("mouseleave.zf.dropdown", $57aa6ed7a3256ce7$var$ignoreMousedisappear(function() {
                        clearTimeout(_this.timeout);
                        _this.timeout = setTimeout(function() {
                            _this.close();
                            _this.$anchors.data("hover", false);
                        }, _this.options.hoverDelay);
                    }));
                    if (this.options.hoverPane) this.$element.off("mouseenter.zf.dropdown mouseleave.zf.dropdown").on("mouseenter.zf.dropdown", function() {
                        clearTimeout(_this.timeout);
                    }).on("mouseleave.zf.dropdown", $57aa6ed7a3256ce7$var$ignoreMousedisappear(function() {
                        clearTimeout(_this.timeout);
                        _this.timeout = setTimeout(function() {
                            _this.close();
                            _this.$anchors.data("hover", false);
                        }, _this.options.hoverDelay);
                    }));
                }
                this.$anchors.add(this.$element).on("keydown.zf.dropdown", function(e) {
                    var $target = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this);
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "Dropdown", {
                        open: function open() {
                            if ($target.is(_this.$anchors) && !$target.is("input, textarea")) {
                                _this.open();
                                _this.$element.attr("tabindex", -1).focus();
                                e.preventDefault();
                            }
                        },
                        close: function close() {
                            _this.close();
                            _this.$anchors.focus();
                        }
                    });
                });
            }
        },
        {
            key: "_addBodyHandler",
            value: function _addBodyHandler() {
                var $body = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document.body).not(this.$element), _this = this;
                $body.off("click.zf.dropdown tap.zf.dropdown").on("click.zf.dropdown tap.zf.dropdown", function(e) {
                    if (_this.$anchors.is(e.target) || _this.$anchors.find(e.target).length) return;
                    if (_this.$element.is(e.target) || _this.$element.find(e.target).length) return;
                    _this.close();
                    $body.off("click.zf.dropdown tap.zf.dropdown");
                });
            }
        },
        {
            key: "open",
            value: function open() {
                // var _this = this;
                /**
       * Fires to close other open dropdowns, typically when dropdown is opening
       * @event Dropdown#closeme
       */ this.$element.trigger("closeme.zf.dropdown", this.$element.attr("id"));
                this.$anchors.addClass("hover").attr({
                    "aria-expanded": true
                });
                // this.$element/*.show()*/;
                this.$element.addClass("is-opening");
                this._setPosition();
                this.$element.removeClass("is-opening").addClass("is-open").attr({
                    "aria-hidden": false
                });
                if (this.options.autoFocus) {
                    var $focusable = $57aa6ed7a3256ce7$export$16e4d70cc375e707.findFocusable(this.$element);
                    if ($focusable.length) $focusable.eq(0).focus();
                }
                if (this.options.closeOnClick) this._addBodyHandler();
                if (this.options.trapFocus) $57aa6ed7a3256ce7$export$16e4d70cc375e707.trapFocus(this.$element);
                /**
       * Fires once the dropdown is visible.
       * @event Dropdown#show
       */ this.$element.trigger("show.zf.dropdown", [
                    this.$element
                ]);
            }
        },
        {
            key: "close",
            value: function close() {
                if (!this.$element.hasClass("is-open")) return false;
                this.$element.removeClass("is-open").attr({
                    "aria-hidden": true
                });
                this.$anchors.removeClass("hover").attr("aria-expanded", false);
                /**
       * Fires once the dropdown is no longer visible.
       * @event Dropdown#hide
       */ this.$element.trigger("hide.zf.dropdown", [
                    this.$element
                ]);
                if (this.options.trapFocus) $57aa6ed7a3256ce7$export$16e4d70cc375e707.releaseFocus(this.$element);
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (this.$element.hasClass("is-open")) {
                    if (this.$anchors.data("hover")) return;
                    this.close();
                } else this.open();
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.off(".zf.trigger").hide();
                this.$anchors.off(".zf.dropdown");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document.body).off("click.zf.dropdown tap.zf.dropdown");
            }
        }
    ]);
    return Dropdown;
}($57aa6ed7a3256ce7$var$Positionable);
$57aa6ed7a3256ce7$export$931cbfb6bfb85fc.defaults = {
    /**
   * Class that designates bounding container of Dropdown (default: window)
   * @option
   * @type {?string}
   * @default null
   */ parentClass: null,
    /**
   * Amount of time to delay opening a submenu on hover event.
   * @option
   * @type {number}
   * @default 250
   */ hoverDelay: 250,
    /**
   * Allow submenus to open on hover events
   * @option
   * @type {boolean}
   * @default false
   */ hover: false,
    /**
   * Don't close dropdown when hovering over dropdown pane
   * @option
   * @type {boolean}
   * @default false
   */ hoverPane: false,
    /**
   * Number of pixels between the dropdown pane and the triggering element on open.
   * @option
   * @type {number}
   * @default 0
   */ vOffset: 0,
    /**
   * Number of pixels between the dropdown pane and the triggering element on open.
   * @option
   * @type {number}
   * @default 0
   */ hOffset: 0,
    /**
   * Position of dropdown. Can be left, right, bottom, top, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */ position: "auto",
    /**
   * Alignment of dropdown relative to anchor. Can be left, right, bottom, top, center, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */ alignment: "auto",
    /**
   * Allow overlap of container/window. If false, dropdown will first try to position as defined by data-position and data-alignment, but reposition if it would cause an overflow.
   * @option
   * @type {boolean}
   * @default false
   */ allowOverlap: false,
    /**
   * Allow overlap of only the bottom of the container. This is the most common
   * behavior for dropdowns, allowing the dropdown to extend the bottom of the
   * screen but not otherwise influence or break out of the container.
   * @option
   * @type {boolean}
   * @default true
   */ allowBottomOverlap: true,
    /**
   * Allow the plugin to trap focus to the dropdown pane if opened with keyboard commands.
   * @option
   * @type {boolean}
   * @default false
   */ trapFocus: false,
    /**
   * Allow the plugin to set focus to the first focusable element within the pane, regardless of method of opening.
   * @option
   * @type {boolean}
   * @default false
   */ autoFocus: false,
    /**
   * Allows a click on the body to close the dropdown.
   * @option
   * @type {boolean}
   * @default false
   */ closeOnClick: false,
    /**
   * If true the default action of the toggle (e.g. follow a link with href) gets executed on click. If hover option is also true the default action gets prevented on first click for mobile / touch devices and executed on second click.
   * @option
   * @type {boolean}
   * @default true
   */ forceFollow: true
};
/**
 * DropdownMenu module.
 * @module foundation.dropdownMenu
 * @requires foundation.util.keyboard
 * @requires foundation.util.box
 * @requires foundation.util.nest
 * @requires foundation.util.touch
 */ var $57aa6ed7a3256ce7$export$e44a253a59704894 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(DropdownMenu, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(DropdownMenu);
    function DropdownMenu() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, DropdownMenu);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(DropdownMenu, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of DropdownMenu.
     * @class
     * @name DropdownMenu
     * @fires DropdownMenu#init
     * @param {jQuery} element - jQuery object to make into a dropdown menu.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, DropdownMenu.defaults, this.$element.data(), options);
                this.className = "DropdownMenu"; // ie9 back compat
                $57aa6ed7a3256ce7$export$746b04bbf92762fd.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))); // Touch init is idempotent, we just need to make sure it's initialied.
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("DropdownMenu", {
                    "ENTER": "open",
                    "SPACE": "open",
                    "ARROW_RIGHT": "next",
                    "ARROW_UP": "up",
                    "ARROW_DOWN": "down",
                    "ARROW_LEFT": "previous",
                    "ESCAPE": "close"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b33048315ba1159e.Feather(this.$element, "dropdown");
                var subs = this.$element.find("li.is-dropdown-submenu-parent");
                this.$element.children(".is-dropdown-submenu-parent").children(".is-dropdown-submenu").addClass("first-sub");
                this.$menuItems = this.$element.find('li[role="none"]');
                this.$tabs = this.$element.children('li[role="none"]');
                this.$tabs.find("ul.is-dropdown-submenu").addClass(this.options.verticalClass);
                if (this.options.alignment === "auto") {
                    if (this.$element.hasClass(this.options.rightClass) || $57aa6ed7a3256ce7$var$rtl() || this.$element.parents(".top-bar-right").is("*")) {
                        this.options.alignment = "right";
                        subs.addClass("opens-left");
                    } else {
                        this.options.alignment = "left";
                        subs.addClass("opens-right");
                    }
                } else if (this.options.alignment === "right") subs.addClass("opens-left");
                else subs.addClass("opens-right");
                this.changed = false;
                this._events();
            }
        },
        {
            key: "_isVertical",
            value: function _isVertical() {
                return this.$tabs.css("display") === "block" || this.$element.css("flex-direction") === "column";
            }
        },
        {
            key: "_isRtl",
            value: function _isRtl() {
                return this.$element.hasClass("align-right") || $57aa6ed7a3256ce7$var$rtl() && !this.$element.hasClass("align-left");
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this, hasTouch = "ontouchstart" in window || typeof window.ontouchstart !== "undefined", parClass = "is-dropdown-submenu-parent";
                // used for onClick and in the keyboard handlers
                var handleClickFn = function handleClickFn(e) {
                    var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target).parentsUntil("ul", ".".concat(parClass)), hasSub = $elem.hasClass(parClass), hasClicked = $elem.attr("data-is-click") === "true", $sub = $elem.children(".is-dropdown-submenu");
                    if (hasSub) {
                        if (hasClicked) {
                            if (!_this.options.closeOnClick || !_this.options.clickOpen && !hasTouch || _this.options.forceFollow && hasTouch) return;
                            e.stopImmediatePropagation();
                            e.preventDefault();
                            _this._hide($elem);
                        } else {
                            e.stopImmediatePropagation();
                            e.preventDefault();
                            _this._show($sub);
                            $elem.add($elem.parentsUntil(_this.$element, ".".concat(parClass))).attr("data-is-click", true);
                        }
                    }
                };
                if (this.options.clickOpen || hasTouch) this.$menuItems.on("click.zf.dropdownMenu touchstart.zf.dropdownMenu", handleClickFn);
                // Handle Leaf element Clicks
                if (_this.options.closeOnClickInside) this.$menuItems.on("click.zf.dropdownMenu", function() {
                    var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), hasSub = $elem.hasClass(parClass);
                    if (!hasSub) _this._hide();
                });
                if (hasTouch && this.options.disableHoverOnTouch) this.options.disableHover = true;
                if (!this.options.disableHover) this.$menuItems.on("mouseenter.zf.dropdownMenu", function() {
                    var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), hasSub = $elem.hasClass(parClass);
                    if (hasSub) {
                        clearTimeout($elem.data("_delay"));
                        $elem.data("_delay", setTimeout(function() {
                            _this._show($elem.children(".is-dropdown-submenu"));
                        }, _this.options.hoverDelay));
                    }
                }).on("mouseleave.zf.dropdownMenu", $57aa6ed7a3256ce7$var$ignoreMousedisappear(function() {
                    var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), hasSub = $elem.hasClass(parClass);
                    if (hasSub && _this.options.autoclose) {
                        if ($elem.attr("data-is-click") === "true" && _this.options.clickOpen) return false;
                        clearTimeout($elem.data("_delay"));
                        $elem.data("_delay", setTimeout(function() {
                            _this._hide($elem);
                        }, _this.options.closingTime));
                    }
                }));
                this.$menuItems.on("keydown.zf.dropdownMenu", function(e) {
                    var $element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target).parentsUntil("ul", '[role="none"]'), isTab = _this.$tabs.index($element) > -1, $elements = isTab ? _this.$tabs : $element.siblings("li").add($element), $prevElement, $nextElement;
                    $elements.each(function(i) {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).is($element)) {
                            $prevElement = $elements.eq(i - 1);
                            $nextElement = $elements.eq(i + 1);
                            return;
                        }
                    });
                    var nextSibling = function nextSibling() {
                        $nextElement.children("a:first").focus();
                        e.preventDefault();
                    }, prevSibling = function prevSibling() {
                        $prevElement.children("a:first").focus();
                        e.preventDefault();
                    }, openSub = function openSub() {
                        var $sub = $element.children("ul.is-dropdown-submenu");
                        if ($sub.length) {
                            _this._show($sub);
                            $element.find("li > a:first").focus();
                            e.preventDefault();
                        } else return;
                    }, closeSub = function closeSub() {
                        //if ($element.is(':first-child')) {
                        var close = $element.parent("ul").parent("li");
                        close.children("a:first").focus();
                        _this._hide(close);
                        e.preventDefault();
                    //}
                    };
                    var functions = {
                        open: openSub,
                        close: function close() {
                            _this._hide(_this.$element);
                            _this.$menuItems.eq(0).children("a").focus(); // focus to first element
                            e.preventDefault();
                        }
                    };
                    if (isTab) {
                        if (_this._isVertical()) {
                            // vertical menu
                            if (_this._isRtl()) // right aligned
                            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend(functions, {
                                down: nextSibling,
                                up: prevSibling,
                                next: closeSub,
                                previous: openSub
                            });
                            else // left aligned
                            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend(functions, {
                                down: nextSibling,
                                up: prevSibling,
                                next: openSub,
                                previous: closeSub
                            });
                        } else // horizontal menu
                        if (_this._isRtl()) // right aligned
                        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend(functions, {
                            next: prevSibling,
                            previous: nextSibling,
                            down: openSub,
                            up: closeSub
                        });
                        else // left aligned
                        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend(functions, {
                            next: nextSibling,
                            previous: prevSibling,
                            down: openSub,
                            up: closeSub
                        });
                    } else // not tabs -> one sub
                    if (_this._isRtl()) // right aligned
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend(functions, {
                        next: closeSub,
                        previous: openSub,
                        down: nextSibling,
                        up: prevSibling
                    });
                    else // left aligned
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend(functions, {
                        next: openSub,
                        previous: closeSub,
                        down: nextSibling,
                        up: prevSibling
                    });
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "DropdownMenu", functions);
                });
            }
        },
        {
            key: "_addBodyHandler",
            value: function _addBodyHandler() {
                var _this2 = this;
                var $body = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document.body);
                this._removeBodyHandler();
                $body.on("click.zf.dropdownMenu tap.zf.dropdownMenu", function(e) {
                    var isItself = !!(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target).closest(_this2.$element).length;
                    if (isItself) return;
                    _this2._hide();
                    _this2._removeBodyHandler();
                });
            }
        },
        {
            key: "_removeBodyHandler",
            value: function _removeBodyHandler() {
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document.body).off("click.zf.dropdownMenu tap.zf.dropdownMenu");
            }
        },
        {
            key: "_show",
            value: function _show($sub) {
                var idx = this.$tabs.index(this.$tabs.filter(function(i, el) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el).find($sub).length > 0;
                }));
                var $sibs = $sub.parent("li.is-dropdown-submenu-parent").siblings("li.is-dropdown-submenu-parent");
                this._hide($sibs, idx);
                $sub.css("visibility", "hidden").addClass("js-dropdown-active").parent("li.is-dropdown-submenu-parent").addClass("is-active");
                var clear = $57aa6ed7a3256ce7$export$e71c4d32a2263218.ImNotTouchingYou($sub, null, true);
                if (!clear) {
                    var oldClass = this.options.alignment === "left" ? "-right" : "-left", $parentLi = $sub.parent(".is-dropdown-submenu-parent");
                    $parentLi.removeClass("opens".concat(oldClass)).addClass("opens-".concat(this.options.alignment));
                    clear = $57aa6ed7a3256ce7$export$e71c4d32a2263218.ImNotTouchingYou($sub, null, true);
                    if (!clear) $parentLi.removeClass("opens-".concat(this.options.alignment)).addClass("opens-inner");
                    this.changed = true;
                }
                $sub.css("visibility", "");
                if (this.options.closeOnClick) this._addBodyHandler();
                /**
       * Fires when the new dropdown pane is visible.
       * @event DropdownMenu#show
       */ this.$element.trigger("show.zf.dropdownMenu", [
                    $sub
                ]);
            }
        },
        {
            key: "_hide",
            value: function _hide($elem, idx) {
                var $toClose;
                if ($elem && $elem.length) $toClose = $elem;
                else if (typeof idx !== "undefined") $toClose = this.$tabs.not(function(i) {
                    return i === idx;
                });
                else $toClose = this.$element;
                var somethingToClose = $toClose.hasClass("is-active") || $toClose.find(".is-active").length > 0;
                if (somethingToClose) {
                    var $activeItem = $toClose.find("li.is-active");
                    $activeItem.add($toClose).attr({
                        "data-is-click": false
                    }).removeClass("is-active");
                    $toClose.find("ul.js-dropdown-active").removeClass("js-dropdown-active");
                    if (this.changed || $toClose.find("opens-inner").length) {
                        var oldClass = this.options.alignment === "left" ? "right" : "left";
                        $toClose.find("li.is-dropdown-submenu-parent").add($toClose).removeClass("opens-inner opens-".concat(this.options.alignment)).addClass("opens-".concat(oldClass));
                        this.changed = false;
                    }
                    clearTimeout($activeItem.data("_delay"));
                    this._removeBodyHandler();
                    /**
         * Fires when the open menus are closed.
         * @event DropdownMenu#hide
         */ this.$element.trigger("hide.zf.dropdownMenu", [
                        $toClose
                    ]);
                }
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$menuItems.off(".zf.dropdownMenu").removeAttr("data-is-click").removeClass("is-right-arrow is-left-arrow is-down-arrow opens-right opens-left opens-inner");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document.body).off(".zf.dropdownMenu");
                $57aa6ed7a3256ce7$export$b33048315ba1159e.Burn(this.$element, "dropdown");
            }
        }
    ]);
    return DropdownMenu;
}($57aa6ed7a3256ce7$var$Plugin);
/**
 * Default settings for plugin
 */ $57aa6ed7a3256ce7$export$e44a253a59704894.defaults = {
    /**
   * Disallows hover events from opening submenus
   * @option
   * @type {boolean}
   * @default false
   */ disableHover: false,
    /**
   * Disallows hover on touch devices
   * @option
   * @type {boolean}
   * @default true
   */ disableHoverOnTouch: true,
    /**
   * Allow a submenu to automatically close on a mouseleave event, if not clicked open.
   * @option
   * @type {boolean}
   * @default true
   */ autoclose: true,
    /**
   * Amount of time to delay opening a submenu on hover event.
   * @option
   * @type {number}
   * @default 50
   */ hoverDelay: 50,
    /**
   * Allow a submenu to open/remain open on parent click event. Allows cursor to move away from menu.
   * @option
   * @type {boolean}
   * @default false
   */ clickOpen: false,
    /**
   * Amount of time to delay closing a submenu on a mouseleave event.
   * @option
   * @type {number}
   * @default 500
   */ closingTime: 500,
    /**
   * Position of the menu relative to what direction the submenus should open. Handled by JS. Can be `'auto'`, `'left'` or `'right'`.
   * @option
   * @type {string}
   * @default 'auto'
   */ alignment: "auto",
    /**
   * Allow clicks on the body to close any open submenus.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnClick: true,
    /**
   * Allow clicks on leaf anchor links to close any open submenus.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnClickInside: true,
    /**
   * Class applied to vertical oriented menus, Foundation default is `vertical`. Update this if using your own class.
   * @option
   * @type {string}
   * @default 'vertical'
   */ verticalClass: "vertical",
    /**
   * Class applied to right-side oriented menus, Foundation default is `align-right`. Update this if using your own class.
   * @option
   * @type {string}
   * @default 'align-right'
   */ rightClass: "align-right",
    /**
   * Boolean to force overide the clicking of links to perform default action, on second touch event for mobile.
   * @option
   * @type {boolean}
   * @default true
   */ forceFollow: true
};
/**
 * Equalizer module.
 * @module foundation.equalizer
 * @requires foundation.util.mediaQuery
 * @requires foundation.util.imageLoader if equalizer contains images
 */ var $57aa6ed7a3256ce7$export$95a41bf8d2ae9c8f = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Equalizer, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Equalizer);
    function Equalizer() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Equalizer);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Equalizer, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of Equalizer.
     * @class
     * @name Equalizer
     * @fires Equalizer#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Equalizer.defaults, this.$element.data(), options);
                this.className = "Equalizer"; // ie9 back compat
                this._init();
            }
        },
        {
            key: "_init",
            value: function _init() {
                var eqId = this.$element.attr("data-equalizer") || "";
                var $watched = this.$element.find('[data-equalizer-watch="'.concat(eqId, '"]'));
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                this.$watched = $watched.length ? $watched : this.$element.find("[data-equalizer-watch]");
                this.$element.attr("data-resize", eqId || $57aa6ed7a3256ce7$var$GetYoDigits(6, "eq"));
                this.$element.attr("data-mutate", eqId || $57aa6ed7a3256ce7$var$GetYoDigits(6, "eq"));
                this.hasNested = this.$element.find("[data-equalizer]").length > 0;
                this.isNested = this.$element.parentsUntil(document.body, "[data-equalizer]").length > 0;
                this.isOn = false;
                this._bindHandler = {
                    onResizeMeBound: this._onResizeMe.bind(this),
                    onPostEqualizedBound: this._onPostEqualized.bind(this)
                };
                var imgs = this.$element.find("img");
                var tooSmall;
                if (this.options.equalizeOn) {
                    tooSmall = this._checkMQ();
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("changed.zf.mediaquery", this._checkMQ.bind(this));
                } else this._events();
                if (typeof tooSmall !== "undefined" && tooSmall === false || typeof tooSmall === "undefined") {
                    if (imgs.length) $57aa6ed7a3256ce7$export$9a7c395a24d73631(imgs, this._reflow.bind(this));
                    else this._reflow();
                }
            }
        },
        {
            key: "_pauseEvents",
            value: function _pauseEvents() {
                this.isOn = false;
                this.$element.off({
                    ".zf.equalizer": this._bindHandler.onPostEqualizedBound,
                    "resizeme.zf.trigger": this._bindHandler.onResizeMeBound,
                    "mutateme.zf.trigger": this._bindHandler.onResizeMeBound
                });
            }
        },
        {
            key: "_onResizeMe",
            value: function _onResizeMe() {
                this._reflow();
            }
        },
        {
            key: "_onPostEqualized",
            value: function _onPostEqualized(e) {
                if (e.target !== this.$element[0]) this._reflow();
            }
        },
        {
            key: "_events",
            value: function _events() {
                this._pauseEvents();
                if (this.hasNested) this.$element.on("postequalized.zf.equalizer", this._bindHandler.onPostEqualizedBound);
                else {
                    this.$element.on("resizeme.zf.trigger", this._bindHandler.onResizeMeBound);
                    this.$element.on("mutateme.zf.trigger", this._bindHandler.onResizeMeBound);
                }
                this.isOn = true;
            }
        },
        {
            key: "_checkMQ",
            value: function _checkMQ() {
                var tooSmall = !$57aa6ed7a3256ce7$export$b745838c41029eb3.is(this.options.equalizeOn);
                if (tooSmall) {
                    if (this.isOn) {
                        this._pauseEvents();
                        this.$watched.css("height", "auto");
                    }
                } else if (!this.isOn) this._events();
                return tooSmall;
            }
        },
        {
            key: "_killswitch",
            value: function _killswitch() {
                return;
            }
        },
        {
            key: "_reflow",
            value: function _reflow() {
                if (!this.options.equalizeOnStack) {
                    if (this._isStacked()) {
                        this.$watched.css("height", "auto");
                        return false;
                    }
                }
                if (this.options.equalizeByRow) this.getHeightsByRow(this.applyHeightByRow.bind(this));
                else this.getHeights(this.applyHeight.bind(this));
            }
        },
        {
            key: "_isStacked",
            value: function _isStacked() {
                if (!this.$watched[0] || !this.$watched[1]) return true;
                return this.$watched[0].getBoundingClientRect().top !== this.$watched[1].getBoundingClientRect().top;
            }
        },
        {
            key: "getHeights",
            value: function getHeights(cb) {
                var heights = [];
                for(var i = 0, len = this.$watched.length; i < len; i++){
                    this.$watched[i].style.height = "auto";
                    heights.push(this.$watched[i].offsetHeight);
                }
                cb(heights);
            }
        },
        {
            key: "getHeightsByRow",
            value: function getHeightsByRow(cb) {
                var lastElTopOffset = this.$watched.length ? this.$watched.first().offset().top : 0, groups = [], group = 0;
                //group by Row
                groups[group] = [];
                for(var i = 0, len = this.$watched.length; i < len; i++){
                    this.$watched[i].style.height = "auto";
                    //maybe could use this.$watched[i].offsetTop
                    var elOffsetTop = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.$watched[i]).offset().top;
                    if (elOffsetTop !== lastElTopOffset) {
                        group++;
                        groups[group] = [];
                        lastElTopOffset = elOffsetTop;
                    }
                    groups[group].push([
                        this.$watched[i],
                        this.$watched[i].offsetHeight
                    ]);
                }
                for(var j = 0, ln = groups.length; j < ln; j++){
                    var heights = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(groups[j]).map(function() {
                        return this[1];
                    }).get();
                    var max = Math.max.apply(null, heights);
                    groups[j].push(max);
                }
                cb(groups);
            }
        },
        {
            key: "applyHeight",
            value: function applyHeight(heights) {
                var max = Math.max.apply(null, heights);
                /**
       * Fires before the heights are applied
       * @event Equalizer#preequalized
       */ this.$element.trigger("preequalized.zf.equalizer");
                this.$watched.css("height", max);
                /**
       * Fires when the heights have been applied
       * @event Equalizer#postequalized
       */ this.$element.trigger("postequalized.zf.equalizer");
            }
        },
        {
            key: "applyHeightByRow",
            value: function applyHeightByRow(groups) {
                /**
       * Fires before the heights are applied
       */ this.$element.trigger("preequalized.zf.equalizer");
                for(var i = 0, len = groups.length; i < len; i++){
                    var groupsILength = groups[i].length, max = groups[i][groupsILength - 1];
                    if (groupsILength <= 2) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(groups[i][0][0]).css({
                            "height": "auto"
                        });
                        continue;
                    }
                    /**
          * Fires before the heights per row are applied
          * @event Equalizer#preequalizedrow
          */ this.$element.trigger("preequalizedrow.zf.equalizer");
                    for(var j = 0, lenJ = groupsILength - 1; j < lenJ; j++)(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(groups[i][j][0]).css({
                        "height": max
                    });
                    /**
          * Fires when the heights per row have been applied
          * @event Equalizer#postequalizedrow
          */ this.$element.trigger("postequalizedrow.zf.equalizer");
                }
                /**
       * Fires when the heights have been applied
       */ this.$element.trigger("postequalized.zf.equalizer");
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this._pauseEvents();
                this.$watched.css("height", "auto");
            }
        }
    ]);
    return Equalizer;
}($57aa6ed7a3256ce7$var$Plugin);
/**
 * Default settings for plugin
 */ $57aa6ed7a3256ce7$export$95a41bf8d2ae9c8f.defaults = {
    /**
   * Enable height equalization when stacked on smaller screens.
   * @option
   * @type {boolean}
   * @default false
   */ equalizeOnStack: false,
    /**
   * Enable height equalization row by row.
   * @option
   * @type {boolean}
   * @default false
   */ equalizeByRow: false,
    /**
   * String representing the minimum breakpoint size the plugin should equalize heights on.
   * @option
   * @type {string}
   * @default ''
   */ equalizeOn: ""
};
/**
 * Interchange module.
 * @module foundation.interchange
 * @requires foundation.util.mediaQuery
 */ var $57aa6ed7a3256ce7$export$b955217673347a91 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Interchange, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Interchange);
    function Interchange() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Interchange);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Interchange, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of Interchange.
     * @class
     * @name Interchange
     * @fires Interchange#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Interchange.defaults, this.$element.data(), options);
                this.rules = [];
                this.currentPath = "";
                this.className = "Interchange"; // ie9 back compat
                // Triggers init is idempotent, just need to make sure it is initialized
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                this._init();
                this._events();
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                var id = this.$element[0].id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "interchange");
                this.$element.attr({
                    "data-resize": id,
                    "id": id
                });
                this._parseOptions();
                this._addBreakpoints();
                this._generateRules();
                this._reflow();
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this;
                this.$element.off("resizeme.zf.trigger").on("resizeme.zf.trigger", function() {
                    return _this._reflow();
                });
            }
        },
        {
            key: "_reflow",
            value: function _reflow() {
                var match;
                // Iterate through each rule, but only save the last match
                for(var i in this.rules)if (this.rules.hasOwnProperty(i)) {
                    var rule = this.rules[i];
                    if (window.matchMedia(rule.query).matches) match = rule;
                }
                if (match) this.replace(match.path);
            }
        },
        {
            key: "_parseOptions",
            value: function _parseOptions() {
                var types = [
                    "auto",
                    "src",
                    "background",
                    "html"
                ];
                if (typeof this.options.type === "undefined") this.options.type = "auto";
                else if (types.indexOf(this.options.type) === -1) {
                    console.warn('Warning: invalid value "'.concat(this.options.type, '" for Interchange option "type"'));
                    this.options.type = "auto";
                }
            }
        },
        {
            key: "_addBreakpoints",
            value: function _addBreakpoints() {
                for(var i in $57aa6ed7a3256ce7$export$b745838c41029eb3.queries)if ($57aa6ed7a3256ce7$export$b745838c41029eb3.queries.hasOwnProperty(i)) {
                    var query = $57aa6ed7a3256ce7$export$b745838c41029eb3.queries[i];
                    Interchange.SPECIAL_QUERIES[query.name] = query.value;
                }
            }
        },
        {
            key: "_generateRules",
            value: function _generateRules() {
                var rulesList = [];
                var rules;
                if (this.options.rules) rules = this.options.rules;
                else rules = this.$element.data("interchange");
                rules = typeof rules === "string" ? rules.match(/\[.*?, .*?\]/g) : rules;
                for(var i in rules)if (rules.hasOwnProperty(i)) {
                    var rule = rules[i].slice(1, -1).split(", ");
                    var path = rule.slice(0, -1).join("");
                    var query = rule[rule.length - 1];
                    if (Interchange.SPECIAL_QUERIES[query]) query = Interchange.SPECIAL_QUERIES[query];
                    rulesList.push({
                        path: path,
                        query: query
                    });
                }
                this.rules = rulesList;
            }
        },
        {
            key: "replace",
            value: function replace(path) {
                var _this2 = this;
                if (this.currentPath === path) return;
                var trigger = "replaced.zf.interchange";
                var type = this.options.type;
                if (type === "auto") {
                    if (this.$element[0].nodeName === "IMG") type = "src";
                    else if (path.match(/\.(gif|jpe?g|png|svg|tiff)([?#].*)?/i)) type = "background";
                    else type = "html";
                }
                // Replacing images
                if (type === "src") this.$element.attr("src", path).on("load", function() {
                    _this2.currentPath = path;
                }).trigger(trigger);
                else if (type === "background") {
                    path = path.replace(/\(/g, "%28").replace(/\)/g, "%29");
                    this.$element.css({
                        "background-image": "url(" + path + ")"
                    }).trigger(trigger);
                } else if (type === "html") (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).get(path, function(response) {
                    _this2.$element.html(response).trigger(trigger);
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(response).foundation();
                    _this2.currentPath = path;
                });
            /**
       * Fires when content in an Interchange element is done being loaded.
       * @event Interchange#replaced
       */ // this.$element.trigger('replaced.zf.interchange');
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.off("resizeme.zf.trigger");
            }
        }
    ]);
    return Interchange;
}($57aa6ed7a3256ce7$var$Plugin);
/**
 * Default settings for plugin
 */ $57aa6ed7a3256ce7$export$b955217673347a91.defaults = {
    /**
   * Rules to be applied to Interchange elements. Set with the `data-interchange` array notation.
   * @option
   * @type {?array}
   * @default null
   */ rules: null,
    /**
   * Type of the responsive ressource to replace. It can take the following options:
   * - `auto` (default): choose the type according to the element tag or the ressource extension,
   * - `src`: replace the `[src]` attribute, recommended for images `<img>`.
   * - `background`: replace the `background-image` CSS property.
   * - `html`: replace the element content.
   * @option
   * @type {string}
   * @default 'auto'
   */ type: "auto"
};
$57aa6ed7a3256ce7$export$b955217673347a91.SPECIAL_QUERIES = {
    "landscape": "screen and (orientation: landscape)",
    "portrait": "screen and (orientation: portrait)",
    "retina": "only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)"
};
/**
 * SmoothScroll module.
 * @module foundation.smoothScroll
 */ var $57aa6ed7a3256ce7$export$f8250c268cd0d487 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(SmoothScroll, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(SmoothScroll);
    function SmoothScroll() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, SmoothScroll);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(SmoothScroll, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of SmoothScroll.
     * @class
     * @name SmoothScroll
     * @fires SmoothScroll#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, SmoothScroll.defaults, this.$element.data(), options);
                this.className = "SmoothScroll"; // ie9 back compat
                this._init();
            }
        },
        {
            key: "_init",
            value: function _init() {
                var id = this.$element[0].id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "smooth-scroll");
                this.$element.attr({
                    id: id
                });
                this._events();
            }
        },
        {
            key: "_events",
            value: function _events() {
                this._linkClickListener = this._handleLinkClick.bind(this);
                this.$element.on("click.zf.smoothScroll", this._linkClickListener);
                this.$element.on("click.zf.smoothScroll", 'a[href^="#"]', this._linkClickListener);
            }
        },
        {
            key: "_handleLinkClick",
            value: function _handleLinkClick(e) {
                var _this = this;
                // Follow the link if it does not point to an anchor.
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.currentTarget).is('a[href^="#"]')) return;
                var arrival = e.currentTarget.getAttribute("href");
                this._inTransition = true;
                SmoothScroll.scrollToLoc(arrival, this.options, function() {
                    _this._inTransition = false;
                });
                e.preventDefault();
            }
        },
        {
            key: "_destroy",
            value: /**
     * Destroys the SmoothScroll instance.
     * @function
     */ function _destroy() {
                this.$element.off("click.zf.smoothScroll", this._linkClickListener);
                this.$element.off("click.zf.smoothScroll", 'a[href^="#"]', this._linkClickListener);
            }
        }
    ], [
        {
            key: "scrollToLoc",
            value: /**
     * Function to scroll to a given location on the page.
     * @param {String} loc - A properly formatted jQuery id selector. Example: '#foo'
     * @param {Object} options - The options to use.
     * @param {Function} callback - The callback function.
     * @static
     * @function
     */ function scrollToLoc(loc) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SmoothScroll.defaults;
                var callback = arguments.length > 2 ? arguments[2] : undefined;
                var $loc = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(loc);
                // Do nothing if target does not exist to prevent errors
                if (!$loc.length) return false;
                var scrollPos = Math.round($loc.offset().top - options.threshold / 2 - options.offset);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html, body").stop(true).animate({
                    scrollTop: scrollPos
                }, options.animationDuration, options.animationEasing, function() {
                    if (typeof callback === "function") callback();
                });
            }
        }
    ]);
    return SmoothScroll;
}($57aa6ed7a3256ce7$var$Plugin);
/**
 * Default settings for plugin.
 */ $57aa6ed7a3256ce7$export$f8250c268cd0d487.defaults = {
    /**
   * Amount of time, in ms, the animated scrolling should take between locations.
   * @option
   * @type {number}
   * @default 500
   */ animationDuration: 500,
    /**
   * Animation style to use when scrolling between locations. Can be `'swing'` or `'linear'`.
   * @option
   * @type {string}
   * @default 'linear'
   * @see {@link https://api.jquery.com/animate|Jquery animate}
   */ animationEasing: "linear",
    /**
   * Number of pixels to use as a marker for location changes.
   * @option
   * @type {number}
   * @default 50
   */ threshold: 50,
    /**
   * Number of pixels to offset the scroll of the page on item click if using a sticky nav bar.
   * @option
   * @type {number}
   * @default 0
   */ offset: 0
};
/**
 * Magellan module.
 * @module foundation.magellan
 * @requires foundation.smoothScroll
 * @requires foundation.util.triggers
 */ var $57aa6ed7a3256ce7$export$a98164a614985365 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Magellan, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Magellan);
    function Magellan() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Magellan);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Magellan, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of Magellan.
     * @class
     * @name Magellan
     * @fires Magellan#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Magellan.defaults, this.$element.data(), options);
                this.className = "Magellan"; // ie9 back compat
                // Triggers init is idempotent, just need to make sure it is initialized
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                this._init();
                this.calcPoints();
            }
        },
        {
            key: "_init",
            value: function _init() {
                var id = this.$element[0].id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "magellan");
                this.$targets = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-magellan-target]");
                this.$links = this.$element.find("a");
                this.$element.attr({
                    "data-resize": id,
                    "data-scroll": id,
                    "id": id
                });
                this.$active = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))();
                this.scrollPos = parseInt(window.pageYOffset, 10);
                this._events();
            }
        },
        {
            key: "calcPoints",
            value: function calcPoints() {
                var _this = this, body = document.body, html = document.documentElement;
                this.points = [];
                this.winHeight = Math.round(Math.max(window.innerHeight, html.clientHeight));
                this.docHeight = Math.round(Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight));
                this.$targets.each(function() {
                    var $tar = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), pt = Math.round($tar.offset().top - _this.options.threshold);
                    $tar.targetPoint = pt;
                    _this.points.push(pt);
                });
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this;
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).one("load", function() {
                    if (_this.options.deepLinking) {
                        if (location.hash) _this.scrollToLoc(location.hash);
                    }
                    _this.calcPoints();
                    _this._updateActive();
                });
                _this.onLoadListener = $57aa6ed7a3256ce7$var$onLoad((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window), function() {
                    _this.$element.on({
                        "resizeme.zf.trigger": _this.reflow.bind(_this),
                        "scrollme.zf.trigger": _this._updateActive.bind(_this)
                    }).on("click.zf.magellan", 'a[href^="#"]', function(e) {
                        e.preventDefault();
                        var arrival = this.getAttribute("href");
                        _this.scrollToLoc(arrival);
                    });
                });
                this._deepLinkScroll = function() {
                    if (_this.options.deepLinking) _this.scrollToLoc(window.location.hash);
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("hashchange", this._deepLinkScroll);
            }
        },
        {
            key: "scrollToLoc",
            value: function scrollToLoc(loc) {
                this._inTransition = true;
                var _this = this;
                var options = {
                    animationEasing: this.options.animationEasing,
                    animationDuration: this.options.animationDuration,
                    threshold: this.options.threshold,
                    offset: this.options.offset
                };
                $57aa6ed7a3256ce7$export$f8250c268cd0d487.scrollToLoc(loc, options, function() {
                    _this._inTransition = false;
                });
            }
        },
        {
            key: "reflow",
            value: function reflow() {
                this.calcPoints();
                this._updateActive();
            }
        },
        {
            key: "_updateActive",
            value: function _updateActive() {
                var _this2 = this;
                if (this._inTransition) return;
                var newScrollPos = parseInt(window.pageYOffset, 10);
                var isScrollingUp = this.scrollPos > newScrollPos;
                this.scrollPos = newScrollPos;
                var activeIdx;
                // Before the first point: no link
                if (newScrollPos < this.points[0] - this.options.offset - (isScrollingUp ? this.options.threshold : 0)) ;
                else if (newScrollPos + this.winHeight === this.docHeight) activeIdx = this.points.length - 1;
                else {
                    var visibleLinks = this.points.filter(function(p) {
                        return p - _this2.options.offset - (isScrollingUp ? _this2.options.threshold : 0) <= newScrollPos;
                    });
                    activeIdx = visibleLinks.length ? visibleLinks.length - 1 : 0;
                }
                // Get the new active link
                var $oldActive = this.$active;
                var activeHash = "";
                if (typeof activeIdx !== "undefined") {
                    this.$active = this.$links.filter('[href="#' + this.$targets.eq(activeIdx).data("magellan-target") + '"]');
                    if (this.$active.length) activeHash = this.$active[0].getAttribute("href");
                } else this.$active = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))();
                var isNewActive = !(!this.$active.length && !$oldActive.length) && !this.$active.is($oldActive);
                var isNewHash = activeHash !== window.location.hash;
                // Update the active link element
                if (isNewActive) {
                    $oldActive.removeClass(this.options.activeClass);
                    this.$active.addClass(this.options.activeClass);
                }
                // Update the hash (it may have changed with the same active link)
                if (this.options.deepLinking && isNewHash) {
                    if (window.history.pushState) {
                        // Set or remove the hash (see: https://stackoverflow.com/a/5298684/4317384
                        var url = activeHash ? activeHash : window.location.pathname + window.location.search;
                        if (this.options.updateHistory) window.history.pushState({}, "", url);
                        else window.history.replaceState({}, "", url);
                    } else window.location.hash = activeHash;
                }
                if (isNewActive) /**
         * Fires when magellan is finished updating to the new active element.
         * @event Magellan#update
         */ this.$element.trigger("update.zf.magellan", [
                    this.$active
                ]);
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.off(".zf.trigger .zf.magellan").find(".".concat(this.options.activeClass)).removeClass(this.options.activeClass);
                if (this.options.deepLinking) {
                    var hash = this.$active[0].getAttribute("href");
                    window.location.hash.replace(hash, "");
                }
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off("hashchange", this._deepLinkScroll);
                if (this.onLoadListener) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(this.onLoadListener);
            }
        }
    ]);
    return Magellan;
}($57aa6ed7a3256ce7$var$Plugin);
/**
 * Default settings for plugin
 */ $57aa6ed7a3256ce7$export$a98164a614985365.defaults = {
    /**
   * Amount of time, in ms, the animated scrolling should take between locations.
   * @option
   * @type {number}
   * @default 500
   */ animationDuration: 500,
    /**
   * Animation style to use when scrolling between locations. Can be `'swing'` or `'linear'`.
   * @option
   * @type {string}
   * @default 'linear'
   * @see {@link https://api.jquery.com/animate|Jquery animate}
   */ animationEasing: "linear",
    /**
   * Number of pixels to use as a marker for location changes.
   * @option
   * @type {number}
   * @default 50
   */ threshold: 50,
    /**
   * Class applied to the active locations link on the magellan container.
   * @option
   * @type {string}
   * @default 'is-active'
   */ activeClass: "is-active",
    /**
   * Allows the script to manipulate the url of the current page, and if supported, alter the history.
   * @option
   * @type {boolean}
   * @default false
   */ deepLinking: false,
    /**
   * Update the browser history with the active link, if deep linking is enabled.
   * @option
   * @type {boolean}
   * @default false
   */ updateHistory: false,
    /**
   * Number of pixels to offset the scroll of the page on item click if using a sticky nav bar.
   * @option
   * @type {number}
   * @default 0
   */ offset: 0
};
/**
 * OffCanvas module.
 * @module foundation.offCanvas
 * @requires foundation.util.keyboard
 * @requires foundation.util.mediaQuery
 * @requires foundation.util.triggers
 */ var $57aa6ed7a3256ce7$export$644db29b3dffde4c = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(OffCanvas, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(OffCanvas);
    function OffCanvas() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, OffCanvas);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(OffCanvas, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of an off-canvas wrapper.
     * @class
     * @name OffCanvas
     * @fires OffCanvas#init
     * @param {Object} element - jQuery object to initialize.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                var _this2 = this;
                this.className = "OffCanvas"; // ie9 back compat
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, OffCanvas.defaults, this.$element.data(), options);
                this.contentClasses = {
                    base: [],
                    reveal: []
                };
                this.$lastTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))();
                this.$triggers = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))();
                this.position = "left";
                this.$content = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))();
                this.nested = !!this.options.nested;
                this.$sticky = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))();
                this.isInCanvas = false;
                // Defines the CSS transition/position classes of the off-canvas content container.
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))([
                    "push",
                    "overlap"
                ]).each(function(index, val) {
                    _this2.contentClasses.base.push("has-transition-" + val);
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))([
                    "left",
                    "right",
                    "top",
                    "bottom"
                ]).each(function(index, val) {
                    _this2.contentClasses.base.push("has-position-" + val);
                    _this2.contentClasses.reveal.push("has-reveal-" + val);
                });
                // Triggers init is idempotent, just need to make sure it is initialized
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                this._init();
                this._events();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("OffCanvas", {
                    "ESCAPE": "close"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                var id = this.$element.attr("id");
                this.$element.attr("aria-hidden", "true");
                // Find off-canvas content, either by ID (if specified), by siblings or by closest selector (fallback)
                if (this.options.contentId) this.$content = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + this.options.contentId);
                else if (this.$element.siblings("[data-off-canvas-content]").length) this.$content = this.$element.siblings("[data-off-canvas-content]").first();
                else this.$content = this.$element.closest("[data-off-canvas-content]").first();
                if (!this.options.contentId) // Assume that the off-canvas element is nested if it isn't a sibling of the content
                this.nested = this.$element.siblings("[data-off-canvas-content]").length === 0;
                else if (this.options.contentId && this.options.nested === null) // Warning if using content ID without setting the nested option
                // Once the element is nested it is required to work properly in this case
                console.warn("Remember to use the nested option if using the content ID option!");
                if (this.nested === true) {
                    // Force transition overlap if nested
                    this.options.transition = "overlap";
                    // Remove appropriate classes if already assigned in markup
                    this.$element.removeClass("is-transition-push");
                }
                this.$element.addClass("is-transition-".concat(this.options.transition, " is-closed"));
                // Find triggers that affect this element and add aria-expanded to them
                this.$triggers = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document).find('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr("aria-expanded", "false").attr("aria-controls", id);
                // Get position by checking for related CSS class
                this.position = this.$element.is(".position-left, .position-top, .position-right, .position-bottom") ? this.$element.attr("class").match(/position\-(left|top|right|bottom)/)[1] : this.position;
                // Add an overlay over the content if necessary
                if (this.options.contentOverlay === true) {
                    var overlay = document.createElement("div");
                    var overlayPosition = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.$element).css("position") === "fixed" ? "is-overlay-fixed" : "is-overlay-absolute";
                    overlay.setAttribute("class", "js-off-canvas-overlay " + overlayPosition);
                    this.$overlay = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(overlay);
                    if (overlayPosition === "is-overlay-fixed") (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.$overlay).insertAfter(this.$element);
                    else this.$content.append(this.$overlay);
                }
                // Get the revealOn option from the class.
                var revealOnRegExp = new RegExp($57aa6ed7a3256ce7$var$RegExpEscape(this.options.revealClass) + "([^\\s]+)", "g");
                var revealOnClass = revealOnRegExp.exec(this.$element[0].className);
                if (revealOnClass) {
                    this.options.isRevealed = true;
                    this.options.revealOn = this.options.revealOn || revealOnClass[1];
                }
                // Ensure the `reveal-on-*` class is set.
                if (this.options.isRevealed === true && this.options.revealOn) {
                    this.$element.first().addClass("".concat(this.options.revealClass).concat(this.options.revealOn));
                    this._setMQChecker();
                }
                if (this.options.transitionTime) this.$element.css("transition-duration", this.options.transitionTime);
                // Find fixed elements that should stay fixed while off-canvas is opened
                this.$sticky = this.$content.find("[data-off-canvas-sticky]");
                if (this.$sticky.length > 0 && this.options.transition === "push") // If there's at least one match force contentScroll:false because the absolute top value doesn't get recalculated on scroll
                // Limit to push transition since there's no transform scope for overlap
                this.options.contentScroll = false;
                var inCanvasFor = this.$element.attr("class").match(/\bin-canvas-for-(\w+)/);
                if (inCanvasFor && inCanvasFor.length === 2) // Set `inCanvasOn` option if found in-canvas-for-[BREAKPONT] CSS class
                this.options.inCanvasOn = inCanvasFor[1];
                else if (this.options.inCanvasOn) // Ensure the CSS class is set
                this.$element.addClass("in-canvas-for-".concat(this.options.inCanvasOn));
                if (this.options.inCanvasOn) this._checkInCanvas();
                // Initally remove all transition/position CSS classes from off-canvas content container.
                this._removeContentClasses();
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this3 = this;
                this.$element.off(".zf.trigger .zf.offCanvas").on({
                    "open.zf.trigger": this.open.bind(this),
                    "close.zf.trigger": this.close.bind(this),
                    "toggle.zf.trigger": this.toggle.bind(this),
                    "keydown.zf.offCanvas": this._handleKeyboard.bind(this)
                });
                if (this.options.closeOnClick === true) {
                    var $target = this.options.contentOverlay ? this.$overlay : this.$content;
                    $target.on({
                        "click.zf.offCanvas": this.close.bind(this)
                    });
                }
                if (this.options.inCanvasOn) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("changed.zf.mediaquery", function() {
                    _this3._checkInCanvas();
                });
            }
        },
        {
            key: "_setMQChecker",
            value: function _setMQChecker() {
                var _this = this;
                this.onLoadListener = $57aa6ed7a3256ce7$var$onLoad((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window), function() {
                    if ($57aa6ed7a3256ce7$export$b745838c41029eb3.atLeast(_this.options.revealOn)) _this.reveal(true);
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("changed.zf.mediaquery", function() {
                    if ($57aa6ed7a3256ce7$export$b745838c41029eb3.atLeast(_this.options.revealOn)) _this.reveal(true);
                    else _this.reveal(false);
                });
            }
        },
        {
            key: "_checkInCanvas",
            value: function _checkInCanvas() {
                this.isInCanvas = $57aa6ed7a3256ce7$export$b745838c41029eb3.atLeast(this.options.inCanvasOn);
                if (this.isInCanvas === true) this.close();
            }
        },
        {
            key: "_removeContentClasses",
            value: function _removeContentClasses(hasReveal) {
                if (typeof hasReveal !== "boolean") this.$content.removeClass(this.contentClasses.base.join(" "));
                else if (hasReveal === false) this.$content.removeClass("has-reveal-".concat(this.position));
            }
        },
        {
            key: "_addContentClasses",
            value: function _addContentClasses(hasReveal) {
                this._removeContentClasses(hasReveal);
                if (typeof hasReveal !== "boolean") this.$content.addClass("has-transition-".concat(this.options.transition, " has-position-").concat(this.position));
                else if (hasReveal === true) this.$content.addClass("has-reveal-".concat(this.position));
            }
        },
        {
            key: "_fixStickyElements",
            value: function _fixStickyElements() {
                this.$sticky.each(function(_, el) {
                    var $el = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el);
                    // If sticky element is currently fixed, adjust its top value to match absolute position due to transform scope
                    // Limit to push transition because postion:fixed works without problems for overlap (no transform scope)
                    if ($el.css("position") === "fixed") {
                        // Save current inline styling to restore it if undoing the absolute fixing
                        var topVal = parseInt($el.css("top"), 10);
                        $el.data("offCanvasSticky", {
                            top: topVal
                        });
                        var absoluteTopVal = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document).scrollTop() + topVal;
                        $el.css({
                            top: "".concat(absoluteTopVal, "px"),
                            width: "100%",
                            transition: "none"
                        });
                    }
                });
            }
        },
        {
            key: "_unfixStickyElements",
            value: function _unfixStickyElements() {
                this.$sticky.each(function(_, el) {
                    var $el = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el);
                    var stickyData = $el.data("offCanvasSticky");
                    // If sticky element has got data object with prior values (meaning it was originally fixed) restore these values once off-canvas is closed
                    if ($57aa6ed7a3256ce7$var$_typeof(stickyData) === "object") {
                        $el.css({
                            top: "".concat(stickyData.top, "px"),
                            width: "",
                            transition: ""
                        });
                        $el.data("offCanvasSticky", "");
                    }
                });
            }
        },
        {
            key: "reveal",
            value: function reveal(isRevealed) {
                if (isRevealed) {
                    this.close();
                    this.isRevealed = true;
                    this.$element.attr("aria-hidden", "false");
                    this.$element.off("open.zf.trigger toggle.zf.trigger");
                    this.$element.removeClass("is-closed");
                } else {
                    this.isRevealed = false;
                    this.$element.attr("aria-hidden", "true");
                    this.$element.off("open.zf.trigger toggle.zf.trigger").on({
                        "open.zf.trigger": this.open.bind(this),
                        "toggle.zf.trigger": this.toggle.bind(this)
                    });
                    this.$element.addClass("is-closed");
                }
                this._addContentClasses(isRevealed);
            }
        },
        {
            key: "_stopScrolling",
            value: function _stopScrolling() {
                return false;
            }
        },
        {
            key: "_recordScrollable",
            value: function _recordScrollable(event) {
                var elem = this;
                elem.lastY = event.touches[0].pageY;
            }
        },
        {
            key: "_preventDefaultAtEdges",
            value: function _preventDefaultAtEdges(event) {
                var elem = this;
                var _this = event.data;
                var delta = elem.lastY - event.touches[0].pageY;
                elem.lastY = event.touches[0].pageY;
                if (!_this._canScroll(delta, elem)) event.preventDefault();
            }
        },
        {
            key: "_scrollboxTouchMoved",
            value: function _scrollboxTouchMoved(event) {
                var elem = this;
                var _this = event.data;
                var parent = elem.closest("[data-off-canvas], [data-off-canvas-scrollbox-outer]");
                var delta = elem.lastY - event.touches[0].pageY;
                parent.lastY = elem.lastY = event.touches[0].pageY;
                event.stopPropagation();
                if (!_this._canScroll(delta, elem)) {
                    if (!_this._canScroll(delta, parent)) event.preventDefault();
                    else parent.scrollTop += delta;
                }
            }
        },
        {
            key: "_canScroll",
            value: function _canScroll(delta, elem) {
                var up = delta < 0;
                var down = delta > 0;
                var allowUp = elem.scrollTop > 0;
                var allowDown = elem.scrollTop < elem.scrollHeight - elem.clientHeight;
                return up && allowUp || down && allowDown;
            }
        },
        {
            key: "open",
            value: function open(event, trigger) {
                var _this4 = this;
                if (this.$element.hasClass("is-open") || this.isRevealed || this.isInCanvas) return;
                var _this = this;
                if (trigger) this.$lastTrigger = trigger;
                if (this.options.forceTo === "top") window.scrollTo(0, 0);
                else if (this.options.forceTo === "bottom") window.scrollTo(0, document.body.scrollHeight);
                if (this.options.transitionTime && this.options.transition !== "overlap") this.$element.siblings("[data-off-canvas-content]").css("transition-duration", this.options.transitionTime);
                else this.$element.siblings("[data-off-canvas-content]").css("transition-duration", "");
                this.$element.addClass("is-open").removeClass("is-closed");
                this.$triggers.attr("aria-expanded", "true");
                this.$element.attr("aria-hidden", "false");
                this.$content.addClass("is-open-" + this.position);
                // If `contentScroll` is set to false, add class and disable scrolling on touch devices.
                if (this.options.contentScroll === false) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").addClass("is-off-canvas-open").on("touchmove", this._stopScrolling);
                    this.$element.on("touchstart", this._recordScrollable);
                    this.$element.on("touchmove", this, this._preventDefaultAtEdges);
                    this.$element.on("touchstart", "[data-off-canvas-scrollbox]", this._recordScrollable);
                    this.$element.on("touchmove", "[data-off-canvas-scrollbox]", this, this._scrollboxTouchMoved);
                }
                if (this.options.contentOverlay === true) this.$overlay.addClass("is-visible");
                if (this.options.closeOnClick === true && this.options.contentOverlay === true) this.$overlay.addClass("is-closable");
                if (this.options.autoFocus === true) this.$element.one($57aa6ed7a3256ce7$var$transitionend(this.$element), function() {
                    if (!_this.$element.hasClass("is-open")) return; // exit if prematurely closed
                    var canvasFocus = _this.$element.find("[data-autofocus]");
                    if (canvasFocus.length) canvasFocus.eq(0).focus();
                    else _this.$element.find("a, button").eq(0).focus();
                });
                if (this.options.trapFocus === true) {
                    this.$content.attr("tabindex", "-1");
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.trapFocus(this.$element);
                }
                if (this.options.transition === "push") this._fixStickyElements();
                this._addContentClasses();
                /**
       * Fires when the off-canvas menu opens.
       * @event OffCanvas#opened
       */ this.$element.trigger("opened.zf.offCanvas");
                /**
       * Fires when the off-canvas menu open transition is done.
       * @event OffCanvas#openedEnd
       */ this.$element.one($57aa6ed7a3256ce7$var$transitionend(this.$element), function() {
                    _this4.$element.trigger("openedEnd.zf.offCanvas");
                });
            }
        },
        {
            key: "close",
            value: function close() {
                var _this5 = this;
                if (!this.$element.hasClass("is-open") || this.isRevealed) return;
                /**
       * Fires when the off-canvas menu closes.
       * @event OffCanvas#close
       */ this.$element.trigger("close.zf.offCanvas");
                this.$element.removeClass("is-open");
                this.$element.attr("aria-hidden", "true");
                this.$content.removeClass("is-open-left is-open-top is-open-right is-open-bottom");
                if (this.options.contentOverlay === true) this.$overlay.removeClass("is-visible");
                if (this.options.closeOnClick === true && this.options.contentOverlay === true) this.$overlay.removeClass("is-closable");
                this.$triggers.attr("aria-expanded", "false");
                // Listen to transitionEnd: add class, re-enable scrolling and release focus when done.
                this.$element.one($57aa6ed7a3256ce7$var$transitionend(this.$element), function() {
                    _this5.$element.addClass("is-closed");
                    _this5._removeContentClasses();
                    if (_this5.options.transition === "push") _this5._unfixStickyElements();
                    // If `contentScroll` is set to false, remove class and re-enable scrolling on touch devices.
                    if (_this5.options.contentScroll === false) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").removeClass("is-off-canvas-open").off("touchmove", _this5._stopScrolling);
                        _this5.$element.off("touchstart", _this5._recordScrollable);
                        _this5.$element.off("touchmove", _this5._preventDefaultAtEdges);
                        _this5.$element.off("touchstart", "[data-off-canvas-scrollbox]", _this5._recordScrollable);
                        _this5.$element.off("touchmove", "[data-off-canvas-scrollbox]", _this5._scrollboxTouchMoved);
                    }
                    if (_this5.options.trapFocus === true) {
                        _this5.$content.removeAttr("tabindex");
                        $57aa6ed7a3256ce7$export$16e4d70cc375e707.releaseFocus(_this5.$element);
                    }
                    /**
         * Fires when the off-canvas menu close transition is done.
         * @event OffCanvas#closed
         */ _this5.$element.trigger("closed.zf.offCanvas");
                });
            }
        },
        {
            key: "toggle",
            value: function toggle(event, trigger) {
                if (this.$element.hasClass("is-open")) this.close(event, trigger);
                else this.open(event, trigger);
            }
        },
        {
            key: "_handleKeyboard",
            value: function _handleKeyboard(e) {
                var _this6 = this;
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "OffCanvas", {
                    close: function close() {
                        _this6.close();
                        _this6.$lastTrigger.focus();
                        return true;
                    },
                    handled: function handled() {
                        e.preventDefault();
                    }
                });
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.close();
                this.$element.off(".zf.trigger .zf.offCanvas");
                this.$overlay.off(".zf.offCanvas");
                if (this.onLoadListener) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(this.onLoadListener);
            }
        }
    ]);
    return OffCanvas;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$644db29b3dffde4c.defaults = {
    /**
   * Allow the user to click outside of the menu to close it.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnClick: true,
    /**
   * Adds an overlay on top of `[data-off-canvas-content]`.
   * @option
   * @type {boolean}
   * @default true
   */ contentOverlay: true,
    /**
   * Target an off-canvas content container by ID that may be placed anywhere. If null the closest content container will be taken.
   * @option
   * @type {?string}
   * @default null
   */ contentId: null,
    /**
   * Define the off-canvas element is nested in an off-canvas content. This is required when using the contentId option for a nested element.
   * @option
   * @type {boolean}
   * @default null
   */ nested: null,
    /**
   * Enable/disable scrolling of the main content when an off canvas panel is open.
   * @option
   * @type {boolean}
   * @default true
   */ contentScroll: true,
    /**
   * Amount of time the open and close transition requires, including the appropriate milliseconds (`ms`) or seconds (`s`) unit (e.g. `500ms`, `.75s`) If none selected, pulls from body style.
   * @option
   * @type {string}
   * @default null
   */ transitionTime: null,
    /**
   * Type of transition for the OffCanvas menu. Options are 'push', 'detached' or 'slide'.
   * @option
   * @type {string}
   * @default push
   */ transition: "push",
    /**
   * Force the page to scroll to top or bottom on open.
   * @option
   * @type {?string}
   * @default null
   */ forceTo: null,
    /**
   * Allow the OffCanvas to remain open for certain breakpoints.
   * @option
   * @type {boolean}
   * @default false
   */ isRevealed: false,
    /**
   * Breakpoint at which to reveal. JS will use a RegExp to target standard classes, if changing classnames, pass your class with the `revealClass` option.
   * @option
   * @type {?string}
   * @default null
   */ revealOn: null,
    /**
   * Breakpoint at which the off-canvas gets moved into canvas content and acts as regular page element.
   * @option
   * @type {?string}
   * @default null
   */ inCanvasOn: null,
    /**
   * Force focus to the offcanvas on open. If true, will focus the opening trigger on close.
   * @option
   * @type {boolean}
   * @default true
   */ autoFocus: true,
    /**
   * Class used to force an OffCanvas to remain open. Foundation defaults for this are `reveal-for-large` & `reveal-for-medium`.
   * @option
   * @type {string}
   * @default reveal-for-
   * @todo improve the regex testing for this.
   */ revealClass: "reveal-for-",
    /**
   * Triggers optional focus trapping when opening an OffCanvas. Sets tabindex of [data-off-canvas-content] to -1 for accessibility purposes.
   * @option
   * @type {boolean}
   * @default false
   */ trapFocus: false
};
/**
 * Orbit module.
 * @module foundation.orbit
 * @requires foundation.util.keyboard
 * @requires foundation.util.motion
 * @requires foundation.util.timer
 * @requires foundation.util.imageLoader
 * @requires foundation.util.touch
 */ var $57aa6ed7a3256ce7$export$439358b35042ae9f = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Orbit, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Orbit);
    function Orbit() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Orbit);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Orbit, [
        {
            key: "_setup",
            value: /**
    * Creates a new instance of an orbit carousel.
    * @class
    * @name Orbit
    * @param {jQuery} element - jQuery object to make into an Orbit Carousel.
    * @param {Object} options - Overrides to the default plugin settings.
    */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Orbit.defaults, this.$element.data(), options);
                this.className = "Orbit"; // ie9 back compat
                $57aa6ed7a3256ce7$export$746b04bbf92762fd.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))); // Touch init is idempotent, we just need to make sure it's initialied.
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("Orbit", {
                    "ltr": {
                        "ARROW_RIGHT": "next",
                        "ARROW_LEFT": "previous"
                    },
                    "rtl": {
                        "ARROW_LEFT": "next",
                        "ARROW_RIGHT": "previous"
                    }
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                // @TODO: consider discussion on PR #9278 about DOM pollution by changeSlide
                this._reset();
                this.$wrapper = this.$element.find(".".concat(this.options.containerClass));
                this.$slides = this.$element.find(".".concat(this.options.slideClass));
                var $images = this.$element.find("img"), initActive = this.$slides.filter(".is-active"), id = this.$element[0].id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "orbit");
                this.$element.attr({
                    "data-resize": id,
                    "id": id
                });
                if (!initActive.length) this.$slides.eq(0).addClass("is-active");
                if (!this.options.useMUI) this.$slides.addClass("no-motionui");
                if ($images.length) $57aa6ed7a3256ce7$export$9a7c395a24d73631($images, this._prepareForOrbit.bind(this));
                else this._prepareForOrbit(); //hehe
                if (this.options.bullets) this._loadBullets();
                this._events();
                if (this.options.autoPlay && this.$slides.length > 1) this.geoSync();
                if (this.options.accessible) // allow wrapper to be focusable to enable arrow navigation
                this.$wrapper.attr("tabindex", 0);
            }
        },
        {
            key: "_loadBullets",
            value: function _loadBullets() {
                this.$bullets = this.$element.find(".".concat(this.options.boxOfBullets)).find("button");
            }
        },
        {
            key: "geoSync",
            value: function geoSync() {
                var _this = this;
                this.timer = new $57aa6ed7a3256ce7$export$c57e9b2d8b9e4de(this.$element, {
                    duration: this.options.timerDelay,
                    infinite: false
                }, function() {
                    _this.changeSlide(true);
                });
                this.timer.start();
            }
        },
        {
            key: "_prepareForOrbit",
            value: function _prepareForOrbit() {
                this._setWrapperHeight();
            }
        },
        {
            key: "_setWrapperHeight",
            value: function _setWrapperHeight(cb) {
                //rewrite this to `for` loop
                var max = 0, temp, counter = 0, _this = this;
                this.$slides.each(function() {
                    temp = this.getBoundingClientRect().height;
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("data-slide", counter);
                    // hide all slides but the active one
                    if (!/mui/g.test((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this)[0].className) && _this.$slides.filter(".is-active")[0] !== _this.$slides.eq(counter)[0]) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).css({
                        "display": "none"
                    });
                    max = temp > max ? temp : max;
                    counter++;
                });
                if (counter === this.$slides.length) {
                    this.$wrapper.css({
                        "height": max
                    }); //only change the wrapper height property once.
                    if (cb) cb(max);
                     //fire callback with max height dimension.
                }
            }
        },
        {
            key: "_setSlideHeight",
            value: function _setSlideHeight(height) {
                this.$slides.each(function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).css("max-height", height);
                });
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this;
                //***************************************
                //**Now using custom event - thanks to:**
                //**      Yohai Ararat of Toronto      **
                //***************************************
                //
                this.$element.off(".resizeme.zf.trigger").on({
                    "resizeme.zf.trigger": this._prepareForOrbit.bind(this)
                });
                if (this.$slides.length > 1) {
                    if (this.options.swipe) this.$slides.off("swipeleft.zf.orbit swiperight.zf.orbit").on("swipeleft.zf.orbit", function(e) {
                        e.preventDefault();
                        _this.changeSlide(true);
                    }).on("swiperight.zf.orbit", function(e) {
                        e.preventDefault();
                        _this.changeSlide(false);
                    });
                    //***************************************
                    if (this.options.autoPlay) {
                        this.$slides.on("click.zf.orbit", function() {
                            _this.$element.data("clickedOn", _this.$element.data("clickedOn") ? false : true);
                            _this.timer[_this.$element.data("clickedOn") ? "pause" : "start"]();
                        });
                        if (this.options.pauseOnHover) this.$element.on("mouseenter.zf.orbit", function() {
                            _this.timer.pause();
                        }).on("mouseleave.zf.orbit", function() {
                            if (!_this.$element.data("clickedOn")) _this.timer.start();
                        });
                    }
                    if (this.options.navButtons) {
                        var $controls = this.$element.find(".".concat(this.options.nextClass, ", .").concat(this.options.prevClass));
                        $controls.attr("tabindex", 0)//also need to handle enter/return and spacebar key presses
                        .on("click.zf.orbit touchend.zf.orbit", function(e) {
                            e.preventDefault();
                            _this.changeSlide((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).hasClass(_this.options.nextClass));
                        });
                    }
                    if (this.options.bullets) this.$bullets.on("click.zf.orbit touchend.zf.orbit", function() {
                        if (/is-active/g.test(this.className)) return false;
                         //if this is active, kick out of function.
                        var idx = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("slide"), ltr = idx > _this.$slides.filter(".is-active").data("slide"), $slide = _this.$slides.eq(idx);
                        _this.changeSlide(ltr, $slide, idx);
                    });
                    if (this.options.accessible) this.$wrapper.add(this.$bullets).on("keydown.zf.orbit", function(e) {
                        // handle keyboard event with keyboard util
                        $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "Orbit", {
                            next: function next() {
                                _this.changeSlide(true);
                            },
                            previous: function previous() {
                                _this.changeSlide(false);
                            },
                            handled: function handled() {
                                // if bullet is focused, make sure focus moves
                                if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target).is(_this.$bullets)) _this.$bullets.filter(".is-active").focus();
                            }
                        });
                    });
                }
            }
        },
        {
            key: "_reset",
            value: function _reset() {
                // Don't do anything if there are no slides (first run)
                if (typeof this.$slides === "undefined") return;
                if (this.$slides.length > 1) {
                    // Remove old events
                    this.$element.off(".zf.orbit").find("*").off(".zf.orbit");
                    // Restart timer if autoPlay is enabled
                    if (this.options.autoPlay) this.timer.restart();
                    // Reset all sliddes
                    this.$slides.each(function(el) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(el).removeClass("is-active is-active is-in").removeAttr("aria-live").hide();
                    });
                    // Show the first slide
                    this.$slides.first().addClass("is-active").show();
                    // Triggers when the slide has finished animating
                    this.$element.trigger("slidechange.zf.orbit", [
                        this.$slides.first()
                    ]);
                    // Select first bullet if bullets are present
                    if (this.options.bullets) this._updateBullets(0);
                }
            }
        },
        {
            key: "changeSlide",
            value: function changeSlide(isLTR, chosenSlide, idx) {
                if (!this.$slides) return;
                 // Don't freak out if we're in the middle of cleanup
                var $curSlide = this.$slides.filter(".is-active").eq(0);
                if (/mui/g.test($curSlide[0].className)) return false;
                 //if the slide is currently animating, kick out of the function
                var $firstSlide = this.$slides.first(), $lastSlide = this.$slides.last(), dirIn = isLTR ? "Right" : "Left", dirOut = isLTR ? "Left" : "Right", _this = this, $newSlide;
                if (!chosenSlide) //most of the time, this will be auto played or clicked from the navButtons.
                $newSlide = isLTR ? //if wrapping enabled, check to see if there is a `next` or `prev` sibling, if not, select the first or last slide to fill in. if wrapping not enabled, attempt to select `next` or `prev`, if there's nothing there, the function will kick out on next step. CRAZY NESTED TERNARIES!!!!!
                this.options.infiniteWrap ? $curSlide.next(".".concat(this.options.slideClass)).length ? $curSlide.next(".".concat(this.options.slideClass)) : $firstSlide : $curSlide.next(".".concat(this.options.slideClass)) //pick next slide if moving left to right
                 : this.options.infiniteWrap ? $curSlide.prev(".".concat(this.options.slideClass)).length ? $curSlide.prev(".".concat(this.options.slideClass)) : $lastSlide : $curSlide.prev(".".concat(this.options.slideClass)); //pick prev slide if moving right to left
                else $newSlide = chosenSlide;
                if ($newSlide.length) {
                    /**
        * Triggers before the next slide starts animating in and only if a next slide has been found.
        * @event Orbit#beforeslidechange
        */ this.$element.trigger("beforeslidechange.zf.orbit", [
                        $curSlide,
                        $newSlide
                    ]);
                    if (this.options.bullets) {
                        idx = idx || this.$slides.index($newSlide); //grab index to update bullets
                        this._updateBullets(idx);
                    }
                    if (this.options.useMUI && !this.$element.is(":hidden")) {
                        $57aa6ed7a3256ce7$export$ab7b018719e111db.animateIn($newSlide.addClass("is-active"), this.options["animInFrom".concat(dirIn)], function() {
                            $newSlide.css({
                                "display": "block"
                            }).attr("aria-live", "polite");
                        });
                        $57aa6ed7a3256ce7$export$ab7b018719e111db.animateOut($curSlide.removeClass("is-active"), this.options["animOutTo".concat(dirOut)], function() {
                            $curSlide.removeAttr("aria-live");
                            if (_this.options.autoPlay && !_this.timer.isPaused) _this.timer.restart();
                        //do stuff?
                        });
                    } else {
                        $curSlide.removeClass("is-active is-in").removeAttr("aria-live").hide();
                        $newSlide.addClass("is-active is-in").attr("aria-live", "polite").show();
                        if (this.options.autoPlay && !this.timer.isPaused) this.timer.restart();
                    }
                    /**
        * Triggers when the slide has finished animating in.
        * @event Orbit#slidechange
        */ this.$element.trigger("slidechange.zf.orbit", [
                        $newSlide
                    ]);
                }
            }
        },
        {
            key: "_updateBullets",
            value: function _updateBullets(idx) {
                var $oldBullet = this.$bullets.filter(".is-active");
                var $othersBullets = this.$bullets.not(".is-active");
                var $newBullet = this.$bullets.eq(idx);
                $oldBullet.removeClass("is-active").blur();
                $newBullet.addClass("is-active");
                // Find the descriptor for the current slide to move it to the new slide button
                var activeStateDescriptor = $oldBullet.children("[data-slide-active-label]").last();
                // If not explicitely given, search for the last "exceeding" span element (compared to others bullets).
                if (!activeStateDescriptor.length) {
                    var spans = $oldBullet.children("span");
                    var spanCountInOthersBullets = $othersBullets.toArray().map(function(b) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(b).children("span").length;
                    });
                    // If there is an exceeding span element, use it as current slide descriptor
                    if (spanCountInOthersBullets.every(function(count) {
                        return count < spans.length;
                    })) {
                        activeStateDescriptor = spans.last();
                        activeStateDescriptor.attr("data-slide-active-label", "");
                    }
                }
                // Move the current slide descriptor to the new slide button
                if (activeStateDescriptor.length) {
                    activeStateDescriptor.detach();
                    $newBullet.append(activeStateDescriptor);
                }
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.off(".zf.orbit").find("*").off(".zf.orbit").end().hide();
            }
        }
    ]);
    return Orbit;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$439358b35042ae9f.defaults = {
    /**
  * Tells the JS to look for and loadBullets.
  * @option
   * @type {boolean}
  * @default true
  */ bullets: true,
    /**
  * Tells the JS to apply event listeners to nav buttons
  * @option
   * @type {boolean}
  * @default true
  */ navButtons: true,
    /**
  * motion-ui animation class to apply
  * @option
   * @type {string}
  * @default 'slide-in-right'
  */ animInFromRight: "slide-in-right",
    /**
  * motion-ui animation class to apply
  * @option
   * @type {string}
  * @default 'slide-out-right'
  */ animOutToRight: "slide-out-right",
    /**
  * motion-ui animation class to apply
  * @option
   * @type {string}
  * @default 'slide-in-left'
  *
  */ animInFromLeft: "slide-in-left",
    /**
  * motion-ui animation class to apply
  * @option
   * @type {string}
  * @default 'slide-out-left'
  */ animOutToLeft: "slide-out-left",
    /**
  * Allows Orbit to automatically animate on page load.
  * @option
   * @type {boolean}
  * @default true
  */ autoPlay: true,
    /**
  * Amount of time, in ms, between slide transitions
  * @option
   * @type {number}
  * @default 5000
  */ timerDelay: 5000,
    /**
  * Allows Orbit to infinitely loop through the slides
  * @option
   * @type {boolean}
  * @default true
  */ infiniteWrap: true,
    /**
  * Allows the Orbit slides to bind to swipe events for mobile, requires an additional util library
  * @option
   * @type {boolean}
  * @default true
  */ swipe: true,
    /**
  * Allows the timing function to pause animation on hover.
  * @option
   * @type {boolean}
  * @default true
  */ pauseOnHover: true,
    /**
  * Allows Orbit to bind keyboard events to the slider, to animate frames with arrow keys
  * @option
   * @type {boolean}
  * @default true
  */ accessible: true,
    /**
  * Class applied to the container of Orbit
  * @option
   * @type {string}
  * @default 'orbit-container'
  */ containerClass: "orbit-container",
    /**
  * Class applied to individual slides.
  * @option
   * @type {string}
  * @default 'orbit-slide'
  */ slideClass: "orbit-slide",
    /**
  * Class applied to the bullet container. You're welcome.
  * @option
   * @type {string}
  * @default 'orbit-bullets'
  */ boxOfBullets: "orbit-bullets",
    /**
  * Class applied to the `next` navigation button.
  * @option
   * @type {string}
  * @default 'orbit-next'
  */ nextClass: "orbit-next",
    /**
  * Class applied to the `previous` navigation button.
  * @option
   * @type {string}
  * @default 'orbit-previous'
  */ prevClass: "orbit-previous",
    /**
  * Boolean to flag the js to use motion ui classes or not. Default to true for backwards compatibility.
  * @option
   * @type {boolean}
  * @default true
  */ useMUI: true
};
var $57aa6ed7a3256ce7$var$MenuPlugins = {
    dropdown: {
        cssClass: "dropdown",
        plugin: $57aa6ed7a3256ce7$export$e44a253a59704894
    },
    drilldown: {
        cssClass: "drilldown",
        plugin: $57aa6ed7a3256ce7$export$c039e4c66cecbe03
    },
    accordion: {
        cssClass: "accordion-menu",
        plugin: $57aa6ed7a3256ce7$export$6abe07ec29339e67
    }
};
// import "foundation.util.triggers.js";
/**
 * ResponsiveMenu module.
 * @module foundation.responsiveMenu
 * @requires foundation.util.triggers
 * @requires foundation.util.mediaQuery
 */ var $57aa6ed7a3256ce7$export$be3a94c40ee849e6 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(ResponsiveMenu, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(ResponsiveMenu);
    function ResponsiveMenu() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, ResponsiveMenu);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(ResponsiveMenu, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of a responsive menu.
     * @class
     * @name ResponsiveMenu
     * @fires ResponsiveMenu#init
     * @param {jQuery} element - jQuery object to make into a dropdown menu.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element) {
                this.$element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element);
                this.rules = this.$element.data("responsive-menu");
                this.currentMq = null;
                this.currentPlugin = null;
                this.className = "ResponsiveMenu"; // ie9 back compat
                this._init();
                this._events();
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                // The first time an Interchange plugin is initialized, this.rules is converted from a string of "classes" to an object of rules
                if (typeof this.rules === "string") {
                    var rulesTree = {};
                    // Parse rules from "classes" pulled from data attribute
                    var rules = this.rules.split(" ");
                    // Iterate through every rule found
                    for(var i = 0; i < rules.length; i++){
                        var rule = rules[i].split("-");
                        var ruleSize = rule.length > 1 ? rule[0] : "small";
                        var rulePlugin = rule.length > 1 ? rule[1] : rule[0];
                        if ($57aa6ed7a3256ce7$var$MenuPlugins[rulePlugin] !== null) rulesTree[ruleSize] = $57aa6ed7a3256ce7$var$MenuPlugins[rulePlugin];
                    }
                    this.rules = rulesTree;
                }
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).isEmptyObject(this.rules)) this._checkMediaQueries();
                // Add data-mutate since children may need it.
                this.$element.attr("data-mutate", this.$element.attr("data-mutate") || $57aa6ed7a3256ce7$var$GetYoDigits(6, "responsive-menu"));
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this;
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("changed.zf.mediaquery", function() {
                    _this._checkMediaQueries();
                });
            // $(window).on('resize.zf.ResponsiveMenu', function() {
            //   _this._checkMediaQueries();
            // });
            }
        },
        {
            key: "_checkMediaQueries",
            value: function _checkMediaQueries() {
                var matchedMq, _this = this;
                // Iterate through each rule and find the last matching rule
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).each(this.rules, function(key) {
                    if ($57aa6ed7a3256ce7$export$b745838c41029eb3.atLeast(key)) matchedMq = key;
                });
                // No match? No dice
                if (!matchedMq) return;
                // Plugin already initialized? We good
                if (this.currentPlugin instanceof this.rules[matchedMq].plugin) return;
                // Remove existing plugin-specific CSS classes
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).each($57aa6ed7a3256ce7$var$MenuPlugins, function(key, value) {
                    _this.$element.removeClass(value.cssClass);
                });
                // Add the CSS class for the new plugin
                this.$element.addClass(this.rules[matchedMq].cssClass);
                // Create an instance of the new plugin
                if (this.currentPlugin) this.currentPlugin.destroy();
                this.currentPlugin = new this.rules[matchedMq].plugin(this.$element, {});
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.currentPlugin.destroy();
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(".zf.ResponsiveMenu");
            }
        }
    ]);
    return ResponsiveMenu;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$be3a94c40ee849e6.defaults = {};
/**
 * ResponsiveToggle module.
 * @module foundation.responsiveToggle
 * @requires foundation.util.mediaQuery
 * @requires foundation.util.motion
 */ var $57aa6ed7a3256ce7$export$990bc2b2cdaf908a = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(ResponsiveToggle, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(ResponsiveToggle);
    function ResponsiveToggle() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, ResponsiveToggle);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(ResponsiveToggle, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of Tab Bar.
     * @class
     * @name ResponsiveToggle
     * @fires ResponsiveToggle#init
     * @param {jQuery} element - jQuery object to attach tab bar functionality to.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element);
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, ResponsiveToggle.defaults, this.$element.data(), options);
                this.className = "ResponsiveToggle"; // ie9 back compat
                this._init();
                this._events();
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                var targetID = this.$element.data("responsive-toggle");
                if (!targetID) console.error("Your tab bar needs an ID of a Menu as the value of data-tab-bar.");
                this.$targetMenu = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(targetID));
                this.$toggler = this.$element.find("[data-toggle]").filter(function() {
                    var target = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).data("toggle");
                    return target === targetID || target === "";
                });
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, this.options, this.$targetMenu.data());
                // If they were set, parse the animation classes
                if (this.options.animate) {
                    var input = this.options.animate.split(" ");
                    this.animationIn = input[0];
                    this.animationOut = input[1] || null;
                }
                this._update();
            }
        },
        {
            key: "_events",
            value: function _events() {
                this._updateMqHandler = this._update.bind(this);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("changed.zf.mediaquery", this._updateMqHandler);
                this.$toggler.on("click.zf.responsiveToggle", this.toggleMenu.bind(this));
            }
        },
        {
            key: "_update",
            value: function _update() {
                // Mobile
                if (!$57aa6ed7a3256ce7$export$b745838c41029eb3.atLeast(this.options.hideFor)) {
                    this.$element.show();
                    this.$targetMenu.hide();
                } else {
                    this.$element.hide();
                    this.$targetMenu.show();
                }
            }
        },
        {
            key: "toggleMenu",
            value: function toggleMenu() {
                var _this = this;
                if (!$57aa6ed7a3256ce7$export$b745838c41029eb3.atLeast(this.options.hideFor)) {
                    /**
         * Fires when the element attached to the tab bar toggles.
         * @event ResponsiveToggle#toggled
         */ if (this.options.animate) {
                        if (this.$targetMenu.is(":hidden")) $57aa6ed7a3256ce7$export$ab7b018719e111db.animateIn(this.$targetMenu, this.animationIn, function() {
                            _this.$element.trigger("toggled.zf.responsiveToggle");
                            _this.$targetMenu.find("[data-mutate]").triggerHandler("mutateme.zf.trigger");
                        });
                        else $57aa6ed7a3256ce7$export$ab7b018719e111db.animateOut(this.$targetMenu, this.animationOut, function() {
                            _this.$element.trigger("toggled.zf.responsiveToggle");
                        });
                    } else {
                        this.$targetMenu.toggle(0);
                        this.$targetMenu.find("[data-mutate]").trigger("mutateme.zf.trigger");
                        this.$element.trigger("toggled.zf.responsiveToggle");
                    }
                }
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.off(".zf.responsiveToggle");
                this.$toggler.off(".zf.responsiveToggle");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off("changed.zf.mediaquery", this._updateMqHandler);
            }
        }
    ]);
    return ResponsiveToggle;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$990bc2b2cdaf908a.defaults = {
    /**
   * The breakpoint after which the menu is always shown, and the tab bar is hidden.
   * @option
   * @type {string}
   * @default 'medium'
   */ hideFor: "medium",
    /**
   * To decide if the toggle should be animated or not.
   * @option
   * @type {boolean}
   * @default false
   */ animate: false
};
/**
 * Reveal module.
 * @module foundation.reveal
 * @requires foundation.util.keyboard
 * @requires foundation.util.touch
 * @requires foundation.util.triggers
 * @requires foundation.util.mediaQuery
 * @requires foundation.util.motion if using animations
 */ var $57aa6ed7a3256ce7$export$9a32a8eb4bb56ca3 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Reveal, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Reveal);
    function Reveal() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Reveal);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Reveal, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of Reveal.
     * @class
     * @name Reveal
     * @param {jQuery} element - jQuery object to use for the modal.
     * @param {Object} options - optional parameters.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Reveal.defaults, this.$element.data(), options);
                this.className = "Reveal"; // ie9 back compat
                this._init();
                // Touch and Triggers init are idempotent, just need to make sure they are initialized
                $57aa6ed7a3256ce7$export$746b04bbf92762fd.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("Reveal", {
                    "ESCAPE": "close"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this2 = this;
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                this.id = this.$element.attr("id");
                this.isActive = false;
                this.cached = {
                    mq: $57aa6ed7a3256ce7$export$b745838c41029eb3.current
                };
                this.$anchor = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-open="'.concat(this.id, '"]')).length ? (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-open="'.concat(this.id, '"]')) : (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-toggle="'.concat(this.id, '"]'));
                this.$anchor.attr({
                    "aria-controls": this.id,
                    "aria-haspopup": "dialog",
                    "tabindex": 0
                });
                if (this.options.fullScreen || this.$element.hasClass("full")) {
                    this.options.fullScreen = true;
                    this.options.overlay = false;
                }
                if (this.options.overlay && !this.$overlay) this.$overlay = this._makeOverlay(this.id);
                this.$element.attr({
                    "role": "dialog",
                    "aria-hidden": true,
                    "data-yeti-box": this.id,
                    "data-resize": this.id
                });
                if (this.$overlay) this.$element.detach().appendTo(this.$overlay);
                else {
                    this.$element.detach().appendTo((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.options.appendTo));
                    this.$element.addClass("without-overlay");
                }
                this._events();
                if (this.options.deepLink && window.location.hash === "#".concat(this.id)) this.onLoadListener = $57aa6ed7a3256ce7$var$onLoad((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window), function() {
                    return _this2.open();
                });
            }
        },
        {
            key: "_makeOverlay",
            value: function _makeOverlay() {
                var additionalOverlayClasses = "";
                if (this.options.additionalOverlayClasses) additionalOverlayClasses = " " + this.options.additionalOverlayClasses;
                return (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("<div></div>").addClass("reveal-overlay" + additionalOverlayClasses).appendTo(this.options.appendTo);
            }
        },
        {
            key: "_updatePosition",
            value: function _updatePosition() {
                var width = this.$element.outerWidth();
                var outerWidth = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).width();
                var height = this.$element.outerHeight();
                var outerHeight = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).height();
                var left, top = null;
                if (this.options.hOffset === "auto") left = parseInt((outerWidth - width) / 2, 10);
                else left = parseInt(this.options.hOffset, 10);
                if (this.options.vOffset === "auto") {
                    if (height > outerHeight) top = parseInt(Math.min(100, outerHeight / 10), 10);
                    else top = parseInt((outerHeight - height) / 4, 10);
                } else if (this.options.vOffset !== null) top = parseInt(this.options.vOffset, 10);
                if (top !== null) this.$element.css({
                    top: top + "px"
                });
                // only worry about left if we don't have an overlay or we have a horizontal offset,
                // otherwise we're perfectly in the middle
                if (!this.$overlay || this.options.hOffset !== "auto") {
                    this.$element.css({
                        left: left + "px"
                    });
                    this.$element.css({
                        margin: "0px"
                    });
                }
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this3 = this;
                var _this = this;
                this.$element.on({
                    "open.zf.trigger": this.open.bind(this),
                    "close.zf.trigger": function closeZfTrigger(event, $element) {
                        if (event.target === _this.$element[0] || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(event.target).parents("[data-closable]")[0] === $element) // only close reveal when it's explicitly called
                        return _this3.close.apply(_this3);
                    },
                    "toggle.zf.trigger": this.toggle.bind(this),
                    "resizeme.zf.trigger": function resizemeZfTrigger() {
                        _this._updatePosition();
                    }
                });
                if (this.options.closeOnClick && this.options.overlay) this.$overlay.off(".zf.reveal").on("click.zf.dropdown tap.zf.dropdown", function(e) {
                    if (e.target === _this.$element[0] || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).contains(_this.$element[0], e.target) || !(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).contains(document, e.target)) return;
                    _this.close();
                });
                if (this.options.deepLink) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("hashchange.zf.reveal:".concat(this.id), this._handleState.bind(this));
            }
        },
        {
            key: "_handleState",
            value: function _handleState() {
                if (window.location.hash === "#" + this.id && !this.isActive) this.open();
                else this.close();
            }
        },
        {
            key: "_disableScroll",
            value: function _disableScroll(scrollTop) {
                scrollTop = scrollTop || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).scrollTop();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document).height() > (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).height()) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").css("top", -scrollTop);
            }
        },
        {
            key: "_enableScroll",
            value: function _enableScroll(scrollTop) {
                scrollTop = scrollTop || parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").css("top"), 10);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document).height() > (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).height()) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").css("top", "");
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).scrollTop(-scrollTop);
                }
            }
        },
        {
            key: "open",
            value: function open() {
                var _this4 = this;
                // either update or replace browser history
                var hash = "#".concat(this.id);
                if (this.options.deepLink && window.location.hash !== hash) {
                    if (window.history.pushState) {
                        if (this.options.updateHistory) window.history.pushState({}, "", hash);
                        else window.history.replaceState({}, "", hash);
                    } else window.location.hash = hash;
                }
                // Remember anchor that opened it to set focus back later, have general anchors as fallback
                this.$activeAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document.activeElement).is(this.$anchor) ? (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document.activeElement) : this.$anchor;
                this.isActive = true;
                // Make elements invisible, but remove display: none so we can get size and positioning
                this.$element.css({
                    "visibility": "hidden"
                }).show().scrollTop(0);
                if (this.options.overlay) this.$overlay.css({
                    "visibility": "hidden"
                }).show();
                this._updatePosition();
                this.$element.hide().css({
                    "visibility": ""
                });
                if (this.$overlay) {
                    this.$overlay.css({
                        "visibility": ""
                    }).hide();
                    if (this.$element.hasClass("fast")) this.$overlay.addClass("fast");
                    else if (this.$element.hasClass("slow")) this.$overlay.addClass("slow");
                }
                if (!this.options.multipleOpened) /**
         * Fires immediately before the modal opens.
         * Closes any other modals that are currently open
         * @event Reveal#closeme
         */ this.$element.trigger("closeme.zf.reveal", this.id);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".reveal:visible").length === 0) this._disableScroll();
                var _this = this;
                // Motion UI method of reveal
                if (this.options.animationIn) {
                    var afterAnimation = function afterAnimation() {
                        _this.$element.attr({
                            "aria-hidden": false,
                            "tabindex": -1
                        }).focus();
                        _this._addGlobalClasses();
                        $57aa6ed7a3256ce7$export$16e4d70cc375e707.trapFocus(_this.$element);
                    };
                    if (this.options.overlay) $57aa6ed7a3256ce7$export$ab7b018719e111db.animateIn(this.$overlay, "fade-in");
                    $57aa6ed7a3256ce7$export$ab7b018719e111db.animateIn(this.$element, this.options.animationIn, function() {
                        if (_this4.$element) {
                            // protect against object having been removed
                            _this4.focusableElements = $57aa6ed7a3256ce7$export$16e4d70cc375e707.findFocusable(_this4.$element);
                            afterAnimation();
                        }
                    });
                } else {
                    if (this.options.overlay) this.$overlay.show(0);
                    this.$element.show(this.options.showDelay);
                }
                // handle accessibility
                this.$element.attr({
                    "aria-hidden": false,
                    "tabindex": -1
                }).focus();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.trapFocus(this.$element);
                this._addGlobalClasses();
                this._addGlobalListeners();
                /**
       * Fires when the modal has successfully opened.
       * @event Reveal#open
       */ this.$element.trigger("open.zf.reveal");
            }
        },
        {
            key: "_addGlobalClasses",
            value: function _addGlobalClasses() {
                var updateScrollbarClass = function updateScrollbarClass() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").toggleClass("zf-has-scroll", !!((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document).height() > (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).height()));
                };
                this.$element.on("resizeme.zf.trigger.revealScrollbarListener", function() {
                    return updateScrollbarClass();
                });
                updateScrollbarClass();
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").addClass("is-reveal-open");
            }
        },
        {
            key: "_removeGlobalClasses",
            value: function _removeGlobalClasses() {
                this.$element.off("resizeme.zf.trigger.revealScrollbarListener");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").removeClass("is-reveal-open");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").removeClass("zf-has-scroll");
            }
        },
        {
            key: "_addGlobalListeners",
            value: function _addGlobalListeners() {
                var _this = this;
                if (!this.$element) return;
                 // If we're in the middle of cleanup, don't freak out
                this.focusableElements = $57aa6ed7a3256ce7$export$16e4d70cc375e707.findFocusable(this.$element);
                if (!this.options.overlay && this.options.closeOnClick && !this.options.fullScreen) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").on("click.zf.dropdown tap.zf.dropdown", function(e) {
                    if (e.target === _this.$element[0] || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).contains(_this.$element[0], e.target) || !(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).contains(document, e.target)) return;
                    _this.close();
                });
                if (this.options.closeOnEsc) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("keydown.zf.reveal", function(e) {
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "Reveal", {
                        close: function close() {
                            if (_this.options.closeOnEsc) _this.close();
                        }
                    });
                });
            }
        },
        {
            key: "close",
            value: function close() {
                if (!this.isActive || !this.$element.is(":visible")) return false;
                var _this = this;
                // Motion UI method of hiding
                if (this.options.animationOut) {
                    if (this.options.overlay) $57aa6ed7a3256ce7$export$ab7b018719e111db.animateOut(this.$overlay, "fade-out");
                    $57aa6ed7a3256ce7$export$ab7b018719e111db.animateOut(this.$element, this.options.animationOut, finishUp);
                } else {
                    this.$element.hide(this.options.hideDelay);
                    if (this.options.overlay) this.$overlay.hide(0, finishUp);
                    else finishUp();
                }
                // Conditionals to remove extra event listeners added on open
                if (this.options.closeOnEsc) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off("keydown.zf.reveal");
                if (!this.options.overlay && this.options.closeOnClick) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").off("click.zf.dropdown tap.zf.dropdown");
                this.$element.off("keydown.zf.reveal");
                function finishUp() {
                    // Get the current top before the modal is closed and restore the scroll after.
                    // TODO: use component properties instead of HTML properties
                    // See https://github.com/foundation/foundation-sites/pull/10786
                    var scrollTop = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html").css("top"), 10);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".reveal:visible").length === 0) _this._removeGlobalClasses(); // also remove .is-reveal-open from the html element when there is no opened reveal
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.releaseFocus(_this.$element);
                    _this.$element.attr("aria-hidden", true);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".reveal:visible").length === 0) _this._enableScroll(scrollTop);
                    /**
        * Fires when the modal is done closing.
        * @event Reveal#closed
        */ _this.$element.trigger("closed.zf.reveal");
                }
                /**
      * Resets the modal content
      * This prevents a running video to keep going in the background
      */ if (this.options.resetOnClose) this.$element.html(this.$element.html());
                this.isActive = false;
                // If deepLink and we did not switched to an other modal...
                if (_this.options.deepLink && window.location.hash === "#".concat(this.id)) {
                    // Remove the history hash
                    if (window.history.replaceState) {
                        var urlWithoutHash = window.location.pathname + window.location.search;
                        if (this.options.updateHistory) window.history.pushState({}, "", urlWithoutHash); // remove the hash
                        else window.history.replaceState("", document.title, urlWithoutHash);
                    } else window.location.hash = "";
                }
                this.$activeAnchor.focus();
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (this.isActive) this.close();
                else this.open();
            }
        },
        {
            key: "_destroy",
            value: /**
     * Destroys an instance of a modal.
     * @function
     */ function _destroy() {
                if (this.options.overlay) {
                    this.$element.appendTo((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.options.appendTo)); // move $element outside of $overlay to prevent error unregisterPlugin()
                    this.$overlay.hide().off().remove();
                }
                this.$element.hide().off();
                this.$anchor.off(".zf");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(".zf.reveal:".concat(this.id));
                if (this.onLoadListener) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(this.onLoadListener);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".reveal:visible").length === 0) this._removeGlobalClasses(); // also remove .is-reveal-open from the html element when there is no opened reveal
            }
        }
    ]);
    return Reveal;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$9a32a8eb4bb56ca3.defaults = {
    /**
   * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
   * @option
   * @type {string}
   * @default ''
   */ animationIn: "",
    /**
   * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
   * @option
   * @type {string}
   * @default ''
   */ animationOut: "",
    /**
   * Time, in ms, to delay the opening of a modal after a click if no animation used.
   * @option
   * @type {number}
   * @default 0
   */ showDelay: 0,
    /**
   * Time, in ms, to delay the closing of a modal after a click if no animation used.
   * @option
   * @type {number}
   * @default 0
   */ hideDelay: 0,
    /**
   * Allows a click on the body/overlay to close the modal.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnClick: true,
    /**
   * Allows the modal to close if the user presses the `ESCAPE` key.
   * @option
   * @type {boolean}
   * @default true
   */ closeOnEsc: true,
    /**
   * If true, allows multiple modals to be displayed at once.
   * @option
   * @type {boolean}
   * @default false
   */ multipleOpened: false,
    /**
   * Distance, in pixels, the modal should push down from the top of the screen.
   * @option
   * @type {number|string}
   * @default auto
   */ vOffset: "auto",
    /**
   * Distance, in pixels, the modal should push in from the side of the screen.
   * @option
   * @type {number|string}
   * @default auto
   */ hOffset: "auto",
    /**
   * Allows the modal to be fullscreen, completely blocking out the rest of the view. JS checks for this as well.
   * @option
   * @type {boolean}
   * @default false
   */ fullScreen: false,
    /**
   * Allows the modal to generate an overlay div, which will cover the view when modal opens.
   * @option
   * @type {boolean}
   * @default true
   */ overlay: true,
    /**
   * Allows the modal to remove and reinject markup on close. Should be true if using video elements w/o using provider's api, otherwise, videos will continue to play in the background.
   * @option
   * @type {boolean}
   * @default false
   */ resetOnClose: false,
    /**
   * Link the location hash to the modal.
   * Set the location hash when the modal is opened/closed, and open/close the modal when the location changes.
   * @option
   * @type {boolean}
   * @default false
   */ deepLink: false,
    /**
   * If `deepLink` is enabled, update the browser history with the open modal
   * @option
   * @default false
   */ updateHistory: false,
    /**
  * Allows the modal to append to custom div.
  * @option
  * @type {string}
  * @default "body"
  */ appendTo: "body",
    /**
   * Allows adding additional class names to the reveal overlay.
   * @option
   * @type {string}
   * @default ''
   */ additionalOverlayClasses: ""
};
/**
 * Slider module.
 * @module foundation.slider
 * @requires foundation.util.motion
 * @requires foundation.util.triggers
 * @requires foundation.util.keyboard
 * @requires foundation.util.touch
 */ var $57aa6ed7a3256ce7$export$472062a354075cee = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Slider, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Slider);
    function Slider() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Slider);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Slider, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of a slider control.
     * @class
     * @name Slider
     * @param {jQuery} element - jQuery object to make into a slider control.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Slider.defaults, this.$element.data(), options);
                this.className = "Slider"; // ie9 back compat
                this.initialized = false;
                // Touch and Triggers inits are idempotent, we just need to make sure it's initialied.
                $57aa6ed7a3256ce7$export$746b04bbf92762fd.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("Slider", {
                    "ltr": {
                        "ARROW_RIGHT": "increase",
                        "ARROW_UP": "increase",
                        "ARROW_DOWN": "decrease",
                        "ARROW_LEFT": "decrease",
                        "SHIFT_ARROW_RIGHT": "increaseFast",
                        "SHIFT_ARROW_UP": "increaseFast",
                        "SHIFT_ARROW_DOWN": "decreaseFast",
                        "SHIFT_ARROW_LEFT": "decreaseFast",
                        "HOME": "min",
                        "END": "max"
                    },
                    "rtl": {
                        "ARROW_LEFT": "increase",
                        "ARROW_RIGHT": "decrease",
                        "SHIFT_ARROW_LEFT": "increaseFast",
                        "SHIFT_ARROW_RIGHT": "decreaseFast"
                    }
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                this.inputs = this.$element.find("input");
                this.handles = this.$element.find("[data-slider-handle]");
                this.$handle = this.handles.eq(0);
                this.$input = this.inputs.length ? this.inputs.eq(0) : (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(this.$handle.attr("aria-controls")));
                this.$fill = this.$element.find("[data-slider-fill]").css(this.options.vertical ? "height" : "width", 0);
                if (this.options.disabled || this.$element.hasClass(this.options.disabledClass)) {
                    this.options.disabled = true;
                    this.$element.addClass(this.options.disabledClass);
                }
                if (!this.inputs.length) {
                    this.inputs = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))().add(this.$input);
                    this.options.binding = true;
                }
                this._setInitAttr(0);
                if (this.handles[1]) {
                    this.options.doubleSided = true;
                    this.$handle2 = this.handles.eq(1);
                    this.$input2 = this.inputs.length > 1 ? this.inputs.eq(1) : (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(this.$handle2.attr("aria-controls")));
                    if (!this.inputs[1]) this.inputs = this.inputs.add(this.$input2);
                    // this.$handle.triggerHandler('click.zf.slider');
                    this._setInitAttr(1);
                }
                // Set handle positions
                this.setHandles();
                this._events();
                this.initialized = true;
            }
        },
        {
            key: "setHandles",
            value: function setHandles() {
                var _this2 = this;
                if (this.handles[1]) this._setHandlePos(this.$handle, this.inputs.eq(0).val(), function() {
                    _this2._setHandlePos(_this2.$handle2, _this2.inputs.eq(1).val());
                });
                else this._setHandlePos(this.$handle, this.inputs.eq(0).val());
            }
        },
        {
            key: "_reflow",
            value: function _reflow() {
                this.setHandles();
            }
        },
        {
            key: "_pctOfBar",
            value: function _pctOfBar(value) {
                var pctOfBar = $57aa6ed7a3256ce7$var$percent(value - this.options.start, this.options.end - this.options.start);
                switch(this.options.positionValueFunction){
                    case "pow":
                        pctOfBar = this._logTransform(pctOfBar);
                        break;
                    case "log":
                        pctOfBar = this._powTransform(pctOfBar);
                        break;
                }
                return pctOfBar.toFixed(2);
            }
        },
        {
            key: "_value",
            value: function _value(pctOfBar) {
                switch(this.options.positionValueFunction){
                    case "pow":
                        pctOfBar = this._powTransform(pctOfBar);
                        break;
                    case "log":
                        pctOfBar = this._logTransform(pctOfBar);
                        break;
                }
                var value;
                if (this.options.vertical) // linear interpolation which is working with negative values for start
                // https://math.stackexchange.com/a/1019084
                value = parseFloat(this.options.end) + pctOfBar * (this.options.start - this.options.end);
                else value = (this.options.end - this.options.start) * pctOfBar + parseFloat(this.options.start);
                return value;
            }
        },
        {
            key: "_logTransform",
            value: function _logTransform(value) {
                return $57aa6ed7a3256ce7$var$baseLog(this.options.nonLinearBase, value * (this.options.nonLinearBase - 1) + 1);
            }
        },
        {
            key: "_powTransform",
            value: function _powTransform(value) {
                return (Math.pow(this.options.nonLinearBase, value) - 1) / (this.options.nonLinearBase - 1);
            }
        },
        {
            key: "_setHandlePos",
            value: function _setHandlePos($hndl, location1, cb) {
                // don't move if the slider has been disabled since its initialization
                if (this.$element.hasClass(this.options.disabledClass)) return;
                //might need to alter that slightly for bars that will have odd number selections.
                location1 = parseFloat(location1); //on input change events, convert string to number...grumble.
                // prevent slider from running out of bounds, if value exceeds the limits set through options, override the value to min/max
                if (location1 < this.options.start) location1 = this.options.start;
                else if (location1 > this.options.end) location1 = this.options.end;
                var isDbl = this.options.doubleSided;
                if (isDbl) {
                    //this block is to prevent 2 handles from crossing eachother. Could/should be improved.
                    if (this.handles.index($hndl) === 0) {
                        var h2Val = parseFloat(this.$handle2.attr("aria-valuenow"));
                        location1 = location1 >= h2Val ? h2Val - this.options.step : location1;
                    } else {
                        var h1Val = parseFloat(this.$handle.attr("aria-valuenow"));
                        location1 = location1 <= h1Val ? h1Val + this.options.step : location1;
                    }
                }
                var _this = this, vert = this.options.vertical, hOrW = vert ? "height" : "width", lOrT = vert ? "top" : "left", handleDim = $hndl[0].getBoundingClientRect()[hOrW], elemDim = this.$element[0].getBoundingClientRect()[hOrW], //percentage of bar min/max value based on click or drag point
                pctOfBar = this._pctOfBar(location1), //number of actual pixels to shift the handle, based on the percentage obtained above
                pxToMove = (elemDim - handleDim) * pctOfBar, //percentage of bar to shift the handle
                movement = ($57aa6ed7a3256ce7$var$percent(pxToMove, elemDim) * 100).toFixed(this.options.decimal);
                //fixing the decimal value for the location number, is passed to other methods as a fixed floating-point value
                location1 = parseFloat(location1.toFixed(this.options.decimal));
                // declare empty object for css adjustments, only used with 2 handled-sliders
                var css = {};
                this._setValues($hndl, location1);
                // TODO update to calculate based on values set to respective inputs??
                if (isDbl) {
                    var isLeftHndl = this.handles.index($hndl) === 0, //empty variable, will be used for min-height/width for fill bar
                    dim, //percentage w/h of the handle compared to the slider bar
                    handlePct = Math.floor($57aa6ed7a3256ce7$var$percent(handleDim, elemDim) * 100);
                    //if left handle, the math is slightly different than if it's the right handle, and the left/top property needs to be changed for the fill bar
                    if (isLeftHndl) {
                        //left or top percentage value to apply to the fill bar.
                        css[lOrT] = "".concat(movement, "%");
                        //calculate the new min-height/width for the fill bar.
                        dim = parseFloat(this.$handle2[0].style[lOrT]) - movement + handlePct;
                        //this callback is necessary to prevent errors and allow the proper placement and initialization of a 2-handled slider
                        //plus, it means we don't care if 'dim' isNaN on init, it won't be in the future.
                        if (cb && typeof cb === "function") cb();
                         //this is only needed for the initialization of 2 handled sliders
                    } else {
                        //just caching the value of the left/bottom handle's left/top property
                        var handlePos = parseFloat(this.$handle[0].style[lOrT]);
                        //calculate the new min-height/width for the fill bar. Use isNaN to prevent false positives for numbers <= 0
                        //based on the percentage of movement of the handle being manipulated, less the opposing handle's left/top position, plus the percentage w/h of the handle itself
                        dim = movement - (isNaN(handlePos) ? (this.options.initialStart - this.options.start) / ((this.options.end - this.options.start) / 100) : handlePos) + handlePct;
                    }
                    // assign the min-height/width to our css object
                    css["min-".concat(hOrW)] = "".concat(dim, "%");
                }
                //because we don't know exactly how the handle will be moved, check the amount of time it should take to move.
                var moveTime = this.$element.data("dragging") ? 1000 / 60 : this.options.moveTime;
                $57aa6ed7a3256ce7$export$e49a5ad3dd6df925(moveTime, $hndl, function() {
                    // adjusting the left/top property of the handle, based on the percentage calculated above
                    // if movement isNaN, that is because the slider is hidden and we cannot determine handle width,
                    // fall back to next best guess.
                    if (isNaN(movement)) $hndl.css(lOrT, "".concat(pctOfBar * 100, "%"));
                    else $hndl.css(lOrT, "".concat(movement, "%"));
                    if (!_this.options.doubleSided) //if single-handled, a simple method to expand the fill bar
                    _this.$fill.css(hOrW, "".concat(pctOfBar * 100, "%"));
                    else //otherwise, use the css object we created above
                    _this.$fill.css(css);
                });
                if (this.initialized) {
                    this.$element.one("finished.zf.animate", function() {
                        /**
           * Fires when the handle is done moving.
           * @event Slider#moved
           */ _this.$element.trigger("moved.zf.slider", [
                            $hndl
                        ]);
                    });
                    /**
         * Fires when the value has not been change for a given time.
         * @event Slider#changed
         */ clearTimeout(_this.timeout);
                    _this.timeout = setTimeout(function() {
                        _this.$element.trigger("changed.zf.slider", [
                            $hndl
                        ]);
                    }, _this.options.changedDelay);
                }
            }
        },
        {
            key: "_setInitAttr",
            value: function _setInitAttr(idx) {
                var initVal = idx === 0 ? this.options.initialStart : this.options.initialEnd;
                var id = this.inputs.eq(idx).attr("id") || $57aa6ed7a3256ce7$var$GetYoDigits(6, "slider");
                this.inputs.eq(idx).attr({
                    "id": id,
                    "max": this.options.end,
                    "min": this.options.start,
                    "step": this.options.step
                });
                this.inputs.eq(idx).val(initVal);
                this.handles.eq(idx).attr({
                    "role": "slider",
                    "aria-controls": id,
                    "aria-valuemax": this.options.end,
                    "aria-valuemin": this.options.start,
                    "aria-valuenow": initVal,
                    "aria-orientation": this.options.vertical ? "vertical" : "horizontal",
                    "tabindex": 0
                });
            }
        },
        {
            key: "_setValues",
            value: function _setValues($handle, val) {
                var idx = this.options.doubleSided ? this.handles.index($handle) : 0;
                this.inputs.eq(idx).val(val);
                $handle.attr("aria-valuenow", val);
            }
        },
        {
            key: "_handleEvent",
            value: function _handleEvent(e, $handle, val) {
                var value;
                if (!val) {
                    //click or drag events
                    e.preventDefault();
                    var _this = this, vertical = this.options.vertical, param = vertical ? "height" : "width", direction = vertical ? "top" : "left", eventOffset = vertical ? e.pageY : e.pageX, barDim = this.$element[0].getBoundingClientRect()[param], windowScroll = vertical ? (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).scrollTop() : (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).scrollLeft();
                    var elemOffset = this.$element.offset()[direction];
                    // touch events emulated by the touch util give position relative to screen, add window.scroll to event coordinates...
                    // best way to guess this is simulated is if clientY == pageY
                    if (e.clientY === e.pageY) eventOffset = eventOffset + windowScroll;
                    var eventFromBar = eventOffset - elemOffset;
                    var barXY;
                    if (eventFromBar < 0) barXY = 0;
                    else if (eventFromBar > barDim) barXY = barDim;
                    else barXY = eventFromBar;
                    var offsetPct = $57aa6ed7a3256ce7$var$percent(barXY, barDim);
                    value = this._value(offsetPct);
                    // turn everything around for RTL, yay math!
                    if ($57aa6ed7a3256ce7$var$rtl() && !this.options.vertical) value = this.options.end - value;
                    value = _this._adjustValue(null, value);
                    if (!$handle) {
                        //figure out which handle it is, pass it to the next function.
                        var firstHndlPos = $57aa6ed7a3256ce7$var$absPosition(this.$handle, direction, barXY, param), secndHndlPos = $57aa6ed7a3256ce7$var$absPosition(this.$handle2, direction, barXY, param);
                        $handle = firstHndlPos <= secndHndlPos ? this.$handle : this.$handle2;
                    }
                } else //change event on input
                value = this._adjustValue(null, val);
                this._setHandlePos($handle, value);
            }
        },
        {
            key: "_adjustValue",
            value: function _adjustValue($handle, value) {
                var val, step = this.options.step, div = parseFloat(step / 2), left, previousVal, nextVal;
                if (!!$handle) val = parseFloat($handle.attr("aria-valuenow"));
                else val = value;
                if (val >= 0) left = val % step;
                else left = step + val % step;
                previousVal = val - left;
                nextVal = previousVal + step;
                if (left === 0) return val;
                val = val >= previousVal + div ? nextVal : previousVal;
                return val;
            }
        },
        {
            key: "_events",
            value: function _events() {
                this._eventsForHandle(this.$handle);
                if (this.handles[1]) this._eventsForHandle(this.$handle2);
            }
        },
        {
            key: "_eventsForHandle",
            value: function _eventsForHandle($handle) {
                var _this = this, curHandle;
                var handleChangeEvent = function handleChangeEvent(e) {
                    var idx = _this.inputs.index((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this));
                    _this._handleEvent(e, _this.handles.eq(idx), (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).val());
                };
                // IE only triggers the change event when the input loses focus which strictly follows the HTML specification
                // listen for the enter key and trigger a change
                // @see https://html.spec.whatwg.org/multipage/input.html#common-input-element-events
                this.inputs.off("keyup.zf.slider").on("keyup.zf.slider", function(e) {
                    if (e.keyCode === 13) handleChangeEvent.call(this, e);
                });
                this.inputs.off("change.zf.slider").on("change.zf.slider", handleChangeEvent);
                if (this.options.clickSelect) this.$element.off("click.zf.slider").on("click.zf.slider", function(e) {
                    if (_this.$element.data("dragging")) return false;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.target).is("[data-slider-handle]")) {
                        if (_this.options.doubleSided) _this._handleEvent(e);
                        else _this._handleEvent(e, _this.$handle);
                    }
                });
                if (this.options.draggable) {
                    this.handles.addTouch();
                    var $body = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body");
                    $handle.off("mousedown.zf.slider").on("mousedown.zf.slider", function(e) {
                        $handle.addClass("is-dragging");
                        _this.$fill.addClass("is-dragging"); //
                        _this.$element.data("dragging", true);
                        curHandle = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(e.currentTarget);
                        $body.on("mousemove.zf.slider", function(ev) {
                            ev.preventDefault();
                            _this._handleEvent(ev, curHandle);
                        }).on("mouseup.zf.slider", function(ev) {
                            _this._handleEvent(ev, curHandle);
                            $handle.removeClass("is-dragging");
                            _this.$fill.removeClass("is-dragging");
                            _this.$element.data("dragging", false);
                            $body.off("mousemove.zf.slider mouseup.zf.slider");
                        });
                    })// prevent events triggered by touch
                    .on("selectstart.zf.slider touchmove.zf.slider", function(e) {
                        e.preventDefault();
                    });
                }
                $handle.off("keydown.zf.slider").on("keydown.zf.slider", function(e) {
                    var _$handle = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), idx = _this.options.doubleSided ? _this.handles.index(_$handle) : 0, oldValue = parseFloat($handle.attr("aria-valuenow")), newValue;
                    // handle keyboard event with keyboard util
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "Slider", {
                        decrease: function decrease() {
                            newValue = oldValue - _this.options.step;
                        },
                        increase: function increase() {
                            newValue = oldValue + _this.options.step;
                        },
                        decreaseFast: function decreaseFast() {
                            newValue = oldValue - _this.options.step * 10;
                        },
                        increaseFast: function increaseFast() {
                            newValue = oldValue + _this.options.step * 10;
                        },
                        min: function min() {
                            newValue = _this.options.start;
                        },
                        max: function max() {
                            newValue = _this.options.end;
                        },
                        handled: function handled() {
                            // only set handle pos when event was handled specially
                            e.preventDefault();
                            _this._setHandlePos(_$handle, newValue);
                        }
                    });
                /*if (newValue) { // if pressed key has special function, update value
          e.preventDefault();
          _this._setHandlePos(_$handle, newValue);
        }*/ });
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.handles.off(".zf.slider");
                this.inputs.off(".zf.slider");
                this.$element.off(".zf.slider");
                clearTimeout(this.timeout);
            }
        }
    ]);
    return Slider;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$472062a354075cee.defaults = {
    /**
   * Minimum value for the slider scale.
   * @option
   * @type {number}
   * @default 0
   */ start: 0,
    /**
   * Maximum value for the slider scale.
   * @option
   * @type {number}
   * @default 100
   */ end: 100,
    /**
   * Minimum value change per change event.
   * @option
   * @type {number}
   * @default 1
   */ step: 1,
    /**
   * Value at which the handle/input *(left handle/first input)* should be set to on initialization.
   * @option
   * @type {number}
   * @default 0
   */ initialStart: 0,
    /**
   * Value at which the right handle/second input should be set to on initialization.
   * @option
   * @type {number}
   * @default 100
   */ initialEnd: 100,
    /**
   * Allows the input to be located outside the container and visible. Set to by the JS
   * @option
   * @type {boolean}
   * @default false
   */ binding: false,
    /**
   * Allows the user to click/tap on the slider bar to select a value.
   * @option
   * @type {boolean}
   * @default true
   */ clickSelect: true,
    /**
   * Set to true and use the `vertical` class to change alignment to vertical.
   * @option
   * @type {boolean}
   * @default false
   */ vertical: false,
    /**
   * Allows the user to drag the slider handle(s) to select a value.
   * @option
   * @type {boolean}
   * @default true
   */ draggable: true,
    /**
   * Disables the slider and prevents event listeners from being applied. Double checked by JS with `disabledClass`.
   * @option
   * @type {boolean}
   * @default false
   */ disabled: false,
    /**
   * Allows the use of two handles. Double checked by the JS. Changes some logic handling.
   * @option
   * @type {boolean}
   * @default false
   */ doubleSided: false,
    /**
   * Potential future feature.
   */ // steps: 100,
    /**
   * Number of decimal places the plugin should go to for floating point precision.
   * @option
   * @type {number}
   * @default 2
   */ decimal: 2,
    /**
   * Time delay for dragged elements.
   */ // dragDelay: 0,
    /**
   * Time, in ms, to animate the movement of a slider handle if user clicks/taps on the bar. Needs to be manually set if updating the transition time in the Sass settings.
   * @option
   * @type {number}
   * @default 200
   */ moveTime: 200,
    //update this if changing the transition time in the sass
    /**
   * Class applied to disabled sliders.
   * @option
   * @type {string}
   * @default 'disabled'
   */ disabledClass: "disabled",
    /**
   * Will invert the default layout for a vertical<span data-tooltip title="who would do this???"> </span>slider.
   * @option
   * @type {boolean}
   * @default false
   */ invertVertical: false,
    /**
   * Milliseconds before the `changed.zf-slider` event is triggered after value change.
   * @option
   * @type {number}
   * @default 500
   */ changedDelay: 500,
    /**
  * Basevalue for non-linear sliders
  * @option
  * @type {number}
  * @default 5
  */ nonLinearBase: 5,
    /**
  * Basevalue for non-linear sliders, possible values are: `'linear'`, `'pow'` & `'log'`. Pow and Log use the nonLinearBase setting.
  * @option
  * @type {string}
  * @default 'linear'
  */ positionValueFunction: "linear"
};
function $57aa6ed7a3256ce7$var$percent(frac, num) {
    return frac / num;
}
function $57aa6ed7a3256ce7$var$absPosition($handle, dir, clickPos, param) {
    return Math.abs($handle.position()[dir] + $handle[param]() / 2 - clickPos);
}
function $57aa6ed7a3256ce7$var$baseLog(base, value) {
    return Math.log(value) / Math.log(base);
}
/**
 * Sticky module.
 * @module foundation.sticky
 * @requires foundation.util.triggers
 * @requires foundation.util.mediaQuery
 */ var $57aa6ed7a3256ce7$export$cbb1b0785b69b9d8 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Sticky, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Sticky);
    function Sticky() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Sticky);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Sticky, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of a sticky thing.
     * @class
     * @name Sticky
     * @param {jQuery} element - jQuery object to make sticky.
     * @param {Object} options - options object passed when creating the element programmatically.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Sticky.defaults, this.$element.data(), options);
                this.className = "Sticky"; // ie9 back compat
                // Triggers init is idempotent, just need to make sure it is initialized
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                this._init();
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                var $parent = this.$element.parent("[data-sticky-container]"), id = this.$element[0].id || $57aa6ed7a3256ce7$var$GetYoDigits(6, "sticky"), _this = this;
                if ($parent.length) this.$container = $parent;
                else {
                    this.wasWrapped = true;
                    this.$element.wrap(this.options.container);
                    this.$container = this.$element.parent();
                }
                this.$container.addClass(this.options.containerClass);
                this.$element.addClass(this.options.stickyClass).attr({
                    "data-resize": id,
                    "data-mutate": id
                });
                if (this.options.anchor !== "") (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + _this.options.anchor).attr({
                    "data-mutate": id
                });
                this.scrollCount = this.options.checkEvery;
                this.isStuck = false;
                this.onLoadListener = $57aa6ed7a3256ce7$var$onLoad((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window), function() {
                    //We calculate the container height to have correct values for anchor points offset calculation.
                    _this.containerHeight = _this.$element.css("display") === "none" ? 0 : _this.$element[0].getBoundingClientRect().height;
                    _this.$container.css("height", _this.containerHeight);
                    _this.elemHeight = _this.containerHeight;
                    if (_this.options.anchor !== "") _this.$anchor = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + _this.options.anchor);
                    else _this._parsePoints();
                    _this._setSizes(function() {
                        var scroll = window.pageYOffset;
                        _this._calc(false, scroll);
                        //Unstick the element will ensure that proper classes are set.
                        if (!_this.isStuck) _this._removeSticky(scroll >= _this.topPoint ? false : true);
                    });
                    _this._events(id.split("-").reverse().join("-"));
                });
            }
        },
        {
            key: "_parsePoints",
            value: function _parsePoints() {
                var top = this.options.topAnchor === "" ? 1 : this.options.topAnchor, btm = this.options.btmAnchor === "" ? document.documentElement.scrollHeight : this.options.btmAnchor, pts = [
                    top,
                    btm
                ], breaks = {};
                for(var i = 0, len = pts.length; i < len && pts[i]; i++){
                    var pt;
                    if (typeof pts[i] === "number") pt = pts[i];
                    else {
                        var place = pts[i].split(":"), anchor = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(place[0]));
                        pt = anchor.offset().top;
                        if (place[1] && place[1].toLowerCase() === "bottom") pt += anchor[0].getBoundingClientRect().height;
                    }
                    breaks[i] = pt;
                }
                this.points = breaks;
                return;
            }
        },
        {
            key: "_events",
            value: function _events(id) {
                var _this = this, scrollListener = this.scrollListener = "scroll.zf.".concat(id);
                if (this.isOn) return;
                if (this.canStick) {
                    this.isOn = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(scrollListener).on(scrollListener, function() {
                        if (_this.scrollCount === 0) {
                            _this.scrollCount = _this.options.checkEvery;
                            _this._setSizes(function() {
                                _this._calc(false, window.pageYOffset);
                            });
                        } else {
                            _this.scrollCount--;
                            _this._calc(false, window.pageYOffset);
                        }
                    });
                }
                this.$element.off("resizeme.zf.trigger").on("resizeme.zf.trigger", function() {
                    _this._eventsHandler(id);
                });
                this.$element.on("mutateme.zf.trigger", function() {
                    _this._eventsHandler(id);
                });
                if (this.$anchor) this.$anchor.on("mutateme.zf.trigger", function() {
                    _this._eventsHandler(id);
                });
            }
        },
        {
            key: "_eventsHandler",
            value: function _eventsHandler(id) {
                var _this = this, scrollListener = this.scrollListener = "scroll.zf.".concat(id);
                _this._setSizes(function() {
                    _this._calc(false);
                    if (_this.canStick) {
                        if (!_this.isOn) _this._events(id);
                    } else if (_this.isOn) _this._pauseListeners(scrollListener);
                });
            }
        },
        {
            key: "_pauseListeners",
            value: function _pauseListeners(scrollListener) {
                this.isOn = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(scrollListener);
                /**
       * Fires when the plugin is paused due to resize event shrinking the view.
       * @event Sticky#pause
       * @private
       */ this.$element.trigger("pause.zf.sticky");
            }
        },
        {
            key: "_calc",
            value: function _calc(checkSizes, scroll) {
                if (checkSizes) this._setSizes();
                if (!this.canStick) {
                    if (this.isStuck) this._removeSticky(true);
                    return false;
                }
                if (!scroll) scroll = window.pageYOffset;
                if (scroll >= this.topPoint) {
                    if (scroll <= this.bottomPoint) {
                        if (!this.isStuck) this._setSticky();
                    } else if (this.isStuck) this._removeSticky(false);
                } else if (this.isStuck) this._removeSticky(true);
            }
        },
        {
            key: "_setSticky",
            value: function _setSticky() {
                var _this = this, stickTo = this.options.stickTo, mrgn = stickTo === "top" ? "marginTop" : "marginBottom", notStuckTo = stickTo === "top" ? "bottom" : "top", css = {};
                css[mrgn] = "".concat(this.options[mrgn], "em");
                css[stickTo] = 0;
                css[notStuckTo] = "auto";
                this.isStuck = true;
                this.$element.removeClass("is-anchored is-at-".concat(notStuckTo)).addClass("is-stuck is-at-".concat(stickTo)).css(css)/**
       * Fires when the $element has become `position: fixed;`
       * Namespaced to `top` or `bottom`, e.g. `sticky.zf.stuckto:top`
       * @event Sticky#stuckto
       */ .trigger("sticky.zf.stuckto:".concat(stickTo));
                this.$element.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", function() {
                    _this._setSizes();
                });
            }
        },
        {
            key: "_removeSticky",
            value: function _removeSticky(isTop) {
                var stickTo = this.options.stickTo, stickToTop = stickTo === "top", css = {}, anchorPt = (this.points ? this.points[1] - this.points[0] : this.anchorHeight) - this.elemHeight, mrgn = stickToTop ? "marginTop" : "marginBottom", topOrBottom = isTop ? "top" : "bottom";
                css[mrgn] = 0;
                css.bottom = "auto";
                if (isTop) css.top = 0;
                else css.top = anchorPt;
                this.isStuck = false;
                this.$element.removeClass("is-stuck is-at-".concat(stickTo)).addClass("is-anchored is-at-".concat(topOrBottom)).css(css)/**
       * Fires when the $element has become anchored.
       * Namespaced to `top` or `bottom`, e.g. `sticky.zf.unstuckfrom:bottom`
       * @event Sticky#unstuckfrom
       */ .trigger("sticky.zf.unstuckfrom:".concat(topOrBottom));
            }
        },
        {
            key: "_setSizes",
            value: function _setSizes(cb) {
                this.canStick = $57aa6ed7a3256ce7$export$b745838c41029eb3.is(this.options.stickyOn);
                if (!this.canStick) {
                    if (cb && typeof cb === "function") cb();
                }
                var newElemWidth = this.$container[0].getBoundingClientRect().width, comp = window.getComputedStyle(this.$container[0]), pdngl = parseInt(comp["padding-left"], 10), pdngr = parseInt(comp["padding-right"], 10);
                if (this.$anchor && this.$anchor.length) this.anchorHeight = this.$anchor[0].getBoundingClientRect().height;
                else this._parsePoints();
                this.$element.css({
                    "max-width": "".concat(newElemWidth - pdngl - pdngr, "px")
                });
                // Recalculate the height only if it is "dynamic"
                if (this.options.dynamicHeight || !this.containerHeight) {
                    // Get the sticked element height and apply it to the container to "hold the place"
                    var newContainerHeight = this.$element[0].getBoundingClientRect().height || this.containerHeight;
                    newContainerHeight = this.$element.css("display") === "none" ? 0 : newContainerHeight;
                    this.$container.css("height", newContainerHeight);
                    this.containerHeight = newContainerHeight;
                }
                this.elemHeight = this.containerHeight;
                if (!this.isStuck) {
                    if (this.$element.hasClass("is-at-bottom")) {
                        var anchorPt = (this.points ? this.points[1] - this.$container.offset().top : this.anchorHeight) - this.elemHeight;
                        this.$element.css("top", anchorPt);
                    }
                }
                this._setBreakPoints(this.containerHeight, function() {
                    if (cb && typeof cb === "function") cb();
                });
            }
        },
        {
            key: "_setBreakPoints",
            value: function _setBreakPoints(elemHeight, cb) {
                if (!this.canStick) {
                    if (cb && typeof cb === "function") cb();
                    else return false;
                }
                var mTop = $57aa6ed7a3256ce7$var$emCalc(this.options.marginTop), mBtm = $57aa6ed7a3256ce7$var$emCalc(this.options.marginBottom), topPoint = this.points ? this.points[0] : this.$anchor.offset().top, bottomPoint = this.points ? this.points[1] : topPoint + this.anchorHeight, // topPoint = this.$anchor.offset().top || this.points[0],
                // bottomPoint = topPoint + this.anchorHeight || this.points[1],
                winHeight = window.innerHeight;
                if (this.options.stickTo === "top") {
                    topPoint -= mTop;
                    bottomPoint -= elemHeight + mTop;
                } else if (this.options.stickTo === "bottom") {
                    topPoint -= winHeight - (elemHeight + mBtm);
                    bottomPoint -= winHeight - mBtm;
                }
                this.topPoint = topPoint;
                this.bottomPoint = bottomPoint;
                if (cb && typeof cb === "function") cb();
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this._removeSticky(true);
                this.$element.removeClass("".concat(this.options.stickyClass, " is-anchored is-at-top")).css({
                    height: "",
                    top: "",
                    bottom: "",
                    "max-width": ""
                }).off("resizeme.zf.trigger").off("mutateme.zf.trigger");
                if (this.$anchor && this.$anchor.length) this.$anchor.off("change.zf.sticky");
                if (this.scrollListener) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(this.scrollListener);
                if (this.onLoadListener) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(this.onLoadListener);
                if (this.wasWrapped) this.$element.unwrap();
                else this.$container.removeClass(this.options.containerClass).css({
                    height: ""
                });
            }
        }
    ]);
    return Sticky;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$cbb1b0785b69b9d8.defaults = {
    /**
   * Customizable container template. Add your own classes for styling and sizing.
   * @option
   * @type {string}
   * @default '&lt;div data-sticky-container&gt;&lt;/div&gt;'
   */ container: "<div data-sticky-container></div>",
    /**
   * Location in the view the element sticks to. Can be `'top'` or `'bottom'`.
   * @option
   * @type {string}
   * @default 'top'
   */ stickTo: "top",
    /**
   * If anchored to a single element, the id of that element.
   * @option
   * @type {string}
   * @default ''
   */ anchor: "",
    /**
   * If using more than one element as anchor points, the id of the top anchor.
   * @option
   * @type {string}
   * @default ''
   */ topAnchor: "",
    /**
   * If using more than one element as anchor points, the id of the bottom anchor.
   * @option
   * @type {string}
   * @default ''
   */ btmAnchor: "",
    /**
   * Margin, in `em`'s to apply to the top of the element when it becomes sticky.
   * @option
   * @type {number}
   * @default 1
   */ marginTop: 1,
    /**
   * Margin, in `em`'s to apply to the bottom of the element when it becomes sticky.
   * @option
   * @type {number}
   * @default 1
   */ marginBottom: 1,
    /**
   * Breakpoint string that is the minimum screen size an element should become sticky.
   * @option
   * @type {string}
   * @default 'medium'
   */ stickyOn: "medium",
    /**
   * Class applied to sticky element, and removed on destruction. Foundation defaults to `sticky`.
   * @option
   * @type {string}
   * @default 'sticky'
   */ stickyClass: "sticky",
    /**
   * Class applied to sticky container. Foundation defaults to `sticky-container`.
   * @option
   * @type {string}
   * @default 'sticky-container'
   */ containerClass: "sticky-container",
    /**
   * If true (by default), keep the sticky container the same height as the element. Otherwise, the container height is set once and does not change.
   * @option
   * @type {boolean}
   * @default true
   */ dynamicHeight: true,
    /**
   * Number of scroll events between the plugin's recalculating sticky points. Setting it to `0` will cause it to recalc every scroll event, setting it to `-1` will prevent recalc on scroll.
   * @option
   * @type {number}
   * @default -1
   */ checkEvery: -1
};
/**
 * Helper function to calculate em values
 * @param Number {em} - number of em's to calculate into pixels
 */ function $57aa6ed7a3256ce7$var$emCalc(em) {
    return parseInt(window.getComputedStyle(document.body, null).fontSize, 10) * em;
}
/**
 * Tabs module.
 * @module foundation.tabs
 * @requires foundation.util.keyboard
 * @requires foundation.util.imageLoader if tabs contain images
 */ var $57aa6ed7a3256ce7$export$b2539bed5023c21c = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Tabs, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Tabs);
    function Tabs() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Tabs);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Tabs, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of tabs.
     * @class
     * @name Tabs
     * @fires Tabs#init
     * @param {jQuery} element - jQuery object to make into tabs.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Tabs.defaults, this.$element.data(), options);
                this.className = "Tabs"; // ie9 back compat
                this._init();
                $57aa6ed7a3256ce7$export$16e4d70cc375e707.register("Tabs", {
                    "ENTER": "open",
                    "SPACE": "open",
                    "ARROW_RIGHT": "next",
                    "ARROW_UP": "previous",
                    "ARROW_DOWN": "next",
                    "ARROW_LEFT": "previous"
                });
            }
        },
        {
            key: "_init",
            value: function _init() {
                var _this2 = this;
                var _this = this;
                this._isInitializing = true;
                this.$element.attr({
                    "role": "tablist"
                });
                this.$tabTitles = this.$element.find(".".concat(this.options.linkClass));
                this.$tabContent = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-tabs-content="'.concat(this.$element[0].id, '"]'));
                this.$tabTitles.each(function() {
                    var $elem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), $link = $elem.find("a"), isActive = $elem.hasClass("".concat(_this.options.linkActiveClass)), hash = $link.attr("data-tabs-target") || $link[0].hash.slice(1), linkId = $link[0].id ? $link[0].id : "".concat(hash, "-label"), $tabContent = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(hash));
                    $elem.attr({
                        "role": "presentation"
                    });
                    $link.attr({
                        "role": "tab",
                        "aria-controls": hash,
                        "aria-selected": isActive,
                        "id": linkId,
                        "tabindex": isActive ? "0" : "-1"
                    });
                    $tabContent.attr({
                        "role": "tabpanel",
                        "aria-labelledby": linkId
                    });
                    // Save up the initial hash to return to it later when going back in history
                    if (isActive) _this._initialAnchor = "#".concat(hash);
                    if (!isActive) $tabContent.attr("aria-hidden", "true");
                    if (isActive && _this.options.autoFocus) _this.onLoadListener = $57aa6ed7a3256ce7$var$onLoad((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window), function() {
                        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html, body").animate({
                            scrollTop: $elem.offset().top
                        }, _this.options.deepLinkSmudgeDelay, function() {
                            $link.focus();
                        });
                    });
                });
                if (this.options.matchHeight) {
                    var $images = this.$tabContent.find("img");
                    if ($images.length) $57aa6ed7a3256ce7$export$9a7c395a24d73631($images, this._setHeight.bind(this));
                    else this._setHeight();
                }
                // Current context-bound function to open tabs on page load or history hashchange
                this._checkDeepLink = function() {
                    var anchor = window.location.hash;
                    if (!anchor.length) {
                        // If we are still initializing and there is no anchor, then there is nothing to do
                        if (_this2._isInitializing) return;
                        // Otherwise, move to the initial anchor
                        if (_this2._initialAnchor) anchor = _this2._initialAnchor;
                    }
                    var anchorNoHash = anchor.indexOf("#") >= 0 ? anchor.slice(1) : anchor;
                    var $anchor = anchorNoHash && (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat(anchorNoHash));
                    var $link = anchor && _this2.$element.find('[href$="'.concat(anchor, '"],[data-tabs-target="').concat(anchorNoHash, '"]')).first();
                    // Whether the anchor element that has been found is part of this element
                    var isOwnAnchor = !!($anchor.length && $link.length);
                    if (isOwnAnchor) {
                        // If there is an anchor for the hash, select it
                        if ($anchor && $anchor.length && $link && $link.length) _this2.selectTab($anchor, true);
                        else _this2._collapse();
                        // Roll up a little to show the titles
                        if (_this2.options.deepLinkSmudge) {
                            var offset = _this2.$element.offset();
                            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html, body").animate({
                                scrollTop: offset.top - _this2.options.deepLinkSmudgeOffset
                            }, _this2.options.deepLinkSmudgeDelay);
                        }
                        /**
           * Fires when the plugin has deeplinked at pageload
           * @event Tabs#deeplink
           */ _this2.$element.trigger("deeplink.zf.tabs", [
                            $link,
                            $anchor
                        ]);
                    }
                };
                //use browser to open a tab, if it exists in this tabset
                if (this.options.deepLink) this._checkDeepLink();
                this._events();
                this._isInitializing = false;
            }
        },
        {
            key: "_events",
            value: function _events() {
                this._addKeyHandler();
                this._addClickHandler();
                this._setHeightMqHandler = null;
                if (this.options.matchHeight) {
                    this._setHeightMqHandler = this._setHeight.bind(this);
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("changed.zf.mediaquery", this._setHeightMqHandler);
                }
                if (this.options.deepLink) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("hashchange", this._checkDeepLink);
            }
        },
        {
            key: "_addClickHandler",
            value: function _addClickHandler() {
                var _this = this;
                this.$element.off("click.zf.tabs").on("click.zf.tabs", ".".concat(this.options.linkClass), function(e) {
                    e.preventDefault();
                    _this._handleTabChange((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this));
                });
            }
        },
        {
            key: "_addKeyHandler",
            value: function _addKeyHandler() {
                var _this = this;
                this.$tabTitles.off("keydown.zf.tabs").on("keydown.zf.tabs", function(e) {
                    if (e.which === 9) return;
                    var $element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), $elements = $element.parent("ul").children("li"), $prevElement, $nextElement;
                    $elements.each(function(i) {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).is($element)) {
                            if (_this.options.wrapOnKeys) {
                                $prevElement = i === 0 ? $elements.last() : $elements.eq(i - 1);
                                $nextElement = i === $elements.length - 1 ? $elements.first() : $elements.eq(i + 1);
                            } else {
                                $prevElement = $elements.eq(Math.max(0, i - 1));
                                $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1));
                            }
                            return;
                        }
                    });
                    // handle keyboard event with keyboard util
                    $57aa6ed7a3256ce7$export$16e4d70cc375e707.handleKey(e, "Tabs", {
                        open: function open() {
                            $element.find('[role="tab"]').focus();
                            _this._handleTabChange($element);
                        },
                        previous: function previous() {
                            $prevElement.find('[role="tab"]').focus();
                            _this._handleTabChange($prevElement);
                        },
                        next: function next() {
                            $nextElement.find('[role="tab"]').focus();
                            _this._handleTabChange($nextElement);
                        },
                        handled: function handled() {
                            e.preventDefault();
                        }
                    });
                });
            }
        },
        {
            key: "_handleTabChange",
            value: function _handleTabChange($target, historyHandled) {
                // With `activeCollapse`, if the target is the active Tab, collapse it.
                if ($target.hasClass("".concat(this.options.linkActiveClass))) {
                    if (this.options.activeCollapse) this._collapse();
                    return;
                }
                var $oldTab = this.$element.find(".".concat(this.options.linkClass, ".").concat(this.options.linkActiveClass)), $tabLink = $target.find('[role="tab"]'), target = $tabLink.attr("data-tabs-target"), anchor = target && target.length ? "#".concat(target) : $tabLink[0].hash, $targetContent = this.$tabContent.find(anchor);
                //close old tab
                this._collapseTab($oldTab);
                //open new tab
                this._openTab($target);
                //either replace or update browser history
                if (this.options.deepLink && !historyHandled) {
                    if (this.options.updateHistory) history.pushState({}, "", anchor);
                    else history.replaceState({}, "", anchor);
                }
                /**
       * Fires when the plugin has successfully changed tabs.
       * @event Tabs#change
       */ this.$element.trigger("change.zf.tabs", [
                    $target,
                    $targetContent
                ]);
                //fire to children a mutation event
                $targetContent.find("[data-mutate]").trigger("mutateme.zf.trigger");
            }
        },
        {
            key: "_openTab",
            value: function _openTab($target) {
                var $tabLink = $target.find('[role="tab"]'), hash = $tabLink.attr("data-tabs-target") || $tabLink[0].hash.slice(1), $targetContent = this.$tabContent.find("#".concat(hash));
                $target.addClass("".concat(this.options.linkActiveClass));
                $tabLink.attr({
                    "aria-selected": "true",
                    "tabindex": "0"
                });
                $targetContent.addClass("".concat(this.options.panelActiveClass)).removeAttr("aria-hidden");
            }
        },
        {
            key: "_collapseTab",
            value: function _collapseTab($target) {
                var $targetAnchor = $target.removeClass("".concat(this.options.linkActiveClass)).find('[role="tab"]').attr({
                    "aria-selected": "false",
                    "tabindex": -1
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#".concat($targetAnchor.attr("aria-controls"))).removeClass("".concat(this.options.panelActiveClass)).attr({
                    "aria-hidden": "true"
                });
            }
        },
        {
            key: "_collapse",
            value: function _collapse() {
                var $activeTab = this.$element.find(".".concat(this.options.linkClass, ".").concat(this.options.linkActiveClass));
                if ($activeTab.length) {
                    this._collapseTab($activeTab);
                    /**
        * Fires when the plugin has successfully collapsed tabs.
        * @event Tabs#collapse
        */ this.$element.trigger("collapse.zf.tabs", [
                        $activeTab
                    ]);
                }
            }
        },
        {
            key: "selectTab",
            value: function selectTab(elem, historyHandled) {
                var idStr, hashIdStr;
                if ($57aa6ed7a3256ce7$var$_typeof(elem) === "object") idStr = elem[0].id;
                else idStr = elem;
                if (idStr.indexOf("#") < 0) hashIdStr = "#".concat(idStr);
                else {
                    hashIdStr = idStr;
                    idStr = idStr.slice(1);
                }
                var $target = this.$tabTitles.has('[href$="'.concat(hashIdStr, '"],[data-tabs-target="').concat(idStr, '"]')).first();
                this._handleTabChange($target, historyHandled);
            }
        },
        {
            key: "_setHeight",
            value: /**
     * Sets the height of each panel to the height of the tallest panel.
     * If enabled in options, gets called on media query change.
     * If loading content via external source, can be called directly or with _reflow.
     * If enabled with `data-match-height="true"`, tabs sets to equal height
     * @function
     * @private
     */ function _setHeight() {
                var max = 0, _this = this; // Lock down the `this` value for the root tabs object
                if (!this.$tabContent) return;
                this.$tabContent.find(".".concat(this.options.panelClass)).css("min-height", "").each(function() {
                    var panel = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this), isActive = panel.hasClass("".concat(_this.options.panelActiveClass)); // get the options from the parent instead of trying to get them from the child
                    if (!isActive) panel.css({
                        "visibility": "hidden",
                        "display": "block"
                    });
                    var temp = this.getBoundingClientRect().height;
                    if (!isActive) panel.css({
                        "visibility": "",
                        "display": ""
                    });
                    max = temp > max ? temp : max;
                }).css("min-height", "".concat(max, "px"));
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.find(".".concat(this.options.linkClass)).off(".zf.tabs").hide().end().find(".".concat(this.options.panelClass)).hide();
                if (this.options.matchHeight) {
                    if (this._setHeightMqHandler != null) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off("changed.zf.mediaquery", this._setHeightMqHandler);
                }
                if (this.options.deepLink) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off("hashchange", this._checkDeepLink);
                if (this.onLoadListener) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off(this.onLoadListener);
            }
        }
    ]);
    return Tabs;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$b2539bed5023c21c.defaults = {
    /**
   * Link the location hash to the active pane.
   * Set the location hash when the active pane changes, and open the corresponding pane when the location changes.
   * @option
   * @type {boolean}
   * @default false
   */ deepLink: false,
    /**
   * If `deepLink` is enabled, adjust the deep link scroll to make sure the top of the tab panel is visible
   * @option
   * @type {boolean}
   * @default false
   */ deepLinkSmudge: false,
    /**
   * If `deepLinkSmudge` is enabled, animation time (ms) for the deep link adjustment
   * @option
   * @type {number}
   * @default 300
   */ deepLinkSmudgeDelay: 300,
    /**
   * If `deepLinkSmudge` is enabled, animation offset from the top for the deep link adjustment
   * @option
   * @type {number}
   * @default 0
   */ deepLinkSmudgeOffset: 0,
    /**
   * If `deepLink` is enabled, update the browser history with the open tab
   * @option
   * @type {boolean}
   * @default false
   */ updateHistory: false,
    /**
   * Allows the window to scroll to content of active pane on load.
   * Not recommended if more than one tab panel per page.
   * @option
   * @type {boolean}
   * @default false
   */ autoFocus: false,
    /**
   * Allows keyboard input to 'wrap' around the tab links.
   * @option
   * @type {boolean}
   * @default true
   */ wrapOnKeys: true,
    /**
   * Allows the tab content panes to match heights if set to true.
   * @option
   * @type {boolean}
   * @default false
   */ matchHeight: false,
    /**
   * Allows active tabs to collapse when clicked.
   * @option
   * @type {boolean}
   * @default false
   */ activeCollapse: false,
    /**
   * Class applied to `li`'s in tab link list.
   * @option
   * @type {string}
   * @default 'tabs-title'
   */ linkClass: "tabs-title",
    /**
   * Class applied to the active `li` in tab link list.
   * @option
   * @type {string}
   * @default 'is-active'
   */ linkActiveClass: "is-active",
    /**
   * Class applied to the content containers.
   * @option
   * @type {string}
   * @default 'tabs-panel'
   */ panelClass: "tabs-panel",
    /**
   * Class applied to the active content container.
   * @option
   * @type {string}
   * @default 'is-active'
   */ panelActiveClass: "is-active"
};
/**
 * Toggler module.
 * @module foundation.toggler
 * @requires foundation.util.motion
 * @requires foundation.util.triggers
 */ var $57aa6ed7a3256ce7$export$9568ba43c78e1cc8 = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(Toggler, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Toggler);
    function Toggler() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Toggler);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Toggler, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of Toggler.
     * @class
     * @name Toggler
     * @fires Toggler#init
     * @param {Object} element - jQuery object to add the trigger to.
     * @param {Object} options - Overrides to the default plugin settings.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Toggler.defaults, element.data(), options);
                this.className = "";
                this.className = "Toggler"; // ie9 back compat
                // Triggers init is idempotent, just need to make sure it is initialized
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                this._init();
                this._events();
            }
        },
        {
            key: "_init",
            value: function _init() {
                // Collect triggers to set ARIA attributes to
                var id = this.$element[0].id, $triggers = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-open~="'.concat(id, '"], [data-close~="').concat(id, '"], [data-toggle~="').concat(id, '"]'));
                var input;
                // Parse animation classes if they were set
                if (this.options.animate) {
                    input = this.options.animate.split(" ");
                    this.animationIn = input[0];
                    this.animationOut = input[1] || null;
                    // - aria-expanded: according to the element visibility.
                    $triggers.attr("aria-expanded", !this.$element.is(":hidden"));
                } else {
                    input = this.options.toggler;
                    if (typeof input !== "string" || !input.length) throw new Error("The 'toggler' option containing the target class is required, got \"".concat(input, '"'));
                    // Allow for a . at the beginning of the string
                    this.className = input[0] === "." ? input.slice(1) : input;
                    // - aria-expanded: according to the elements class set.
                    $triggers.attr("aria-expanded", this.$element.hasClass(this.className));
                }
                // - aria-controls: adding the element id to it if not already in it.
                $triggers.each(function(index, trigger) {
                    var $trigger = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(trigger);
                    var controls = $trigger.attr("aria-controls") || "";
                    var containsId = new RegExp("\\b".concat($57aa6ed7a3256ce7$var$RegExpEscape(id), "\\b")).test(controls);
                    if (!containsId) $trigger.attr("aria-controls", controls ? "".concat(controls, " ").concat(id) : id);
                });
            }
        },
        {
            key: "_events",
            value: function _events() {
                this.$element.off("toggle.zf.trigger").on("toggle.zf.trigger", this.toggle.bind(this));
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                this[this.options.animate ? "_toggleAnimate" : "_toggleClass"]();
            }
        },
        {
            key: "_toggleClass",
            value: function _toggleClass() {
                this.$element.toggleClass(this.className);
                var isOn = this.$element.hasClass(this.className);
                if (isOn) /**
         * Fires if the target element has the class after a toggle.
         * @event Toggler#on
         */ this.$element.trigger("on.zf.toggler");
                else /**
         * Fires if the target element does not have the class after a toggle.
         * @event Toggler#off
         */ this.$element.trigger("off.zf.toggler");
                this._updateARIA(isOn);
                this.$element.find("[data-mutate]").trigger("mutateme.zf.trigger");
            }
        },
        {
            key: "_toggleAnimate",
            value: function _toggleAnimate() {
                var _this = this;
                if (this.$element.is(":hidden")) $57aa6ed7a3256ce7$export$ab7b018719e111db.animateIn(this.$element, this.animationIn, function() {
                    _this._updateARIA(true);
                    this.trigger("on.zf.toggler");
                    this.find("[data-mutate]").trigger("mutateme.zf.trigger");
                });
                else $57aa6ed7a3256ce7$export$ab7b018719e111db.animateOut(this.$element, this.animationOut, function() {
                    _this._updateARIA(false);
                    this.trigger("off.zf.toggler");
                    this.find("[data-mutate]").trigger("mutateme.zf.trigger");
                });
            }
        },
        {
            key: "_updateARIA",
            value: function _updateARIA(isOn) {
                var id = this.$element[0].id;
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-open="'.concat(id, '"], [data-close="').concat(id, '"], [data-toggle="').concat(id, '"]')).attr({
                    "aria-expanded": isOn ? true : false
                });
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.off(".zf.toggler");
            }
        }
    ]);
    return Toggler;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$9568ba43c78e1cc8.defaults = {
    /**
   * Class of the element to toggle. It can be provided with or without "."
   * @option
   * @type {string}
   */ toggler: undefined,
    /**
   * Tells the plugin if the element should animated when toggled.
   * @option
   * @type {boolean}
   * @default false
   */ animate: false
};
/**
 * Tooltip module.
 * @module foundation.tooltip
 * @requires foundation.util.box
 * @requires foundation.util.mediaQuery
 * @requires foundation.util.triggers
 */ var $57aa6ed7a3256ce7$export$28c660c63b792dea = /*#__PURE__*/ function(_Positionable) {
    $57aa6ed7a3256ce7$var$_inherits(Tooltip, _Positionable);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(Tooltip);
    function Tooltip() {
        $57aa6ed7a3256ce7$var$_classCallCheck(this, Tooltip);
        return _super.apply(this, arguments);
    }
    $57aa6ed7a3256ce7$var$_createClass(Tooltip, [
        {
            key: "_setup",
            value: /**
     * Creates a new instance of a Tooltip.
     * @class
     * @name Tooltip
     * @fires Tooltip#init
     * @param {jQuery} element - jQuery object to attach a tooltip to.
     * @param {Object} options - object to extend the default configuration.
     */ function _setup(element, options) {
                this.$element = element;
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, Tooltip.defaults, this.$element.data(), options);
                this.className = "Tooltip"; // ie9 back compat
                this.isActive = false;
                this.isClick = false;
                // Triggers init is idempotent, just need to make sure it is initialized
                $57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
                this._init();
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                var elemId = this.$element.attr("aria-describedby") || $57aa6ed7a3256ce7$var$GetYoDigits(6, "tooltip");
                this.options.tipText = this.options.tipText || this.$element.attr("title");
                this.template = this.options.template ? (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this.options.template) : this._buildTemplate(elemId);
                if (this.options.allowHtml) this.template.appendTo(document.body).html(this.options.tipText).hide();
                else this.template.appendTo(document.body).text(this.options.tipText).hide();
                this.$element.attr({
                    "title": "",
                    "aria-describedby": elemId,
                    "data-yeti-box": elemId,
                    "data-toggle": elemId,
                    "data-resize": elemId
                }).addClass(this.options.triggerClass);
                $57aa6ed7a3256ce7$var$_get($57aa6ed7a3256ce7$var$_getPrototypeOf(Tooltip.prototype), "_init", this).call(this);
                this._events();
            }
        },
        {
            key: "_getDefaultPosition",
            value: function _getDefaultPosition() {
                // handle legacy classnames
                var elementClassName = this.$element[0].className;
                if (this.$element[0] instanceof SVGElement) elementClassName = elementClassName.baseVal;
                var position = elementClassName.match(/\b(top|left|right|bottom)\b/g);
                return position ? position[0] : "top";
            }
        },
        {
            key: "_getDefaultAlignment",
            value: function _getDefaultAlignment() {
                return "center";
            }
        },
        {
            key: "_getHOffset",
            value: function _getHOffset() {
                if (this.position === "left" || this.position === "right") return this.options.hOffset + this.options.tooltipWidth;
                else return this.options.hOffset;
            }
        },
        {
            key: "_getVOffset",
            value: function _getVOffset() {
                if (this.position === "top" || this.position === "bottom") return this.options.vOffset + this.options.tooltipHeight;
                else return this.options.vOffset;
            }
        },
        {
            key: "_buildTemplate",
            value: function _buildTemplate(id) {
                var templateClasses = "".concat(this.options.tooltipClass, " ").concat(this.options.templateClasses).trim();
                var $template = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("<div></div>").addClass(templateClasses).attr({
                    "role": "tooltip",
                    "aria-hidden": true,
                    "data-is-active": false,
                    "data-is-focus": false,
                    "id": id
                });
                return $template;
            }
        },
        {
            key: "_setPosition",
            value: function _setPosition() {
                $57aa6ed7a3256ce7$var$_get($57aa6ed7a3256ce7$var$_getPrototypeOf(Tooltip.prototype), "_setPosition", this).call(this, this.$element, this.template);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.options.showOn !== "all" && !$57aa6ed7a3256ce7$export$b745838c41029eb3.is(this.options.showOn)) // console.error('The screen is too small to display this tooltip');
                return false;
                var _this = this;
                this.template.css("visibility", "hidden").show();
                this._setPosition();
                this.template.removeClass("top bottom left right").addClass(this.position);
                this.template.removeClass("align-top align-bottom align-left align-right align-center").addClass("align-" + this.alignment);
                /**
       * Fires to close all other open tooltips on the page
       * @event Closeme#tooltip
       */ this.$element.trigger("closeme.zf.tooltip", this.template.attr("id"));
                this.template.attr({
                    "data-is-active": true,
                    "aria-hidden": false
                });
                _this.isActive = true;
                this.template.stop().hide().css("visibility", "").fadeIn(this.options.fadeInDuration, function() {
                //maybe do stuff?
                });
                /**
       * Fires when the tooltip is shown
       * @event Tooltip#show
       */ this.$element.trigger("show.zf.tooltip");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                this.template.stop().attr({
                    "aria-hidden": true,
                    "data-is-active": false
                }).fadeOut(this.options.fadeOutDuration, function() {
                    _this.isActive = false;
                    _this.isClick = false;
                });
                /**
       * fires when the tooltip is hidden
       * @event Tooltip#hide
       */ this.$element.trigger("hide.zf.tooltip");
            }
        },
        {
            key: "_events",
            value: function _events() {
                var _this = this;
                var hasTouch = "ontouchstart" in window || typeof window.ontouchstart !== "undefined";
                var isFocus = false;
                // `disableForTouch: Fully disable the tooltip on touch devices
                if (hasTouch && this.options.disableForTouch) return;
                if (!this.options.disableHover) this.$element.on("mouseenter.zf.tooltip", function() {
                    if (!_this.isActive) _this.timeout = setTimeout(function() {
                        _this.show();
                    }, _this.options.hoverDelay);
                }).on("mouseleave.zf.tooltip", $57aa6ed7a3256ce7$var$ignoreMousedisappear(function() {
                    clearTimeout(_this.timeout);
                    if (!isFocus || _this.isClick && !_this.options.clickOpen) _this.hide();
                }));
                if (hasTouch) this.$element.on("tap.zf.tooltip touchend.zf.tooltip", function() {
                    _this.isActive ? _this.hide() : _this.show();
                });
                if (this.options.clickOpen) this.$element.on("mousedown.zf.tooltip", function() {
                    if (_this.isClick) ;
                    else {
                        _this.isClick = true;
                        if ((_this.options.disableHover || !_this.$element.attr("tabindex")) && !_this.isActive) _this.show();
                    }
                });
                else this.$element.on("mousedown.zf.tooltip", function() {
                    _this.isClick = true;
                });
                this.$element.on({
                    // 'toggle.zf.trigger': this.toggle.bind(this),
                    // 'close.zf.trigger': this.hide.bind(this)
                    "close.zf.trigger": this.hide.bind(this)
                });
                this.$element.on("focus.zf.tooltip", function() {
                    isFocus = true;
                    if (_this.isClick) {
                        // If we're not showing open on clicks, we need to pretend a click-launched focus isn't
                        // a real focus, otherwise on hover and come back we get bad behavior
                        if (!_this.options.clickOpen) isFocus = false;
                        return false;
                    } else _this.show();
                }).on("focusout.zf.tooltip", function() {
                    isFocus = false;
                    _this.isClick = false;
                    _this.hide();
                }).on("resizeme.zf.trigger", function() {
                    if (_this.isActive) _this._setPosition();
                });
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (this.isActive) this.hide();
                else this.show();
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.$element.attr("title", this.template.text()).off(".zf.trigger .zf.tooltip").removeClass(this.options.triggerClass).removeClass("top right left bottom").removeAttr("aria-describedby data-disable-hover data-resize data-toggle data-tooltip data-yeti-box");
                this.template.remove();
            }
        }
    ]);
    return Tooltip;
}($57aa6ed7a3256ce7$var$Positionable);
$57aa6ed7a3256ce7$export$28c660c63b792dea.defaults = {
    /**
   * Time, in ms, before a tooltip should open on hover.
   * @option
   * @type {number}
   * @default 200
   */ hoverDelay: 200,
    /**
   * Time, in ms, a tooltip should take to fade into view.
   * @option
   * @type {number}
   * @default 150
   */ fadeInDuration: 150,
    /**
   * Time, in ms, a tooltip should take to fade out of view.
   * @option
   * @type {number}
   * @default 150
   */ fadeOutDuration: 150,
    /**
   * Disables hover events from opening the tooltip if set to true
   * @option
   * @type {boolean}
   * @default false
   */ disableHover: false,
    /**
   * Disable the tooltip for touch devices.
   * This can be useful to make elements with a tooltip on it trigger their
   * action on the first tap instead of displaying the tooltip.
   * @option
   * @type {booelan}
   * @default false
   */ disableForTouch: false,
    /**
   * Optional addtional classes to apply to the tooltip template on init.
   * @option
   * @type {string}
   * @default ''
   */ templateClasses: "",
    /**
   * Non-optional class added to tooltip templates. Foundation default is 'tooltip'.
   * @option
   * @type {string}
   * @default 'tooltip'
   */ tooltipClass: "tooltip",
    /**
   * Class applied to the tooltip anchor element.
   * @option
   * @type {string}
   * @default 'has-tip'
   */ triggerClass: "has-tip",
    /**
   * Minimum breakpoint size at which to open the tooltip.
   * @option
   * @type {string}
   * @default 'small'
   */ showOn: "small",
    /**
   * Custom template to be used to generate markup for tooltip.
   * @option
   * @type {string}
   * @default ''
   */ template: "",
    /**
   * Text displayed in the tooltip template on open.
   * @option
   * @type {string}
   * @default ''
   */ tipText: "",
    touchCloseText: "Tap to close.",
    /**
   * Allows the tooltip to remain open if triggered with a click or touch event.
   * @option
   * @type {boolean}
   * @default true
   */ clickOpen: true,
    /**
   * Position of tooltip. Can be left, right, bottom, top, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */ position: "auto",
    /**
   * Alignment of tooltip relative to anchor. Can be left, right, bottom, top, center, or auto.
   * @option
   * @type {string}
   * @default 'auto'
   */ alignment: "auto",
    /**
   * Allow overlap of container/window. If false, tooltip will first try to
   * position as defined by data-position and data-alignment, but reposition if
   * it would cause an overflow.  @option
   * @type {boolean}
   * @default false
   */ allowOverlap: false,
    /**
   * Allow overlap of only the bottom of the container. This is the most common
   * behavior for dropdowns, allowing the dropdown to extend the bottom of the
   * screen but not otherwise influence or break out of the container.
   * Less common for tooltips.
   * @option
   * @type {boolean}
   * @default false
   */ allowBottomOverlap: false,
    /**
   * Distance, in pixels, the template should push away from the anchor on the Y axis.
   * @option
   * @type {number}
   * @default 0
   */ vOffset: 0,
    /**
   * Distance, in pixels, the template should push away from the anchor on the X axis
   * @option
   * @type {number}
   * @default 0
   */ hOffset: 0,
    /**
   * Distance, in pixels, the template spacing auto-adjust for a vertical tooltip
   * @option
   * @type {number}
   * @default 14
   */ tooltipHeight: 14,
    /**
   * Distance, in pixels, the template spacing auto-adjust for a horizontal tooltip
   * @option
   * @type {number}
   * @default 12
   */ tooltipWidth: 12,
    /**
  * Allow HTML in tooltip. Warning: If you are loading user-generated content into tooltips,
  * allowing HTML may open yourself up to XSS attacks.
  * @option
  * @type {boolean}
  * @default false
  */ allowHtml: false
};
// The plugin matches the plugin classes with these plugin instances.
var $57aa6ed7a3256ce7$var$MenuPlugins$1 = {
    tabs: {
        cssClass: "tabs",
        plugin: $57aa6ed7a3256ce7$export$b2539bed5023c21c,
        open: function open(plugin, target) {
            return plugin.selectTab(target);
        },
        close: null,
        toggle: null
    },
    accordion: {
        cssClass: "accordion",
        plugin: $57aa6ed7a3256ce7$export$a766cd26d0d69044,
        open: function open(plugin, target) {
            return plugin.down((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(target));
        },
        close: function close(plugin, target) {
            return plugin.up((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(target));
        },
        toggle: function toggle(plugin, target) {
            return plugin.toggle((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(target));
        }
    }
};
/**
 * ResponsiveAccordionTabs module.
 * @module foundation.responsiveAccordionTabs
 * @requires foundation.util.motion
 * @requires foundation.accordion
 * @requires foundation.tabs
 */ var $57aa6ed7a3256ce7$export$b81160fbef1b6bda = /*#__PURE__*/ function(_Plugin) {
    $57aa6ed7a3256ce7$var$_inherits(ResponsiveAccordionTabs, _Plugin);
    var _super = $57aa6ed7a3256ce7$var$_createSuper(ResponsiveAccordionTabs);
    function ResponsiveAccordionTabs(element, options) {
        var _this2;
        $57aa6ed7a3256ce7$var$_classCallCheck(this, ResponsiveAccordionTabs);
        _this2 = _super.call(this, element, options);
        return $57aa6ed7a3256ce7$var$_possibleConstructorReturn(_this2, _this2.options.reflow && _this2.storezfData || $57aa6ed7a3256ce7$var$_assertThisInitialized(_this2));
    }
    /**
   * Creates a new instance of a responsive accordion tabs.
   * @class
   * @name ResponsiveAccordionTabs
   * @fires ResponsiveAccordionTabs#init
   * @param {jQuery} element - jQuery object to make into Responsive Accordion Tabs.
   * @param {Object} options - Overrides to the default plugin settings.
   */ $57aa6ed7a3256ce7$var$_createClass(ResponsiveAccordionTabs, [
        {
            key: "_setup",
            value: function _setup(element, options) {
                this.$element = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element);
                this.$element.data("zfPluginBase", this);
                this.options = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).extend({}, ResponsiveAccordionTabs.defaults, this.$element.data(), options);
                this.rules = this.$element.data("responsive-accordion-tabs");
                this.currentMq = null;
                this.currentRule = null;
                this.currentPlugin = null;
                this.className = "ResponsiveAccordionTabs"; // ie9 back compat
                if (!this.$element.attr("id")) this.$element.attr("id", $57aa6ed7a3256ce7$var$GetYoDigits(6, "responsiveaccordiontabs"));
                this._init();
                this._events();
            }
        },
        {
            key: "_init",
            value: function _init() {
                $57aa6ed7a3256ce7$export$b745838c41029eb3._init();
                // The first time an Interchange plugin is initialized, this.rules is converted from a string of "classes" to an object of rules
                if (typeof this.rules === "string") {
                    var rulesTree = {};
                    // Parse rules from "classes" pulled from data attribute
                    var rules = this.rules.split(" ");
                    // Iterate through every rule found
                    for(var i = 0; i < rules.length; i++){
                        var rule = rules[i].split("-");
                        var ruleSize = rule.length > 1 ? rule[0] : "small";
                        var rulePlugin = rule.length > 1 ? rule[1] : rule[0];
                        if ($57aa6ed7a3256ce7$var$MenuPlugins$1[rulePlugin] !== null) rulesTree[ruleSize] = $57aa6ed7a3256ce7$var$MenuPlugins$1[rulePlugin];
                    }
                    this.rules = rulesTree;
                }
                this._getAllOptions();
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).isEmptyObject(this.rules)) this._checkMediaQueries();
            }
        },
        {
            key: "_getAllOptions",
            value: function _getAllOptions() {
                //get all defaults and options
                var _this = this;
                _this.allOptions = {};
                for(var key in $57aa6ed7a3256ce7$var$MenuPlugins$1)if ($57aa6ed7a3256ce7$var$MenuPlugins$1.hasOwnProperty(key)) {
                    var obj = $57aa6ed7a3256ce7$var$MenuPlugins$1[key];
                    try {
                        var dummyPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("<ul></ul>");
                        var tmpPlugin = new obj.plugin(dummyPlugin, _this.options);
                        for(var keyKey in tmpPlugin.options)if (tmpPlugin.options.hasOwnProperty(keyKey) && keyKey !== "zfPlugin") {
                            var objObj = tmpPlugin.options[keyKey];
                            _this.allOptions[keyKey] = objObj;
                        }
                        tmpPlugin.destroy();
                    } catch (e) {
                        console.warn("Warning: Problems getting Accordion/Tab options: ".concat(e));
                    }
                }
            }
        },
        {
            key: "_events",
            value: function _events() {
                this._changedZfMediaQueryHandler = this._checkMediaQueries.bind(this);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).on("changed.zf.mediaquery", this._changedZfMediaQueryHandler);
            }
        },
        {
            key: "_checkMediaQueries",
            value: function _checkMediaQueries() {
                var matchedMq, _this = this;
                // Iterate through each rule and find the last matching rule
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).each(this.rules, function(key) {
                    if ($57aa6ed7a3256ce7$export$b745838c41029eb3.atLeast(key)) matchedMq = key;
                });
                // No match? No dice
                if (!matchedMq) return;
                // Plugin already initialized? We good
                if (this.currentPlugin instanceof this.rules[matchedMq].plugin) return;
                // Remove existing plugin-specific CSS classes
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).each($57aa6ed7a3256ce7$var$MenuPlugins$1, function(key, value) {
                    _this.$element.removeClass(value.cssClass);
                });
                // Add the CSS class for the new plugin
                this.$element.addClass(this.rules[matchedMq].cssClass);
                // Create an instance of the new plugin
                if (this.currentPlugin) {
                    //don't know why but on nested elements data zfPlugin get's lost
                    if (!this.currentPlugin.$element.data("zfPlugin") && this.storezfData) this.currentPlugin.$element.data("zfPlugin", this.storezfData);
                    this.currentPlugin.destroy();
                }
                this._handleMarkup(this.rules[matchedMq].cssClass);
                this.currentRule = this.rules[matchedMq];
                this.currentPlugin = new this.currentRule.plugin(this.$element, this.options);
                this.storezfData = this.currentPlugin.$element.data("zfPlugin");
            }
        },
        {
            key: "_handleMarkup",
            value: function _handleMarkup(toSet) {
                var _this = this, fromString = "accordion";
                var $panels = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-tabs-content=" + this.$element.attr("id") + "]");
                if ($panels.length) fromString = "tabs";
                if (fromString === toSet) return;
                var tabsTitle = _this.allOptions.linkClass ? _this.allOptions.linkClass : "tabs-title";
                var tabsPanel = _this.allOptions.panelClass ? _this.allOptions.panelClass : "tabs-panel";
                this.$element.removeAttr("role");
                var $liHeads = this.$element.children("." + tabsTitle + ",[data-accordion-item]").removeClass(tabsTitle).removeClass("accordion-item").removeAttr("data-accordion-item");
                var $liHeadsA = $liHeads.children("a").removeClass("accordion-title");
                if (fromString === "tabs") {
                    $panels = $panels.children("." + tabsPanel).removeClass(tabsPanel).removeAttr("role").removeAttr("aria-hidden").removeAttr("aria-labelledby");
                    $panels.children("a").removeAttr("role").removeAttr("aria-controls").removeAttr("aria-selected");
                } else $panels = $liHeads.children("[data-tab-content]").removeClass("accordion-content");
                $panels.css({
                    display: "",
                    visibility: ""
                });
                $liHeads.css({
                    display: "",
                    visibility: ""
                });
                if (toSet === "accordion") $panels.each(function(key, value) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(value).appendTo($liHeads.get(key)).addClass("accordion-content").attr("data-tab-content", "").removeClass("is-active").css({
                        height: ""
                    });
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-tabs-content=" + _this.$element.attr("id") + "]").after('<div id="tabs-placeholder-' + _this.$element.attr("id") + '"></div>').detach();
                    $liHeads.addClass("accordion-item").attr("data-accordion-item", "");
                    $liHeadsA.addClass("accordion-title");
                });
                else if (toSet === "tabs") {
                    var $tabsContent = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("[data-tabs-content=" + _this.$element.attr("id") + "]");
                    var $placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#tabs-placeholder-" + _this.$element.attr("id"));
                    if ($placeholder.length) {
                        $tabsContent = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('<div class="tabs-content"></div>').insertAfter($placeholder).attr("data-tabs-content", _this.$element.attr("id"));
                        $placeholder.remove();
                    } else $tabsContent = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('<div class="tabs-content"></div>').insertAfter(_this.$element).attr("data-tabs-content", _this.$element.attr("id"));
                    $panels.each(function(key, value) {
                        var tempValue = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(value).appendTo($tabsContent).addClass(tabsPanel);
                        var hash = $liHeadsA.get(key).hash.slice(1);
                        var id = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(value).attr("id") || $57aa6ed7a3256ce7$var$GetYoDigits(6, "accordion");
                        if (hash !== id) {
                            if (hash !== "") (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(value).attr("id", hash);
                            else {
                                hash = id;
                                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(value).attr("id", hash);
                                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))($liHeadsA.get(key)).attr("href", (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))($liHeadsA.get(key)).attr("href").replace("#", "") + "#" + hash);
                            }
                        }
                        var isActive = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))($liHeads.get(key)).hasClass("is-active");
                        if (isActive) tempValue.addClass("is-active");
                    });
                    $liHeads.addClass(tabsTitle);
                }
            }
        },
        {
            key: "open",
            value: function open() {
                if (this.currentRule && typeof this.currentRule.open === "function") {
                    var _this$currentRule;
                    return (_this$currentRule = this.currentRule).open.apply(_this$currentRule, [
                        this.currentPlugin
                    ].concat(Array.prototype.slice.call(arguments)));
                }
            }
        },
        {
            key: "close",
            value: function close() {
                if (this.currentRule && typeof this.currentRule.close === "function") {
                    var _this$currentRule2;
                    return (_this$currentRule2 = this.currentRule).close.apply(_this$currentRule2, [
                        this.currentPlugin
                    ].concat(Array.prototype.slice.call(arguments)));
                }
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (this.currentRule && typeof this.currentRule.toggle === "function") {
                    var _this$currentRule3;
                    return (_this$currentRule3 = this.currentRule).toggle.apply(_this$currentRule3, [
                        this.currentPlugin
                    ].concat(Array.prototype.slice.call(arguments)));
                }
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                if (this.currentPlugin) this.currentPlugin.destroy();
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).off("changed.zf.mediaquery", this._changedZfMediaQueryHandler);
            }
        }
    ]);
    return ResponsiveAccordionTabs;
}($57aa6ed7a3256ce7$var$Plugin);
$57aa6ed7a3256ce7$export$b81160fbef1b6bda.defaults = {};
$57aa6ed7a3256ce7$export$4143ab5b91744744.addToJquery((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
// Add Foundation Utils to Foundation global namespace for backwards
// compatibility.
$57aa6ed7a3256ce7$export$4143ab5b91744744.rtl = $57aa6ed7a3256ce7$var$rtl;
$57aa6ed7a3256ce7$export$4143ab5b91744744.GetYoDigits = $57aa6ed7a3256ce7$var$GetYoDigits;
$57aa6ed7a3256ce7$export$4143ab5b91744744.transitionend = $57aa6ed7a3256ce7$var$transitionend;
$57aa6ed7a3256ce7$export$4143ab5b91744744.RegExpEscape = $57aa6ed7a3256ce7$var$RegExpEscape;
$57aa6ed7a3256ce7$export$4143ab5b91744744.onLoad = $57aa6ed7a3256ce7$var$onLoad;
$57aa6ed7a3256ce7$export$4143ab5b91744744.Box = $57aa6ed7a3256ce7$export$e71c4d32a2263218;
$57aa6ed7a3256ce7$export$4143ab5b91744744.onImagesLoaded = $57aa6ed7a3256ce7$export$9a7c395a24d73631;
$57aa6ed7a3256ce7$export$4143ab5b91744744.Keyboard = $57aa6ed7a3256ce7$export$16e4d70cc375e707;
$57aa6ed7a3256ce7$export$4143ab5b91744744.MediaQuery = $57aa6ed7a3256ce7$export$b745838c41029eb3;
$57aa6ed7a3256ce7$export$4143ab5b91744744.Motion = $57aa6ed7a3256ce7$export$ab7b018719e111db;
$57aa6ed7a3256ce7$export$4143ab5b91744744.Move = $57aa6ed7a3256ce7$export$e49a5ad3dd6df925;
$57aa6ed7a3256ce7$export$4143ab5b91744744.Nest = $57aa6ed7a3256ce7$export$b33048315ba1159e;
$57aa6ed7a3256ce7$export$4143ab5b91744744.Timer = $57aa6ed7a3256ce7$export$c57e9b2d8b9e4de;
// Touch and Triggers previously were almost purely sede effect driven,
// so no need to add it to Foundation, just init them.
$57aa6ed7a3256ce7$export$746b04bbf92762fd.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))));
$57aa6ed7a3256ce7$export$2f0ccbe60836e02e.init((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))), $57aa6ed7a3256ce7$export$4143ab5b91744744);
$57aa6ed7a3256ce7$export$b745838c41029eb3._init();
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$3d3f1ff3b6a4f356, "Abide");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$a766cd26d0d69044, "Accordion");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$6abe07ec29339e67, "AccordionMenu");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$c039e4c66cecbe03, "Drilldown");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$931cbfb6bfb85fc, "Dropdown");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$e44a253a59704894, "DropdownMenu");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$95a41bf8d2ae9c8f, "Equalizer");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$b955217673347a91, "Interchange");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$a98164a614985365, "Magellan");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$644db29b3dffde4c, "OffCanvas");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$439358b35042ae9f, "Orbit");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$be3a94c40ee849e6, "ResponsiveMenu");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$990bc2b2cdaf908a, "ResponsiveToggle");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$9a32a8eb4bb56ca3, "Reveal");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$472062a354075cee, "Slider");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$f8250c268cd0d487, "SmoothScroll");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$cbb1b0785b69b9d8, "Sticky");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$b2539bed5023c21c, "Tabs");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$9568ba43c78e1cc8, "Toggler");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$28c660c63b792dea, "Tooltip");
$57aa6ed7a3256ce7$export$4143ab5b91744744.plugin($57aa6ed7a3256ce7$export$b81160fbef1b6bda, "ResponsiveAccordionTabs");
var $57aa6ed7a3256ce7$export$2e2bcd8739ae039 = $57aa6ed7a3256ce7$export$4143ab5b91744744;


const $28098bff0e2b5f57$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $28098bff0e2b5f57$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $28098bff0e2b5f57$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($28098bff0e2b5f57$var$e(t) ? t : $28098bff0e2b5f57$var$i(t.parentElement, n));
}, $28098bff0e2b5f57$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $28098bff0e2b5f57$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $28098bff0e2b5f57$var$o = (t, e, i)=>{
    t && $28098bff0e2b5f57$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $28098bff0e2b5f57$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $28098bff0e2b5f57$var$r = {
    passive: !1
};
class $28098bff0e2b5f57$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $28098bff0e2b5f57$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $28098bff0e2b5f57$var$r), this.element.addEventListener("touchmove", this.onMove, $28098bff0e2b5f57$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $28098bff0e2b5f57$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $28098bff0e2b5f57$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $28098bff0e2b5f57$var$a(t)) : [
            new $28098bff0e2b5f57$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $28098bff0e2b5f57$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $28098bff0e2b5f57$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $28098bff0e2b5f57$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $28098bff0e2b5f57$var$r), this.element.removeEventListener("touchmove", this.onMove, $28098bff0e2b5f57$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $28098bff0e2b5f57$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $28098bff0e2b5f57$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $28098bff0e2b5f57$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $28098bff0e2b5f57$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $28098bff0e2b5f57$var$d(i) ? Object.assign(t[e], $28098bff0e2b5f57$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $28098bff0e2b5f57$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $28098bff0e2b5f57$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $28098bff0e2b5f57$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $28098bff0e2b5f57$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $28098bff0e2b5f57$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $28098bff0e2b5f57$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($28098bff0e2b5f57$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($28098bff0e2b5f57$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $28098bff0e2b5f57$var$g extends $28098bff0e2b5f57$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $28098bff0e2b5f57$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($28098bff0e2b5f57$var$m || ($28098bff0e2b5f57$var$m = {}));
const $28098bff0e2b5f57$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $28098bff0e2b5f57$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $28098bff0e2b5f57$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $28098bff0e2b5f57$var$b
}, $28098bff0e2b5f57$var$w = '<circle cx="25" cy="25" r="20"></circle>', $28098bff0e2b5f57$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $28098bff0e2b5f57$var$w + $28098bff0e2b5f57$var$w + "</svg></div>", $28098bff0e2b5f57$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $28098bff0e2b5f57$var$S = (t, e)=>{
    t && $28098bff0e2b5f57$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $28098bff0e2b5f57$var$P = (t, e)=>{
    t && $28098bff0e2b5f57$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $28098bff0e2b5f57$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $28098bff0e2b5f57$var$T = 1e5, $28098bff0e2b5f57$var$M = 1e4, $28098bff0e2b5f57$var$O = "mousemove", $28098bff0e2b5f57$var$A = "drag", $28098bff0e2b5f57$var$L = "content", $28098bff0e2b5f57$var$z = "auto";
let $28098bff0e2b5f57$var$R = null, $28098bff0e2b5f57$var$k = null;
class $28098bff0e2b5f57$export$b704d075ddd20210 extends $28098bff0e2b5f57$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $28098bff0e2b5f57$var$k && ($28098bff0e2b5f57$var$k = window.matchMedia("(hover: none)").matches), $28098bff0e2b5f57$var$k;
    }
    get isMobile() {
        return null === $28098bff0e2b5f57$var$R && ($28098bff0e2b5f57$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $28098bff0e2b5f57$var$R;
    }
    get panMode() {
        return this.options.panMode !== $28098bff0e2b5f57$var$O || this.isTouchDevice ? $28098bff0e2b5f57$var$A : $28098bff0e2b5f57$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $28098bff0e2b5f57$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $28098bff0e2b5f57$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $28098bff0e2b5f57$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $28098bff0e2b5f57$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $28098bff0e2b5f57$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $28098bff0e2b5f57$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $28098bff0e2b5f57$var$n($28098bff0e2b5f57$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($28098bff0e2b5f57$var$L);
        let i = this.option($28098bff0e2b5f57$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $28098bff0e2b5f57$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $28098bff0e2b5f57$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $28098bff0e2b5f57$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $28098bff0e2b5f57$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $28098bff0e2b5f57$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($28098bff0e2b5f57$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($28098bff0e2b5f57$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $28098bff0e2b5f57$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $28098bff0e2b5f57$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $28098bff0e2b5f57$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $28098bff0e2b5f57$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $28098bff0e2b5f57$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $28098bff0e2b5f57$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $28098bff0e2b5f57$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $28098bff0e2b5f57$var$t(this.targetScale) <= $28098bff0e2b5f57$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $28098bff0e2b5f57$var$h(s[0], s[1]), r = $28098bff0e2b5f57$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $28098bff0e2b5f57$var$c(s[0], s[1]), p = $28098bff0e2b5f57$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $28098bff0e2b5f57$var$t(this.targetScale) === $28098bff0e2b5f57$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($28098bff0e2b5f57$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $28098bff0e2b5f57$var$t(this.targetScale) === $28098bff0e2b5f57$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $28098bff0e2b5f57$var$t(y) === $28098bff0e2b5f57$var$t(w) && (g = 0), "x" === this.lockedAxis && $28098bff0e2b5f57$var$t(y) === $28098bff0e2b5f57$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $28098bff0e2b5f57$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $28098bff0e2b5f57$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $28098bff0e2b5f57$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $28098bff0e2b5f57$var$S(this.container, "is-scaling"), $28098bff0e2b5f57$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $28098bff0e2b5f57$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $28098bff0e2b5f57$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $28098bff0e2b5f57$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $28098bff0e2b5f57$var$C);
        for (const n of $28098bff0e2b5f57$var$v){
            const s = "e" == n || "f" === n ? $28098bff0e2b5f57$var$M : $28098bff0e2b5f57$var$T;
            o[n] = $28098bff0e2b5f57$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $28098bff0e2b5f57$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $28098bff0e2b5f57$var$z, b = this.option("height", g) || $28098bff0e2b5f57$var$z;
        const y = v === $28098bff0e2b5f57$var$z, w = b === $28098bff0e2b5f57$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($28098bff0e2b5f57$var$t(this.targetScale) < $28098bff0e2b5f57$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $28098bff0e2b5f57$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $28098bff0e2b5f57$var$t(o * n, $28098bff0e2b5f57$var$M), p = $28098bff0e2b5f57$var$t(a * n, $28098bff0e2b5f57$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $28098bff0e2b5f57$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $28098bff0e2b5f57$var$A && !!this.option("touch"), p = d && u;
        if (u && ($28098bff0e2b5f57$var$t(a) < $28098bff0e2b5f57$var$t(r) && !this.panOnlyZoomed && (p = !0), ($28098bff0e2b5f57$var$t(s.width, 1) > $28098bff0e2b5f57$var$t(s.fitWidth, 1) || $28098bff0e2b5f57$var$t(s.height, 1) > $28098bff0e2b5f57$var$t(s.fitHeight, 1)) && (p = !0)), $28098bff0e2b5f57$var$t(s.width * a, 1) < $28098bff0e2b5f57$var$t(s.fitWidth, 1) && (p = !1), n === $28098bff0e2b5f57$var$O && (p = !1), $28098bff0e2b5f57$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $28098bff0e2b5f57$var$t(l) > $28098bff0e2b5f57$var$t(a), g = !f && !p && d && $28098bff0e2b5f57$var$t(l) < $28098bff0e2b5f57$var$t(a);
        $28098bff0e2b5f57$var$o(i, this.cn("canZoomIn"), f), $28098bff0e2b5f57$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $28098bff0e2b5f57$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $28098bff0e2b5f57$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $28098bff0e2b5f57$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $28098bff0e2b5f57$var$t(y[e], $28098bff0e2b5f57$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $28098bff0e2b5f57$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $28098bff0e2b5f57$var$m.Init ? this.animate() : this.isResting || (this.state = $28098bff0e2b5f57$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $28098bff0e2b5f57$var$m.Init || this.state === $28098bff0e2b5f57$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $28098bff0e2b5f57$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $28098bff0e2b5f57$var$S(this.container, "is-scaling"), $28098bff0e2b5f57$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $28098bff0e2b5f57$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $28098bff0e2b5f57$var$P(this.container, "is-animating"), this.isScaling && $28098bff0e2b5f57$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $28098bff0e2b5f57$var$O || !e) return;
        if ($28098bff0e2b5f57$var$t(this.targetScale) <= $28098bff0e2b5f57$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $28098bff0e2b5f57$var$m.Destroy || this.state === $28098bff0e2b5f57$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $28098bff0e2b5f57$var$t(l) < $28098bff0e2b5f57$var$t(r) && $28098bff0e2b5f57$var$t(o) <= $28098bff0e2b5f57$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $28098bff0e2b5f57$var$t(l) > $28098bff0e2b5f57$var$t(a) && $28098bff0e2b5f57$var$t(o) >= $28098bff0e2b5f57$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $28098bff0e2b5f57$var$t(l) !== $28098bff0e2b5f57$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($28098bff0e2b5f57$var$t(this.contentRect.width, 1) < $28098bff0e2b5f57$var$t(this.contentRect.fitWidth, 1) || $28098bff0e2b5f57$var$t(this.targetScale) < $28098bff0e2b5f57$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $28098bff0e2b5f57$var$t(this.targetScale) > $28098bff0e2b5f57$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $28098bff0e2b5f57$var$z, originX: i = $28098bff0e2b5f57$var$z, originY: n = $28098bff0e2b5f57$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $28098bff0e2b5f57$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $28098bff0e2b5f57$var$O && (s = this.pmme || s), s || i === $28098bff0e2b5f57$var$z || n === $28098bff0e2b5f57$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $28098bff0e2b5f57$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $28098bff0e2b5f57$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $28098bff0e2b5f57$var$m.Init && this.state !== $28098bff0e2b5f57$var$m.Destroy) {
            this.stop("current");
            for (const t of $28098bff0e2b5f57$var$v)this.target[t] = $28098bff0e2b5f57$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $28098bff0e2b5f57$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $28098bff0e2b5f57$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($28098bff0e2b5f57$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$y
}), Object.defineProperty($28098bff0e2b5f57$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $28098bff0e2b5f57$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $28098bff0e2b5f57$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $28098bff0e2b5f57$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $28098bff0e2b5f57$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($28098bff0e2b5f57$var$B || ($28098bff0e2b5f57$var$B = {}));
const $28098bff0e2b5f57$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $28098bff0e2b5f57$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $28098bff0e2b5f57$var$_ extends $28098bff0e2b5f57$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $28098bff0e2b5f57$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $28098bff0e2b5f57$var$W extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $28098bff0e2b5f57$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $28098bff0e2b5f57$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($28098bff0e2b5f57$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $28098bff0e2b5f57$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$28098bff0e2b5f57$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $28098bff0e2b5f57$var$P(t, this.cn("isPrev")), $28098bff0e2b5f57$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $28098bff0e2b5f57$var$P(i, this.cn("isNext")), $28098bff0e2b5f57$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $28098bff0e2b5f57$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $28098bff0e2b5f57$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($28098bff0e2b5f57$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$$
});
const $28098bff0e2b5f57$var$X = "disabled", $28098bff0e2b5f57$var$q = "next", $28098bff0e2b5f57$var$Y = "prev";
class $28098bff0e2b5f57$var$V extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($28098bff0e2b5f57$var$X), s.removeAttribute($28098bff0e2b5f57$var$X), t.isInfinite || (i <= 0 && n.setAttribute($28098bff0e2b5f57$var$X, ""), i >= e - 1 && s.setAttribute($28098bff0e2b5f57$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $28098bff0e2b5f57$var$P(n, this.cn("button") + " " + this.cn(t === $28098bff0e2b5f57$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $28098bff0e2b5f57$var$q ? $28098bff0e2b5f57$var$Y : $28098bff0e2b5f57$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $28098bff0e2b5f57$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($28098bff0e2b5f57$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($28098bff0e2b5f57$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($28098bff0e2b5f57$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $28098bff0e2b5f57$var$Z extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $28098bff0e2b5f57$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $28098bff0e2b5f57$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $28098bff0e2b5f57$var$B.Ready || i.state !== $28098bff0e2b5f57$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $28098bff0e2b5f57$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($28098bff0e2b5f57$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $28098bff0e2b5f57$var$U = {
    Navigation: $28098bff0e2b5f57$var$V,
    Dots: $28098bff0e2b5f57$var$W,
    Sync: $28098bff0e2b5f57$var$Z
}, $28098bff0e2b5f57$var$G = "animationend", $28098bff0e2b5f57$var$K = "isSelected", $28098bff0e2b5f57$var$J = "slide";
class $28098bff0e2b5f57$export$144901db2ea8e967 extends $28098bff0e2b5f57$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $28098bff0e2b5f57$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $28098bff0e2b5f57$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$28098bff0e2b5f57$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $28098bff0e2b5f57$var$D(this.slideNext.bind(this), 150), this.slidePrev = $28098bff0e2b5f57$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $28098bff0e2b5f57$var$u({}, $28098bff0e2b5f57$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $28098bff0e2b5f57$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $28098bff0e2b5f57$var$d(e) && (n += t, $28098bff0e2b5f57$var$u(i, e));
        n === this.bp && this.state !== $28098bff0e2b5f57$var$B.Init || (this.bp = n, this.state === $28098bff0e2b5f57$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $28098bff0e2b5f57$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $28098bff0e2b5f57$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $28098bff0e2b5f57$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $28098bff0e2b5f57$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $28098bff0e2b5f57$var$P(t, this.cn("container")), $28098bff0e2b5f57$var$o(t, e.isLTR, !this.isRTL), $28098bff0e2b5f57$var$o(t, e.isRTL, this.isRTL), $28098bff0e2b5f57$var$o(t, e.isVertical, !this.isHorizontal), $28098bff0e2b5f57$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $28098bff0e2b5f57$var$P(i, e.viewport), i.append(...$28098bff0e2b5f57$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $28098bff0e2b5f57$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$28098bff0e2b5f57$var$F(t, `.${this.cn($28098bff0e2b5f57$var$J)}`)
        ].forEach((t)=>{
            if ($28098bff0e2b5f57$var$E(t)) {
                const e = $28098bff0e2b5f57$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($28098bff0e2b5f57$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $28098bff0e2b5f57$export$b704d075ddd20210(this.viewport, $28098bff0e2b5f57$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($28098bff0e2b5f57$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $28098bff0e2b5f57$var$t(e.pos, 1e3), e.dim = $28098bff0e2b5f57$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $28098bff0e2b5f57$var$P(r, this.cn($28098bff0e2b5f57$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $28098bff0e2b5f57$var$t(o, 1e3),
            gap: $28098bff0e2b5f57$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$28098bff0e2b5f57$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($28098bff0e2b5f57$var$t(i.pos) < $28098bff0e2b5f57$var$t(a) && $28098bff0e2b5f57$var$t(i.pos + i.dim + i.gap) < $28098bff0e2b5f57$var$t(g) && $28098bff0e2b5f57$var$t(g) > $28098bff0e2b5f57$var$t(r - a) && (i.el.style[e] = `${$28098bff0e2b5f57$var$t(p + f, 1e3)}px`), $28098bff0e2b5f57$var$t(i.pos + i.gap) >= $28098bff0e2b5f57$var$t(r - a) && $28098bff0e2b5f57$var$t(i.pos) > $28098bff0e2b5f57$var$t(g + a) && $28098bff0e2b5f57$var$t(g) < $28098bff0e2b5f57$var$t(a) && (i.el.style[e] = `-${$28098bff0e2b5f57$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$28098bff0e2b5f57$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $28098bff0e2b5f57$var$P(n, this.cn($28098bff0e2b5f57$var$J)), $28098bff0e2b5f57$var$P(n, t.class), $28098bff0e2b5f57$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($28098bff0e2b5f57$var$K);
        if (i.classList.contains(n) && ($28098bff0e2b5f57$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($28098bff0e2b5f57$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $28098bff0e2b5f57$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $28098bff0e2b5f57$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($28098bff0e2b5f57$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($28098bff0e2b5f57$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($28098bff0e2b5f57$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($28098bff0e2b5f57$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($28098bff0e2b5f57$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $28098bff0e2b5f57$var$S(e, o), e.complete && ($28098bff0e2b5f57$var$P(e, s), setTimeout(()=>{
                $28098bff0e2b5f57$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $28098bff0e2b5f57$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $28098bff0e2b5f57$var$n($28098bff0e2b5f57$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $28098bff0e2b5f57$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $28098bff0e2b5f57$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $28098bff0e2b5f57$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $28098bff0e2b5f57$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($28098bff0e2b5f57$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($28098bff0e2b5f57$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $28098bff0e2b5f57$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $28098bff0e2b5f57$var$t(n, 1e3), o = $28098bff0e2b5f57$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $28098bff0e2b5f57$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $28098bff0e2b5f57$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $28098bff0e2b5f57$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $28098bff0e2b5f57$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $28098bff0e2b5f57$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $28098bff0e2b5f57$var$m.Init && n.state !== $28098bff0e2b5f57$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $28098bff0e2b5f57$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $28098bff0e2b5f57$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($28098bff0e2b5f57$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$export$b704d075ddd20210
}), Object.defineProperty($28098bff0e2b5f57$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$j
}), Object.defineProperty($28098bff0e2b5f57$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$U
});
const $28098bff0e2b5f57$var$tt = function(t) {
    if (!$28098bff0e2b5f57$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $28098bff0e2b5f57$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $28098bff0e2b5f57$var$it;
const $28098bff0e2b5f57$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $28098bff0e2b5f57$var$st = (t)=>{
    if (t && $28098bff0e2b5f57$var$et) {
        void 0 === $28098bff0e2b5f57$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $28098bff0e2b5f57$var$it = !0, !1;
            }
        });
        try {
            if ($28098bff0e2b5f57$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $28098bff0e2b5f57$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $28098bff0e2b5f57$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $28098bff0e2b5f57$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $28098bff0e2b5f57$var$rt, $28098bff0e2b5f57$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($28098bff0e2b5f57$var$rt || ($28098bff0e2b5f57$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($28098bff0e2b5f57$var$lt || ($28098bff0e2b5f57$var$lt = {}));
let $28098bff0e2b5f57$var$ct = "", $28098bff0e2b5f57$var$ht = !1, $28098bff0e2b5f57$var$dt = !1, $28098bff0e2b5f57$var$ut = null;
const $28098bff0e2b5f57$var$pt = ()=>{
    let t = "", e = "";
    const i = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $28098bff0e2b5f57$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $28098bff0e2b5f57$var$gt = ()=>{
    const { slug: t, index: e } = $28098bff0e2b5f57$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $28098bff0e2b5f57$var$mt = ()=>{
    if (!1 === $28098bff0e2b5f57$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $28098bff0e2b5f57$var$ft(), { slug: n } = $28098bff0e2b5f57$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($28098bff0e2b5f57$var$ht = !0, t.close())), $28098bff0e2b5f57$var$gt();
}, $28098bff0e2b5f57$var$vt = ()=>{
    $28098bff0e2b5f57$var$ut && clearTimeout($28098bff0e2b5f57$var$ut), queueMicrotask(()=>{
        $28098bff0e2b5f57$var$mt();
    });
}, $28098bff0e2b5f57$var$bt = ()=>{
    window.addEventListener("hashchange", $28098bff0e2b5f57$var$vt, !1), setTimeout(()=>{
        $28098bff0e2b5f57$var$mt();
    }, 500);
};
$28098bff0e2b5f57$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $28098bff0e2b5f57$var$bt() : document.addEventListener("DOMContentLoaded", $28098bff0e2b5f57$var$bt));
const $28098bff0e2b5f57$var$yt = "is-zooming-in";
class $28098bff0e2b5f57$var$wt extends $28098bff0e2b5f57$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $28098bff0e2b5f57$var$S(this.instance.container, $28098bff0e2b5f57$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $28098bff0e2b5f57$var$m.Init || a.state === $28098bff0e2b5f57$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $28098bff0e2b5f57$var$rt.CustomClosing, i.classList.remove($28098bff0e2b5f57$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $28098bff0e2b5f57$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $28098bff0e2b5f57$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($28098bff0e2b5f57$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $28098bff0e2b5f57$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $28098bff0e2b5f57$var$n(l)), !l || !$28098bff0e2b5f57$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $28098bff0e2b5f57$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $28098bff0e2b5f57$export$b704d075ddd20210(r, $28098bff0e2b5f57$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $28098bff0e2b5f57$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($28098bff0e2b5f57$var$S(s, $28098bff0e2b5f57$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $28098bff0e2b5f57$var$P(s, $28098bff0e2b5f57$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $28098bff0e2b5f57$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $28098bff0e2b5f57$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($28098bff0e2b5f57$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $28098bff0e2b5f57$var$xt = "html", $28098bff0e2b5f57$var$Et = "image", $28098bff0e2b5f57$var$St = "map", $28098bff0e2b5f57$var$Pt = "youtube", $28098bff0e2b5f57$var$Ct = "vimeo", $28098bff0e2b5f57$var$Tt = "html5video", $28098bff0e2b5f57$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $28098bff0e2b5f57$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $28098bff0e2b5f57$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $28098bff0e2b5f57$var$Lt extends $28098bff0e2b5f57$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $28098bff0e2b5f57$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $28098bff0e2b5f57$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $28098bff0e2b5f57$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $28098bff0e2b5f57$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $28098bff0e2b5f57$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($28098bff0e2b5f57$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $28098bff0e2b5f57$var$Pt || e === $28098bff0e2b5f57$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($28098bff0e2b5f57$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $28098bff0e2b5f57$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $28098bff0e2b5f57$var$Pt && t.type !== $28098bff0e2b5f57$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $28098bff0e2b5f57$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $28098bff0e2b5f57$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $28098bff0e2b5f57$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $28098bff0e2b5f57$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $28098bff0e2b5f57$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $28098bff0e2b5f57$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $28098bff0e2b5f57$var$Mt(e, this.optionFor(t, $28098bff0e2b5f57$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $28098bff0e2b5f57$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $28098bff0e2b5f57$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $28098bff0e2b5f57$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $28098bff0e2b5f57$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $28098bff0e2b5f57$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $28098bff0e2b5f57$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $28098bff0e2b5f57$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $28098bff0e2b5f57$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $28098bff0e2b5f57$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $28098bff0e2b5f57$var$St:
                case $28098bff0e2b5f57$var$Pt:
                case $28098bff0e2b5f57$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $28098bff0e2b5f57$var$Pt,
            $28098bff0e2b5f57$var$Ct,
            $28098bff0e2b5f57$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($28098bff0e2b5f57$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$Ot
});
const $28098bff0e2b5f57$var$zt = "play", $28098bff0e2b5f57$var$Rt = "pause", $28098bff0e2b5f57$var$kt = "ready";
class $28098bff0e2b5f57$var$It extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $28098bff0e2b5f57$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $28098bff0e2b5f57$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $28098bff0e2b5f57$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $28098bff0e2b5f57$var$zt, $28098bff0e2b5f57$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $28098bff0e2b5f57$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $28098bff0e2b5f57$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $28098bff0e2b5f57$var$S(i, "has-autoplay"), e !== $28098bff0e2b5f57$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $28098bff0e2b5f57$var$zt && (t.state = $28098bff0e2b5f57$var$Rt, t.clear(), t.emit($28098bff0e2b5f57$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $28098bff0e2b5f57$var$zt) {
                if (t.state === $28098bff0e2b5f57$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $28098bff0e2b5f57$var$zt || this.state === $28098bff0e2b5f57$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($28098bff0e2b5f57$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $28098bff0e2b5f57$var$Dt extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $28098bff0e2b5f57$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $28098bff0e2b5f57$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $28098bff0e2b5f57$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $28098bff0e2b5f57$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($28098bff0e2b5f57$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $28098bff0e2b5f57$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $28098bff0e2b5f57$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($28098bff0e2b5f57$var$jt || ($28098bff0e2b5f57$var$jt = {}));
const $28098bff0e2b5f57$var$Bt = "isResting", $28098bff0e2b5f57$var$Ht = "thumbWidth", $28098bff0e2b5f57$var$Nt = "thumbHeight", $28098bff0e2b5f57$var$_t = "thumbClipWidth";
let $28098bff0e2b5f57$var$$t = class extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $28098bff0e2b5f57$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$28098bff0e2b5f57$var$_t] = parseFloat(i[$28098bff0e2b5f57$var$_t] || "") || e[$28098bff0e2b5f57$var$_t] || 0, e[$28098bff0e2b5f57$var$Nt] = parseFloat(i.thumbHeight || "") || e[$28098bff0e2b5f57$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $28098bff0e2b5f57$var$S(e, this.cn($28098bff0e2b5f57$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$28098bff0e2b5f57$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $28098bff0e2b5f57$var$o(e, this.cn($28098bff0e2b5f57$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$28098bff0e2b5f57$var$Ht] = t[$28098bff0e2b5f57$var$_t] && t[$28098bff0e2b5f57$var$Nt] ? Math.round(this[$28098bff0e2b5f57$var$Nt] * (t[$28098bff0e2b5f57$var$_t] / t[$28098bff0e2b5f57$var$Nt])) : this[$28098bff0e2b5f57$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$28098bff0e2b5f57$var$Ht] = e("width") || 40, this[$28098bff0e2b5f57$var$_t] = e("clip-width") || 40, this[$28098bff0e2b5f57$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $28098bff0e2b5f57$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $28098bff0e2b5f57$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $28098bff0e2b5f57$var$P(l, `is-${s}`), $28098bff0e2b5f57$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $28098bff0e2b5f57$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $28098bff0e2b5f57$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $28098bff0e2b5f57$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$28098bff0e2b5f57$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$28098bff0e2b5f57$var$Ht], a = i[$28098bff0e2b5f57$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $28098bff0e2b5f57$var$t(1 - Math.abs(s.getProgress(e))), o = $28098bff0e2b5f57$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $28098bff0e2b5f57$var$m.Init || n.state === $28098bff0e2b5f57$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$28098bff0e2b5f57$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $28098bff0e2b5f57$var$jt.Init, $28098bff0e2b5f57$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $28098bff0e2b5f57$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($28098bff0e2b5f57$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$Ft
});
const $28098bff0e2b5f57$var$Wt = Object.assign(Object.assign({}, $28098bff0e2b5f57$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $28098bff0e2b5f57$var$Xt = "is-masked", $28098bff0e2b5f57$var$qt = "aria-hidden";
class $28098bff0e2b5f57$var$Yt extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $28098bff0e2b5f57$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $28098bff0e2b5f57$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $28098bff0e2b5f57$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $28098bff0e2b5f57$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $28098bff0e2b5f57$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $28098bff0e2b5f57$var$jt.Hidden ? (t.state = $28098bff0e2b5f57$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($28098bff0e2b5f57$var$qt), e.classList.remove($28098bff0e2b5f57$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($28098bff0e2b5f57$var$Xt), e.setAttribute($28098bff0e2b5f57$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $28098bff0e2b5f57$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($28098bff0e2b5f57$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$Wt
});
const $28098bff0e2b5f57$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $28098bff0e2b5f57$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($28098bff0e2b5f57$var$Zt || ($28098bff0e2b5f57$var$Zt = {}));
const $28098bff0e2b5f57$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $28098bff0e2b5f57$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $28098bff0e2b5f57$var$Kt = "has-toolbar", $28098bff0e2b5f57$var$Jt = "fancybox__toolbar";
class $28098bff0e2b5f57$var$Qt extends $28098bff0e2b5f57$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $28098bff0e2b5f57$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $28098bff0e2b5f57$var$P(i, $28098bff0e2b5f57$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $28098bff0e2b5f57$var$P(r, "is-absolute"), this.state = $28098bff0e2b5f57$var$Zt.Ready, this.onRefresh();
        } else this.state = $28098bff0e2b5f57$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $28098bff0e2b5f57$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $28098bff0e2b5f57$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $28098bff0e2b5f57$var$Jt);
        return i || (i = document.createElement("div"), $28098bff0e2b5f57$var$P(i, $28098bff0e2b5f57$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $28098bff0e2b5f57$var$P(t, $28098bff0e2b5f57$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$28098bff0e2b5f57$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $28098bff0e2b5f57$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $28098bff0e2b5f57$var$Vt[t]) {
            const e = $28098bff0e2b5f57$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $28098bff0e2b5f57$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($28098bff0e2b5f57$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $28098bff0e2b5f57$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($28098bff0e2b5f57$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $28098bff0e2b5f57$var$Zt.Disabled;
        const e = this.instance.container;
        e && $28098bff0e2b5f57$var$S(e, $28098bff0e2b5f57$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($28098bff0e2b5f57$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$Ut
});
const $28098bff0e2b5f57$var$te = {
    Hash: class extends $28098bff0e2b5f57$var$_ {
        onReady() {
            $28098bff0e2b5f57$var$ht = !1;
        }
        onChange(t) {
            $28098bff0e2b5f57$var$ut && clearTimeout($28098bff0e2b5f57$var$ut);
            const { hash: e } = $28098bff0e2b5f57$var$pt(), { hash: i } = $28098bff0e2b5f57$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($28098bff0e2b5f57$var$ct = i === e ? "" : i), e && e !== i && ($28098bff0e2b5f57$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $28098bff0e2b5f57$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$28098bff0e2b5f57$var$dt && (t = "pushState", $28098bff0e2b5f57$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($28098bff0e2b5f57$var$ut && clearTimeout($28098bff0e2b5f57$var$ut), !$28098bff0e2b5f57$var$ht && $28098bff0e2b5f57$var$dt) return $28098bff0e2b5f57$var$dt = !1, $28098bff0e2b5f57$var$ht = !1, void window.history.back();
            if (!$28098bff0e2b5f57$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($28098bff0e2b5f57$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $28098bff0e2b5f57$var$ft();
        }
        static startFromUrl() {
            $28098bff0e2b5f57$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $28098bff0e2b5f57$var$vt, !1);
        }
    },
    Html: $28098bff0e2b5f57$var$Lt,
    Images: $28098bff0e2b5f57$var$wt,
    Slideshow: $28098bff0e2b5f57$var$Dt,
    Thumbs: $28098bff0e2b5f57$var$Yt,
    Toolbar: $28098bff0e2b5f57$var$Qt
}, $28098bff0e2b5f57$var$ee = "with-fancybox", $28098bff0e2b5f57$var$ie = "hide-scrollbar", $28098bff0e2b5f57$var$ne = "--fancybox-scrollbar-compensate", $28098bff0e2b5f57$var$se = "--fancybox-body-margin", $28098bff0e2b5f57$var$oe = "aria-hidden", $28098bff0e2b5f57$var$ae = "is-using-tab", $28098bff0e2b5f57$var$re = "is-animated", $28098bff0e2b5f57$var$le = "is-compact", $28098bff0e2b5f57$var$ce = "is-loading", $28098bff0e2b5f57$var$he = "is-opening", $28098bff0e2b5f57$var$de = "has-caption", $28098bff0e2b5f57$var$ue = "disabled", $28098bff0e2b5f57$var$pe = "tabindex", $28098bff0e2b5f57$var$fe = "download", $28098bff0e2b5f57$var$ge = "href", $28098bff0e2b5f57$var$me = "src", $28098bff0e2b5f57$var$ve = (t)=>"string" == typeof t, $28098bff0e2b5f57$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $28098bff0e2b5f57$var$ye, $28098bff0e2b5f57$var$we = null, $28098bff0e2b5f57$var$xe = null, $28098bff0e2b5f57$var$Ee = 0, $28098bff0e2b5f57$var$Se = 0, $28098bff0e2b5f57$var$Pe = 0, $28098bff0e2b5f57$var$Ce = 0;
const $28098bff0e2b5f57$var$Te = new Map;
let $28098bff0e2b5f57$var$Me = 0;
class $28098bff0e2b5f57$export$cb45b08d97cdc4fd extends $28098bff0e2b5f57$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $28098bff0e2b5f57$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $28098bff0e2b5f57$var$ye || ($28098bff0e2b5f57$var$ye = $28098bff0e2b5f57$var$ot()), this.id = e.id || ++$28098bff0e2b5f57$var$Me, $28098bff0e2b5f57$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $28098bff0e2b5f57$var$rt.Destroy) return;
        this.state = $28098bff0e2b5f57$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $28098bff0e2b5f57$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$28098bff0e2b5f57$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($28098bff0e2b5f57$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($28098bff0e2b5f57$var$ne, `${n}px`), s && e.style.setProperty($28098bff0e2b5f57$var$se, `${s}px`), e.classList.add($28098bff0e2b5f57$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $28098bff0e2b5f57$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($28098bff0e2b5f57$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $28098bff0e2b5f57$var$ye && !$28098bff0e2b5f57$var$ye.isFullscreen() ? $28098bff0e2b5f57$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $28098bff0e2b5f57$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($28098bff0e2b5f57$var$le, this.isCompact), $28098bff0e2b5f57$var$P(s, this.option("mainClass") || ""), $28098bff0e2b5f57$var$P(s, $28098bff0e2b5f57$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $28098bff0e2b5f57$var$P(document.documentElement, $28098bff0e2b5f57$var$ee), $28098bff0e2b5f57$var$we && $28098bff0e2b5f57$var$xe || ($28098bff0e2b5f57$var$we = document.createElement("span"), $28098bff0e2b5f57$var$P($28098bff0e2b5f57$var$we, "fancybox-focus-guard"), $28098bff0e2b5f57$var$we.setAttribute($28098bff0e2b5f57$var$pe, "0"), $28098bff0e2b5f57$var$we.setAttribute($28098bff0e2b5f57$var$oe, "true"), $28098bff0e2b5f57$var$we.setAttribute("aria-label", "Focus guard"), $28098bff0e2b5f57$var$xe = $28098bff0e2b5f57$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($28098bff0e2b5f57$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($28098bff0e2b5f57$var$xe)), s.addEventListener("mousedown", (t)=>{
                $28098bff0e2b5f57$var$Ee = t.pageX, $28098bff0e2b5f57$var$Se = t.pageY, $28098bff0e2b5f57$var$S(s, $28098bff0e2b5f57$var$ae);
            }), this.option("closeExisting")) for (const t of $28098bff0e2b5f57$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($28098bff0e2b5f57$var$P(s, $28098bff0e2b5f57$var$re), setTimeout(()=>{
                this.isClosing() || $28098bff0e2b5f57$var$S(s, $28098bff0e2b5f57$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $28098bff0e2b5f57$export$144901db2ea8e967(n, $28098bff0e2b5f57$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $28098bff0e2b5f57$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $28098bff0e2b5f57$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($28098bff0e2b5f57$var$ue), i.removeAttribute($28098bff0e2b5f57$var$pe)) : (i.setAttribute($28098bff0e2b5f57$var$ue, ""), i.setAttribute($28098bff0e2b5f57$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($28098bff0e2b5f57$var$ue), i.removeAttribute($28098bff0e2b5f57$var$pe)) : (i.setAttribute($28098bff0e2b5f57$var$ue, ""), i.setAttribute($28098bff0e2b5f57$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$28098bff0e2b5f57$var$ve(i[$28098bff0e2b5f57$var$me]) || (n = i[$28098bff0e2b5f57$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($28098bff0e2b5f57$var$ue), t.removeAttribute($28098bff0e2b5f57$var$pe), t.setAttribute($28098bff0e2b5f57$var$ge, n), t.setAttribute($28098bff0e2b5f57$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($28098bff0e2b5f57$var$ue, ""), t.setAttribute($28098bff0e2b5f57$var$pe, "-1"), t.removeAttribute($28098bff0e2b5f57$var$ge), t.removeAttribute($28098bff0e2b5f57$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $28098bff0e2b5f57$var$Ee) > 30 || Math.abs(t.pageY - $28098bff0e2b5f57$var$Se) > 30) return;
        const o = document.activeElement;
        if ($28098bff0e2b5f57$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($28098bff0e2b5f57$var$nt) || o.blur();
            }
            if ($28098bff0e2b5f57$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($28098bff0e2b5f57$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($28098bff0e2b5f57$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($28098bff0e2b5f57$var$Pe, $28098bff0e2b5f57$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $28098bff0e2b5f57$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $28098bff0e2b5f57$var$P(this.container, $28098bff0e2b5f57$var$ae) : $28098bff0e2b5f57$var$S(this.container, $28098bff0e2b5f57$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($28098bff0e2b5f57$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $28098bff0e2b5f57$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $28098bff0e2b5f57$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $28098bff0e2b5f57$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $28098bff0e2b5f57$var$S(s, $28098bff0e2b5f57$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $28098bff0e2b5f57$var$S(t.el, $28098bff0e2b5f57$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $28098bff0e2b5f57$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $28098bff0e2b5f57$var$P(r, $28098bff0e2b5f57$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $28098bff0e2b5f57$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $28098bff0e2b5f57$var$P(s, $28098bff0e2b5f57$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $28098bff0e2b5f57$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $28098bff0e2b5f57$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($28098bff0e2b5f57$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $28098bff0e2b5f57$var$xe ? d = c[0] : this.lastFocus !== s && i !== $28098bff0e2b5f57$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $28098bff0e2b5f57$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $28098bff0e2b5f57$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $28098bff0e2b5f57$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($28098bff0e2b5f57$var$E(e) ? o = e : (o = $28098bff0e2b5f57$var$n(e + ""), $28098bff0e2b5f57$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $28098bff0e2b5f57$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $28098bff0e2b5f57$var$E(o) ? ($28098bff0e2b5f57$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $28098bff0e2b5f57$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $28098bff0e2b5f57$var$lt.Ready, this.emit("done", t), $28098bff0e2b5f57$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($28098bff0e2b5f57$var$S(this.container, $28098bff0e2b5f57$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $28098bff0e2b5f57$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $28098bff0e2b5f57$var$P(e, $28098bff0e2b5f57$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $28098bff0e2b5f57$var$lt.Loading) {
                let i = $28098bff0e2b5f57$var$n($28098bff0e2b5f57$var$x);
                $28098bff0e2b5f57$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($28098bff0e2b5f57$var$S(e, $28098bff0e2b5f57$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $28098bff0e2b5f57$var$lt.Loading && (this.emit("loaded", t), t.state = $28098bff0e2b5f57$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($28098bff0e2b5f57$var$S(e, "has-error"), $28098bff0e2b5f57$var$S(e, "has-unknown"), $28098bff0e2b5f57$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $28098bff0e2b5f57$var$ye && $28098bff0e2b5f57$var$ye.isFullscreen() ? Promise.resolve($28098bff0e2b5f57$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $28098bff0e2b5f57$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $28098bff0e2b5f57$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $28098bff0e2b5f57$var$ye && ($28098bff0e2b5f57$var$ye.isFullscreen() ? $28098bff0e2b5f57$var$ye.exit() : $28098bff0e2b5f57$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $28098bff0e2b5f57$var$rt.Closing,
            $28098bff0e2b5f57$var$rt.CustomClosing,
            $28098bff0e2b5f57$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $28098bff0e2b5f57$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($28098bff0e2b5f57$var$tt(r) ? $28098bff0e2b5f57$var$st(r) : r.focus()), s && ($28098bff0e2b5f57$var$S(s, $28098bff0e2b5f57$var$he), $28098bff0e2b5f57$var$P(s, "is-closing"), s.setAttribute($28098bff0e2b5f57$var$oe, "true"), this.option("animated") && $28098bff0e2b5f57$var$P(s, $28098bff0e2b5f57$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $28098bff0e2b5f57$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $28098bff0e2b5f57$var$Pe = window.scrollX, $28098bff0e2b5f57$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $28098bff0e2b5f57$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $28098bff0e2b5f57$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $28098bff0e2b5f57$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $28098bff0e2b5f57$var$Te.delete(this.id);
        const i = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($28098bff0e2b5f57$var$we && ($28098bff0e2b5f57$var$we.remove(), $28098bff0e2b5f57$var$we = null), $28098bff0e2b5f57$var$xe && ($28098bff0e2b5f57$var$xe.remove(), $28098bff0e2b5f57$var$xe = null), $28098bff0e2b5f57$var$S(document.documentElement, $28098bff0e2b5f57$var$ee), (()=>{
            if (!$28098bff0e2b5f57$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($28098bff0e2b5f57$var$ie), e.style.setProperty($28098bff0e2b5f57$var$se, ""), t.documentElement.style.setProperty($28098bff0e2b5f57$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$28098bff0e2b5f57$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $28098bff0e2b5f57$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $28098bff0e2b5f57$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$28098bff0e2b5f57$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $28098bff0e2b5f57$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($28098bff0e2b5f57$var$ve(t) ? (i = document.body, n = t) : (i = t, $28098bff0e2b5f57$var$ve(e) && (n = e)), !i) return;
        const s = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $28098bff0e2b5f57$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $28098bff0e2b5f57$export$cb45b08d97cdc4fd.fromEvent);
        $28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $28098bff0e2b5f57$var$u({}, $28098bff0e2b5f57$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $28098bff0e2b5f57$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($28098bff0e2b5f57$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $28098bff0e2b5f57$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $28098bff0e2b5f57$var$u({}, a.get(s) || {}, o), !!o && $28098bff0e2b5f57$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $28098bff0e2b5f57$var$u({}, $28098bff0e2b5f57$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$28098bff0e2b5f57$var$me] || n.getAttribute($28098bff0e2b5f57$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($28098bff0e2b5f57$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$28098bff0e2b5f57$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$28098bff0e2b5f57$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $28098bff0e2b5f57$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $28098bff0e2b5f57$var$Te.get(t);
        return Array.from($28098bff0e2b5f57$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $28098bff0e2b5f57$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $28098bff0e2b5f57$var$Te.values())t.close(...e);
        else {
            const t = $28098bff0e2b5f57$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($28098bff0e2b5f57$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($28098bff0e2b5f57$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$at
}), Object.defineProperty($28098bff0e2b5f57$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $28098bff0e2b5f57$var$te
}), Object.defineProperty($28098bff0e2b5f57$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});



var $99dc7a165646c27f$exports = {};
/*!
* sweetalert2 v11.12.4
* Released under the MIT License.
*/ (function(global, factory) {
    $99dc7a165646c27f$exports = factory();
})($99dc7a165646c27f$exports, function() {
    "use strict";
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _arrayWithoutHoles(r) {
        if (Array.isArray(r)) return _arrayLikeToArray(r);
    }
    function _assertClassBrand(e, t, n) {
        if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
        throw new TypeError("Private element is not present on this object");
    }
    function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function _callSuper(t, o, e) {
        return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
    }
    function _checkPrivateRedeclaration(e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _classPrivateFieldGet2(s, a) {
        return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
        _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
        return s.set(_assertClassBrand(s, a), r), r;
    }
    function _construct(t, e, r) {
        if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
        var o = [
            null
        ];
        o.push.apply(o, e);
        var p = new (t.bind.apply(t, o))();
        return p;
    }
    function _defineProperties(e, r) {
        for(var t = 0; t < r.length; t++){
            var o = r[t];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
    }
    function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function _createForOfIteratorHelper(r, e) {
        var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (!t) {
            if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
                t && (r = t);
                var n = 0, F = function() {};
                return {
                    s: F,
                    n: function() {
                        return n >= r.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: r[n++]
                        };
                    },
                    e: function(r) {
                        throw r;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var o, a = !0, u = !1;
        return {
            s: function() {
                t = t.call(r);
            },
            n: function() {
                var r = t.next();
                return a = r.done, r;
            },
            e: function(r) {
                u = !0, o = r;
            },
            f: function() {
                try {
                    a || null == t.return || t.return();
                } finally{
                    if (u) throw o;
                }
            }
        };
    }
    function _get() {
        return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
            var p = _superPropBase(e, t);
            if (p) {
                var n = Object.getOwnPropertyDescriptor(p, t);
                return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
            }
        }, _get.apply(null, arguments);
    }
    function _getPrototypeOf(t) {
        return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, _getPrototypeOf(t);
    }
    function _inherits(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(t, "prototype", {
            writable: !1
        }), e && _setPrototypeOf(t, e);
    }
    function _isNativeReflectConstruct() {
        try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (t) {}
        return (_isNativeReflectConstruct = function() {
            return !!t;
        })();
    }
    function _iterableToArray(r) {
        if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _possibleConstructorReturn(t, e) {
        if (e && ("object" == typeof e || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(t);
    }
    function _setPrototypeOf(t, e) {
        return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t;
        }, _setPrototypeOf(t, e);
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _superPropBase(t, o) {
        for(; !({}).hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
        return t;
    }
    function _superPropGet(t, e, r, o) {
        var p = _get(_getPrototypeOf(t.prototype), e, r);
        return function(t) {
            return p.apply(r, t);
        };
    }
    function _toConsumableArray(r) {
        return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var RESTORE_FOCUS_TIMEOUT = 100;
    /** @type {GlobalState} */ var globalState = {};
    var focusPreviousActiveElement = function focusPreviousActiveElement() {
        if (globalState.previousActiveElement instanceof HTMLElement) {
            globalState.previousActiveElement.focus();
            globalState.previousActiveElement = null;
        } else if (document.body) document.body.focus();
    };
    /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */ var restoreActiveElement = function restoreActiveElement(returnFocus) {
        return new Promise(function(resolve) {
            if (!returnFocus) return resolve();
            var x = window.scrollX;
            var y = window.scrollY;
            globalState.restoreFocusTimeout = setTimeout(function() {
                focusPreviousActiveElement();
                resolve();
            }, RESTORE_FOCUS_TIMEOUT); // issues/900
            window.scrollTo(x, y);
        });
    };
    var swalPrefix = "swal2-";
    /**
   * @typedef {Record<SwalClass, string>} SwalClasses
   */ /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */ /** @type {SwalClass[]} */ var classNames = [
        "container",
        "shown",
        "height-auto",
        "iosfix",
        "popup",
        "modal",
        "no-backdrop",
        "no-transition",
        "toast",
        "toast-shown",
        "show",
        "hide",
        "close",
        "title",
        "html-container",
        "actions",
        "confirm",
        "deny",
        "cancel",
        "default-outline",
        "footer",
        "icon",
        "icon-content",
        "image",
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "label",
        "textarea",
        "inputerror",
        "input-label",
        "validation-message",
        "progress-steps",
        "active-progress-step",
        "progress-step",
        "progress-step-line",
        "loader",
        "loading",
        "styled",
        "top",
        "top-start",
        "top-end",
        "top-left",
        "top-right",
        "center",
        "center-start",
        "center-end",
        "center-left",
        "center-right",
        "bottom",
        "bottom-start",
        "bottom-end",
        "bottom-left",
        "bottom-right",
        "grow-row",
        "grow-column",
        "grow-fullscreen",
        "rtl",
        "timer-progress-bar",
        "timer-progress-bar-container",
        "scrollbar-measure",
        "icon-success",
        "icon-warning",
        "icon-info",
        "icon-question",
        "icon-error"
    ];
    var swalClasses = classNames.reduce(function(acc, className) {
        acc[className] = swalPrefix + className;
        return acc;
    }, /** @type {SwalClasses} */ {});
    /** @type {SwalIcon[]} */ var icons = [
        "success",
        "warning",
        "info",
        "question",
        "error"
    ];
    var iconTypes = icons.reduce(function(acc, icon) {
        acc[icon] = swalPrefix + icon;
        return acc;
    }, /** @type {SwalIcons} */ {});
    var consolePrefix = "SweetAlert2:";
    /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */ var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */ var warn = function warn(message) {
        console.warn("".concat(consolePrefix, " ").concat(_typeof(message) === "object" ? message.join(" ") : message));
    };
    /**
   * Standardize console errors
   *
   * @param {string} message
   */ var error = function error(message) {
        console.error("".concat(consolePrefix, " ").concat(message));
    };
    /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */ var previousWarnOnceMessages = [];
    /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */ var warnOnce = function warnOnce(message) {
        if (!previousWarnOnceMessages.includes(message)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string?} useInstead
   */ var warnAboutDeprecation = function warnAboutDeprecation(deprecatedParam) {
        var useInstead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        warnOnce('"'.concat(deprecatedParam, '" is deprecated and will be removed in the next major release.').concat(useInstead ? ' Use "'.concat(useInstead, '" instead.') : ""));
    };
    /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {Function | any} arg
   * @returns {any}
   */ var callIfFunction = function callIfFunction(arg) {
        return typeof arg === "function" ? arg() : arg;
    };
    /**
   * @param {any} arg
   * @returns {boolean}
   */ var hasToPromiseFn = function hasToPromiseFn(arg) {
        return arg && typeof arg.toPromise === "function";
    };
    /**
   * @param {any} arg
   * @returns {Promise<any>}
   */ var asPromise = function asPromise(arg) {
        return hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    };
    /**
   * @param {any} arg
   * @returns {boolean}
   */ var isPromise = function isPromise(arg) {
        return arg && Promise.resolve(arg) === arg;
    };
    /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */ var getContainer = function getContainer() {
        return document.body.querySelector(".".concat(swalClasses.container));
    };
    /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */ var elementBySelector = function elementBySelector(selectorString) {
        var container = getContainer();
        return container ? container.querySelector(selectorString) : null;
    };
    /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */ var elementByClass = function elementByClass(className) {
        return elementBySelector(".".concat(className));
    };
    /**
   * @returns {HTMLElement | null}
   */ var getPopup = function getPopup() {
        return elementByClass(swalClasses.popup);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getIcon = function getIcon() {
        return elementByClass(swalClasses.icon);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getIconContent = function getIconContent() {
        return elementByClass(swalClasses["icon-content"]);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getTitle = function getTitle() {
        return elementByClass(swalClasses.title);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getHtmlContainer = function getHtmlContainer() {
        return elementByClass(swalClasses["html-container"]);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getImage = function getImage() {
        return elementByClass(swalClasses.image);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getProgressSteps = function getProgressSteps() {
        return elementByClass(swalClasses["progress-steps"]);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getValidationMessage = function getValidationMessage() {
        return elementByClass(swalClasses["validation-message"]);
    };
    /**
   * @returns {HTMLButtonElement | null}
   */ var getConfirmButton = function getConfirmButton() {
        return /** @type {HTMLButtonElement} */ elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.confirm));
    };
    /**
   * @returns {HTMLButtonElement | null}
   */ var getCancelButton = function getCancelButton() {
        return /** @type {HTMLButtonElement} */ elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.cancel));
    };
    /**
   * @returns {HTMLButtonElement | null}
   */ var getDenyButton = function getDenyButton() {
        return /** @type {HTMLButtonElement} */ elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.deny));
    };
    /**
   * @returns {HTMLElement | null}
   */ var getInputLabel = function getInputLabel() {
        return elementByClass(swalClasses["input-label"]);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getLoader = function getLoader() {
        return elementBySelector(".".concat(swalClasses.loader));
    };
    /**
   * @returns {HTMLElement | null}
   */ var getActions = function getActions() {
        return elementByClass(swalClasses.actions);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getFooter = function getFooter() {
        return elementByClass(swalClasses.footer);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getTimerProgressBar = function getTimerProgressBar() {
        return elementByClass(swalClasses["timer-progress-bar"]);
    };
    /**
   * @returns {HTMLElement | null}
   */ var getCloseButton = function getCloseButton() {
        return elementByClass(swalClasses.close);
    };
    // https://github.com/jkup/focusable/blob/master/index.js
    var focusable = '\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n';
    /**
   * @returns {HTMLElement[]}
   */ var getFocusableElements = function getFocusableElements() {
        var popup = getPopup();
        if (!popup) return [];
        /** @type {NodeListOf<HTMLElement>} */ var focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
        var focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex)// sort according to tabindex
        .sort(function(a, b) {
            var tabindexA = parseInt(a.getAttribute("tabindex") || "0");
            var tabindexB = parseInt(b.getAttribute("tabindex") || "0");
            if (tabindexA > tabindexB) return 1;
            else if (tabindexA < tabindexB) return -1;
            return 0;
        });
        /** @type {NodeListOf<HTMLElement>} */ var otherFocusableElements = popup.querySelectorAll(focusable);
        var otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter(function(el) {
            return el.getAttribute("tabindex") !== "-1";
        });
        return _toConsumableArray(new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))).filter(function(el) {
            return isVisible$1(el);
        });
    };
    /**
   * @returns {boolean}
   */ var isModal = function isModal() {
        return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses["toast-shown"]) && !hasClass(document.body, swalClasses["no-backdrop"]);
    };
    /**
   * @returns {boolean}
   */ var isToast = function isToast() {
        var popup = getPopup();
        if (!popup) return false;
        return hasClass(popup, swalClasses.toast);
    };
    /**
   * @returns {boolean}
   */ var isLoading = function isLoading() {
        var popup = getPopup();
        if (!popup) return false;
        return popup.hasAttribute("data-loading");
    };
    /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */ var setInnerHtml = function setInnerHtml(elem, html) {
        elem.textContent = "";
        if (html) {
            var parser = new DOMParser();
            var parsed = parser.parseFromString(html, "text/html");
            var head = parsed.querySelector("head");
            if (head) Array.from(head.childNodes).forEach(function(child) {
                elem.appendChild(child);
            });
            var body = parsed.querySelector("body");
            if (body) Array.from(body.childNodes).forEach(function(child) {
                if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
                else elem.appendChild(child);
            });
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */ var hasClass = function hasClass(elem, className) {
        if (!className) return false;
        var classList = className.split(/\s+/);
        for(var i = 0; i < classList.length; i++){
            if (!elem.classList.contains(classList[i])) return false;
        }
        return true;
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */ var removeCustomClasses = function removeCustomClasses(elem, params) {
        Array.from(elem.classList).forEach(function(className) {
            if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) elem.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */ var applyCustomClass = function applyCustomClass(elem, params, className) {
        removeCustomClasses(elem, params);
        if (!params.customClass) return;
        var customClass = params.customClass[/** @type {keyof SweetAlertCustomClass} */ className];
        if (!customClass) return;
        if (typeof customClass !== "string" && !customClass.forEach) {
            warn("Invalid type of customClass.".concat(className, '! Expected string or iterable object, got "').concat(_typeof(customClass), '"'));
            return;
        }
        addClass(elem, customClass);
    };
    /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass | SweetAlertInput} inputClass
   * @returns {HTMLInputElement | null}
   */ var getInput$1 = function getInput(popup, inputClass) {
        if (!inputClass) return null;
        switch(inputClass){
            case "select":
            case "textarea":
            case "file":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses[inputClass]));
            case "checkbox":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.checkbox, " input"));
            case "radio":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.radio, " input:checked")) || popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.radio, " input:first-child"));
            case "range":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.range, " input"));
            default:
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.input));
        }
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */ var focusInput = function focusInput(input) {
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== "file") {
            // http://stackoverflow.com/a/2345915
            var val = input.value;
            input.value = "";
            input.value = val;
        }
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   * @param {boolean} condition
   */ var toggleClass = function toggleClass(target, classList, condition) {
        if (!target || !classList) return;
        if (typeof classList === "string") classList = classList.split(/\s+/).filter(Boolean);
        classList.forEach(function(className) {
            if (Array.isArray(target)) target.forEach(function(elem) {
                if (condition) elem.classList.add(className);
                else elem.classList.remove(className);
            });
            else if (condition) target.classList.add(className);
            else target.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ var addClass = function addClass(target, classList) {
        toggleClass(target, classList, true);
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ var removeClass = function removeClass(target, classList) {
        toggleClass(target, classList, false);
    };
    /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */ var getDirectChildByClass = function getDirectChildByClass(elem, className) {
        var children = Array.from(elem.children);
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child instanceof HTMLElement && hasClass(child, className)) return child;
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {*} value
   */ var applyNumericalStyle = function applyNumericalStyle(elem, property, value) {
        if (value === "".concat(parseInt(value))) value = parseInt(value);
        if (value || parseInt(value) === 0) elem.style.setProperty(property, typeof value === "number" ? "".concat(value, "px") : value);
        else elem.style.removeProperty(property);
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ var show = function show(elem) {
        var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "flex";
        if (!elem) return;
        elem.style.display = display;
    };
    /**
   * @param {HTMLElement | null} elem
   */ var hide = function hide(elem) {
        if (!elem) return;
        elem.style.display = "none";
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ var showWhenInnerHtmlPresent = function showWhenInnerHtmlPresent(elem) {
        var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "block";
        if (!elem) return;
        new MutationObserver(function() {
            toggle(elem, elem.innerHTML, display);
        }).observe(elem, {
            childList: true,
            subtree: true
        });
    };
    /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */ var setStyle = function setStyle(parent, selector, property, value) {
        /** @type {HTMLElement | null} */ var el = parent.querySelector(selector);
        if (el) el.style.setProperty(property, value);
    };
    /**
   * @param {HTMLElement} elem
   * @param {any} condition
   * @param {string} display
   */ var toggle = function toggle(elem, condition) {
        var display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "flex";
        if (condition) show(elem, display);
        else hide(elem);
    };
    /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement | null} elem
   * @returns {boolean}
   */ var isVisible$1 = function isVisible(elem) {
        return !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    };
    /**
   * @returns {boolean}
   */ var allButtonsAreHidden = function allButtonsAreHidden() {
        return !isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    };
    /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ var isScrollable = function isScrollable(elem) {
        return !!(elem.scrollHeight > elem.clientHeight);
    };
    /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ var hasCssAnimation = function hasCssAnimation(elem) {
        var style = window.getComputedStyle(elem);
        var animDuration = parseFloat(style.getPropertyValue("animation-duration") || "0");
        var transDuration = parseFloat(style.getPropertyValue("transition-duration") || "0");
        return animDuration > 0 || transDuration > 0;
    };
    /**
   * @param {number} timer
   * @param {boolean} reset
   */ var animateTimerProgressBar = function animateTimerProgressBar(timer) {
        var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        if (isVisible$1(timerProgressBar)) {
            if (reset) {
                timerProgressBar.style.transition = "none";
                timerProgressBar.style.width = "100%";
            }
            setTimeout(function() {
                timerProgressBar.style.transition = "width ".concat(timer / 1000, "s linear");
                timerProgressBar.style.width = "0%";
            }, 10);
        }
    };
    var stopTimerProgressBar = function stopTimerProgressBar() {
        var timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        var timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        timerProgressBar.style.removeProperty("transition");
        timerProgressBar.style.width = "100%";
        var timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        var timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
        timerProgressBar.style.width = "".concat(timerProgressBarPercent, "%");
    };
    /**
   * Detect Node env
   *
   * @returns {boolean}
   */ var isNodeEnv = function isNodeEnv() {
        return typeof window === "undefined" || typeof document === "undefined";
    };
    var sweetHTML = '\n <div aria-labelledby="'.concat(swalClasses.title, '" aria-describedby="').concat(swalClasses["html-container"], '" class="').concat(swalClasses.popup, '" tabindex="-1">\n   <button type="button" class="').concat(swalClasses.close, '"></button>\n   <ul class="').concat(swalClasses["progress-steps"], '"></ul>\n   <div class="').concat(swalClasses.icon, '"></div>\n   <img class="').concat(swalClasses.image, '" />\n   <h2 class="').concat(swalClasses.title, '" id="').concat(swalClasses.title, '"></h2>\n   <div class="').concat(swalClasses["html-container"], '" id="').concat(swalClasses["html-container"], '"></div>\n   <input class="').concat(swalClasses.input, '" id="').concat(swalClasses.input, '" />\n   <input type="file" class="').concat(swalClasses.file, '" />\n   <div class="').concat(swalClasses.range, '">\n     <input type="range" />\n     <output></output>\n   </div>\n   <select class="').concat(swalClasses.select, '" id="').concat(swalClasses.select, '"></select>\n   <div class="').concat(swalClasses.radio, '"></div>\n   <label class="').concat(swalClasses.checkbox, '">\n     <input type="checkbox" id="').concat(swalClasses.checkbox, '" />\n     <span class="').concat(swalClasses.label, '"></span>\n   </label>\n   <textarea class="').concat(swalClasses.textarea, '" id="').concat(swalClasses.textarea, '"></textarea>\n   <div class="').concat(swalClasses["validation-message"], '" id="').concat(swalClasses["validation-message"], '"></div>\n   <div class="').concat(swalClasses.actions, '">\n     <div class="').concat(swalClasses.loader, '"></div>\n     <button type="button" class="').concat(swalClasses.confirm, '"></button>\n     <button type="button" class="').concat(swalClasses.deny, '"></button>\n     <button type="button" class="').concat(swalClasses.cancel, '"></button>\n   </div>\n   <div class="').concat(swalClasses.footer, '"></div>\n   <div class="').concat(swalClasses["timer-progress-bar-container"], '">\n     <div class="').concat(swalClasses["timer-progress-bar"], '"></div>\n   </div>\n </div>\n').replace(/(^|\n)\s*/g, "");
    /**
   * @returns {boolean}
   */ var resetOldContainer = function resetOldContainer() {
        var oldContainer = getContainer();
        if (!oldContainer) return false;
        oldContainer.remove();
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses["no-backdrop"],
            swalClasses["toast-shown"],
            swalClasses["has-column"]
        ]);
        return true;
    };
    var resetValidationMessage$1 = function resetValidationMessage() {
        globalState.currentInstance.resetValidationMessage();
    };
    var addInputChangeListeners = function addInputChangeListeners() {
        var popup = getPopup();
        var input = getDirectChildByClass(popup, swalClasses.input);
        var file = getDirectChildByClass(popup, swalClasses.file);
        /** @type {HTMLInputElement} */ var range = popup.querySelector(".".concat(swalClasses.range, " input"));
        /** @type {HTMLOutputElement} */ var rangeOutput = popup.querySelector(".".concat(swalClasses.range, " output"));
        var select = getDirectChildByClass(popup, swalClasses.select);
        /** @type {HTMLInputElement} */ var checkbox = popup.querySelector(".".concat(swalClasses.checkbox, " input"));
        var textarea = getDirectChildByClass(popup, swalClasses.textarea);
        input.oninput = resetValidationMessage$1;
        file.onchange = resetValidationMessage$1;
        select.onchange = resetValidationMessage$1;
        checkbox.onchange = resetValidationMessage$1;
        textarea.oninput = resetValidationMessage$1;
        range.oninput = function() {
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
        range.onchange = function() {
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
    };
    /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */ var getTarget = function getTarget(target) {
        return typeof target === "string" ? document.querySelector(target) : target;
    };
    /**
   * @param {SweetAlertOptions} params
   */ var setupAccessibility = function setupAccessibility(params) {
        var popup = getPopup();
        popup.setAttribute("role", params.toast ? "alert" : "dialog");
        popup.setAttribute("aria-live", params.toast ? "polite" : "assertive");
        if (!params.toast) popup.setAttribute("aria-modal", "true");
    };
    /**
   * @param {HTMLElement} targetElement
   */ var setupRTL = function setupRTL(targetElement) {
        if (window.getComputedStyle(targetElement).direction === "rtl") addClass(getContainer(), swalClasses.rtl);
    };
    /**
   * Add modal + backdrop + no-war message for Russians to DOM
   *
   * @param {SweetAlertOptions} params
   */ var init = function init(params) {
        // Clean up the old popup container if it exists
        var oldContainerExisted = resetOldContainer();
        if (isNodeEnv()) {
            error("SweetAlert2 requires document to initialize");
            return;
        }
        var container = document.createElement("div");
        container.className = swalClasses.container;
        if (oldContainerExisted) addClass(container, swalClasses["no-transition"]);
        setInnerHtml(container, sweetHTML);
        var targetElement = getTarget(params.target);
        targetElement.appendChild(container);
        setupAccessibility(params);
        setupRTL(targetElement);
        addInputChangeListeners();
    };
    /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */ var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
        // DOM element
        if (param instanceof HTMLElement) target.appendChild(param);
        else if (_typeof(param) === "object") handleObject(param, target);
        else if (param) setInnerHtml(target, param);
    };
    /**
   * @param {any} param
   * @param {HTMLElement} target
   */ var handleObject = function handleObject(param, target) {
        // JQuery element(s)
        if (param.jquery) handleJqueryElem(target, param);
        else setInnerHtml(target, param.toString());
    };
    /**
   * @param {HTMLElement} target
   * @param {any} elem
   */ var handleJqueryElem = function handleJqueryElem(target, elem) {
        target.textContent = "";
        if (0 in elem) for(var i = 0; (i in elem); i++)target.appendChild(elem[i].cloneNode(true));
        else target.appendChild(elem.cloneNode(true));
    };
    /**
   * @returns {'webkitAnimationEnd' | 'animationend' | false}
   */ var animationEndEvent = function() {
        // Prevent run in Node env
        if (isNodeEnv()) return false;
        var testEl = document.createElement("div");
        // Chrome, Safari and Opera
        if (typeof testEl.style.webkitAnimation !== "undefined") return "webkitAnimationEnd";
        // Standard syntax
        if (typeof testEl.style.animation !== "undefined") return "animationend";
        return false;
    }();
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderActions = function renderActions(instance, params) {
        var actions = getActions();
        var loader = getLoader();
        if (!actions || !loader) return;
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Custom class
        applyCustomClass(actions, params, "actions");
        // Render all the buttons
        renderButtons(actions, loader, params);
        // Loader
        setInnerHtml(loader, params.loaderHtml || "");
        applyCustomClass(loader, params, "loader");
    };
    /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */ function renderButtons(actions, loader, params) {
        var confirmButton = getConfirmButton();
        var denyButton = getDenyButton();
        var cancelButton = getCancelButton();
        if (!confirmButton || !denyButton || !cancelButton) return;
        // Render buttons
        renderButton(confirmButton, "confirm", params);
        renderButton(denyButton, "deny", params);
        renderButton(cancelButton, "cancel", params);
        handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
        if (params.reverseButtons) {
            if (params.toast) {
                actions.insertBefore(cancelButton, confirmButton);
                actions.insertBefore(denyButton, confirmButton);
            } else {
                actions.insertBefore(cancelButton, loader);
                actions.insertBefore(denyButton, loader);
                actions.insertBefore(confirmButton, loader);
            }
        }
    }
    /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */ function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
        if (!params.buttonsStyling) {
            removeClass([
                confirmButton,
                denyButton,
                cancelButton
            ], swalClasses.styled);
            return;
        }
        addClass([
            confirmButton,
            denyButton,
            cancelButton
        ], swalClasses.styled);
        // Buttons background colors
        if (params.confirmButtonColor) {
            confirmButton.style.backgroundColor = params.confirmButtonColor;
            addClass(confirmButton, swalClasses["default-outline"]);
        }
        if (params.denyButtonColor) {
            denyButton.style.backgroundColor = params.denyButtonColor;
            addClass(denyButton, swalClasses["default-outline"]);
        }
        if (params.cancelButtonColor) {
            cancelButton.style.backgroundColor = params.cancelButtonColor;
            addClass(cancelButton, swalClasses["default-outline"]);
        }
    }
    /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */ function renderButton(button, buttonType, params) {
        var buttonName = /** @type {'Confirm' | 'Deny' | 'Cancel'} */ capitalizeFirstLetter(buttonType);
        toggle(button, params["show".concat(buttonName, "Button")], "inline-block");
        setInnerHtml(button, params["".concat(buttonType, "ButtonText")] || ""); // Set caption text
        button.setAttribute("aria-label", params["".concat(buttonType, "ButtonAriaLabel")] || ""); // ARIA label
        // Add buttons custom classes
        button.className = swalClasses[buttonType];
        applyCustomClass(button, params, "".concat(buttonType, "Button"));
    }
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderCloseButton = function renderCloseButton(instance, params) {
        var closeButton = getCloseButton();
        if (!closeButton) return;
        setInnerHtml(closeButton, params.closeButtonHtml || "");
        // Custom class
        applyCustomClass(closeButton, params, "closeButton");
        toggle(closeButton, params.showCloseButton);
        closeButton.setAttribute("aria-label", params.closeButtonAriaLabel || "");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderContainer = function renderContainer(instance, params) {
        var container = getContainer();
        if (!container) return;
        handleBackdropParam(container, params.backdrop);
        handlePositionParam(container, params.position);
        handleGrowParam(container, params.grow);
        // Custom class
        applyCustomClass(container, params, "container");
    };
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */ function handleBackdropParam(container, backdrop) {
        if (typeof backdrop === "string") container.style.background = backdrop;
        else if (!backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses["no-backdrop"]);
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */ function handlePositionParam(container, position) {
        if (!position) return;
        if (position in swalClasses) addClass(container, swalClasses[position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */ function handleGrowParam(container, grow) {
        if (!grow) return;
        addClass(container, swalClasses["grow-".concat(grow)]);
    }
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateProps = {
        innerParams: new WeakMap(),
        domCache: new WeakMap()
    };
    /** @type {InputClass[]} */ var inputClasses = [
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "textarea"
    ];
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderInput = function renderInput(instance, params) {
        var popup = getPopup();
        if (!popup) return;
        var innerParams = privateProps.innerParams.get(instance);
        var rerender = !innerParams || params.input !== innerParams.input;
        inputClasses.forEach(function(inputClass) {
            var inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
            if (!inputContainer) return;
            // set attributes
            setAttributes(inputClass, params.inputAttributes);
            // set class
            inputContainer.className = swalClasses[inputClass];
            if (rerender) hide(inputContainer);
        });
        if (params.input) {
            if (rerender) showInput(params);
            // set custom class
            setCustomClass(params);
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ var showInput = function showInput(params) {
        if (!params.input) return;
        if (!renderInputType[params.input]) {
            error("Unexpected type of input! Expected ".concat(Object.keys(renderInputType).join(" | "), ', got "').concat(params.input, '"'));
            return;
        }
        var inputContainer = getInputContainer(params.input);
        if (!inputContainer) return;
        var input = renderInputType[params.input](inputContainer, params);
        show(inputContainer);
        // input autofocus
        if (params.inputAutoFocus) setTimeout(function() {
            focusInput(input);
        });
    };
    /**
   * @param {HTMLInputElement} input
   */ var removeAttributes = function removeAttributes(input) {
        for(var i = 0; i < input.attributes.length; i++){
            var attrName = input.attributes[i].name;
            if (![
                "id",
                "type",
                "value",
                "style"
            ].includes(attrName)) input.removeAttribute(attrName);
        }
    };
    /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */ var setAttributes = function setAttributes(inputClass, inputAttributes) {
        var popup = getPopup();
        if (!popup) return;
        var input = getInput$1(popup, inputClass);
        if (!input) return;
        removeAttributes(input);
        for(var attr in inputAttributes)input.setAttribute(attr, inputAttributes[attr]);
    };
    /**
   * @param {SweetAlertOptions} params
   */ var setCustomClass = function setCustomClass(params) {
        if (!params.input) return;
        var inputContainer = getInputContainer(params.input);
        if (inputContainer) applyCustomClass(inputContainer, params, "input");
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */ var setInputPlaceholder = function setInputPlaceholder(input, params) {
        if (!input.placeholder && params.inputPlaceholder) input.placeholder = params.inputPlaceholder;
    };
    /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */ var setInputLabel = function setInputLabel(input, prependTo, params) {
        if (params.inputLabel) {
            var label = document.createElement("label");
            var labelClass = swalClasses["input-label"];
            label.setAttribute("for", input.id);
            label.className = labelClass;
            if (_typeof(params.customClass) === "object") addClass(label, params.customClass.inputLabel);
            label.innerText = params.inputLabel;
            prependTo.insertAdjacentElement("beforebegin", label);
        }
    };
    /**
   * @param {SweetAlertInput} inputType
   * @returns {HTMLElement | undefined}
   */ var getInputContainer = function getInputContainer(inputType) {
        var popup = getPopup();
        if (!popup) return;
        return getDirectChildByClass(popup, swalClasses[/** @type {SwalClass} */ inputType] || swalClasses.input);
    };
    /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */ var checkAndSetInputValue = function checkAndSetInputValue(input, inputValue) {
        if ([
            "string",
            "number"
        ].includes(_typeof(inputValue))) input.value = "".concat(inputValue);
        else if (!isPromise(inputValue)) warn('Unexpected type of inputValue! Expected "string", "number" or "Promise", got "'.concat(_typeof(inputValue), '"'));
    };
    /** @type {Record<SweetAlertInput, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */ var renderInputType = {};
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType["datetime-local"] = renderInputType.time = renderInputType.week = renderInputType.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */ function(input, params) {
        checkAndSetInputValue(input, params.inputValue);
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        input.type = params.input;
        return input;
    };
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.file = function(input, params) {
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        return input;
    };
    /**
   * @param {HTMLInputElement} range
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.range = function(range, params) {
        var rangeInput = range.querySelector("input");
        var rangeOutput = range.querySelector("output");
        checkAndSetInputValue(rangeInput, params.inputValue);
        rangeInput.type = params.input;
        checkAndSetInputValue(rangeOutput, params.inputValue);
        setInputLabel(rangeInput, range, params);
        return range;
    };
    /**
   * @param {HTMLSelectElement} select
   * @param {SweetAlertOptions} params
   * @returns {HTMLSelectElement}
   */ renderInputType.select = function(select, params) {
        select.textContent = "";
        if (params.inputPlaceholder) {
            var placeholder = document.createElement("option");
            setInnerHtml(placeholder, params.inputPlaceholder);
            placeholder.value = "";
            placeholder.disabled = true;
            placeholder.selected = true;
            select.appendChild(placeholder);
        }
        setInputLabel(select, select, params);
        return select;
    };
    /**
   * @param {HTMLInputElement} radio
   * @returns {HTMLInputElement}
   */ renderInputType.radio = function(radio) {
        radio.textContent = "";
        return radio;
    };
    /**
   * @param {HTMLLabelElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.checkbox = function(checkboxContainer, params) {
        var checkbox = getInput$1(getPopup(), "checkbox");
        checkbox.value = "1";
        checkbox.checked = Boolean(params.inputValue);
        var label = checkboxContainer.querySelector("span");
        setInnerHtml(label, params.inputPlaceholder);
        return checkbox;
    };
    /**
   * @param {HTMLTextAreaElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {HTMLTextAreaElement}
   */ renderInputType.textarea = function(textarea, params) {
        checkAndSetInputValue(textarea, params.inputValue);
        setInputPlaceholder(textarea, params);
        setInputLabel(textarea, textarea, params);
        /**
     * @param {HTMLElement} el
     * @returns {number}
     */ var getMargin = function getMargin(el) {
            return parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
        };
        // https://github.com/sweetalert2/sweetalert2/issues/2291
        setTimeout(function() {
            // https://github.com/sweetalert2/sweetalert2/issues/1699
            if ("MutationObserver" in window) {
                var initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
                var textareaResizeHandler = function textareaResizeHandler() {
                    // check if texarea is still in document (i.e. popup wasn't closed in the meantime)
                    if (!document.body.contains(textarea)) return;
                    var textareaWidth = textarea.offsetWidth + getMargin(textarea);
                    if (textareaWidth > initialPopupWidth) getPopup().style.width = "".concat(textareaWidth, "px");
                    else applyNumericalStyle(getPopup(), "width", params.width);
                };
                new MutationObserver(textareaResizeHandler).observe(textarea, {
                    attributes: true,
                    attributeFilter: [
                        "style"
                    ]
                });
            }
        });
        return textarea;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderContent = function renderContent(instance, params) {
        var htmlContainer = getHtmlContainer();
        if (!htmlContainer) return;
        showWhenInnerHtmlPresent(htmlContainer);
        applyCustomClass(htmlContainer, params, "htmlContainer");
        // Content as HTML
        if (params.html) {
            parseHtmlToContainer(params.html, htmlContainer);
            show(htmlContainer, "block");
        } else if (params.text) {
            htmlContainer.textContent = params.text;
            show(htmlContainer, "block");
        } else hide(htmlContainer);
        renderInput(instance, params);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderFooter = function renderFooter(instance, params) {
        var footer = getFooter();
        if (!footer) return;
        showWhenInnerHtmlPresent(footer);
        toggle(footer, params.footer, "block");
        if (params.footer) parseHtmlToContainer(params.footer, footer);
        // Custom class
        applyCustomClass(footer, params, "footer");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderIcon = function renderIcon(instance, params) {
        var innerParams = privateProps.innerParams.get(instance);
        var icon = getIcon();
        if (!icon) return;
        // if the given icon already rendered, apply the styling without re-rendering the icon
        if (innerParams && params.icon === innerParams.icon) {
            // Custom or default content
            setContent(icon, params);
            applyStyles(icon, params);
            return;
        }
        if (!params.icon && !params.iconHtml) {
            hide(icon);
            return;
        }
        if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
            error('Unknown icon! Expected "success", "error", "warning", "info" or "question", got "'.concat(params.icon, '"'));
            hide(icon);
            return;
        }
        show(icon);
        // Custom or default content
        setContent(icon, params);
        applyStyles(icon, params);
        // Animate icon
        addClass(icon, params.showClass && params.showClass.icon);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ var applyStyles = function applyStyles(icon, params) {
        for(var _i = 0, _Object$entries = Object.entries(iconTypes); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), iconType = _Object$entries$_i[0], iconClassName = _Object$entries$_i[1];
            if (params.icon !== iconType) removeClass(icon, iconClassName);
        }
        addClass(icon, params.icon && iconTypes[params.icon]);
        // Icon color
        setColor(icon, params);
        // Success icon background color
        adjustSuccessIconBackgroundColor();
        // Custom class
        applyCustomClass(icon, params, "icon");
    };
    // Adjust success icon background color to match the popup background color
    var adjustSuccessIconBackgroundColor = function adjustSuccessIconBackgroundColor() {
        var popup = getPopup();
        if (!popup) return;
        var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue("background-color");
        /** @type {NodeListOf<HTMLElement>} */ var successIconParts = popup.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
        for(var i = 0; i < successIconParts.length; i++)successIconParts[i].style.backgroundColor = popupBackgroundColor;
    };
    var successIconHtml = '\n  <div class="swal2-success-circular-line-left"></div>\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n  <div class="swal2-success-circular-line-right"></div>\n';
    var errorIconHtml = '\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ var setContent = function setContent(icon, params) {
        if (!params.icon && !params.iconHtml) return;
        var oldContent = icon.innerHTML;
        var newContent = "";
        if (params.iconHtml) newContent = iconContent(params.iconHtml);
        else if (params.icon === "success") {
            newContent = successIconHtml;
            oldContent = oldContent.replace(/ style=".*?"/g, ""); // undo adjustSuccessIconBackgroundColor()
        } else if (params.icon === "error") newContent = errorIconHtml;
        else if (params.icon) {
            var defaultIconHtml = {
                question: "?",
                warning: "!",
                info: "i"
            };
            newContent = iconContent(defaultIconHtml[params.icon]);
        }
        if (oldContent.trim() !== newContent.trim()) setInnerHtml(icon, newContent);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ var setColor = function setColor(icon, params) {
        if (!params.iconColor) return;
        icon.style.color = params.iconColor;
        icon.style.borderColor = params.iconColor;
        for(var _i2 = 0, _arr = [
            ".swal2-success-line-tip",
            ".swal2-success-line-long",
            ".swal2-x-mark-line-left",
            ".swal2-x-mark-line-right"
        ]; _i2 < _arr.length; _i2++){
            var sel = _arr[_i2];
            setStyle(icon, sel, "background-color", params.iconColor);
        }
        setStyle(icon, ".swal2-success-ring", "border-color", params.iconColor);
    };
    /**
   * @param {string} content
   * @returns {string}
   */ var iconContent = function iconContent(content) {
        return '<div class="'.concat(swalClasses["icon-content"], '">').concat(content, "</div>");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderImage = function renderImage(instance, params) {
        var image = getImage();
        if (!image) return;
        if (!params.imageUrl) {
            hide(image);
            return;
        }
        show(image, "");
        // Src, alt
        image.setAttribute("src", params.imageUrl);
        image.setAttribute("alt", params.imageAlt || "");
        // Width, height
        applyNumericalStyle(image, "width", params.imageWidth);
        applyNumericalStyle(image, "height", params.imageHeight);
        // Class
        image.className = swalClasses.image;
        applyCustomClass(image, params, "image");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderPopup = function renderPopup(instance, params) {
        var container = getContainer();
        var popup = getPopup();
        if (!container || !popup) return;
        // Width
        // https://github.com/sweetalert2/sweetalert2/issues/2170
        if (params.toast) {
            applyNumericalStyle(container, "width", params.width);
            popup.style.width = "100%";
            var loader = getLoader();
            if (loader) popup.insertBefore(loader, getIcon());
        } else applyNumericalStyle(popup, "width", params.width);
        // Padding
        applyNumericalStyle(popup, "padding", params.padding);
        // Color
        if (params.color) popup.style.color = params.color;
        // Background
        if (params.background) popup.style.background = params.background;
        hide(getValidationMessage());
        // Classes
        addClasses$1(popup, params);
    };
    /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ var addClasses$1 = function addClasses(popup, params) {
        var showClass = params.showClass || {};
        // Default Class + showClass when updating Swal.update({})
        popup.className = "".concat(swalClasses.popup, " ").concat(isVisible$1(popup) ? showClass.popup : "");
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses["toast-shown"]);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom class
        applyCustomClass(popup, params, "popup");
        // TODO: remove in the next major
        if (typeof params.customClass === "string") addClass(popup, params.customClass);
        // Icon class (#1842)
        if (params.icon) addClass(popup, swalClasses["icon-".concat(params.icon)]);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderProgressSteps = function renderProgressSteps(instance, params) {
        var progressStepsContainer = getProgressSteps();
        if (!progressStepsContainer) return;
        var progressSteps = params.progressSteps, currentProgressStep = params.currentProgressStep;
        if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
            hide(progressStepsContainer);
            return;
        }
        show(progressStepsContainer);
        progressStepsContainer.textContent = "";
        if (currentProgressStep >= progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
        progressSteps.forEach(function(step, index) {
            var stepEl = createStepElement(step);
            progressStepsContainer.appendChild(stepEl);
            if (index === currentProgressStep) addClass(stepEl, swalClasses["active-progress-step"]);
            if (index !== progressSteps.length - 1) {
                var lineEl = createLineElement(params);
                progressStepsContainer.appendChild(lineEl);
            }
        });
    };
    /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */ var createStepElement = function createStepElement(step) {
        var stepEl = document.createElement("li");
        addClass(stepEl, swalClasses["progress-step"]);
        setInnerHtml(stepEl, step);
        return stepEl;
    };
    /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */ var createLineElement = function createLineElement(params) {
        var lineEl = document.createElement("li");
        addClass(lineEl, swalClasses["progress-step-line"]);
        if (params.progressStepsDistance) applyNumericalStyle(lineEl, "width", params.progressStepsDistance);
        return lineEl;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var renderTitle = function renderTitle(instance, params) {
        var title = getTitle();
        if (!title) return;
        showWhenInnerHtmlPresent(title);
        toggle(title, params.title || params.titleText, "block");
        if (params.title) parseHtmlToContainer(params.title, title);
        if (params.titleText) title.innerText = params.titleText;
        // Custom class
        applyCustomClass(title, params, "title");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var render = function render(instance, params) {
        renderPopup(instance, params);
        renderContainer(instance, params);
        renderProgressSteps(instance, params);
        renderIcon(instance, params);
        renderImage(instance, params);
        renderTitle(instance, params);
        renderCloseButton(instance, params);
        renderContent(instance, params);
        renderActions(instance, params);
        renderFooter(instance, params);
        var popup = getPopup();
        if (typeof params.didRender === "function" && popup) params.didRender(popup);
    };
    /*
   * Global function to determine if SweetAlert2 popup is shown
   */ var isVisible = function isVisible() {
        return isVisible$1(getPopup());
    };
    /*
   * Global function to click 'Confirm' button
   */ var clickConfirm = function clickConfirm() {
        var _dom$getConfirmButton;
        return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    /*
   * Global function to click 'Deny' button
   */ var clickDeny = function clickDeny() {
        var _dom$getDenyButton;
        return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    /*
   * Global function to click 'Cancel' button
   */ var clickCancel = function clickCancel() {
        var _dom$getCancelButton;
        return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    /** @typedef {'cancel' | 'backdrop' | 'close' | 'esc' | 'timer'} DismissReason */ /** @type {Record<DismissReason, DismissReason>} */ var DismissReason = Object.freeze({
        cancel: "cancel",
        backdrop: "backdrop",
        close: "close",
        esc: "esc",
        timer: "timer"
    });
    /**
   * @param {GlobalState} globalState
   */ var removeKeydownHandler = function removeKeydownHandler(globalState) {
        if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
            globalState.keydownTarget.removeEventListener("keydown", globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = false;
        }
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {*} dismissWith
   */ var addKeydownHandler = function addKeydownHandler(globalState, innerParams, dismissWith) {
        removeKeydownHandler(globalState);
        if (!innerParams.toast) {
            globalState.keydownHandler = function(e) {
                return keydownHandler(innerParams, e, dismissWith);
            };
            globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
            globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
            globalState.keydownTarget.addEventListener("keydown", globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = true;
        }
    };
    /**
   * @param {number} index
   * @param {number} increment
   */ var setFocus = function setFocus(index, increment) {
        var _dom$getPopup;
        var focusableElements = getFocusableElements();
        // search for visible elements and select the next possible match
        if (focusableElements.length) {
            index = index + increment;
            // rollover to first item
            if (index === focusableElements.length) index = 0;
            else if (index === -1) index = focusableElements.length - 1;
            focusableElements[index].focus();
            return;
        }
        // no visible focusable elements, focus the popup
        (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
    };
    var arrowKeysNextButton = [
        "ArrowRight",
        "ArrowDown"
    ];
    var arrowKeysPreviousButton = [
        "ArrowLeft",
        "ArrowUp"
    ];
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {KeyboardEvent} event
   * @param {Function} dismissWith
   */ var keydownHandler = function keydownHandler(innerParams, event, dismissWith) {
        if (!innerParams) return; // This instance has already been destroyed
        // Ignore keydown during IME composition
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
        // https://github.com/sweetalert2/sweetalert2/issues/720
        // https://github.com/sweetalert2/sweetalert2/issues/2406
        if (event.isComposing || event.keyCode === 229) return;
        if (innerParams.stopKeydownPropagation) event.stopPropagation();
        // ENTER
        if (event.key === "Enter") handleEnter(event, innerParams);
        else if (event.key === "Tab") handleTab(event);
        else if ([].concat(arrowKeysNextButton, arrowKeysPreviousButton).includes(event.key)) handleArrows(event.key);
        else if (event.key === "Escape") handleEsc(event, innerParams, dismissWith);
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */ var handleEnter = function handleEnter(event, innerParams) {
        // https://github.com/sweetalert2/sweetalert2/issues/2386
        if (!callIfFunction(innerParams.allowEnterKey)) return;
        var input = getInput$1(getPopup(), innerParams.input);
        if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
            if ([
                "textarea",
                "file"
            ].includes(innerParams.input)) return; // do not submit
            clickConfirm();
            event.preventDefault();
        }
    };
    /**
   * @param {KeyboardEvent} event
   */ var handleTab = function handleTab(event) {
        var targetElement = event.target;
        var focusableElements = getFocusableElements();
        var btnIndex = -1;
        for(var i = 0; i < focusableElements.length; i++)if (targetElement === focusableElements[i]) {
            btnIndex = i;
            break;
        }
        // Cycle to the next button
        if (!event.shiftKey) setFocus(btnIndex, 1);
        else setFocus(btnIndex, -1);
        event.stopPropagation();
        event.preventDefault();
    };
    /**
   * @param {string} key
   */ var handleArrows = function handleArrows(key) {
        var actions = getActions();
        var confirmButton = getConfirmButton();
        var denyButton = getDenyButton();
        var cancelButton = getCancelButton();
        if (!actions || !confirmButton || !denyButton || !cancelButton) return;
        /** @type HTMLElement[] */ var buttons = [
            confirmButton,
            denyButton,
            cancelButton
        ];
        if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) return;
        var sibling = arrowKeysNextButton.includes(key) ? "nextElementSibling" : "previousElementSibling";
        var buttonToFocus = document.activeElement;
        if (!buttonToFocus) return;
        for(var i = 0; i < actions.children.length; i++){
            buttonToFocus = buttonToFocus[sibling];
            if (!buttonToFocus) return;
            if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) break;
        }
        if (buttonToFocus instanceof HTMLButtonElement) buttonToFocus.focus();
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ var handleEsc = function handleEsc(event, innerParams, dismissWith) {
        if (callIfFunction(innerParams.allowEscapeKey)) {
            event.preventDefault();
            dismissWith(DismissReason.esc);
        }
    };
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateMethods = {
        swalPromiseResolve: new WeakMap(),
        swalPromiseReject: new WeakMap()
    };
    // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
    // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
    // elements not within the active modal dialog will not be surfaced if a user opens a screen
    // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
    var setAriaHidden = function setAriaHidden() {
        var container = getContainer();
        var bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach(function(el) {
            if (el.contains(container)) return;
            if (el.hasAttribute("aria-hidden")) el.setAttribute("data-previous-aria-hidden", el.getAttribute("aria-hidden") || "");
            el.setAttribute("aria-hidden", "true");
        });
    };
    var unsetAriaHidden = function unsetAriaHidden() {
        var bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach(function(el) {
            if (el.hasAttribute("data-previous-aria-hidden")) {
                el.setAttribute("aria-hidden", el.getAttribute("data-previous-aria-hidden") || "");
                el.removeAttribute("data-previous-aria-hidden");
            } else el.removeAttribute("aria-hidden");
        });
    };
    // @ts-ignore
    var isSafariOrIOS = typeof window !== "undefined" && !!window.GestureEvent; // true for Safari desktop + all iOS browsers https://stackoverflow.com/a/70585394
    /**
   * Fix iOS scrolling
   * http://stackoverflow.com/q/39626302
   */ var iOSfix = function iOSfix() {
        if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
            var offset = document.body.scrollTop;
            document.body.style.top = "".concat(offset * -1, "px");
            addClass(document.body, swalClasses.iosfix);
            lockBodyScroll();
        }
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */ var lockBodyScroll = function lockBodyScroll() {
        var container = getContainer();
        if (!container) return;
        /** @type {boolean} */ var preventTouchMove;
        /**
     * @param {TouchEvent} event
     */ container.ontouchstart = function(event) {
            preventTouchMove = shouldPreventTouchMove(event);
        };
        /**
     * @param {TouchEvent} event
     */ container.ontouchmove = function(event) {
            if (preventTouchMove) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    };
    /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */ var shouldPreventTouchMove = function shouldPreventTouchMove(event) {
        var target = event.target;
        var container = getContainer();
        var htmlContainer = getHtmlContainer();
        if (!container || !htmlContainer) return false;
        if (isStylus(event) || isZoom(event)) return false;
        if (target === container) return true;
        if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== "INPUT" && // #1603
        target.tagName !== "TEXTAREA" && // #2266
        !(isScrollable(htmlContainer) && // #1944
        htmlContainer.contains(target))) return true;
        return false;
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {*} event
   * @returns {boolean}
   */ var isStylus = function isStylus(event) {
        return event.touches && event.touches.length && event.touches[0].touchType === "stylus";
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ var isZoom = function isZoom(event) {
        return event.touches && event.touches.length > 1;
    };
    var undoIOSfix = function undoIOSfix() {
        if (hasClass(document.body, swalClasses.iosfix)) {
            var offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = "";
            document.body.scrollTop = offset * -1;
        }
    };
    /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */ var measureScrollbar = function measureScrollbar() {
        var scrollDiv = document.createElement("div");
        scrollDiv.className = swalClasses["scrollbar-measure"];
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */ var previousBodyPadding = null;
    /**
   * @param {string} initialBodyOverflow
   */ var replaceScrollbarWithPadding = function replaceScrollbarWithPadding(initialBodyOverflow) {
        // for queues, do not do this more than once
        if (previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === "scroll" // https://github.com/sweetalert2/sweetalert2/issues/2663
        ) {
            // add padding so the content doesn't shift after removal of scrollbar
            previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"));
            document.body.style.paddingRight = "".concat(previousBodyPadding + measureScrollbar(), "px");
        }
    };
    var undoReplaceScrollbarWithPadding = function undoReplaceScrollbarWithPadding() {
        if (previousBodyPadding !== null) {
            document.body.style.paddingRight = "".concat(previousBodyPadding, "px");
            previousBodyPadding = null;
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ function removePopupAndResetState(instance, container, returnFocus, didClose) {
        if (isToast()) triggerDidCloseAndDispose(instance, didClose);
        else {
            restoreActiveElement(returnFocus).then(function() {
                return triggerDidCloseAndDispose(instance, didClose);
            });
            removeKeydownHandler(globalState);
        }
        // workaround for https://github.com/sweetalert2/sweetalert2/issues/2088
        // for some reason removing the container in Safari will scroll the document to bottom
        if (isSafariOrIOS) {
            container.setAttribute("style", "display:none !important");
            container.removeAttribute("class");
            container.innerHTML = "";
        } else container.remove();
        if (isModal()) {
            undoReplaceScrollbarWithPadding();
            undoIOSfix();
            unsetAriaHidden();
        }
        removeBodyClasses();
    }
    /**
   * Remove SweetAlert2 classes from body
   */ function removeBodyClasses() {
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses.shown,
            swalClasses["height-auto"],
            swalClasses["no-backdrop"],
            swalClasses["toast-shown"]
        ]);
    }
    /**
   * Instance method to close sweetAlert
   *
   * @param {any} resolveValue
   */ function close(resolveValue) {
        resolveValue = prepareResolveValue(resolveValue);
        var swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
        var didClose = triggerClosePopup(this);
        if (this.isAwaitingPromise) // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
        {
            if (!resolveValue.isDismissed) {
                handleAwaitingPromise(this);
                swalPromiseResolve(resolveValue);
            }
        } else if (didClose) // Resolve Swal promise
        swalPromiseResolve(resolveValue);
    }
    var triggerClosePopup = function triggerClosePopup(instance) {
        var popup = getPopup();
        if (!popup) return false;
        var innerParams = privateProps.innerParams.get(instance);
        if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) return false;
        removeClass(popup, innerParams.showClass.popup);
        addClass(popup, innerParams.hideClass.popup);
        var backdrop = getContainer();
        removeClass(backdrop, innerParams.showClass.backdrop);
        addClass(backdrop, innerParams.hideClass.backdrop);
        handlePopupAnimation(instance, popup, innerParams);
        return true;
    };
    /**
   * @param {any} error
   */ function rejectPromise(error) {
        var rejectPromise = privateMethods.swalPromiseReject.get(this);
        handleAwaitingPromise(this);
        if (rejectPromise) // Reject Swal promise
        rejectPromise(error);
    }
    /**
   * @param {SweetAlert} instance
   */ var handleAwaitingPromise = function handleAwaitingPromise(instance) {
        if (instance.isAwaitingPromise) {
            delete instance.isAwaitingPromise;
            // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
            if (!privateProps.innerParams.get(instance)) instance._destroy();
        }
    };
    /**
   * @param {any} resolveValue
   * @returns {SweetAlertResult}
   */ var prepareResolveValue = function prepareResolveValue(resolveValue) {
        // When user calls Swal.close()
        if (typeof resolveValue === "undefined") return {
            isConfirmed: false,
            isDenied: false,
            isDismissed: true
        };
        return Object.assign({
            isConfirmed: false,
            isDenied: false,
            isDismissed: false
        }, resolveValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */ var handlePopupAnimation = function handlePopupAnimation(instance, popup, innerParams) {
        var container = getContainer();
        // If animation is supported, animate
        var animationIsSupported = animationEndEvent && hasCssAnimation(popup);
        if (typeof innerParams.willClose === "function") innerParams.willClose(popup);
        if (animationIsSupported) animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
        else // Otherwise, remove immediately
        removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ var animatePopup = function animatePopup(instance, popup, container, returnFocus, didClose) {
        if (!animationEndEvent) return;
        globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
        popup.addEventListener(animationEndEvent, function(e) {
            if (e.target === popup) {
                globalState.swalCloseEventFinishedCallback();
                delete globalState.swalCloseEventFinishedCallback;
            }
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} didClose
   */ var triggerDidCloseAndDispose = function triggerDidCloseAndDispose(instance, didClose) {
        setTimeout(function() {
            if (typeof didClose === "function") didClose.bind(instance.params)();
            // instance might have been destroyed already
            if (instance._destroy) instance._destroy();
        });
    };
    /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ var showLoading = function showLoading(buttonToReplace) {
        var popup = getPopup();
        if (!popup) new Swal();
        popup = getPopup();
        if (!popup) return;
        var loader = getLoader();
        if (isToast()) hide(getIcon());
        else replaceButton(popup, buttonToReplace);
        show(loader);
        popup.setAttribute("data-loading", "true");
        popup.setAttribute("aria-busy", "true");
        popup.focus();
    };
    /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ var replaceButton = function replaceButton(popup, buttonToReplace) {
        var actions = getActions();
        var loader = getLoader();
        if (!actions || !loader) return;
        if (!buttonToReplace && isVisible$1(getConfirmButton())) buttonToReplace = getConfirmButton();
        show(actions);
        if (buttonToReplace) {
            hide(buttonToReplace);
            loader.setAttribute("data-button-to-replace", buttonToReplace.className);
            actions.insertBefore(loader, buttonToReplace);
        }
        addClass([
            popup,
            actions
        ], swalClasses.loading);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var handleInputOptionsAndValue = function handleInputOptionsAndValue(instance, params) {
        if (params.input === "select" || params.input === "radio") handleInputOptions(instance, params);
        else if ([
            "text",
            "email",
            "number",
            "tel",
            "textarea"
        ].some(function(i) {
            return i === params.input;
        }) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
            showLoading(getConfirmButton());
            handleInputValue(instance, params);
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {SweetAlertInputValue}
   */ var getInputValue = function getInputValue(instance, innerParams) {
        var input = instance.getInput();
        if (!input) return null;
        switch(innerParams.input){
            case "checkbox":
                return getCheckboxValue(input);
            case "radio":
                return getRadioValue(input);
            case "file":
                return getFileValue(input);
            default:
                return innerParams.inputAutoTrim ? input.value.trim() : input.value;
        }
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */ var getCheckboxValue = function getCheckboxValue(input) {
        return input.checked ? 1 : 0;
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */ var getRadioValue = function getRadioValue(input) {
        return input.checked ? input.value : null;
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */ var getFileValue = function getFileValue(input) {
        return input.files && input.files.length ? input.getAttribute("multiple") !== null ? input.files : input.files[0] : null;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var handleInputOptions = function handleInputOptions(instance, params) {
        var popup = getPopup();
        if (!popup) return;
        /**
     * @param {Record<string, any>} inputOptions
     */ var processInputOptions = function processInputOptions(inputOptions) {
            if (params.input === "select") populateSelectOptions(popup, _formatInputOptions(inputOptions), params);
            else if (params.input === "radio") populateRadioOptions(popup, _formatInputOptions(inputOptions), params);
        };
        if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
            showLoading(getConfirmButton());
            asPromise(params.inputOptions).then(function(inputOptions) {
                instance.hideLoading();
                processInputOptions(inputOptions);
            });
        } else if (_typeof(params.inputOptions) === "object") processInputOptions(params.inputOptions);
        else error("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(_typeof(params.inputOptions)));
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ var handleInputValue = function handleInputValue(instance, params) {
        var input = instance.getInput();
        if (!input) return;
        hide(input);
        asPromise(params.inputValue).then(function(inputValue) {
            input.value = params.input === "number" ? "".concat(parseFloat(inputValue) || 0) : "".concat(inputValue);
            show(input);
            input.focus();
            instance.hideLoading();
        })["catch"](function(err) {
            error("Error in inputValue promise: ".concat(err));
            input.value = "";
            show(input);
            input.focus();
            instance.hideLoading();
        });
    };
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateSelectOptions(popup, inputOptions, params) {
        var select = getDirectChildByClass(popup, swalClasses.select);
        if (!select) return;
        /**
     * @param {HTMLElement} parent
     * @param {string} optionLabel
     * @param {string} optionValue
     */ var renderOption = function renderOption(parent, optionLabel, optionValue) {
            var option = document.createElement("option");
            option.value = optionValue;
            setInnerHtml(option, optionLabel);
            option.selected = isSelected(optionValue, params.inputValue);
            parent.appendChild(option);
        };
        inputOptions.forEach(function(inputOption) {
            var optionValue = inputOption[0];
            var optionLabel = inputOption[1];
            // <optgroup> spec:
            // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
            // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
            // check whether this is a <optgroup>
            if (Array.isArray(optionLabel)) {
                // if it is an array, then it is an <optgroup>
                var optgroup = document.createElement("optgroup");
                optgroup.label = optionValue;
                optgroup.disabled = false; // not configurable for now
                select.appendChild(optgroup);
                optionLabel.forEach(function(o) {
                    return renderOption(optgroup, o[1], o[0]);
                });
            } else // case of <option>
            renderOption(select, optionLabel, optionValue);
        });
        select.focus();
    }
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateRadioOptions(popup, inputOptions, params) {
        var radio = getDirectChildByClass(popup, swalClasses.radio);
        if (!radio) return;
        inputOptions.forEach(function(inputOption) {
            var radioValue = inputOption[0];
            var radioLabel = inputOption[1];
            var radioInput = document.createElement("input");
            var radioLabelElement = document.createElement("label");
            radioInput.type = "radio";
            radioInput.name = swalClasses.radio;
            radioInput.value = radioValue;
            if (isSelected(radioValue, params.inputValue)) radioInput.checked = true;
            var label = document.createElement("span");
            setInnerHtml(label, radioLabel);
            label.className = swalClasses.label;
            radioLabelElement.appendChild(radioInput);
            radioLabelElement.appendChild(label);
            radio.appendChild(radioLabelElement);
        });
        var radios = radio.querySelectorAll("input");
        if (radios.length) radios[0].focus();
    }
    /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {Record<string, any>} inputOptions
   * @typedef {string[]} InputOptionFlattened
   * @returns {InputOptionFlattened[]}
   */ var _formatInputOptions = function formatInputOptions(inputOptions) {
        /** @type {InputOptionFlattened[]} */ var result = [];
        if (inputOptions instanceof Map) inputOptions.forEach(function(value, key) {
            var valueFormatted = value;
            if (_typeof(valueFormatted) === "object") // case of <optgroup>
            valueFormatted = _formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        else Object.keys(inputOptions).forEach(function(key) {
            var valueFormatted = inputOptions[key];
            if (_typeof(valueFormatted) === "object") // case of <optgroup>
            valueFormatted = _formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        return result;
    };
    /**
   * @param {string} optionValue
   * @param {SweetAlertInputValue} inputValue
   * @returns {boolean}
   */ var isSelected = function isSelected(optionValue, inputValue) {
        return !!inputValue && inputValue.toString() === optionValue.toString();
    };
    var _this = undefined;
    /**
   * @param {SweetAlert} instance
   */ var handleConfirmButtonClick = function handleConfirmButtonClick(instance) {
        var innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.input) handleConfirmOrDenyWithInput(instance, "confirm");
        else confirm(instance, true);
    };
    /**
   * @param {SweetAlert} instance
   */ var handleDenyButtonClick = function handleDenyButtonClick(instance) {
        var innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.returnInputValueOnDeny) handleConfirmOrDenyWithInput(instance, "deny");
        else deny(instance, false);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} dismissWith
   */ var handleCancelButtonClick = function handleCancelButtonClick(instance, dismissWith) {
        instance.disableButtons();
        dismissWith(DismissReason.cancel);
    };
    /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */ var handleConfirmOrDenyWithInput = function handleConfirmOrDenyWithInput(instance, type) {
        var innerParams = privateProps.innerParams.get(instance);
        if (!innerParams.input) {
            error('The "input" parameter is needed to be set when using returnInputValueOn'.concat(capitalizeFirstLetter(type)));
            return;
        }
        var input = instance.getInput();
        var inputValue = getInputValue(instance, innerParams);
        if (innerParams.inputValidator) handleInputValidator(instance, inputValue, type);
        else if (input && !input.checkValidity()) {
            instance.enableButtons();
            instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
        } else if (type === "deny") deny(instance, inputValue);
        else confirm(instance, inputValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertInputValue} inputValue
   * @param {'confirm' | 'deny'} type
   */ var handleInputValidator = function handleInputValidator(instance, inputValue, type) {
        var innerParams = privateProps.innerParams.get(instance);
        instance.disableInput();
        var validationPromise = Promise.resolve().then(function() {
            return asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage));
        });
        validationPromise.then(function(validationMessage) {
            instance.enableButtons();
            instance.enableInput();
            if (validationMessage) instance.showValidationMessage(validationMessage);
            else if (type === "deny") deny(instance, inputValue);
            else confirm(instance, inputValue);
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ var deny = function deny(instance, value) {
        var innerParams = privateProps.innerParams.get(instance || _this);
        if (innerParams.showLoaderOnDeny) showLoading(getDenyButton());
        if (innerParams.preDeny) {
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
            var preDenyPromise = Promise.resolve().then(function() {
                return asPromise(innerParams.preDeny(value, innerParams.validationMessage));
            });
            preDenyPromise.then(function(preDenyValue) {
                if (preDenyValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else instance.close({
                    isDenied: true,
                    value: typeof preDenyValue === "undefined" ? value : preDenyValue
                });
            })["catch"](function(error) {
                return rejectWith(instance || _this, error);
            });
        } else instance.close({
            isDenied: true,
            value: value
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ var succeedWith = function succeedWith(instance, value) {
        instance.close({
            isConfirmed: true,
            value: value
        });
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */ var rejectWith = function rejectWith(instance, error) {
        instance.rejectPromise(error);
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {any} value
   */ var confirm = function confirm(instance, value) {
        var innerParams = privateProps.innerParams.get(instance || _this);
        if (innerParams.showLoaderOnConfirm) showLoading();
        if (innerParams.preConfirm) {
            instance.resetValidationMessage();
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
            var preConfirmPromise = Promise.resolve().then(function() {
                return asPromise(innerParams.preConfirm(value, innerParams.validationMessage));
            });
            preConfirmPromise.then(function(preConfirmValue) {
                if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else succeedWith(instance, typeof preConfirmValue === "undefined" ? value : preConfirmValue);
            })["catch"](function(error) {
                return rejectWith(instance || _this, error);
            });
        } else succeedWith(instance, value);
    };
    /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */ function hideLoading() {
        // do nothing if popup is closed
        var innerParams = privateProps.innerParams.get(this);
        if (!innerParams) return;
        var domCache = privateProps.domCache.get(this);
        hide(domCache.loader);
        if (isToast()) {
            if (innerParams.icon) show(getIcon());
        } else showRelatedButton(domCache);
        removeClass([
            domCache.popup,
            domCache.actions
        ], swalClasses.loading);
        domCache.popup.removeAttribute("aria-busy");
        domCache.popup.removeAttribute("data-loading");
        domCache.confirmButton.disabled = false;
        domCache.denyButton.disabled = false;
        domCache.cancelButton.disabled = false;
    }
    var showRelatedButton = function showRelatedButton(domCache) {
        var buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute("data-button-to-replace"));
        if (buttonToReplace.length) show(buttonToReplace[0], "inline-block");
        else if (allButtonsAreHidden()) hide(domCache.actions);
    };
    /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   */ function getInput() {
        var innerParams = privateProps.innerParams.get(this);
        var domCache = privateProps.domCache.get(this);
        if (!domCache) return null;
        return getInput$1(domCache.popup, innerParams.input);
    }
    /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */ function setButtonsDisabled(instance, buttons, disabled) {
        var domCache = privateProps.domCache.get(instance);
        buttons.forEach(function(button) {
            domCache[button].disabled = disabled;
        });
    }
    /**
   * @param {HTMLInputElement | null} input
   * @param {boolean} disabled
   */ function setInputDisabled(input, disabled) {
        var popup = getPopup();
        if (!popup || !input) return;
        if (input.type === "radio") {
            /** @type {NodeListOf<HTMLInputElement>} */ var radios = popup.querySelectorAll('[name="'.concat(swalClasses.radio, '"]'));
            for(var i = 0; i < radios.length; i++)radios[i].disabled = disabled;
        } else input.disabled = disabled;
    }
    /**
   * Enable all the buttons
   * @this {SweetAlert}
   */ function enableButtons() {
        setButtonsDisabled(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], false);
    }
    /**
   * Disable all the buttons
   * @this {SweetAlert}
   */ function disableButtons() {
        setButtonsDisabled(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], true);
    }
    /**
   * Enable the input field
   * @this {SweetAlert}
   */ function enableInput() {
        setInputDisabled(this.getInput(), false);
    }
    /**
   * Disable the input field
   * @this {SweetAlert}
   */ function disableInput() {
        setInputDisabled(this.getInput(), true);
    }
    /**
   * Show block with validation message
   *
   * @param {string} error
   * @this {SweetAlert}
   */ function showValidationMessage(error) {
        var domCache = privateProps.domCache.get(this);
        var params = privateProps.innerParams.get(this);
        setInnerHtml(domCache.validationMessage, error);
        domCache.validationMessage.className = swalClasses["validation-message"];
        if (params.customClass && params.customClass.validationMessage) addClass(domCache.validationMessage, params.customClass.validationMessage);
        show(domCache.validationMessage);
        var input = this.getInput();
        if (input) {
            input.setAttribute("aria-invalid", "true");
            input.setAttribute("aria-describedby", swalClasses["validation-message"]);
            focusInput(input);
            addClass(input, swalClasses.inputerror);
        }
    }
    /**
   * Hide block with validation message
   *
   * @this {SweetAlert}
   */ function resetValidationMessage() {
        var domCache = privateProps.domCache.get(this);
        if (domCache.validationMessage) hide(domCache.validationMessage);
        var input = this.getInput();
        if (input) {
            input.removeAttribute("aria-invalid");
            input.removeAttribute("aria-describedby");
            removeClass(input, swalClasses.inputerror);
        }
    }
    var defaultParams = {
        title: "",
        titleText: "",
        text: "",
        html: "",
        footer: "",
        icon: undefined,
        iconColor: undefined,
        iconHtml: undefined,
        template: undefined,
        toast: false,
        animation: true,
        showClass: {
            popup: "swal2-show",
            backdrop: "swal2-backdrop-show",
            icon: "swal2-icon-show"
        },
        hideClass: {
            popup: "swal2-hide",
            backdrop: "swal2-backdrop-hide",
            icon: "swal2-icon-hide"
        },
        customClass: {},
        target: "body",
        color: undefined,
        backdrop: true,
        heightAuto: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: false,
        preConfirm: undefined,
        preDeny: undefined,
        confirmButtonText: "OK",
        confirmButtonAriaLabel: "",
        confirmButtonColor: undefined,
        denyButtonText: "No",
        denyButtonAriaLabel: "",
        denyButtonColor: undefined,
        cancelButtonText: "Cancel",
        cancelButtonAriaLabel: "",
        cancelButtonColor: undefined,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusDeny: false,
        focusCancel: false,
        returnFocus: true,
        showCloseButton: false,
        closeButtonHtml: "&times;",
        closeButtonAriaLabel: "Close this dialog",
        loaderHtml: "",
        showLoaderOnConfirm: false,
        showLoaderOnDeny: false,
        imageUrl: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageAlt: "",
        timer: undefined,
        timerProgressBar: false,
        width: undefined,
        padding: undefined,
        background: undefined,
        input: undefined,
        inputPlaceholder: "",
        inputLabel: "",
        inputValue: "",
        inputOptions: {},
        inputAutoFocus: true,
        inputAutoTrim: true,
        inputAttributes: {},
        inputValidator: undefined,
        returnInputValueOnDeny: false,
        validationMessage: undefined,
        grow: false,
        position: "center",
        progressSteps: [],
        currentProgressStep: undefined,
        progressStepsDistance: undefined,
        willOpen: undefined,
        didOpen: undefined,
        didRender: undefined,
        willClose: undefined,
        didClose: undefined,
        didDestroy: undefined,
        scrollbarPadding: true
    };
    var updatableParams = [
        "allowEscapeKey",
        "allowOutsideClick",
        "background",
        "buttonsStyling",
        "cancelButtonAriaLabel",
        "cancelButtonColor",
        "cancelButtonText",
        "closeButtonAriaLabel",
        "closeButtonHtml",
        "color",
        "confirmButtonAriaLabel",
        "confirmButtonColor",
        "confirmButtonText",
        "currentProgressStep",
        "customClass",
        "denyButtonAriaLabel",
        "denyButtonColor",
        "denyButtonText",
        "didClose",
        "didDestroy",
        "footer",
        "hideClass",
        "html",
        "icon",
        "iconColor",
        "iconHtml",
        "imageAlt",
        "imageHeight",
        "imageUrl",
        "imageWidth",
        "preConfirm",
        "preDeny",
        "progressSteps",
        "returnFocus",
        "reverseButtons",
        "showCancelButton",
        "showCloseButton",
        "showConfirmButton",
        "showDenyButton",
        "text",
        "title",
        "titleText",
        "willClose"
    ];
    /** @type {Record<string, string | undefined>} */ var deprecatedParams = {
        allowEnterKey: undefined
    };
    var toastIncompatibleParams = [
        "allowOutsideClick",
        "allowEnterKey",
        "backdrop",
        "focusConfirm",
        "focusDeny",
        "focusCancel",
        "returnFocus",
        "heightAuto",
        "keydownListenerCapture"
    ];
    /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */ var isValidParameter = function isValidParameter(paramName) {
        return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */ var isUpdatableParameter = function isUpdatableParameter(paramName) {
        return updatableParams.indexOf(paramName) !== -1;
    };
    /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */ var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
        return deprecatedParams[paramName];
    };
    /**
   * @param {string} param
   */ var checkIfParamIsValid = function checkIfParamIsValid(param) {
        if (!isValidParameter(param)) warn('Unknown parameter "'.concat(param, '"'));
    };
    /**
   * @param {string} param
   */ var checkIfToastParamIsValid = function checkIfToastParamIsValid(param) {
        if (toastIncompatibleParams.includes(param)) warn('The parameter "'.concat(param, '" is incompatible with toasts'));
    };
    /**
   * @param {string} param
   */ var checkIfParamIsDeprecated = function checkIfParamIsDeprecated(param) {
        var isDeprecated = isDeprecatedParameter(param);
        if (isDeprecated) warnAboutDeprecation(param, isDeprecated);
    };
    /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */ var showWarningsForParams = function showWarningsForParams(params) {
        if (params.backdrop === false && params.allowOutsideClick) warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
        for(var param in params){
            checkIfParamIsValid(param);
            if (params.toast) checkIfToastParamIsValid(param);
            checkIfParamIsDeprecated(param);
        }
    };
    /**
   * Updates popup parameters.
   *
   * @param {SweetAlertOptions} params
   */ function update(params) {
        var popup = getPopup();
        var innerParams = privateProps.innerParams.get(this);
        if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
            warn("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
            return;
        }
        var validUpdatableParams = filterValidParams(params);
        var updatedParams = Object.assign({}, innerParams, validUpdatableParams);
        render(this, updatedParams);
        privateProps.innerParams.set(this, updatedParams);
        Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, params),
                writable: false,
                enumerable: true
            }
        });
    }
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ var filterValidParams = function filterValidParams(params) {
        var validUpdatableParams = {};
        Object.keys(params).forEach(function(param) {
            if (isUpdatableParameter(param)) validUpdatableParams[param] = params[param];
            else warn("Invalid parameter to update: ".concat(param));
        });
        return validUpdatableParams;
    };
    /**
   * Dispose the current SweetAlert2 instance
   */ function _destroy() {
        var domCache = privateProps.domCache.get(this);
        var innerParams = privateProps.innerParams.get(this);
        if (!innerParams) {
            disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
            return; // This instance has already been destroyed
        }
        // Check if there is another Swal closing
        if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
            globalState.swalCloseEventFinishedCallback();
            delete globalState.swalCloseEventFinishedCallback;
        }
        if (typeof innerParams.didDestroy === "function") innerParams.didDestroy();
        disposeSwal(this);
    }
    /**
   * @param {SweetAlert} instance
   */ var disposeSwal = function disposeSwal(instance) {
        disposeWeakMaps(instance);
        // Unset this.params so GC will dispose it (#1569)
        delete instance.params;
        // Unset globalState props so GC will dispose globalState (#1569)
        delete globalState.keydownHandler;
        delete globalState.keydownTarget;
        // Unset currentInstance
        delete globalState.currentInstance;
    };
    /**
   * @param {SweetAlert} instance
   */ var disposeWeakMaps = function disposeWeakMaps(instance) {
        // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
        if (instance.isAwaitingPromise) {
            unsetWeakMaps(privateProps, instance);
            instance.isAwaitingPromise = true;
        } else {
            unsetWeakMaps(privateMethods, instance);
            unsetWeakMaps(privateProps, instance);
            delete instance.isAwaitingPromise;
            // Unset instance methods
            delete instance.disableButtons;
            delete instance.enableButtons;
            delete instance.getInput;
            delete instance.disableInput;
            delete instance.enableInput;
            delete instance.hideLoading;
            delete instance.disableLoading;
            delete instance.showValidationMessage;
            delete instance.resetValidationMessage;
            delete instance.close;
            delete instance.closePopup;
            delete instance.closeModal;
            delete instance.closeToast;
            delete instance.rejectPromise;
            delete instance.update;
            delete instance._destroy;
        }
    };
    /**
   * @param {object} obj
   * @param {SweetAlert} instance
   */ var unsetWeakMaps = function unsetWeakMaps(obj, instance) {
        for(var i in obj)obj[i]["delete"](instance);
    };
    var instanceMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        _destroy: _destroy,
        close: close,
        closeModal: close,
        closePopup: close,
        closeToast: close,
        disableButtons: disableButtons,
        disableInput: disableInput,
        disableLoading: hideLoading,
        enableButtons: enableButtons,
        enableInput: enableInput,
        getInput: getInput,
        handleAwaitingPromise: handleAwaitingPromise,
        hideLoading: hideLoading,
        rejectPromise: rejectPromise,
        resetValidationMessage: resetValidationMessage,
        showValidationMessage: showValidationMessage,
        update: update
    });
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ var handlePopupClick = function handlePopupClick(innerParams, domCache, dismissWith) {
        if (innerParams.toast) handleToastClick(innerParams, domCache, dismissWith);
        else {
            // Ignore click events that had mousedown on the popup but mouseup on the container
            // This can happen when the user drags a slider
            handleModalMousedown(domCache);
            // Ignore click events that had mousedown on the container but mouseup on the popup
            handleContainerMousedown(domCache);
            handleModalClick(innerParams, domCache, dismissWith);
        }
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ var handleToastClick = function handleToastClick(innerParams, domCache, dismissWith) {
        // Closing toast by internal click
        domCache.popup.onclick = function() {
            if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) return;
            dismissWith(DismissReason.close);
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ var isAnyButtonShown = function isAnyButtonShown(innerParams) {
        return !!(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    var ignoreOutsideClick = false;
    /**
   * @param {DomCache} domCache
   */ var handleModalMousedown = function handleModalMousedown(domCache) {
        domCache.popup.onmousedown = function() {
            domCache.container.onmouseup = function(e) {
                domCache.container.onmouseup = function() {};
                // We only check if the mouseup target is the container because usually it doesn't
                // have any other direct children aside of the popup
                if (e.target === domCache.container) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {DomCache} domCache
   */ var handleContainerMousedown = function handleContainerMousedown(domCache) {
        domCache.container.onmousedown = function(e) {
            // prevent the modal text from being selected on double click on the container (allowOutsideClick: false)
            if (e.target === domCache.container) e.preventDefault();
            domCache.popup.onmouseup = function(e) {
                domCache.popup.onmouseup = function() {};
                // We also need to check if the mouseup target is a child of the popup
                if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ var handleModalClick = function handleModalClick(innerParams, domCache, dismissWith) {
        domCache.container.onclick = function(e) {
            if (ignoreOutsideClick) {
                ignoreOutsideClick = false;
                return;
            }
            if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) dismissWith(DismissReason.backdrop);
        };
    };
    var isJqueryElement = function isJqueryElement(elem) {
        return _typeof(elem) === "object" && elem.jquery;
    };
    var isElement = function isElement(elem) {
        return elem instanceof Element || isJqueryElement(elem);
    };
    var argsToParams = function argsToParams(args) {
        var params = {};
        if (_typeof(args[0]) === "object" && !isElement(args[0])) Object.assign(params, args[0]);
        else [
            "title",
            "html",
            "icon"
        ].forEach(function(name, index) {
            var arg = args[index];
            if (typeof arg === "string" || isElement(arg)) params[name] = arg;
            else if (arg !== undefined) error("Unexpected type of ".concat(name, '! Expected "string" or "Element", got ').concat(_typeof(arg)));
        });
        return params;
    };
    /**
   * Main method to create a new SweetAlert2 popup
   *
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */ function fire() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _construct(this, args);
    }
    /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   */ function mixin(mixinParams) {
        var MixinSwal = /*#__PURE__*/ function(_this) {
            function MixinSwal() {
                _classCallCheck(this, MixinSwal);
                return _callSuper(this, MixinSwal, arguments);
            }
            _inherits(MixinSwal, _this);
            return _createClass(MixinSwal, [
                {
                    key: "_main",
                    value: function _main(params, priorityMixinParams) {
                        return _superPropGet(MixinSwal, "_main", this)([
                            params,
                            Object.assign({}, mixinParams, priorityMixinParams)
                        ]);
                    }
                }
            ]);
        }(this); // @ts-ignore
        return MixinSwal;
    }
    /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */ var getTimerLeft = function getTimerLeft() {
        return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ var stopTimer = function stopTimer() {
        if (globalState.timeout) {
            stopTimerProgressBar();
            return globalState.timeout.stop();
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ var resumeTimer = function resumeTimer() {
        if (globalState.timeout) {
            var remaining = globalState.timeout.start();
            animateTimerProgressBar(remaining);
            return remaining;
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ var toggleTimer = function toggleTimer() {
        var timer = globalState.timeout;
        return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} ms
   * @returns {number | undefined}
   */ var increaseTimer = function increaseTimer(ms) {
        if (globalState.timeout) {
            var remaining = globalState.timeout.increase(ms);
            animateTimerProgressBar(remaining, true);
            return remaining;
        }
    };
    /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */ var isTimerRunning = function isTimerRunning() {
        return !!(globalState.timeout && globalState.timeout.isRunning());
    };
    var bodyClickListenerAdded = false;
    var clickHandlers = {};
    /**
   * @param {string} attr
   */ function bindClickHandler() {
        var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "data-swal-template";
        clickHandlers[attr] = this;
        if (!bodyClickListenerAdded) {
            document.body.addEventListener("click", bodyClickListener);
            bodyClickListenerAdded = true;
        }
    }
    var bodyClickListener = function bodyClickListener(event) {
        for(var el = event.target; el && el !== document; el = el.parentNode)for(var attr in clickHandlers){
            var template = el.getAttribute(attr);
            if (template) {
                clickHandlers[attr].fire({
                    template: template
                });
                return;
            }
        }
    };
    var staticMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        argsToParams: argsToParams,
        bindClickHandler: bindClickHandler,
        clickCancel: clickCancel,
        clickConfirm: clickConfirm,
        clickDeny: clickDeny,
        enableLoading: showLoading,
        fire: fire,
        getActions: getActions,
        getCancelButton: getCancelButton,
        getCloseButton: getCloseButton,
        getConfirmButton: getConfirmButton,
        getContainer: getContainer,
        getDenyButton: getDenyButton,
        getFocusableElements: getFocusableElements,
        getFooter: getFooter,
        getHtmlContainer: getHtmlContainer,
        getIcon: getIcon,
        getIconContent: getIconContent,
        getImage: getImage,
        getInputLabel: getInputLabel,
        getLoader: getLoader,
        getPopup: getPopup,
        getProgressSteps: getProgressSteps,
        getTimerLeft: getTimerLeft,
        getTimerProgressBar: getTimerProgressBar,
        getTitle: getTitle,
        getValidationMessage: getValidationMessage,
        increaseTimer: increaseTimer,
        isDeprecatedParameter: isDeprecatedParameter,
        isLoading: isLoading,
        isTimerRunning: isTimerRunning,
        isUpdatableParameter: isUpdatableParameter,
        isValidParameter: isValidParameter,
        isVisible: isVisible,
        mixin: mixin,
        resumeTimer: resumeTimer,
        showLoading: showLoading,
        stopTimer: stopTimer,
        toggleTimer: toggleTimer
    });
    var Timer = /*#__PURE__*/ function() {
        /**
     * @param {Function} callback
     * @param {number} delay
     */ function Timer(callback, delay) {
            _classCallCheck(this, Timer);
            this.callback = callback;
            this.remaining = delay;
            this.running = false;
            this.start();
        }
        /**
     * @returns {number}
     */ return _createClass(Timer, [
            {
                key: "start",
                value: function start() {
                    if (!this.running) {
                        this.running = true;
                        this.started = new Date();
                        this.id = setTimeout(this.callback, this.remaining);
                    }
                    return this.remaining;
                }
            },
            {
                key: "stop",
                value: function stop() {
                    if (this.started && this.running) {
                        this.running = false;
                        clearTimeout(this.id);
                        this.remaining -= new Date().getTime() - this.started.getTime();
                    }
                    return this.remaining;
                }
            },
            {
                key: "increase",
                value: function increase(n) {
                    var running = this.running;
                    if (running) this.stop();
                    this.remaining += n;
                    if (running) this.start();
                    return this.remaining;
                }
            },
            {
                key: "getTimerLeft",
                value: function getTimerLeft() {
                    if (this.running) {
                        this.stop();
                        this.start();
                    }
                    return this.remaining;
                }
            },
            {
                key: "isRunning",
                value: function isRunning() {
                    return this.running;
                }
            }
        ]);
    }();
    var swalStringParams = [
        "swal-title",
        "swal-html",
        "swal-footer"
    ];
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ var getTemplateParams = function getTemplateParams(params) {
        var template = typeof params.template === "string" ? /** @type {HTMLTemplateElement} */ document.querySelector(params.template) : params.template;
        if (!template) return {};
        /** @type {DocumentFragment} */ var templateContent = template.content;
        showWarningsForElements(templateContent);
        var result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ var getSwalParams = function getSwalParams(templateContent) {
        /** @type {Record<string, any>} */ var result = {};
        /** @type {HTMLElement[]} */ var swalParams = Array.from(templateContent.querySelectorAll("swal-param"));
        swalParams.forEach(function(param) {
            showWarningsForAttributes(param, [
                "name",
                "value"
            ]);
            var paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute("name");
            var value = param.getAttribute("value");
            if (!paramName || !value) return;
            if (typeof defaultParams[paramName] === "boolean") result[paramName] = value !== "false";
            else if (_typeof(defaultParams[paramName]) === "object") result[paramName] = JSON.parse(value);
            else result[paramName] = value;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ var getSwalFunctionParams = function getSwalFunctionParams(templateContent) {
        /** @type {Record<string, any>} */ var result = {};
        /** @type {HTMLElement[]} */ var swalFunctions = Array.from(templateContent.querySelectorAll("swal-function-param"));
        swalFunctions.forEach(function(param) {
            var paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute("name");
            var value = param.getAttribute("value");
            if (!paramName || !value) return;
            result[paramName] = new Function("return ".concat(value))();
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ var getSwalButtons = function getSwalButtons(templateContent) {
        /** @type {Record<string, any>} */ var result = {};
        /** @type {HTMLElement[]} */ var swalButtons = Array.from(templateContent.querySelectorAll("swal-button"));
        swalButtons.forEach(function(button) {
            showWarningsForAttributes(button, [
                "type",
                "color",
                "aria-label"
            ]);
            var type = button.getAttribute("type");
            if (!type || ![
                "confirm",
                "cancel",
                "deny"
            ].includes(type)) return;
            result["".concat(type, "ButtonText")] = button.innerHTML;
            result["show".concat(capitalizeFirstLetter(type), "Button")] = true;
            if (button.hasAttribute("color")) result["".concat(type, "ButtonColor")] = button.getAttribute("color");
            if (button.hasAttribute("aria-label")) result["".concat(type, "ButtonAriaLabel")] = button.getAttribute("aria-label");
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Pick<SweetAlertOptions, 'imageUrl' | 'imageWidth' | 'imageHeight' | 'imageAlt'>}
   */ var getSwalImage = function getSwalImage(templateContent) {
        var result = {};
        /** @type {HTMLElement | null} */ var image = templateContent.querySelector("swal-image");
        if (image) {
            showWarningsForAttributes(image, [
                "src",
                "width",
                "height",
                "alt"
            ]);
            if (image.hasAttribute("src")) result.imageUrl = image.getAttribute("src") || undefined;
            if (image.hasAttribute("width")) result.imageWidth = image.getAttribute("width") || undefined;
            if (image.hasAttribute("height")) result.imageHeight = image.getAttribute("height") || undefined;
            if (image.hasAttribute("alt")) result.imageAlt = image.getAttribute("alt") || undefined;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ var getSwalIcon = function getSwalIcon(templateContent) {
        var result = {};
        /** @type {HTMLElement | null} */ var icon = templateContent.querySelector("swal-icon");
        if (icon) {
            showWarningsForAttributes(icon, [
                "type",
                "color"
            ]);
            if (icon.hasAttribute("type")) result.icon = icon.getAttribute("type");
            if (icon.hasAttribute("color")) result.iconColor = icon.getAttribute("color");
            result.iconHtml = icon.innerHTML;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ var getSwalInput = function getSwalInput(templateContent) {
        /** @type {Record<string, any>} */ var result = {};
        /** @type {HTMLElement | null} */ var input = templateContent.querySelector("swal-input");
        if (input) {
            showWarningsForAttributes(input, [
                "type",
                "label",
                "placeholder",
                "value"
            ]);
            result.input = input.getAttribute("type") || "text";
            if (input.hasAttribute("label")) result.inputLabel = input.getAttribute("label");
            if (input.hasAttribute("placeholder")) result.inputPlaceholder = input.getAttribute("placeholder");
            if (input.hasAttribute("value")) result.inputValue = input.getAttribute("value");
        }
        /** @type {HTMLElement[]} */ var inputOptions = Array.from(templateContent.querySelectorAll("swal-input-option"));
        if (inputOptions.length) {
            result.inputOptions = {};
            inputOptions.forEach(function(option) {
                showWarningsForAttributes(option, [
                    "value"
                ]);
                var optionValue = option.getAttribute("value");
                if (!optionValue) return;
                var optionName = option.innerHTML;
                result.inputOptions[optionValue] = optionName;
            });
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {Record<string, any>}
   */ var getSwalStringParams = function getSwalStringParams(templateContent, paramNames) {
        /** @type {Record<string, any>} */ var result = {};
        for(var i in paramNames){
            var paramName = paramNames[i];
            /** @type {HTMLElement | null} */ var tag = templateContent.querySelector(paramName);
            if (tag) {
                showWarningsForAttributes(tag, []);
                result[paramName.replace(/^swal-/, "")] = tag.innerHTML.trim();
            }
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   */ var showWarningsForElements = function showWarningsForElements(templateContent) {
        var allowedElements = swalStringParams.concat([
            "swal-param",
            "swal-function-param",
            "swal-button",
            "swal-image",
            "swal-icon",
            "swal-input",
            "swal-input-option"
        ]);
        Array.from(templateContent.children).forEach(function(el) {
            var tagName = el.tagName.toLowerCase();
            if (!allowedElements.includes(tagName)) warn("Unrecognized element <".concat(tagName, ">"));
        });
    };
    /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */ var showWarningsForAttributes = function showWarningsForAttributes(el, allowedAttributes) {
        Array.from(el.attributes).forEach(function(attribute) {
            if (allowedAttributes.indexOf(attribute.name) === -1) warn([
                'Unrecognized attribute "'.concat(attribute.name, '" on <').concat(el.tagName.toLowerCase(), ">."),
                "".concat(allowedAttributes.length ? "Allowed attributes are: ".concat(allowedAttributes.join(", ")) : "To set the value, use HTML within the element.")
            ]);
        });
    };
    var SHOW_CLASS_TIMEOUT = 10;
    /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */ var openPopup = function openPopup(params) {
        var container = getContainer();
        var popup = getPopup();
        if (typeof params.willOpen === "function") params.willOpen(popup);
        var bodyStyles = window.getComputedStyle(document.body);
        var initialBodyOverflow = bodyStyles.overflowY;
        addClasses(container, popup, params);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        setTimeout(function() {
            setScrollingVisibility(container, popup);
        }, SHOW_CLASS_TIMEOUT);
        if (isModal()) {
            fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
            setAriaHidden();
        }
        if (!isToast() && !globalState.previousActiveElement) globalState.previousActiveElement = document.activeElement;
        if (typeof params.didOpen === "function") setTimeout(function() {
            return params.didOpen(popup);
        });
        removeClass(container, swalClasses["no-transition"]);
    };
    /**
   * @param {AnimationEvent} event
   */ var _swalOpenAnimationFinished = function swalOpenAnimationFinished(event) {
        var popup = getPopup();
        if (event.target !== popup || !animationEndEvent) return;
        var container = getContainer();
        popup.removeEventListener(animationEndEvent, _swalOpenAnimationFinished);
        container.style.overflowY = "auto";
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */ var setScrollingVisibility = function setScrollingVisibility(container, popup) {
        if (animationEndEvent && hasCssAnimation(popup)) {
            container.style.overflowY = "hidden";
            popup.addEventListener(animationEndEvent, _swalOpenAnimationFinished);
        } else container.style.overflowY = "auto";
    };
    /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */ var fixScrollContainer = function fixScrollContainer(container, scrollbarPadding, initialBodyOverflow) {
        iOSfix();
        if (scrollbarPadding && initialBodyOverflow !== "hidden") replaceScrollbarWithPadding(initialBodyOverflow);
        // sweetalert2/issues/1247
        setTimeout(function() {
            container.scrollTop = 0;
        });
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ var addClasses = function addClasses(container, popup, params) {
        addClass(container, params.showClass.backdrop);
        if (params.animation) {
            // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
            popup.style.setProperty("opacity", "0", "important");
            show(popup, "grid");
            setTimeout(function() {
                // Animate popup right after showing it
                addClass(popup, params.showClass.popup);
                // and remove the opacity workaround
                popup.style.removeProperty("opacity");
            }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
        } else show(popup, "grid");
        addClass([
            document.documentElement,
            document.body
        ], swalClasses.shown);
        if (params.heightAuto && params.backdrop && !params.toast) addClass([
            document.documentElement,
            document.body
        ], swalClasses["height-auto"]);
    };
    var defaultInputValidators = {
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ email: function email(string, validationMessage) {
            return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || "Invalid email address");
        },
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ url: function url(string, validationMessage) {
            // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || "Invalid URL");
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ function setDefaultInputValidators(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (params.inputValidator) return;
        if (params.input === "email") params.inputValidator = defaultInputValidators["email"];
        if (params.input === "url") params.inputValidator = defaultInputValidators["url"];
    }
    /**
   * @param {SweetAlertOptions} params
   */ function validateCustomTargetElement(params) {
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === "string" && !document.querySelector(params.target) || typeof params.target !== "string" && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = "body";
        }
    }
    /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */ function setParameters(params) {
        setDefaultInputValidators(params);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
        validateCustomTargetElement(params);
        // Replace newlines with <br> in title
        if (typeof params.title === "string") params.title = params.title.split("\n").join("<br />");
        init(params);
    }
    /** @type {SweetAlert} */ var currentInstance;
    var _promise = /*#__PURE__*/ new WeakMap();
    var SweetAlert = /*#__PURE__*/ function() {
        /**
     * @param {...any} args
     * @this {SweetAlert}
     */ function SweetAlert() {
            _classCallCheck(this, SweetAlert);
            /**
       * @type {Promise<SweetAlertResult>}
       */ _classPrivateFieldInitSpec(this, _promise, void 0);
            // Prevent run in Node env
            if (typeof window === "undefined") return;
            currentInstance = this;
            // @ts-ignore
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var outerParams = Object.freeze(this.constructor.argsToParams(args));
            /** @type {Readonly<SweetAlertOptions>} */ this.params = outerParams;
            /** @type {boolean} */ this.isAwaitingPromise = false;
            _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
        }
        return _createClass(SweetAlert, [
            {
                key: "_main",
                value: function _main(userParams) {
                    var mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    showWarningsForParams(Object.assign({}, mixinParams, userParams));
                    if (globalState.currentInstance) {
                        var swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
                        var isAwaitingPromise = globalState.currentInstance.isAwaitingPromise;
                        globalState.currentInstance._destroy();
                        if (!isAwaitingPromise) swalPromiseResolve({
                            isDismissed: true
                        });
                        if (isModal()) unsetAriaHidden();
                    }
                    globalState.currentInstance = currentInstance;
                    var innerParams = prepareParams(userParams, mixinParams);
                    setParameters(innerParams);
                    Object.freeze(innerParams);
                    // clear the previous timer
                    if (globalState.timeout) {
                        globalState.timeout.stop();
                        delete globalState.timeout;
                    }
                    // clear the restore focus timeout
                    clearTimeout(globalState.restoreFocusTimeout);
                    var domCache = populateDomCache(currentInstance);
                    render(currentInstance, innerParams);
                    privateProps.innerParams.set(currentInstance, innerParams);
                    return swalPromise(currentInstance, domCache, innerParams);
                }
            },
            {
                key: "then",
                value: function then(onFulfilled) {
                    return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
                }
            },
            {
                key: "finally",
                value: function _finally(onFinally) {
                    return _classPrivateFieldGet2(_promise, this)["finally"](onFinally);
                }
            }
        ]);
    }();
    /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise}
   */ var swalPromise = function swalPromise(instance, domCache, innerParams) {
        return new Promise(function(resolve, reject) {
            // functions to handle all closings/dismissals
            /**
       * @param {DismissReason} dismiss
       */ var dismissWith = function dismissWith(dismiss) {
                instance.close({
                    isDismissed: true,
                    dismiss: dismiss
                });
            };
            privateMethods.swalPromiseResolve.set(instance, resolve);
            privateMethods.swalPromiseReject.set(instance, reject);
            domCache.confirmButton.onclick = function() {
                handleConfirmButtonClick(instance);
            };
            domCache.denyButton.onclick = function() {
                handleDenyButtonClick(instance);
            };
            domCache.cancelButton.onclick = function() {
                handleCancelButtonClick(instance, dismissWith);
            };
            domCache.closeButton.onclick = function() {
                dismissWith(DismissReason.close);
            };
            handlePopupClick(innerParams, domCache, dismissWith);
            addKeydownHandler(globalState, innerParams, dismissWith);
            handleInputOptionsAndValue(instance, innerParams);
            openPopup(innerParams);
            setupTimer(globalState, innerParams, dismissWith);
            initFocus(domCache, innerParams);
            // Scroll container to top on open (#1247, #1946)
            setTimeout(function() {
                domCache.container.scrollTop = 0;
            });
        });
    };
    /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */ var prepareParams = function prepareParams(userParams, mixinParams) {
        var templateParams = getTemplateParams(userParams);
        var params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
        params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
        params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
        if (params.animation === false) {
            params.showClass = {
                backdrop: "swal2-noanimation"
            };
            params.hideClass = {};
        }
        return params;
    };
    /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */ var populateDomCache = function populateDomCache(instance) {
        var domCache = {
            popup: getPopup(),
            container: getContainer(),
            actions: getActions(),
            confirmButton: getConfirmButton(),
            denyButton: getDenyButton(),
            cancelButton: getCancelButton(),
            loader: getLoader(),
            closeButton: getCloseButton(),
            validationMessage: getValidationMessage(),
            progressSteps: getProgressSteps()
        };
        privateProps.domCache.set(instance, domCache);
        return domCache;
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ var setupTimer = function setupTimer(globalState, innerParams, dismissWith) {
        var timerProgressBar = getTimerProgressBar();
        hide(timerProgressBar);
        if (innerParams.timer) {
            globalState.timeout = new Timer(function() {
                dismissWith("timer");
                delete globalState.timeout;
            }, innerParams.timer);
            if (innerParams.timerProgressBar) {
                show(timerProgressBar);
                applyCustomClass(timerProgressBar, innerParams, "timerProgressBar");
                setTimeout(function() {
                    if (globalState.timeout && globalState.timeout.running) // timer can be already stopped or unset at this point
                    animateTimerProgressBar(innerParams.timer);
                });
            }
        }
    };
    /**
   * Initialize focus in the popup:
   *
   * 1. If `toast` is `true`, don't steal focus from the document.
   * 2. Else if there is an [autofocus] element, focus it.
   * 3. Else if `focusConfirm` is `true` and confirm button is visible, focus it.
   * 4. Else if `focusDeny` is `true` and deny button is visible, focus it.
   * 5. Else if `focusCancel` is `true` and cancel button is visible, focus it.
   * 6. Else focus the first focusable element in a popup (if any).
   *
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */ var initFocus = function initFocus(domCache, innerParams) {
        if (innerParams.toast) return;
        // TODO: this is dumb, remove `allowEnterKey` param in the next major version
        if (!callIfFunction(innerParams.allowEnterKey)) {
            warnAboutDeprecation("allowEnterKey");
            blurActiveElement();
            return;
        }
        if (focusAutofocus(domCache)) return;
        if (focusButton(domCache, innerParams)) return;
        setFocus(-1, 1);
    };
    /**
   * @param {DomCache} domCache
   * @returns {boolean}
   */ var focusAutofocus = function focusAutofocus(domCache) {
        var autofocusElements = domCache.popup.querySelectorAll("[autofocus]");
        var _iterator = _createForOfIteratorHelper(autofocusElements), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var autofocusElement = _step.value;
                if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
                    autofocusElement.focus();
                    return true;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ var focusButton = function focusButton(domCache, innerParams) {
        if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
            domCache.denyButton.focus();
            return true;
        }
        if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
            domCache.cancelButton.focus();
            return true;
        }
        if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
            domCache.confirmButton.focus();
            return true;
        }
        return false;
    };
    var blurActiveElement = function blurActiveElement() {
        if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === "function") document.activeElement.blur();
    };
    // Dear russian users visiting russian sites. Let's have fun.
    if (typeof window !== "undefined" && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
        var now = new Date();
        var initiationDate = localStorage.getItem("swal-initiation");
        if (!initiationDate) localStorage.setItem("swal-initiation", "".concat(now));
        else if ((now.getTime() - Date.parse(initiationDate)) / 86400000 > 3) setTimeout(function() {
            document.body.style.pointerEvents = "none";
            var ukrainianAnthem = document.createElement("audio");
            ukrainianAnthem.src = "https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3";
            ukrainianAnthem.loop = true;
            document.body.appendChild(ukrainianAnthem);
            setTimeout(function() {
                ukrainianAnthem.play()["catch"](function() {
                // ignore
                });
            }, 2500);
        }, 500);
    }
    // Assign instance methods from src/instanceMethods/*.js to prototype
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    // Assign static methods from src/staticMethods/*.js to constructor
    Object.assign(SweetAlert, staticMethods);
    // Proxy to instance methods to constructor, for now, for backwards compatibility
    Object.keys(instanceMethods).forEach(function(key) {
        /**
     * @param {...any} args
     * @returns {any | undefined}
     */ SweetAlert[key] = function() {
            if (currentInstance && currentInstance[key]) {
                var _currentInstance;
                return (_currentInstance = currentInstance)[key].apply(_currentInstance, arguments);
            }
            return null;
        };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = "11.12.4";
    var Swal = SweetAlert;
    // @ts-ignore
    Swal["default"] = Swal;
    return Swal;
});
if (typeof $99dc7a165646c27f$exports !== "undefined" && $99dc7a165646c27f$exports.Sweetalert2) $99dc7a165646c27f$exports.swal = $99dc7a165646c27f$exports.sweetAlert = $99dc7a165646c27f$exports.Swal = $99dc7a165646c27f$exports.SweetAlert = $99dc7a165646c27f$exports.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, '.swal2-popup.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-popup.swal2-toast>*{grid-column:2}.swal2-popup.swal2-toast .swal2-title{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.5em;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-popup.swal2-toast .swal2-html-container{margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-popup.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-popup.swal2-toast .swal2-styled{margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:rgba(0,0,0,.4)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):focus-visible{box-shadow:0 0 0 3px rgba(112,102,224,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):focus-visible{box-shadow:0 0 0 3px rgba(220,55,65,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):focus-visible{box-shadow:0 0 0 3px rgba(110,120,129,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-default-outline:focus-visible{box-shadow:0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em;text-align:center}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em}div:where(.swal2-container) button:where(.swal2-close){z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:rgba(0,0,0,0);color:#ccc;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:none;background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) .swal2-html-container{z-index:1;justify-content:center;margin:0;padding:1em 1.6em .3em;overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:rgba(0,0,0,0);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:#fff}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:rgba(0,0,0,0);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:#fff;color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:0.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#facea8;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#9de0f6;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#c9dae1;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:swal2-show .3s}.swal2-hide{animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static !important}}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}');


const $c1ce9d969bfa6909$var$url_base = "https://api.unsplash.com/";
const $c1ce9d969bfa6909$var$client_id = "&client_id=_Lo9ruec1rqQ_-ERrp_NHgqbfBdANyAzPYaSLwGdXh0";
const $c1ce9d969bfa6909$var$search_endpoint = "search/photos?&query=fondos+de+";
const $c1ce9d969bfa6909$var$container = document.getElementById("container");
const $c1ce9d969bfa6909$var$table = document.getElementById("table");
(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#searchBtn").click(function() {
    $c1ce9d969bfa6909$var$container.innerHTML = "";
    var searchTerm = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#searchInput").val();
    fetch(`${$c1ce9d969bfa6909$var$url_base}${$c1ce9d969bfa6909$var$search_endpoint}${searchTerm}${$c1ce9d969bfa6909$var$client_id}`).then((response)=>response.json()).then((data)=>{
        const results = data.results;
        $c1ce9d969bfa6909$var$createImage(results);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#searchInput").val("");
});
function $c1ce9d969bfa6909$var$createImage(images) {
    images.forEach((image)=>{
        const card = `
        <div class="cell" data-equalizer-watch>
          <div class="card">
            <div class="card-divider" style="background-color: ${image.color};">
              <label>
                <input data-tooltip tabindex="4" title="Escribe aqui el nombre de la ciudad o pais" class="name-place text-center" type="text" placeholder="Escribe aqui">
              </label>
            </div>
            <a href="${image.urls.thumb}" data-caption="${image.alt_description}">
              <img class="thumbail" src="${image.urls.regular}" alt="${image.alt_description}">
            </a>  
          </div>
        </div>
        `;
        $c1ce9d969bfa6909$var$container.innerHTML += card;
    });
}
const $c1ce9d969bfa6909$var$drake = dragula([
    $c1ce9d969bfa6909$var$container,
    $c1ce9d969bfa6909$var$table
]);
$c1ce9d969bfa6909$var$drake.on("drop", (el)=>{
    const img = el.querySelector("img");
    img.setAttribute("data-fancybox", "gallery");
});
(0, $28098bff0e2b5f57$export$cb45b08d97cdc4fd).bind("[data-fancybox]", {
});
function $c1ce9d969bfa6909$var$savePlaces() {
    (0, (/*@__PURE__*/$parcel$interopDefault($1b5031d44df7baeb$exports))).set("places", $c1ce9d969bfa6909$var$table.innerHTML);
}
function $c1ce9d969bfa6909$var$getPlaces() {
    const savedPlaces = (0, (/*@__PURE__*/$parcel$interopDefault($1b5031d44df7baeb$exports))).get("places");
    $c1ce9d969bfa6909$var$table.innerHTML = savedPlaces;
}
window.onload = function() {
    $c1ce9d969bfa6909$var$getPlaces();
};
(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#saveBtn").on("click", function() {
    $c1ce9d969bfa6909$var$savePlaces();
    $c1ce9d969bfa6909$var$savedAlert();
});
function $c1ce9d969bfa6909$var$savedAlert() {
    (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
        position: "top-end",
        icon: "success",
        title: "Tus favoritos han sido guardados con exito",
        showConfirmButton: false,
        timer: 1500
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#tip").on("click", function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire("Las imagenes no estan fijas, puedes arrastrar e intercambiarlas a tu gusto");
});


//# sourceMappingURL=index.523fcfb3.js.map
